/* eslint-disable import/extensions */
/* eslint-disable no-constant-condition */
/* eslint-disable no-empty */
/* eslint-disable no-lone-blocks */
/* eslint-disable no-self-assign */
/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect, Suspense, useRef } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import './KonfiguratorDetail.css';
import HeaderSlim from './includes/HeaderSlim';

import { motion } from 'framer-motion';
import { Stats, OrbitControls, Text, Line, Cone, useGLTF, Environment, PerspectiveCamera } from '@react-three/drei';
import { Canvas, act, useLoader } from '@react-three/fiber';
import { OrbitControls as VanillaOrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';

import Detailmodel from './includes/Detailmodel';
import EasyAlu from './includes/EasyAlu';
import Glassmodel from './includes/Glassmodel.js';
import './KonfiguratorResponsive.css';
import { Helmet } from 'react-helmet';
import LinkData from './includes/Links.json';
import BaseClampModel from './includes/BaseClampModel.js';
import FrenchBalcony from './includes/FrenchBalcony.js';
import { WebGLRenderer } from 'three';
import { Utility } from '../utility/utility.js';
import { ThreeUtilityGetter } from '../utility/three-utility-getter/three-utility-getter.js';
import * as THREE from 'three';
import { ConfigurationPdfTemplate } from '../utility/pdf-wrapper/pdf-templates/configuration-pdf-template/configuration-pdf-template.js';
import { usePdfCreator } from '../hooks/use-pdf-creator.js';
import Qline from './includes/Qline.js';
import { Connect } from 'aws-sdk';
import ConfiguratorPrivateConnectParent from './includes/ConfiguratorPrivateConnectParent';
import Footernew from './includes/Footernew';
import NeedHelp from './includes/NeedHelp';
import { useLocale } from 'hooks/use-locale';

function KonfiguratorDetail(props) {
  //Code is clearly self explanatory

  const translationEdelstahl = {
    'da-dk': 'Rustfrit stål',
    'de-at': 'Edelstahl',
    'de-ch': 'Edelstahl',
    'de-de': 'Edelstahl',
    en: 'Stainless Steel',
    'en-ca': 'Stainless Steel',
    'en-gb': 'Stainless Steel',
    'en-ie': 'Stainless Steel',
    'en-us': 'Stainless Steel',
    es: 'Acero inoxidable',
    'es-es': 'Acero inoxidable',
    'es-us': 'Acero inoxidable',
    'fi-fi': 'Ruostumaton teräs',
    'fr-be': 'Acier inoxydable',
    'fr-ca': 'Acier inoxydable',
    'fr-ch': 'Acier inoxydable',
    'fr-lu': 'Acier inoxydable',
    'it-ch': 'Acciaio inossidabile',
    'it-it': 'Acciaio inossidabile',
    'nb-no': 'Rustfritt stål',
    'nl-nl': 'Roestvrij staal',
    'nl-be': 'Roestvrij staal',
    'pl-pl': 'Stal nierdzewna',
    'pt-br': 'Aço inoxidável',
    'pt-pt': 'Aço inoxidável',
    'sv-se': 'Rostfritt stål',
  };
  let [HasInstaller, setHasInstaller] = useState(false);
  const [AnnoyCustomer, setAnnoyCustomer] = useState(false);
  const [Popupcount, setPopupcount] = useState(0);
  const [PrivateData, setPrivateData] = useState();
  let baseurl = window.location.origin;
  let fileInputRef = useRef();
  let [fovnbr, setfovnbr] = useState(15);
  let [OpenArtlist, setOpenArtlist] = useState(false);
  const [ralcolor, setralcolor] = useState('');
  const [ralcolorbool, setralcolorbool] = useState(false);
  let [klammer, setklammer] = useState();
  let [hohe, sethohe] = useState(1100);
  let [pfosten2, setpfosten2] = useState();
  let [doppel, setdoppel] = useState();
  let [bodentief, setbodentief] = useState(true);
  let [handlaufmat, sethandlaufmat] = useState('bevel');
  let [baseclampsubsystem, setbaseclampsubsystem] = useState('64');
  let [loadingdone, setloadingdone] = useState(0);
  let [handlaufweg, sethandlaufweg] = useState('nein');
  let [pfostenmaterial, setpfostenmaterial] = useState('metall');
  let [AnkerImAngebot, setAnkerImAngebot] = useState(true);
  let [klammermaterial, setklammermaterial] = useState('metall');
  let [glasart, setglasart] = useState('klarglas');
  let [montageart, setmontageart] = useState('top');
  let [includeglass, setincludeglass] = useState(true);
  let [cuttosize, setcuttosize] = useState(true);
  let [untergrundd, setuntergrundd] = useState('beton');
  let [selectstep, setselectstep] = useState(1);
  let [gelaender, setgelaender] = useState('baluster');
  let [finalurl, setfinalurl] = useState('');
  let [namepara, setnamepara] = useState('unnamed');
  let [form, setform] = useState('i');
  let [len1, setlen1] = useState(2100);
  let [len2, setlen2] = useState(2600);
  let [len3, setlen3] = useState(800);
  let [fenstermontage, setfenstermontage] = useState('Front');
  let [fbsystem, setfbsystem] = useState('EasyGlassView');
  let [windowwidth, setwindowwidth] = useState(1900);
  let [windowheight, setwindowheight] = useState(1900);
  let [windowdistance, setwindowdistance] = useState(150);
  let [windowinset, setwindowinset] = useState(0);
  let [Fbcustomglas, setFbcustomglas] = useState(true);
  let [Fbcustomglaswidth, setFbcustomglaswidth] = useState(2000);
  let [PostShape, setPostShape] = useState('round');

  const [Pfostenrund, setPfostenrund] = useState('42');
  const [QlineHandlauf, setQlineHandlauf] = useState('42');
  let [inout, setinout] = useState('out');
  let [initload, setinitload] = useState(0);
  let [wall1, setwall1] = useState(false);
  let [wall2, setwall2] = useState(false);
  let [campos1, setcampos1] = useState(43);
  const [TapHandrail, setTapHandrail] = useState(true);
  const [TapPosts, setTapPosts] = useState(true);

  let [coords, setcoords] = useState([
    [0, 0],
    [20, 0],
  ]);

  const [step1bool, setstep1bool] = useState(false);
  let [countt, setcountt] = useState(0);
  let [countt2, setcountt2] = useState(0);
  let [savecode, setsavecode] = useState('');
  let [initloadbool, setinitloadbool] = useState(0);
  let [windowamount, setwindowamount] = useState(2);
  let [colorr, setcolorr] = useState('anrtz');
  let [polarcoord, setpolarcoord] = useState(0);
  let [business, setbusiness] = useState(false);
  let [alreadycust, setalreadycust] = useState(0);
  let adjcount = 0;
  const baluster1 = useRef(null);

  const [qlineinfill, setqlineinfill] = useState('glass');
  const glass1 = useRef(null);
  const picket1 = useRef(null);
  let [triggerforglass, settriggerforglass] = useState(false);
  const ushape2 = useRef(null);
  const ishape2 = useRef(null);
  const lshape2 = useRef(null);
  let height1 = useRef(null);
  let height2 = useRef(null);
  let height3 = useRef(null);
  let email = '';
  let custid = '';
  let rndcount = 0;
  let textareatext = '';
  let postcode = '';
  let unterg1 = useRef(null);
  let unterg2 = useRef(null);
  let unterg3 = useRef(null);
  let rotatecount = 0;
  let free1 = useRef(null);
  let wall1s = useRef(null);
  let [movementbool, setmovementbool] = useState(false);
  let free2 = useRef(null);
  let wall2s = useRef(null);
  let [showmenu, setshowmenu] = useState(false);
  let handlauf1 = useRef(null);
  let handlauf2 = useRef(null);
  const location = useLocation();
  let [glassthicknessbaseclamps, setglassthicknessbaseclamps] = useState('17.52mm');
  let [glaspanelwidthi, setglaspanelwithi] = useState(100.00001);
  let [glaspanelwidthl, setglaspanelwithl] = useState(100.00001);
  let [glaspanelwidthu, setglaspanelwithu] = useState(100.00001);
  const [InstallerId, setInstallerId] = useState();

  useEffect(() => {
    if (windowinset < 60 && fenstermontage == 'Inset') {
      setfenstermontage('Front');
    }
  }, [windowinset]);

  useEffect(() => {
    if (selectstep == 1 || (selectstep > 1 && selectstep < 7 && window.innerHeight > 934) || selectstep >= 9) {
      if (!document.body.classList.contains('body-scrollable-content')) {
        document.body.classList.add('body-scrollable-content');
      }
    }

    if (selectstep == 9) {
      displaySchematicStep9();
    }
    if (selectstep > 9) {
      setTimeout(() => {
        if (document.querySelector('.ConfiguratorPrivatForm-LastStep')) {
          document
            .querySelector('.ConfiguratorPrivatForm-LastStep')
            .scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 1000);
    }

    // Cleanup function
    return () => {
      if (document.body.classList.contains('body-scrollable-content')) {
        document.body.classList.remove('body-scrollable-content');
      }
    };
  }, [selectstep]);

  let colorr1 = useRef(null);
  let colorr2 = useRef(null);
  let colorr3 = useRef(null);
  let [infotext, setinfotext] = useState({ data: [] });
  let params = useParams();
  let topmountref = useRef(null);
  let faciamountref = useRef(null);
  const CameraRef = useRef(null);
  const orbitRef = useRef(null);
  const cammy = useRef(null);
  let para = useParams();
  let [ForceHeaderUpdate, setForceHeaderUpdate] = useState(false);
  let decideclamp = para.count != 'en-us' && para.count != 'es-us' ? 'round' : 'square';
  let [ClampShape, setClampShape] = useState(decideclamp);
  useEffect(() => {
    setForceHeaderUpdate((prev) => !prev);
  }, [window.location.search]);
  let [camval, setcamval] = useState(0);
  let param = useParams();
  let token = process.env.REACT_APP_PUBLIC_KEY;

  let numberss = 1;
  let savearr = [];
  let linky;

  const [renderer, setRenderer] = useState(null);
  const [scene, setScene] = useState(null);
  const [camera, setCamera] = useState(null);
  const [PdfTemplateAnchor, createPdfFromTemplate] = usePdfCreator(window.location.origin?.includes('localhost'));
  const [configurationPdfTableData, setConfigurationPdfTableData] = useState([]);
  const [overviewPdfTableData, setOverviewPdfTableData] = useState([]);
  const navigate = useNavigate();
  const locale = useLocale();

  // this verifies the url and sets the state of the configurator according to the url params
  useEffect(() => {
    const parts = location.pathname.split('/').filter((x) => x && x !== '');
    if (parts.length > 4) return Utility.redirectToNotFound(locale, navigate);

    const code = parts[3];
    if (!code) return;

    if (code.length !== 8) return Utility.redirectToNotFound(locale, navigate);
    if (code === 'register') return Utility.redirectToNotFound(locale, navigate);
    if (code === 'consumer') return Utility.redirectToNotFound(locale, navigate);
  }, [location.pathname]);

  const removeObjectFromScene = (object) => {
    if (object.geometry) object.geometry.dispose();
    if (object.material) {
      if (Array.isArray(object.material)) {
        object.material.forEach((material) => material.dispose());
      } else {
        object.material.dispose();
      }
    }
    if (object.texture) object.texture.dispose();

    if (object.parent) {
      object.parent.remove(object);
    }
  };
  const removeSpecificObjectsFromScene = (scene, objectTypes) => {
    const objectsToRemove = [];

    scene.traverse((child) => {
      if (
        objectTypes.find((x) => child.type.includes(x)) ||
        (child.geometry && objectTypes.find((x) => child.geometry.type.includes(x))) ||
        objectTypes.find((x) => Object.getPrototypeOf(child).constructor.name.includes(x))
      ) {
        objectsToRemove.push(child);
      }
    });
    objectsToRemove.forEach((object) => removeObjectFromScene(object));
  };
  const getTopViewSchematic = (clearColor = '#ffffff', alpha = 0) => {
    const { right, front, left } = getDimensions();
    const length = form === 'u' ? Math.max(right, left) : right;
    const distance = Math.sqrt((length / 100) ** 2 + (front / 100) ** 2) + 30;
    const middle =
      form === 'u'
        ? new THREE.Vector3(front, 0, 0).divideScalar(200)
        : form === 'l'
          ? new THREE.Vector3(front, 0, 0).divideScalar(200)
          : new THREE.Vector3(0, 0, length < 1000 ? length / -200 : length / 1000);
    const topScene = scene.clone(true);
    removeSpecificObjectsFromScene(topScene, ['Cone', 'Text', 'Line']);
    const topCamera = new THREE.PerspectiveCamera(75, 8 / 6, 0.1, 1000);
    const canvas = document.createElement('canvas');
    const topRenderer = new THREE.WebGLRenderer({ antialias: true, canvas });
    topRenderer.setSize(800, 600);
    topRenderer.setClearColor(clearColor, alpha);
    topCamera.position.set(middle.x, middle.y + distance, middle.z);
    topCamera.rotation.set(-Math.PI / 2, 0, -Math.PI / 2);
    topRenderer.render(topScene, topCamera);
    const dataURL = topRenderer.domElement.toDataURL('image/png');
    return dataURL;
  };

  const getCurrentView = () => {
    renderer.render(scene, camera);
    const dataURL = renderer.domElement.toDataURL('image/png');
    return dataURL;
  };

  const getOverviewSchematic = async (clearColor = '#ffffff', alpha = 0) => {
    const { right, front, left } = getDimensions();
    const isFb = gelaender === 'frenchbalcony';
    const overviewScene = scene.clone(true);
    const canvas = document.createElement('canvas');
    const overviewRenderer = new THREE.WebGLRenderer({ antialias: true, canvas, alpha: true });
    const length = form === 'u' ? Math.max(right, left) : right;
    const distance =
      form !== 'i' ? Math.sqrt((length / 100) ** 2 + (front / 100) ** 2) / 200 + 40 : right / 120 + 40 + 25;
    overviewRenderer.setSize(3200, 2400);
    overviewRenderer.setClearColor(clearColor, alpha);
    const overviewCamera = new THREE.PerspectiveCamera(75, 8 / 6, 0.1, 1000);

    const middle =
      form === 'u'
        ? new THREE.Vector3(front, 0, Math.max(right, left)).divideScalar(100)
        : form === 'l'
          ? new THREE.Vector3(front, 0, right).divideScalar(100)
          : new THREE.Vector3(front, 0, right).divideScalar(1000);

    const widthSum = length + front;
    const xProportion = front / widthSum;
    const zProportion = length / widthSum;

    const position = isFb
      ? new THREE.Vector3(0, hohe / 100, 0 - distance - 10)
      : form !== 'i'
        ? new THREE.Vector3(0 - distance * xProportion, distance / 2, 0 - distance * zProportion - length / 100)
        : new THREE.Vector3(0 - distance - 10, hohe / 100, 0);

    const lookAt = form !== 'i' ? new THREE.Vector3(front / 100, 0, right / 100) : new THREE.Vector3(0, 0, 0);

    overviewCamera.position.set(position.x, position.y, position.z);
    overviewCamera.lookAt(lookAt);

    const textsAdded = [];
    const meshes = [];
    scene.traverse((child) => {
      if (Object.getPrototypeOf(child).constructor.name !== 'Text' || textsAdded.includes(child.text)) {
        return;
      }
      const text = child;
      const scale = Math.max(front, right, left) > 7500 ? 2 : 1; // distance / 40;
      const geometry = text.geometry.clone();

      const material = text.material.clone();
      const textMesh = new THREE.Mesh(geometry, material);

      textMesh.position.set(...middle);
      textMesh.lookAt(overviewCamera.position);

      const meshRotation = textMesh.rotation.clone();
      textMesh.position.set(
        ...text.position
          .clone()
          .add(
            new THREE.Vector3(
              isFb ? (windowamount === 1 ? 8 : 3.5) : form !== 'i' ? -5 : 0,
              isFb ? -0.4 : -1,
              isFb ? 0 : -2 + length / -225,
            ),
          ),
      );
      textMesh.rotation.set(meshRotation.x, meshRotation.y, meshRotation.z);
      textMesh.scale.set(scale, scale, scale);
      overviewScene.add(textMesh);
      textsAdded.push(text.text);
      meshes.push(textMesh);
    });
    overviewRenderer.render(overviewScene, overviewCamera);
    const dataURL = overviewRenderer.domElement.toDataURL('image/png');

    meshes.forEach((mesh) => mesh.removeFromParent());
    return dataURL;
  };

  const getDimensions = () => {
    const right = Number(len1);
    const front = Number(form === 'i' ? 0 : len2);
    const left = Number(form !== 'u' ? 0 : len3);

    return { right, front, left };
  };

  // downloads the current configuration as PDF file
  const downloadConfigurationPdf = async () => {
    const { right, front, left } = getDimensions();

    const topViewSchematic = await Utility.addSizeTextToImage(
      await Utility.removeEmptyFrameFromImage(getTopViewSchematic()),
      {
        left: front ? `B: ${front}` : undefined,
        top: left ? `C: ${left}` : undefined,
        bottom: right ? `A: ${right}` : right,
      },
      { fontSize: 30, padding: 50 },
    );

    const overviewSchematic = await Utility.addSizeTextToImage(
      await Utility.removeEmptyFrameFromImage(await getOverviewSchematic()),
      {},
      { fontSize: 30, padding: 20 },
    );

    const tableData = configurationPdfTableData;
    const overview = overviewPdfTableData;

    const link = await getConfigUrl(100, 100, 'pdf');

    const translations = {
      'table-title': infotext.data[0].attributes.FreeData1.data[125],
      'thank-you': infotext.data[0].attributes.FreeData1.data[126],
      'enquiry-number': infotext.data[0].attributes.FreeData1.data[127],
      'schematic-title': infotext.data[0].attributes.FreeData1.data[128],
      'qr-code': infotext.data[0].attributes.FreeData1.data[129],
    };

    const pdf = await createPdfFromTemplate(
      <ConfigurationPdfTemplate
        schematicOverview={overviewSchematic}
        schematicTopView={topViewSchematic}
        tableData={tableData}
        overview={overview}
        link={link}
        translations={translations}
      />,
    );
    if (pdf)
      Utility.downloadFile(URL.createObjectURL(pdf), `configuration ${new Date(Date.now()).toLocaleDateString()}.pdf`);
  };

  const getConfigUrl = async (qrWidth, qrHeight, fileType) => {
    const [configId, configDisplayUrl] = window.location.origin.includes('localhost')
      ? ['DEVELOP', window.location.href + 'DEVELOP']
      : saveConfig();

    const configUrl =
      configDisplayUrl +
      (configDisplayUrl.includes('?') ? '&' : '?') +
      `utm_source=${fileType}&utm_medium=qr_code&utm_campaign=configurator&utm_content=${configId}`;

    return {
      configId,
      configUrl,
      configDisplayUrl,
      qrDisplayText: infotext.data[0].attributes.FreeData1.data[124],
      qrCode: await Utility.getQRCode(configUrl, qrWidth, qrHeight),
    };
  };

  // downloads the current schematic as PNG file
  const downloadCurrentSchematic = async (moveCamera = true) => {
    const schematic = moveCamera ? await getOverviewSchematic() : getCurrentView();
    const cut = await Utility.removeEmptyFrameFromImage(schematic);
    const padded = await Utility.addSizeTextToImage(cut, {}, { padding: 50, fontSize: 14 });

    if (selectstep < 7 && selectstep != 9) {
      Utility.downloadFile(padded, `schematic_${new Date(Date.now()).toLocaleDateString()}.png`);
      return;
    }

    const borderWidth = 12.5;

    const imgDimensions = await Utility.getImageDimensions(padded);
    const fontSize = Math.sqrt(imgDimensions.width ** 2 + imgDimensions.height ** 2) / 75;
    const qrSize = Math.max(fontSize * 4, 124);
    const { qrDisplayText, qrCode } = await getConfigUrl(qrSize, qrSize, 'schematic');

    const qrPaddedAndTexted = await Utility.addTextToImage(padded, {
      fontSize: fontSize,
      text: qrDisplayText,
      position: {
        x: imgDimensions.width - qrSize - borderWidth * 2 - 24,
        y: imgDimensions.height - borderWidth,
      },
      alignTextHorizontally: 'right',
      alignTextVertically: 'bottom',
    });

    const qrBorder = await Utility.addImageToOtherImage(
      qrPaddedAndTexted,
      '#EFEFEE',
      { bottom: -borderWidth, right: -borderWidth },
      qrSize + borderWidth * 2,
      qrSize + borderWidth * 2,
    );

    const qrAdded = await Utility.addImageToOtherImage(
      qrBorder,
      qrCode,
      { right: borderWidth, bottom: borderWidth },
      qrSize,
      qrSize,
    );
    const qrPadded = await Utility.addSizeTextToImage(
      qrAdded,
      {},
      { padding: { bottom: qrSize / 4, right: qrSize / 4 } },
    );
    if (selectstep === 9) {
      // Convert qrPadded to an HTMLImageElement
      const imgElement = await createImageElement(padded);

      // Pass the valid image element to imageToBlob
      const blob = await imageToBlob(imgElement);

      // Return Base64 Data URL for display
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    }
    if (selectstep != 9) {
      Utility.downloadFile(qrPadded, `schematic_${new Date(Date.now()).toLocaleDateString()}.png`);
    }
  };

  const createImageElement = async (src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => reject(new Error('Failed to load image from source.'));
      img.src = typeof src === 'string' ? src : URL.createObjectURL(src); // Base64 or Blob
    });
  };

  const displaySchematicStep9 = async () => {
    const imageSrc = await downloadCurrentSchematic(false);
    if (imageSrc) {
      const imgElement = document.getElementById('schematicImage'); // Ensure this ID exists in your HTML
      if (imgElement) {
        imgElement.src = imageSrc;
      } else {
        console.error('Image element with ID "schematicImage" not found.');
      }
    }
  };

  const imageToBlob = async (image) => {
    // Ensure the image is valid
    if (
      !(image instanceof HTMLImageElement) &&
      !(image instanceof HTMLCanvasElement) &&
      !(image instanceof OffscreenCanvas) &&
      !(image instanceof SVGImageElement)
    ) {
      throw new TypeError('Provided value is not a valid image-like object.');
    }

    // Create a canvas element
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    // Set canvas dimensions
    canvas.width = image.width;
    canvas.height = image.height;

    // Draw the image on the canvas
    ctx.drawImage(image, 0, 0);

    // Convert canvas content to a Blob
    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (blob) {
          resolve(blob);
        } else {
          reject(new Error('Failed to convert image to Blob.'));
        }
      });
    });
  };

  const arraysMapping = {
    'da-dk': LinkData.data.da_arr,
    'de-at': LinkData.data.de_arr,
    'de-ch': LinkData.data.de_arr,
    'de-de': LinkData.data.de_arr,
    en: LinkData.data.en_arr,
    'en-ca': LinkData.data.en_us_arr,
    'en-gb': LinkData.data.en_arr,
    'en-ie': LinkData.data.en_arr,
    'en-at': LinkData.data.en_arr,
    'en-us': LinkData.data.en_us_arr,
    es: LinkData.data.es_arr,
    'es-es': LinkData.data.es_arr,
    'es-us': LinkData.data.es_arr,
    'fi-fi': LinkData.data.fi_arr,
    'fr-be': LinkData.data.fr_arr,
    'fr-fr': LinkData.data.fr_arr,
    'fr-ca': LinkData.data.fr_arr,
    'fr-ch': LinkData.data.fr_arr,
    'fr-lu': LinkData.data.fr_arr,
    'it-ch': LinkData.data.it_arr,
    'it-it': LinkData.data.it_arr,
    'nb-no': LinkData.data.nb_arr,
    'nl-nl': LinkData.data.nl_arr,
    'nl-be': LinkData.data.nl_arr,
    'pl-pl': LinkData.data.pl_arr,
    'pt-br': LinkData.data.pt_arr,
    'pt-pt': LinkData.data.pt_arr,
    'sv-se': LinkData.data.sv_arr,
    'cs-cz': LinkData.data.en_arr,
    'sk-sk': LinkData.data.en_arr,
    'hu-hu': LinkData.data.en_arr,
    'sl-SI': LinkData.data.en_arr,
  };

  linky = arraysMapping[param.count];
  let finallink = linky[1];

  LinkData.data.Locales.forEach((item, index) => {
    let arry = [];
    if (item) {
      let splitlocale = [];
      if (item != 'es') {
        splitlocale = item.split('-');
      }

      arry = splitlocale[0] + '_arr';
      if (item == 'es') {
        arry = 'es_arr';
      }
      if (item == 'en-us') {
        arry = 'en_us_arr';
      }
      if (item == 'en-ca') {
        arry = 'en_us_arr';
      }

      if (item == 'x-default') {
        arry = 'en_arr';
      }
      let saveitem = item;
      if (item == 'x-default') {
        saveitem = 'x-default';
        item = 'en';
      }
      let actlink = LinkData.data[arry];
      try {
        savearr[index] = ['https://q-railing.com/' + item + actlink[numberss], saveitem];
      } catch (error) {}
    } else {
    }
  });

  useEffect(() => {
    if (showmenu) {
      if (document.querySelector('.articlelist') && window.innerWidth < 1024) {
        document.querySelector('.privatepublicclass-inner').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [showmenu]);

  const publictoken = process.env.REACT_APP_CONFIGURATOR_PUBLIC_KEY;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    loadactiveitem(selectstep);
    if (document.body.clientWidth < 536) {
      RespMoveBar();
    }

    if (
      gelaender != 'glass' &&
      gelaender != 'baseclamps' &&
      gelaender != 'frenchbalcony' &&
      gelaender != 'qline' &&
      selectstep > 4 &&
      handlaufmat != 'bevel' &&
      handlaufmat != 'straight'
    ) {
      sethandlaufmat('straight');
    }
    if (gelaender == 'glass' && selectstep > 4 && (handlaufmat == 'bevel' || handlaufmat == 'straight')) {
      sethandlaufmat('round');
    }
    if (gelaender == 'baseclamps' && selectstep > 4 && handlaufmat != 'none' && handlaufmat != 'edgep') {
      sethandlaufmat('edgep');
    }
    if (gelaender == 'frenchbalcony' && selectstep > 4 && fbsystem == 'Mod6507') {
      setcolorr('edelstahl');
    }
  }, [selectstep]);

  useEffect(() => {
    const queryString = window.location.search;

    if (queryString.match('ea')) {
      setgelaender('baluster');
      setTimeout(() => {
        orbitRef.current.setAzimuthalAngle(-1.5245);
      }, 1650);
      setTimeout(() => {
        orbitRef.current.setAzimuthalAngle(-1.5245);
      }, 50);
      if (queryString.match('ea2')) {
        setselectstep(2);
      }
    }

    if (queryString.match('ep')) {
      setgelaender('picket');
      setTimeout(() => {
        orbitRef.current.setAzimuthalAngle(-1.5245);
      }, 1150);
      setTimeout(() => {
        orbitRef.current.setAzimuthalAngle(-1.5245);
      }, 50);
      if (queryString.match('ep2')) {
        setselectstep(2);
      }
    }
    if (queryString.match('egs')) {
      setgelaender('glass');
      setwall1(true);
      setwall2(true);
      setTimeout(() => {
        orbitRef.current.setAzimuthalAngle(-2.8245);
      }, 750);
      if (queryString.match('egs2')) {
        setselectstep(2);
      }
    }
    if (queryString.match('ql')) {
      setgelaender('qline');
      setwall1(false);
      setwall2(false);
      sethandlaufmat('round');
      setcolorr('satin316');
      setTimeout(() => {
        orbitRef.current.setAzimuthalAngle(-2.8245);
      }, 1250);
      if (queryString.match('ql2')) {
        setselectstep(2);
      }
    }
    if (queryString.match('bc')) {
      setgelaender('baseclamps');
      setcolorr('brano');
      setTimeout(() => {
        orbitRef.current.setAzimuthalAngle(-1.5345);
      }, 950);
      if (queryString.match('bc2')) {
        setselectstep(2);
      }
    }
    if (queryString.match('fb')) {
      setgelaender('frenchbalcony');
      sethandlaufmat('edgep');
      setcolorr('brano');
      setTimeout(() => {
        orbitRef.current.setAzimuthalAngle(-2.8245);
      }, 1250);
      if (queryString.match('fb2')) {
        setselectstep(2);
      }
    }
    if (!queryString) {
      setTimeout(() => {
        orbitRef.current.setAzimuthalAngle(-1.5245);
      }, 1150);
      setTimeout(() => {
        orbitRef.current.setAzimuthalAngle(-1.5245);
      }, 50);
    }

    setinitload(1);
  }, [location]);

  useEffect(() => {
    setTimeout(() => {
      orbitRef.current.setAzimuthalAngle(-1.5245);
    }, 2250);
  }, [orbitRef]);

  useEffect(() => {
    const queryString = window.location.search;
    if (orbitRef.current) {
      if (queryString.match('ea')) {
        setgelaender('baluster');
      }

      if (queryString.match('ep')) {
        setgelaender('picket');
      }
      if (queryString.match('bc')) {
        setgelaender('baseclamps');
      }
      if (queryString.match('egs')) {
        setgelaender('glass');
        setwall1(true);
        setwall2(true);
        setTimeout(() => {
          orbitRef.current.setAzimuthalAngle(-2.8245);
        }, 750);
      } else if (queryString.match('fb')) {
        setTimeout(() => {
          orbitRef.current.setAzimuthalAngle(-2.8245);
        }, 1150);
      } else {
        setTimeout(() => {
          orbitRef.current.setAzimuthalAngle(-1.5245);
        }, 1150);
        setTimeout(() => {
          orbitRef.current.setAzimuthalAngle(-1.5245);
        }, 50);
      }
    }

    setinitload(1);
  }, [window.location.search]);
  useEffect(() => {
    fetchdata();
    if (document.body.clientWidth < 678) {
      setfovnbr(20);
    }
    if (document.body.clientWidth < 400) {
      setfovnbr(23);
    }
    if ((para.count == 'en-us' || para.count == 'es-us') && windowwidth == 1900) {
      setFbcustomglaswidth(72.8 + 3.94);
    }
  }, []);

  useEffect(() => {
    if (((len1 > 2700 && len1 < 4500) || (len2 > 2700 && len2 < 4500) || (len3 > 2700 && len3 < 4500)) && countt < 2) {
      orbitRef.current.object.rotation.fromArray([Math.PI / 15, 0, 0]);
      orbitRef.current.autoRotate = true;
      orbitRef.current.zoom = 0.1;
      orbitRef.current.zomm0 = 0.1;
      orbitRef.current.autoRotateSpeed = 13;
      setTimeout(() => {
        orbitRef.current.autoRotate = false;
      }, 600);
      setcountt((countt = countt + 1));
    }
    if (len1 > 4500 || len2 > 4500 || len3 > 4500) {
      //orbitRef.current.object.fov = 27
      //cammy.current.fov = 27
    }
    if (len1 > 6500 || len2 > 6500 || len3 > 6500) {
      camval = 15;
    }
  }, [len1, len2, len3]);

  useEffect(() => {
    if (form != 'i' && countt2 < 1) {
      orbitRef.current.object.rotation.fromArray([Math.PI / 15, 0, 0]);
      orbitRef.current.autoRotate = true;
      orbitRef.current.zoom = 0.1;
      orbitRef.current.zomm0 = 0.1;
      orbitRef.current.autoRotateSpeed = 15;

      if (document.body.clientWidth > 860) {
        orbitRef.current.object.fov = 17;
        cammy.current.fov = 17;
      }

      if (countt2 == 0) {
        setTimeout(() => {
          orbitRef.current.autoRotate = false;
        }, 580);
      }

      //CameraRef.current.camera = { position: [-75, 35, 12], fov: 62 }
      setcountt2((countt2 = countt2 + 1));
    }
  }, [form]);
  function setcamy(propsy, init) {
    if (propsy == 1 && init == 1) {
      if (orbitRef != null) {
        if (!wall1 || !wall2) {
          setwall1(true);
          setwall2(true);
          setcolorr('gray');
          settriggerforglass(true);
        }

        setTimeout(() => {
          orbitRef.current.setAzimuthalAngle(-2.9245);
        }, 150);
      }
    }
    if (propsy == 1 && init == 1 && initloadbool === 0) {
      if (orbitRef != null) {
        if (!wall1 || !wall2) {
          setwall1(true);
          setwall2(true);
          setcolorr('gray');
          settriggerforglass(true);
          sethandlaufmat('round');
        }

        setTimeout(() => {
          orbitRef.current.setAzimuthalAngle(-2.9245);
        }, 750);
      }
    }
    if (propsy == 2 && init == 1) {
      setcolorr('anrtz');
      if (triggerforglass) {
        setwall1(false);
        setwall2(false);
        settriggerforglass(false);
      }
      if (orbitRef != null) {
        setTimeout(() => {
          orbitRef.current.setAzimuthalAngle(-1.5245);
        }, 150);
      }
    }

    if (propsy == 3 && init == 1) {
      if (orbitRef != null) {
        setTimeout(() => {
          orbitRef.current.setAzimuthalAngle(1.43245);
        }, 150);
      }
    }
    setinitloadbool(1);
  }
  const [CustSlug, setCustSlug] = useState('qrailing');
  useState(() => {
    if (para.count == 'en-us' || para.count == 'es-us') {
      setglassthicknessbaseclamps('11/16"');
      setwindowwidth(72.8);
    }

    const queryParams = new URLSearchParams(window.location.search);
    const custSlug = queryParams.get('cust');
    if (custSlug) {
      const customermapping = {
        'qrailing/': 'Q-railing',
        'meier/': 'Meier',
        'rvs/': 'Rvs',
        'rvs-land/': 'rvs-land',
        'rubelo/': 'rubelo',
        'hekwerkshop/': 'hekwerkshop',
        'wholesaleglass/': 'wholesaleglass',
        'storax/': 'storax',
        'glasmaatje/': 'glasmaatje',
        'glassinside/': 'glassinside',
        'aluleaf/': 'aluleaf',
        'glas123/': 'glas123',
      };

      setCustSlug(customermapping[custSlug] || 'Q-railing');
    }
  }, []);

  useEffect(() => {
    // Only send when the configurator is actually embedded in an iframe
    if (window.parent === window) return;

    const sideAMm = parseInt(len1);
    const sideBMm = form === 'i' ? 0 : parseInt(len2);
    const sideCMm = form === 'u' ? parseInt(len3) : 0;

    let totalMm = sideAMm;

    if (form === 'l') {
      totalMm = sideAMm + sideBMm;
    }

    if (form === 'u') {
      totalMm = sideAMm + sideBMm + sideCMm;
    }

    // Determine the currently configured railing system
    let system = 'Easy Alu';

    if (gelaender === 'glass') {
      system = 'Easy Glass Smart';
    }

    if (gelaender === 'picket') {
      system = 'Easy Alu Picket';
    }

    if (gelaender === 'baluster') {
      system = 'Easy Alu';
    }

    if (gelaender === 'baseclamps') {
      system = baseclampsubsystem === '60' ? 'MOD 6000' : 'MOD 6400';
    }

    if (gelaender === 'frenchbalcony') {
      system = fbsystem === 'Mod6507' ? 'MOD 6507' : 'Easy Glass View';
    }

    if (gelaender === 'qline') {
      system = PostShape === 'round' ? 'Q-line' : 'Square Line';
    }

    const message = {
      source: 'q-railing-configurator',
      version: 0.71,
      event: 'konfigurator_meter_changed',
      description: 'The configured railing length or railing system has changed.',

      system,
      systemKey: gelaender,

      form,

      // Combined length
      meters: totalMm / 1000,
      millimeters: totalMm,

      // Individual sides
      sides: {
        a: {
          meters: sideAMm / 1000,
          millimeters: sideAMm,
        },
        b: {
          meters: sideBMm / 1000,
          millimeters: sideBMm,
        },
        c: {
          meters: sideCMm / 1000,
          millimeters: sideCMm,
        },
      },
    };

    console.info('[Q-railing Configurator] Posting configuration to parent:', message);

    window.parent.postMessage(message, '*');
  }, [CustSlug, form, len1, len2, len3, gelaender, baseclampsubsystem, fbsystem, PostShape]);
  useEffect(() => {
    if (CustSlug) {
      if (CustSlug === 'Rvs') {
        if (document.querySelector('.forbtn')) {
          document.querySelector('.forbtn').style = 'background-color: #224ea7 !important';
        }
      }
      if (CustSlug === 'rvs-land') {
        if (document.querySelector('.forbtn')) {
          document.querySelector('.forbtn').style = 'background-color: #009FE7 !important';
        }
      }
      if (CustSlug === 'wholesaleglass') {
        if (document.querySelector('.forbtn')) {
          document.querySelector('.forbtn').style = 'background-color: #191852 !important';
        }
      }
      if (CustSlug === 'rubelo') {
        if (document.querySelector('.forbtn')) {
          document.querySelector('.forbtn').style = 'background-color: #d22c32 !important';
        }
      }
      if (CustSlug === 'storax') {
        if (document.querySelector('.forbtn')) {
          document.querySelector('.forbtn').style = 'background-color: #009ee2 !important';
        }
      }

      if (CustSlug === 'hekwerkshop') {
        if (document.querySelector('.forbtn')) {
          document.querySelector('.forbtn').style = 'background-color: #327c78 !important';
        }
      }

      if (CustSlug === 'aluleaf') {
        if (document.querySelector('.forbtn')) {
          document.querySelector('.forbtn').style = 'background-color: #728960 !important';
        }
      }
      if (CustSlug === 'glasmaatje') {
        if (document.querySelector('.forbtn')) {
          document.querySelector('.forbtn').style = 'background-color: #408D9E !important';
        }
      }
      if (CustSlug === 'glassinside') {
        if (document.querySelector('.forbtn')) {
          document.querySelector('.forbtn').style = 'background-color: #0093b2 !important';
        }
      }
      if (CustSlug === 'glas123') {
        if (document.querySelector('.forbtn')) {
          document.querySelector('.forbtn').style = 'background-color: #F19234 !important';
        }
      }
    }
  }, [CustSlug, selectstep]);

  async function fetchdata() {
    let token = process.env.REACT_APP_PUBLIC_KEY2;
    const requestOptions2 = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    };
    let la;
    let arrla;
    let arrla1 = '';
    if (param.count) {
      la = param.count;
      arrla = la.split('-');
      if (param.count == 'en') {
        arrla = ['en', 'INTERNATIONAL'];
      }
      if (param.count == 'es') {
        arrla = ['es', 'INTERNATIONAL'];
      }
      if (arrla[1]) {
        arrla[1] = arrla[1].toUpperCase();
        arrla1 = arrla[0] + '-' + arrla[1];
        if (arrla[1] == 'INTERNATIONAL') {
          arrla1 = arrla[0];
        }
      }
    } else {
      arrla1 = 'en';
    }

    if (
      arrla1 == 'de-DE' ||
      arrla1 == 'nl-NL' ||
      arrla1 == 'fr-LU' ||
      arrla1 == 'en-GB' ||
      arrla1 == 'en-IE' ||
      arrla1 == 'es-ES' ||
      arrla1 == 'it-IT' ||
      arrla1 == 'de-AT' ||
      arrla1 == 'de-CH' ||
      arrla1 == 'fr-CH' ||
      arrla1 == 'it-CH' ||
      arrla1 == 'fr-FR' ||
      arrla1 == 'nl-BE' ||
      arrla1 == 'fr-BE' ||
      arrla1 == 'da-DK' ||
      arrla1 == 'nb-NO' ||
      arrla1 == 'sv-SE' ||
      arrla1 == 'fi-FI' ||
      arrla1 == 'pt-PT' ||
      arrla1 == 'pl-PL' ||
      arrla1 == 'en-US' ||
      arrla1 == 'es-US' ||
      arrla1 == 'pt-BR' ||
      arrla1 == 'en-CA' ||
      arrla1 == 'fr-CA' ||
      arrla1 == 'tr-TR'
    ) {
      fetch(
        'https://strapi-qrailing.azurewebsites.net/api/components?locale=' +
          arrla1 +
          '&filters[Slug][$eq]=Configuratortext',
        requestOptions2,
      )
        .then((res) => res.json())
        .then((json) => {
          setinfotext(json);
        })
        .then(() => returnsteps());
    } else {
      fetch(
        'https://strapi-qrailing.azurewebsites.net/api/components?locale=' +
          arrla1 +
          '&filters[Slug][$eq]=Configuratortext',
        requestOptions2,
      )
        .then((res) => res.json())
        .then((json) => setinfotext(json))
        .then(() => returnsteps());
    }
  }

  function activeitem(ref, step, substep) {
    if (step == 'step1') {
      const baluster1ClassList = baluster1.current.classList;
      const glass1ClassList = glass1.current.classList;
      const picket1ClassList = picket1.current.classList;
      if (ref === baluster1) {
        if (picket1ClassList.contains('activeitem')) {
          picket1ClassList.remove('activeitem');
        }
        if (glass1ClassList.contains('activeitem')) {
          glass1ClassList.remove('activeitem');
        }
        baluster1ClassList.add('activeitem');
      }

      if (ref === picket1) {
        if (baluster1ClassList.contains('activeitem')) {
          baluster1ClassList.remove('activeitem');
        }
        if (glass1ClassList.contains('activeitem')) {
          glass1ClassList.remove('activeitem');
        }
        picket1ClassList.add('activeitem');
      }

      if (ref === glass1) {
        if (baluster1ClassList.contains('activeitem')) {
          baluster1ClassList.remove('activeitem');
        }
        if (picket1ClassList.contains('activeitem')) {
          picket1ClassList.remove('activeitem');
        }
        glass1ClassList.add('activeitem');
      }
    }
  }
  function loadactiveitem(step) {
    if (step == 1) {
      if (gelaender == 'baluster') {
        activeitem(baluster1, 'step1', 1);
      }
      if (gelaender == 'glass') {
        activeitem(glass1, 'step1', 1);
      }
      if (gelaender == 'picket') {
        activeitem(picket1, 'step1', 1);
      }
    }
    if (step == 2) {
      if (form == 'i') {
        activeitem(ishape2, 'step2', 1);
      }
      if (form == 'l') {
        activeitem(lshape2, 'step2', 1);
      }
      if (form == 'u') {
        activeitem(ushape2, 'step2', 1);
      }
    }
    if (step == 3) {
      if (hohe == 900) {
        activeitem(height1, 'step3', 1);
      }
      if (hohe == 1000) {
        activeitem(height2, 'step3', 1);
      }
      if (hohe == 1100) {
        activeitem(height3, 'step3', 1);
      }

      if (montageart == 'top') {
        activeitem(topmountref, 'step3', 2);
      }
      if (montageart == 'side') {
        activeitem(faciamountref, 'step3', 2);
      }
    }
    if (step == 4) {
      if (untergrundd == 'beton') {
        activeitem(unterg1, 'step4', 1);
      }
      if (untergrundd == 'holz') {
        activeitem(unterg2, 'step4', 1);
      }
      if (untergrundd == 'metall') {
        activeitem(unterg3, 'step4', 1);
      }

      if (wall1) {
        activeitem(wall1s, 'step4', 2);
      }
      if (!wall1) {
        activeitem(free1, 'step4', 2);
      }
      if (wall2) {
        activeitem(wall2s, 'step4', 3);
      }
      if (!wall2) {
        activeitem(free2, 'step4', 3);
      }
    }
    if (step == 5) {
      if (handlaufmat == 'bevel') {
        activeitem(handlauf1, 'step5', 1);
      }
      if (handlaufmat == 'straight') {
        activeitem(handlauf2, 'step5', 1);
      }
      if (colorr == 'gray') {
        activeitem(colorr1, 'step5', 2);
      }
      if (colorr == 'anrtz') {
        activeitem(colorr2, 'step5', 2);
      }
      if (colorr == 'black') {
        activeitem(colorr3, 'step5', 2);
      }
    }
  }
  function saveConfig() {
    /* if (savecode && savecode.trim().length > 0) {
      console.log('FAIL');
      return [savecode, finalurl];
    }*/
    let reqbody;
    let savestring = '';
    const characterss = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const characterssLength = characterss.length;
    let nav = document.referrer;
    let date = new Date();
    let version = navigator.appVersion.toString();
    let year = date.getFullYear();
    let month = date.getMonth();
    let day = date.getDate();
    let hrs = date.getHours();
    let min = date.getMinutes();
    let sec = date.getSeconds();

    let time = 'CONFIG:' + year + '/' + month + '/' + day + ' - ' + hrs + ':' + min;

    let lang = navigator.language;
    let browser = navigator.appName;

    nav = nav.toString();

    lang = lang.toString();
    browser = browser.toString();

    for (let i = 0; i < 8; i++) {
      let nbr = Math.floor(Math.random() * 26);
      savestring = savestring + characterss[nbr];
    }
    Math.floor(Math.random() * characterssLength);
    setsavecode(savestring);

    let rnurl = window.location.href;

    if (rnurl.match(/\/\/[A-Z][A-Z][A-Z][A-Z][A-Z][A-Z][A-Z][A-Z]/)) {
      rnurl = rnurl.replace(/\/\/[A-Z][A-Z][A-Z][A-Z][A-Z][A-Z][A-Z][A-Z]/, '/');
    }
    if (rnurl.match(/\?ea2/)) {
      rnurl = rnurl.replace(/\?ea2/, '');
    }
    if (rnurl.match(/\?egs2/)) {
      rnurl = rnurl.replace(/\?egs2/, '');
    }
    if (rnurl.match(/\?ep2/)) {
      rnurl = rnurl.replace(/\?ep2/, '');
    }
    if (rnurl.match(/\?bc2/)) {
      rnurl = rnurl.replace(/\?bc2/, '');
    }
    if (rnurl.match(/\?fb2/)) {
      rnurl = rnurl.replace(/\?fb2/, '');
    }
    if (rnurl.match(/\?ql2/)) {
      rnurl = rnurl.replace(/\?ql2/, '');
    }

    if (rnurl.match(/\?ea/)) {
      rnurl = rnurl.replace(/\?ea/, '');
    }
    if (rnurl.match(/\?egs/)) {
      rnurl = rnurl.replace(/\?egs/, '');
    }
    if (rnurl.match(/\?ep/)) {
      rnurl = rnurl.replace(/\?ep/, '');
    }
    if (rnurl.match(/\?bc/)) {
      rnurl = rnurl.replace(/\?bc/, '');
    }
    if (rnurl.match(/\?fb/)) {
      rnurl = rnurl.replace(/\?fb/, '');
    }
    if (rnurl.match(/\?ql/)) {
      rnurl = rnurl.replace(/\?ql/, '');
    }

    const finalUrlTemp = 'https://q-railing.com/' + para.count + finallink + savestring;
    setfinalurl(finalUrlTemp);

    let wally = 'free1';
    let wally2 = 'free2';
    let cutto = 'CutToSize-Yes';
    let include = 'IncludeGlass-Yes';

    if (!cuttosize) {
      cutto = 'CutToSize-No';
    }
    if (!includeglass) {
      include = 'IncludeGlass-No';
    }
    if (wall1) {
      wally = 'wall1';
    }
    if (wall2) {
      wally2 = 'wall2';
    }
    let savecolor = colorr;
    if (ralcolor != '' && ralcolor.length == 4 && ralcolorbool) {
      savecolor = ralcolor;
    }
    if (fbsystem == 'Mod6507' && gelaender == 'frenchbalcony') {
      savecolor = translationEdelstahl[para.count];
    }
    let Taphandrailstring = 'TapHandrail-No';
    let Tappostsstring = 'TapPosts-No';

    if (TapHandrail) {
      Taphandrailstring = 'TapHandrail-Yes';
    }
    if (TapPosts) {
      Tappostsstring = 'TapPosts-Yes';
    }

    let speicher = '' + len1 + '::' + len2 + '::' + len3 + '::';
    let vals =
      hohe +
      '::' +
      gelaender +
      '::' +
      form +
      '::' +
      handlaufmat +
      '::' +
      montageart +
      '::' +
      untergrundd +
      '::' +
      savecolor +
      '::' +
      len1.toString() +
      '::' +
      len2.toString() +
      '::' +
      len3.toString() +
      '::' +
      wally +
      '::' +
      wally2 +
      '::' +
      cutto +
      '::' +
      include +
      '::' +
      glassthicknessbaseclamps +
      '::' +
      glaspanelwidthi +
      '::' +
      glaspanelwidthl +
      '::' +
      glaspanelwidthu +
      '::' +
      baseclampsubsystem +
      '::' +
      fbsystem +
      '::' +
      windowwidth +
      '::' +
      bodentief +
      '::' +
      fenstermontage +
      '::' +
      Fbcustomglaswidth +
      '::' +
      PostShape +
      '::' +
      ClampShape +
      '::' +
      qlineinfill +
      '::' +
      Pfostenrund +
      '::' +
      QlineHandlauf +
      '::' +
      Taphandrailstring +
      '::' +
      Tappostsstring;
    vals = vals.toString();

    let userId = 'Q-railing';
    if (CustSlug === 'Rvs') {
      userId = 'Rvs';
    }
    if (CustSlug === 'rvs-land') {
      userId = 'rvs-land';
    }
    if (CustSlug === 'wholesaleglass') {
      userId = 'wholesaleglass';
    }
    if (CustSlug === 'rubelo') {
      userId = 'rubelo';
    }
    if (CustSlug === 'storax') {
      userId = 'storax';
    }
    if (CustSlug === 'hekwerkshop') {
      userId = 'hekwerkshop';
    }
    if (CustSlug === 'aluleaf') {
      userId = 'aluleaf';
    }
    if (CustSlug === 'glasmaatje') {
      userId = 'glasmaatje';
    }
    if (CustSlug === 'glassinside') {
      userId = 'glassinside';
    }
    if (CustSlug === 'glas123') {
      userId = 'glas123';
    }

    reqbody = JSON.stringify({
      data: {
        Slug: savestring,
        ConfiguratorData: vals,
        DateTime: time,
        Title: 'Configuration',
        Link: para.count,
        UserId: userId,
      },
    });

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: reqbody,
    };

    fetch('https://strapi-qrailing.azurewebsites.net/api/configurations', requestOptions)
      .then((response) => response.json())
      .then(setTimeout(() => {}, 2000))
      .then((data) => this.setState({ postId: data.id }));

    return [savestring, finalUrlTemp];
  }

  useEffect(() => {
    if (PrivateData) {
      setmailtoLink(
        `mailto:?subject=${encodeURIComponent(infotext.data[0].attributes.FreeData1.data[188])}&cc=${encodeURIComponent('digital@q-railing.com')}&body=${encodeURIComponent(`\n\n${infotext.data[0].attributes.FreeData1.data[229]}\n\n${infotext.data[0].attributes.FreeData1.data[230]}\n\n${infotext.data[0].attributes.FreeData1.data[232]}:${baseurl + '/' + para.count + finallink + savecode}\n\n${infotext.data[0].attributes.FreeData1.data[233]}\n\n${infotext.data[0].attributes.FreeData1.data[234]}\n\n${PrivateData.fname} ${PrivateData.lname}\n${PrivateData.street}\n${PrivateData.city}${PrivateData.postcode}\n${PrivateData.phone}\n${PrivateData.email}\n\n${infotext.data[0].attributes.FreeData1.data[189]}\n${PrivateData.fname} ${PrivateData.lname}`)}`,
      );
    }
  }, [PrivateData]);
  const [PrivateDataAvailable, setPrivateDataAvailable] = useState(false);
  const [nothingbelow, setnothingbelow] = useState(true);
  function checkprivateactive() {
    let checksum = 0;
    if (document.getElementById('ConfigRequestLastNameP')) {
      if (document.getElementById('ConfigRequestLastNameP').value != '') {
        checksum = checksum + 1;
      }
    }
    if (document.getElementById('ConfigRequestFirstNameP')) {
      if (document.getElementById('ConfigRequestFirstNameP').value != '') {
        checksum = checksum + 1;
      }
    }

    if (document.getElementById('ConfigRequestPhoneP')) {
      if (document.getElementById('ConfigRequestPhoneP').value != '') {
        checksum = checksum + 1;
      }
    }
    if (document.getElementById('ConfigRequestStreetP')) {
      if (document.getElementById('ConfigRequestStreetP').value != '') {
        checksum = checksum + 1;
      }
    }
    if (document.getElementById('ConfigRequestSalutationP')) {
      if (document.getElementById('ConfigRequestSalutationP').value != '') {
        checksum = checksum + 1;
      }
    }
    if (document.getElementById('ConfigRequestCityP')) {
      if (document.getElementById('ConfigRequestCityP').value != '') {
        checksum = checksum + 1;
      }
    }
    if (document.querySelector('.ConfigRequestPostCodeP')) {
      if (document.querySelector('.ConfigRequestPostCodeP').value != '') {
        checksum = checksum + 1;
      }
    }
    if (document.getElementById('ConfigRequestEmail')) {
      if (document.getElementById('ConfigRequestEmail').value != '') {
        checksum = checksum + 1;
      }
    }
    //8 is correct
    if (checksum >= 8) {
      setPrivateDataAvailable(true);
    } else {
      setPrivateDataAvailable(false);
    }
  }

  function RequestQuote() {
    let reqbody;
    let savestring = '';
    let mail;
    let custcode;
    let text;
    let maildiv;
    let custcodediv;
    let textdiv;

    let fname;
    let lname;
    let phonenbr;
    let salutation;
    let street;
    let city;
    let country;
    let company;
    let industrygroup;
    let vat;
    let postcode;

    let fnamediv;
    let lnamediv;
    let phonenbrdiv;
    let salutationdiv;
    let streetdiv;
    let citydiv;
    let countrydiv;
    let companydiv;
    let industrygroupdiv;
    let vatdiv;
    let postcodediv;
    let taphandrail = 'No';
    let tapposts = 'No';
    let housenbr = '';
    let iframecustomertype = 'Private';

    if (business && alreadycust == 1) {
      mail = document.getElementById('ConfigRequestEmailB').value;
      custcode = document.getElementById('ConfigRequestIdB').value;
      text = document.getElementById('ConfigRequestTextB').value;
      maildiv = document.getElementById('ConfigRequestEmailB');
      textdiv = document.getElementById('ConfigRequestTextB');
      custcodediv = document.getElementById('ConfigRequestIdB');

      custcodediv.style = 'border: 0px solid maroon !important';
      textdiv.style = 'border: 0px solid maroon !important';
      maildiv.style = 'border: 0px solid maroon !important';
    }
    if (!business) {
      mail = document.getElementById('ConfigRequestEmail').value;
      custcode = document.getElementById('ConfigRequestId').value;
      text = document.getElementById('ConfigRequestText').value;
      lname = document.getElementById('ConfigRequestLastNameP').value;
      fname = document.getElementById('ConfigRequestFirstNameP').value;
      phonenbr = document.getElementById('ConfigRequestPhoneP').value;
      street = document.getElementById('ConfigRequestStreetP').value;
      salutation = document.getElementById('ConfigRequestSalutationP').value;
      city = document.getElementById('ConfigRequestCityP').value;
      postcode = document.querySelector('.ConfigRequestPostCodeP').value;
      iframecustomertype = document.getElementById('ConfigRequestCustomerTypeAddP').value;
      //NEW
      lnamediv = document.getElementById('ConfigRequestLastNameP');
      phonenbrdiv = document.getElementById('ConfigRequestPhoneP');
      streetdiv = document.getElementById('ConfigRequestStreetP');
      salutationdiv = document.getElementById('ConfigRequestSalutationP');
      citydiv = document.getElementById('ConfigRequestCityP');
      postcodediv = document.querySelector('.ConfigRequestPostCodeP');

      //
      maildiv = document.getElementById('ConfigRequestEmail');
      textdiv = document.getElementById('ConfigRequestText');
      custcodediv = document.getElementById('ConfigRequestId');
      //NEW
      lnamediv.style = 'border: 0px solid maroon !important';
      phonenbrdiv.style = 'border: 0px solid maroon !important';
      streetdiv.style = 'border: 0px solid maroon !important';
      salutationdiv.style = 'border: 0px solid maroon !important';
      citydiv.style = 'border: 0px solid maroon !important';

      postcodediv.style = 'border: 0px solid maroon !important';
      //
      custcodediv.style = 'border: 0px solid maroon !important';
      textdiv.style = 'border: 0px solid maroon !important';
      maildiv.style = 'border: 0px solid maroon !important';

      if (document.querySelector('#ConfigRequestStreetNbrP')) {
        housenbr = document.querySelector('#ConfigRequestStreetNbrP').value;
      }

      if (!business) {
        setPrivateData({
          street: street + ' ' + housenbr,
          city: city,
          postcode: postcode,
          mail: mail,
          text: text,
          fname: fname,
          lname: lname,
          phone: phonenbr,
          salutation: salutation,
        });
      }
    }

    if (business && alreadycust == 2) {
      mail = document.getElementById('ConfigRequestEmailB').value;
      text = document.getElementById('ConfigRequestTextB').value;

      fname = document.getElementById('ConfigRequestFirstNameB').value;
      lname = document.getElementById('ConfigRequestLastNameB').value;
      phonenbr = document.getElementById('ConfigRequestPhoneB').value;
      street = document.getElementById('ConfigRequestStreetB').value;
      salutation = document.getElementById('ConfigRequestSalutationB').value;
      city = document.getElementById('ConfigRequestCityB').value;
      country = document.getElementById('ConfigRequestCountryB').value;
      industrygroup = document.getElementById('ConfigRequestIndustryGroupB').value;
      vat = document.getElementById('ConfigRequestVatB').value;
      postcode = document.getElementById('ConfigRequestPostCodeB').value;
      company = document.getElementById('ConfigRequestCompanyB').value;

      fnamediv = document.getElementById('ConfigRequestFirstNameB');
      lnamediv = document.getElementById('ConfigRequestLastNameB');
      phonenbrdiv = document.getElementById('ConfigRequestPhoneB');
      streetdiv = document.getElementById('ConfigRequestStreetB');
      salutationdiv = document.getElementById('ConfigRequestSalutationB');
      citydiv = document.getElementById('ConfigRequestCityB');
      countrydiv = document.getElementById('ConfigRequestCountryB');
      industrygroupdiv = document.getElementById('ConfigRequestIndustryGroupB');
      vatdiv = document.getElementById('ConfigRequestVatB');
      postcodediv = document.getElementById('ConfigRequestPostCodeB');
      companydiv = document.getElementById('ConfigRequestCompanyB');

      maildiv = document.getElementById('ConfigRequestEmailB');
      textdiv = document.getElementById('ConfigRequestTextB');

      fnamediv.style = 'border: 0px solid maroon !important';
      lnamediv.style = 'border: 0px solid maroon !important';
      phonenbrdiv.style = 'border: 0px solid maroon !important';
      streetdiv.style = 'border: 0px solid maroon !important';
      salutationdiv.style = 'border: 0px solid maroon !important';
      citydiv.style = 'border: 0px solid maroon !important';
      countrydiv.style = 'border: 0px solid maroon !important';
      industrygroupdiv.style = 'border: 0px solid maroon !important';
      vatdiv.style = 'border: 0px solid maroon !important';
      postcodediv.style = 'border: 0px solid maroon !important';
      companydiv.style = 'border: 0px solid maroon !important';

      maildiv.style = 'border: 0px solid maroon !important';
      textdiv.style = 'border: 0px solid maroon !important';
    }

    if (!mail) {
      maildiv.style = 'border: 1px solid maroon !important';
      return;
    }
    if (!mail.match('@')) {
      maildiv.style = 'border: 1px solid maroon !important';
      return;
    }
    if (!mail.match('.')) {
      maildiv.style = 'border: 1px solid maroon !important';
      return;
    }
    if (!custcode && alreadycust == 1) {
      custcodediv.style = 'border: 1px solid maroon !important';
      return;
    }

    if (business && alreadycust == 1) {
      if (!custcode.match('-')) {
        custcodediv.style = 'border: 1px solid maroon !important';
        return;
      }
      if (!custcode.match(/\d\d-\d\d\d\d\d\d/)) {
        custcodediv.style = 'border: 1px solid maroon !important';
        return;
      }
    }

    if (business && alreadycust == 2) {
      if (!fname) {
        fnamediv.style = 'border: 1px solid maroon !important';
        return;
      }
      if (!lname) {
        lnamediv.style = 'border: 1px solid maroon !important';
        return;
      }
      if (!company) {
        companydiv.style = 'border: 1px solid maroon !important';
        return;
      }
      if (!phonenbr) {
        phonenbrdiv.style = 'border: 1px solid maroon !important';
        return;
      }
      if (!street) {
        streetdiv.style = 'border: 1px solid maroon !important';
        return;
      }
      if (!salutation) {
        salutationdiv.style = 'border: 1px solid maroon !important';
        return;
      }
      if (!city) {
        citydiv.style = 'border: 1px solid maroon !important';
        return;
      }
      if (!country) {
        country.style = 'border: 1px solid maroon !important';
        return;
      }
      if (!industrygroup) {
        industrygroupdiv.style = 'border: 1px solid maroon !important';
        return;
      }
      if (!postcode) {
        postcodediv.style = 'border: 1px solid maroon !important';
        return;
      }
      if (
        para.count == 'it-it' ||
        para.count == 'fr-lu' ||
        para.count == 'nl-nl' ||
        para.count == 'da-dk' ||
        para.count == 'fi-fi' ||
        para.count == 'pl-pl' ||
        para.count == 'en-gb' ||
        para.count == 'pl-pl' ||
        para.count == 'en-ie'
      ) {
        if (!vat) {
          vatdiv.style = 'border: 1px solid maroon !important';
          return;
        }
      }

      if (
        (param.count == 'da-dk' ||
          param.count == 'fi-fi' ||
          param.count == 'it-it' ||
          param.count == 'pl-pl' ||
          param.count == 'sv-se') &&
        vat
      ) {
        if (vat.length < 7 || vat.length > 12) {
          //!vat.match(/^\d+$/) && !vat.match(/^[a-zA-Z]{2}\d+$/) before

          vatdiv.style = 'border: 1px solid maroon !important';
          return;
        }
        if (!vat.match(/^[a-zA-Z0-9-]+$/)) {
          vatdiv.style = 'border: 1px solid maroon !important';
          return;
        }
      }
    }

    //NEW
    if (!business) {
      if (!street) {
        streetdiv.style = 'border: 1px solid maroon !important';
        return;
      }
      if (!salutation) {
        salutationdiv.style = 'border: 1px solid maroon !important';
        return;
      }
      if (!phonenbr) {
        phonenbrdiv.style = 'border: 1px solid maroon !important';
        return;
      }
      if (!lname) {
        lnamediv.style = 'border: 1px solid maroon !important';
        return;
      }
      if (!city) {
        citydiv.style = 'border: 1px solid maroon !important';
        return;
      }
      if (!postcode) {
        postcodediv.style = 'border: 1px solid maroon !important';
        return;
      }
    }

    const arraysMapping2 = {
      'da-dk': LinkData.data.da_arr,
      'de-at': LinkData.data.de_arr,
      'de-ch': LinkData.data.de_arr,
      'de-de': LinkData.data.de_arr,
      en: LinkData.data.en_arr,
      'en-ca': LinkData.data.en_us_arr,
      'en-gb': LinkData.data.en_arr,
      'en-ie': LinkData.data.en_arr,
      'en-at': LinkData.data.en_arr,
      'en-us': LinkData.data.en_us_arr,
      es: LinkData.data.es_arr,
      'es-es': LinkData.data.es_arr,
      'es-us': LinkData.data.es_arr,
      'fi-fi': LinkData.data.fi_arr,
      'fr-be': LinkData.data.fr_arr,
      'fr-fr': LinkData.data.fr_arr,
      'fr-ca': LinkData.data.fr_arr,
      'fr-ch': LinkData.data.fr_arr,
      'fr-lu': LinkData.data.fr_arr,
      'it-ch': LinkData.data.it_arr,
      'it-it': LinkData.data.it_arr,
      'nb-no': LinkData.data.nb_arr,
      'nl-nl': LinkData.data.nl_arr,
      'nl-be': LinkData.data.nl_arr,
      'pl-pl': LinkData.data.pl_arr,
      'pt-br': LinkData.data.pt_arr,
      'pt-pt': LinkData.data.pt_arr,
      'sv-se': LinkData.data.sv_arr,
      'cs-cz': LinkData.data.en_arr,
      'sk-sk': LinkData.data.en_arr,
      'hu-hu': LinkData.data.en_arr,
      'sl-SI': LinkData.data.en_arr,
    };

    let linky2 = arraysMapping2[param.count];
    let finallink2 = linky2[1];

    let wally = 'free1';
    let wally2 = 'free2';

    let cutto = 'CutToSize-Yes';
    let include = 'IncludeGlass-Yes';

    if (!cuttosize) {
      cutto = 'CutToSize-No';
    }
    if (!includeglass) {
      include = 'IncludeGlass-No';
    }
    if (wall1) {
      wally = 'wall1';
    }
    if (wall2) {
      wally2 = 'wall2';
    }
    let savecolor = colorr;
    if (ralcolor != '' && ralcolorbool && ralcolor.length == 4) {
      savecolor = ralcolor;
    }
    if (fbsystem == 'Mod6507' && gelaender == 'frenchbalcony') {
      savecolor = translationEdelstahl[para.count];
    }
    let Taphandrailstring = 'TapHandrail-No';
    let Tappostsstring = 'TapPosts-No';

    if (TapHandrail) {
      Taphandrailstring = 'TapHandrail-Yes';
    }
    if (TapPosts) {
      Tappostsstring = 'TapPosts-Yes';
    }

    let vals =
      hohe +
      '::' +
      gelaender +
      '::' +
      form +
      '::' +
      handlaufmat +
      '::' +
      montageart +
      '::' +
      untergrundd +
      '::' +
      savecolor +
      '::' +
      len1.toString() +
      '::' +
      len2.toString() +
      '::' +
      len3.toString() +
      '::' +
      wally +
      '::' +
      wally2 +
      '::' +
      cutto +
      '::' +
      includeglass +
      '::' +
      glaspanelwidthi +
      '::' +
      glaspanelwidthl +
      '::' +
      glaspanelwidthu +
      '::' +
      baseclampsubsystem +
      '::' +
      fbsystem +
      '::' +
      windowwidth +
      '::' +
      bodentief +
      '::' +
      fenstermontage +
      '::' +
      Fbcustomglaswidth +
      '::' +
      PostShape +
      '::' +
      ClampShape +
      '::' +
      qlineinfill +
      '::' +
      Pfostenrund +
      '::' +
      QlineHandlauf +
      '::' +
      Taphandrailstring +
      '::' +
      Tappostsstring;
    vals = vals.toString();

    reqbody = JSON.stringify({
      data: {
        CustomerId: 'NEW REQUEST FOR SHOPACCOUNT',
        Email: mail,
        Locale: para.count,
        CompanyName: company,
        Phone: phonenbr,
        Salutation: salutation,
        LastName: lname,
        FirstName: fname,
        Street: street,
        PostCode: postcode,
        City: city,
        Country: country,
        IndustryGroup: industrygroup,
        Vat: vat,
      },
    });
    let CustomerStatus = 'NewCustomer';
    let CustomerType = 'Business';
    if (!business) {
      CustomerType = 'Private';
    }
    if (alreadycust != 2 && business) {
      CustomerStatus = 'existingCustomer';
    }
    let postcodeprivate = 'N/A because business';
    if (!business) {
      postcodeprivate = postcode;
    }
    let railingtype =
      gelaender == 'glass' ? 'Easy Glass Smart' : gelaender == 'picket' ? 'Easy Alu Picket' : 'Easy Alu Glass';

    {
      gelaender == 'qline' && PostShape == 'round' && (railingtype = 'Q-line');
    }
    {
      gelaender == 'qline' && PostShape != 'round' && (railingtype = 'Square Line');
    }

    if (gelaender == 'baseclamps') {
      if (baseclampsubsystem == '60') {
        railingtype = 'MOD 6000';
      } else {
        railingtype = 'MOD 6400';
      }
    }
    if (gelaender == 'frenchbalcony') {
      if (fbsystem == 'Mod6507') {
        railingtype = 'MOD 6507';
      } else {
        railingtype = 'Easy Glass View';
      }
    }

    let color =
      colorr == 'black'
        ? infotext.data[0].attributes.FreeData1.data[12]
        : colorr == 'brano'
          ? infotext.data[0].attributes.FreeData1.data[60]
          : colorr == 'gray'
            ? infotext.data[0].attributes.FreeData1.data[13]
            : infotext.data[0].attributes.FreeData1.data[14];

    {
      colorr == 'satin304' && (color = 'Satin304');
    }
    {
      colorr == 'satin316' && (color = 'Satin316');
    }

    let mount = montageart == 'top' ? 'Topmount' : 'Fasciamount';
    let Cutsize = cuttosize ? 'Yes' : 'No';
    let icglass = includeglass ? 'Yes' : 'No';
    let hasinstaller = HasInstaller ? 'Yes' : 'No';

    if (gelaender == 'glass' || gelaender == 'frenchbalcony') {
      color = infotext.data[0].attributes.FreeData1.data[60];
    }

    if (gelaender == 'baseclamps') {
      if (colorr == 'gray') {
        color = infotext.data[0].attributes.FreeData1.data[117];
      } else {
        color = infotext.data[0].attributes.FreeData1.data[118];
      }
      mount = 'Topmount';
    }

    let untergrund =
      untergrundd == 'beton'
        ? infotext.data[0].attributes.FreeData1.data[7]
        : untergrundd == 'holz'
          ? infotext.data[0].attributes.FreeData1.data[8]
          : infotext.data[0].attributes.FreeData1.data[9];

    if (gelaender == 'frenchbalcony') {
      if (fenstermontage == 'Inset') {
        untergrund = infotext.data[0].attributes.FreeData1.data[140];
      } else {
        untergrund = infotext.data[0].attributes.FreeData1.data[141];
      }
    }
    let fbAnchors = 'No';
    let fbCustomGlass = 'No';
    if (gelaender == 'frenchbalcony') {
      if (AnkerImAngebot) {
        fbAnchors = 'Yes';
      }
      if (Fbcustomglas) {
        fbCustomGlass = 'Yes';
      }
    }

    if (gelaender == 'qline') {
      if (AnkerImAngebot) {
        fbAnchors = 'Yes';
      }
    }

    if (ralcolor != '' && ralcolorbool && ralcolor.length == 4) {
      color = ralcolor;
    }
    if (gelaender == 'frenchbalcony' && fbsystem == 'Mod6507') {
      color = translationEdelstahl[para.count];
    }
    if (TapHandrail) {
      taphandrail = 'Yes';
    }
    if (TapPosts) {
      tapposts = 'Yes';
    }

    let IframeSlug = 'Q-railing';
    if (CustSlug === 'Rvs') {
      IframeSlug = 'Rvs';
    }
    if (CustSlug === 'rvs-land') {
      IframeSlug = 'rvs-land';
    }
    if (CustSlug === 'wholesaleglass') {
      IframeSlug = 'wholesaleglass';
    }
    if (CustSlug === 'rubelo') {
      IframeSlug = 'rubelo';
    }
    if (CustSlug === 'storax') {
      IframeSlug = 'storax';
    }

    if (CustSlug === 'hekwerkshop') {
      IframeSlug = 'hekwerkshop';
    }

    if (CustSlug === 'aluleaf') {
      IframeSlug = 'aluleaf';
    }
    if (CustSlug === 'glasmaatje') {
      IframeSlug = 'glasmaatje';
    }
    if (CustSlug === 'glassinside') {
      IframeSlug = 'glassinside';
    }
    if (CustSlug === 'glas123') {
      IframeSlug = 'glas123';
    }
    let reqbodyconfireq = JSON.stringify({
      data: {
        Type: 'ConfiguratorRequest',
        Email: mail,
        Locale: para.count,
        ConfiguratorData: vals,
        Shape: form,
        System: gelaender,
        CustomerId: custcode,
        PostCode: savestring,
        ConfigurationCode: 'https://q-railing.com/' + para.count + finallink2 + savecode,
        RailingType: railingtype,
        CustomerType: CustomerType,
        CustomerStatus: CustomerStatus,
        Mount: mount,
        SurfaceColor: color,
        Underground: untergrund,
        Comments: text,
        PostCode: custcode,
        CutToSize: Cutsize,
        IncludeGlass: icglass,
        Name: lname,
        Phone: phonenbr,
        StreetNr: street + ' ' + housenbr,
        Salutation: salutation,
        City: city,
        HasInstaller: hasinstaller,
        CustomGlass: Fbcustomglaswidth.toString(),
        WindowWidth: fbCustomGlass,
        IncludeAnchors: fbAnchors,
        DrillPosts: tapposts,
        DrillHandrail: taphandrail,
        IframeSlug: IframeSlug,
        IframeText: iframecustomertype,
      },
    });

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: reqbody,
    };

    const requestOptionsConfireq = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: reqbodyconfireq,
    };

    if (CustSlug === 'rubelo') {
      sendToIframeParent(mail);
    }

    const bootstrap = async () => {
      const tableData = [];
      const table = document.querySelector('.articletable');
      const rows = [...table.querySelectorAll('tr')];
      for (const row of rows) {
        const cells = await Promise.all(
          [...row.querySelectorAll('td')].map(async (cell) => {
            if (!cell.querySelector('img')) {
              return [...cell.childNodes]
                .filter((x) => x.nodeType === Node.TEXT_NODE)
                .map((x) => x.textContent)
                .join('');
            }
            const img = cell.querySelector('img');
            return img.src;
          }),
        );
        tableData.push(cells);
      }

      const overviewHtml = document.getElementsByClassName('overview-table')[0];
      const overview = [
        [
          overviewHtml.querySelector('.railing-type-title')?.textContent,
          overviewHtml.querySelector('.railing-type')?.textContent,
        ],
        [
          overviewHtml.querySelector('.mount-type-title')?.textContent,
          overviewHtml.querySelector('.mount-type')?.textContent,
        ],
        [
          overviewHtml.querySelector('.mount-surface-title')?.textContent,
          overviewHtml.querySelector('.mount-surface')?.textContent,
        ],
        [
          overviewHtml.querySelector('.surface-color-title')?.textContent,
          overviewHtml.querySelector('.surface-color')?.textContent,
        ],
        [
          infotext.data[0].attributes.FreeData1.data[130],
          cuttosize ? infotext.data[0].attributes.FreeData1.data[69] : infotext.data[0].attributes.FreeData1.data[90],
        ],
      ];

      for (const key in overview) {
        overview[key][0] ??= '';
        overview[key][1] ??= '';
      }

      setConfigurationPdfTableData(tableData);
      setOverviewPdfTableData(overview);

      window.dataLayer ??= [];
      window.dataLayer.push({
        event: 'config_inquiry',
        configurationID: savecode,
      });
      setnamepara(fname + '_' + lname);
      // replace current location with config location withput reloading or rerendering
      window.history.pushState(
        {},
        window.document.title,
        '/' + window.location.pathname.split('/').splice(1, 3).join('/') + '/' + savecode,
      );
      setselectstep(7);
    };

    if (localStorage.getItem('_$TEST_SYSTEM') === 'true') {
      bootstrap();
      return;
    }
    //HERE REPLACE WITH http://localhost:1337 for testing mailtemplate https://strapi-qrailing.azurewebsites.net
    fetch('https://strapi-qrailing.azurewebsites.net/api/configurators', requestOptionsConfireq)
      .then((response) => response.json())
      .then(
        setTimeout(() => {
          console.log('-');
        }, 2000),
      )
      .then((data) => this.setState({ postId: data.id }))
      .then(() => {});

    if (alreadycust == 2 && business) {
      fetch('https://strapi-qrailing.azurewebsites.net/api/shop-account-requests', requestOptions)
        .then((response) => response.json())
        .then(
          setTimeout(() => {
            console.log('-');
          }, 2000),
        )
        .then((data) => this.setState({ postId: data.id }))
        .then(() => {});
    }

    bootstrap();
  }

  function sendToIframeParent(mail) {
    console.log('SendingIframeParent');
    try {
      const targetOrigin = 'https://www.rubelo.cz';
      window.parent.postMessage(
        {
          event: 'konfigurator_submitted',
          value: 1000,
          currency: 'CZK',
          email: mail || 'digital@q-railing.com',
        },
        targetOrigin,
      );
    } catch (e) {
      console.warn('postMessage failed', e);
    }
  }

  function sendDocs() {
    const file = fileInputRef.current.files[0];

    let Errorwarning = '';
    if (!file) {
      Errorwarning = infotext.data[0].attributes.FreeData1.data[99];

      return;
    }

    Errorwarning = '';

    const now = new Date();
    let addnbr = 999999999;
    let add = parseInt(addnbr * Math.random());
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    const timestamp = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;

    const formData = new FormData();
    formData.append('files', file, add + '_FILE_' + timestamp); // Use "files" as the key

    const requestOptions = {
      method: 'POST',
      body: formData,
    };

    fetch('https://strapi-qrailing.azurewebsites.net/api/upload/', requestOptions)
      .then((response) => response.json())
      .then((data) => {
        // Handle success or further actions
        setselectstep(8);
      })
      .catch((error) => {
        console.error('Error uploading file:', error);
        // Handle error
      });
  }
  function checkAndAdjustInput(value) {
    let adjustedValue = value;

    if (params.count === 'en-us' || params.count === 'es-us') {
      adjustedValue = parseFloat(value) * 25.4;
    }
    // Check if the value is within the range
    if (adjustedValue < 500) {
      adjustedValue = 500;
    } else if (adjustedValue > 2100) {
      adjustedValue = 2100;
    }
    if (adjustedValue < 1200) {
      setwindowamount(1);
    }

    // Convert back to inches if necessary
    if (params.count === 'en-us' || params.count === 'es-us') {
      adjustedValue = (adjustedValue / 25.4).toFixed(2);
    }
    return adjustedValue;
  }

  function enteroldcode(e) {
    setTimeout(() => {
      if (e.length > 5) {
        fetch('https://strapi-qrailing.azurewebsites.net/api/configurations?filters[Slug][$eq]=' + e)
          .then((res) => res.json())
          .then((json) => {
            if (json.data.length > 0) {
              let stringger = json.data[0].attributes.ConfiguratorData;
              let arr = stringger.split('::');
              sethohe(arr[0]);
              setgelaender(arr[1]);
              if (arr[1] == 'glass') {
                activeitem(glass1, 'step1', 1);
              }
              if (arr[1] == 'picket') {
                activeitem(picket1, 'step1', 1);
              }
              if (arr[1] == 'baluster') {
                activeitem(baluster1, 'step1', 1);
              }
              setform(arr[2]);
              sethandlaufmat(arr[3]);

              setmontageart(arr[4]);
              setuntergrundd(arr[5]);
              setcolorr(arr[6]);
              if (/^\d{0,4}$/.test(arr[6])) {
                setralcolor(arr[6]);
                setcolorr('gray');
                setralcolorbool(true);
              }

              setlen1(parseInt(arr[7]));
              setlen2(parseInt(arr[8]));
              setlen3(parseInt(arr[9]));
              setsavecode(e);
              if (arr[10] == 'wall1') {
                setwall1(true);
              }
              if (arr[11] == 'wall2') {
                setwall2(true);
              }
              if (arr[12] == 'CutToSize-No') {
                setcuttosize(false);
              }
              if (arr[13] == 'IncludeGlass-No') {
                setincludeglass(false);
              }
              setglassthicknessbaseclamps(arr[14]);
              setglaspanelwithi(parseFloat(arr[15]));
              setglaspanelwithl(parseFloat(arr[16]));
              setglaspanelwithu(parseFloat(arr[17]));
              setbaseclampsubsystem(arr[18]);
              setfbsystem(arr[19]);
              setwindowwidth(arr[20]);
              setbodentief(arr[21]);
              setfenstermontage(arr[22]);
              setFbcustomglaswidth(arr[23]);
              setPostShape(arr[24]);
              setClampShape(arr[25]);
              setqlineinfill(arr[26]);
              setPfostenrund(arr[27]);
              setQlineHandlauf(arr[28]);

              if (arr[29] == 'TapHandrail-Yes') {
                setTapHandrail(true);
              } else {
                setTapHandrail(false);
              }

              if (arr[30] == 'TapPosts-Yes') {
                setTapPosts(true);
              } else {
                setTapPosts(false);
              }

              setselectstep(6);
            }
          });
      }
    }, 30);
  }
  function adjustmeasure(e, nr) {
    if (e > 15000) {
      document.getElementById('Configurator-size-error-warning').innerText =
        infotext.data.length > 0
          ? infotext.data[0].attributes.FreeData1.data[94]
          : 'Please choose a Measurement below 15000 mm';
      if (nr == '1') {
        document.getElementById('Measurement1').value = 15000;
        setlen1(15000);
      }
      if (nr == '2') {
        document.getElementById('Measurement2').value = 15000;
        setlen2(15000);
      }
      if (nr == '3') {
        document.getElementById('Measurement3').value = 15000;
        setlen3(15000);
      }
    }

    if (nr == '1') {
      if ((e >= 500 && e <= 15000) || ((para.count == 'en-us' || para.count == 'es-us') && e <= 1000)) {
        if (e > 3000) {
          document.getElementById('Configurator-size-error-warning').innerText = '';
          let res = 10;

          res = 10 + (1 / 500) * e;
          orbitRef.current.object.fov = res;
          cammy.current.fov = res;
        }

        if (para.count == 'en-us' || para.count == 'es-us') {
          e = e * 25.4;
        }
        setlen1(e);
      }
    }
    if (nr == '2') {
      if ((e >= 500 && e <= 15000) || ((para.count == 'en-us' || para.count == 'es-us') && e <= 1000)) {
        document.getElementById('Configurator-size-error-warning').innerText = '';
        if (para.count == 'en-us' || para.count == 'es-us') {
          e = e * 25.4;
        }
        setlen2(e);
      }
    }
    if (nr == '3') {
      if ((e >= 500 && e <= 15000) || ((para.count == 'en-us' || para.count == 'es-us') && e <= 1000)) {
        document.getElementById('Configurator-size-error-warning').innerText = '';
        if (para.count == 'en-us' || para.count == 'es-us') {
          e = e * 25.4;
        }
        setlen3(e);
      }
    }
  }
  function returnsteps() {
    //logic for baseclamps if One thing is allowed or not
    let allowed3clampsi = true;
    let allowed3clampsl = true;
    let allowed3clampsu = true;

    if (len1 < 1001 || (len1 > 1500 && len1 < 2020)) {
      allowed3clampsi = false;
    }
    if (len2 < 1001 || (len2 > 1500 && len2 < 2020)) {
      allowed3clampsl = false;
    }
    if (len3 < 1001 || (len3 > 1500 && len3 < 2020)) {
      allowed3clampsu = false;
    }

    if (selectstep == 1) {
      return (
        <>
          <div className="step1choice step1-configurator scrollable-content" id="Configurator-Extended-Step">
            <div className="Step1Scroll">
              <h3 className="Headline-configurator">
                {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[34] : 'Select a railing type'}
              </h3>

              <div className="step1-selection bigsize-button ConfiguratorDesktopButton">
                <button
                  ref={baluster1}
                  id="ConfigStep1AluGlass"
                  className={gelaender == 'baluster' ? 'activeitem' : ''}
                  onClick={() => {
                    setgelaender('baluster');
                    setcamy(2, 1);
                    if (colorr != 'black' && colorr != 'anrtz' && colorr != 'brano' && colorr != 'gray') {
                      setcolorr('anrtz');
                    }
                  }}
                >
                  <img
                    loading={'lazy'}
                    className="activeicon railing-choice-img "
                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easy_alu_glass.webp"
                    width={248}
                    height={136}
                  />
                  <div className="bluecheck1">
                    <img
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/check_icon.svg"
                      width={16}
                    />
                  </div>
                </button>
                <div className="first_railing_choice">
                  <h4>
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[35] : 'Post railing system'}
                  </h4>
                </div>
                <span>
                  {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[36] : 'Easy Alu - Glas'}
                </span>
              </div>

              <div
                className={
                  CustSlug != 'aluleaf' ? 'step1-selection bigsize-button ConfiguratorDesktopButton' : 'hidden'
                }
              >
                <button
                  ref={glass1}
                  id="ConfigStep1EasyGlassSmart"
                  className={gelaender == 'glass' ? 'activeitem' : ''}
                  onClick={() => {
                    setgelaender('glass');
                    setcamy(1, 1);
                  }}
                >
                  <img
                    loading={'lazy'}
                    className="railing-choice-img"
                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easy_glass_smart.webp"
                    width={248}
                    height={136}
                  />
                  <div className="bluecheck1">
                    <img
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/check_icon.svg"
                      width={16}
                    />
                  </div>
                </button>
                <div className="first_railing_choice">
                  <h4>
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[37] : 'Glas railing system'}
                  </h4>
                </div>
                <span>
                  {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[38] : 'Easy Glass - Smart'}
                </span>
              </div>

              <div className="step1-selection bigsize-button ConfiguratorDesktopButton">
                <button
                  ref={picket1}
                  id="ConfigStep1AluPicket"
                  className={gelaender == 'picket' ? 'activeitem' : ''}
                  onClick={() => {
                    setgelaender('picket');
                    setcamy(2, 1);
                    setcolorr('black');
                  }}
                >
                  <img
                    loading={'lazy'}
                    className="railing-choice-img"
                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easy_alu_picket.webp"
                    width={200}
                    height={100}
                  />
                  <div className="bluecheck1">
                    <img
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/check_icon.svg"
                      width={16}
                    />
                  </div>
                </button>
                <div className="first_railing_choice">
                  <h4>
                    {infotext.data.length > 0
                      ? infotext.data[0].attributes.FreeData1.data[39]
                      : 'Picket railing system'}
                  </h4>
                </div>
                <span>
                  {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[40] : 'Easy Alu - Picket'}{' '}
                </span>
              </div>

              <div
                className={
                  CustSlug != 'aluleaf' ? 'step1-selection bigsize-button ConfiguratorDesktopButton' : 'hidden'
                }
              >
                <button
                  id="ConfigStep1Baseclamps"
                  className={gelaender == 'baseclamps' ? 'activeitem' : ''}
                  onClick={() => {
                    setgelaender('baseclamps');
                    setcamy(2, 1);
                    setcolorr('brano');
                  }}
                >
                  <img
                    loading={'lazy'}
                    className="railing-choice-img"
                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/mod6400step1.webp"
                    width={200}
                    height={100}
                  />
                  <div className="bluecheck1">
                    <img
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/check_icon.svg"
                      width={16}
                    />
                  </div>
                </button>
                <div className="first_railing_choice">
                  <h4>
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[109] : 'Baseclamp system'}
                  </h4>
                </div>
                <span>
                  {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[110] : 'MOD - 6000/6400'}{' '}
                </span>
              </div>

              <div
                className={
                  CustSlug != 'aluleaf' ? 'step1-selection bigsize-button ConfiguratorDesktopButton' : 'hidden'
                }
              >
                <button
                  id="ConfigStep1FrenchBalcony"
                  className={gelaender == 'frenchbalcony' ? 'activeitem' : ''}
                  onClick={() => {
                    setgelaender('frenchbalcony');
                    setcamy(1, 1);
                    setcolorr('brano');
                  }}
                >
                  <img
                    loading={'lazy'}
                    className="railing-choice-img"
                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/frenchbalcony2.png"
                    width={200}
                    height={100}
                  />
                  <div className="bluecheck1">
                    <img
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/check_icon.svg"
                      width={16}
                    />
                  </div>
                </button>
                <div className="first_railing_choice">
                  <h4>
                    {infotext.data.length > 0
                      ? infotext.data[0].attributes.FreeData1.data[139]
                      : 'French balcony system'}
                  </h4>
                </div>
                <span>
                  {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[138] : 'French balcony'}
                </span>
              </div>

              <div
                className={
                  CustSlug != 'aluleaf' ? 'step1-selection bigsize-button ConfiguratorDesktopButton' : 'hidden'
                }
              >
                <button
                  id="ConfigStep1Qline"
                  className={gelaender == 'qline' ? 'activeitem' : ''}
                  onClick={() => {
                    setgelaender('qline');
                    setcamy(1, 1);
                    setcolorr('satin316');
                    sethandlaufmat('round');
                    setwall1(false);
                    setwall2(false);
                  }}
                >
                  <img
                    loading={'lazy'}
                    className="railing-choice-img"
                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/qline_step1.webp"
                    width={200}
                    height={100}
                  />
                  <div className="bluecheck1">
                    <img
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/check_icon.svg"
                      width={16}
                    />
                  </div>
                </button>
                <div className="first_railing_choice">
                  <h4>
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[150] : 'Post railing system'}
                  </h4>
                </div>
                <span>
                  {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[151] : 'Q-line/Square Line'}
                </span>
              </div>

              <div id="step1ScrollSupport"></div>

              <div className="step1-selection bigsize-button ConfiguratorMobileButton">
                <button
                  className={gelaender == 'baluster' && 'activeitem'}
                  id="ConfigStep1AluGlass"
                  onClick={() => {
                    setgelaender('baluster');
                    activeitem(baluster1, 'step1', 1);
                    setcamy(2, 1);
                  }}
                >
                  <div className="step1-mobile-button-text-adjust">
                    <h4>
                      {infotext.data.length > 0
                        ? infotext.data[0].attributes.FreeData1.data[35]
                        : 'Glas railing system'}
                    </h4>
                    <span>
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[36] : 'Easy Alu - Glas'}
                    </span>
                  </div>
                  <img
                    className="activeicon railing-choice-img "
                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easy_alu_glass.webp"
                    width={48}
                    height={32}
                  />
                  <div className="bluecheck1">
                    <img
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/check_icon.svg"
                      width={16}
                    />
                  </div>
                </button>
              </div>

              <div
                className={CustSlug != 'aluleaf' ? 'step1-selection bigsize-button ConfiguratorMobileButton' : 'hidden'}
              >
                <button
                  className={gelaender == 'glass' && 'activeitem'}
                  id="ConfigStep1EasyGlassSmart"
                  onClick={() => {
                    setgelaender('glass');
                    activeitem(glass1, 'step1', 1);
                    setcamy(1, 1);
                  }}
                >
                  <div className="step1-mobile-button-text-adjust">
                    <h4>
                      {infotext.data.length > 0
                        ? infotext.data[0].attributes.FreeData1.data[37]
                        : 'Glas railing system'}
                    </h4>
                    <span>
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[38] : 'Easy Glass - Smart'}
                    </span>
                  </div>
                  <img
                    className="railing-choice-img"
                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easy_glass_smart.webp"
                    width={48}
                    height={32}
                  />
                  <div className="bluecheck1">
                    <img
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/check_icon.svg"
                      width={16}
                    />
                  </div>
                </button>
              </div>

              <div className="step1-selection bigsize-button ConfiguratorMobileButton">
                <button
                  className={gelaender == 'picket' && 'activeitem'}
                  id="ConfigStep1AluPicket"
                  onClick={() => {
                    setgelaender('picket');
                    activeitem(picket1, 'step1', 1);
                    setcamy(2, 1);
                  }}
                >
                  <div className="step1-mobile-button-text-adjust">
                    <h4>
                      {infotext.data.length > 0
                        ? infotext.data[0].attributes.FreeData1.data[39]
                        : 'Glas railing system'}
                    </h4>
                    <span>
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[40] : 'Easy Alu - Picket'}
                    </span>
                  </div>
                  <img
                    className="railing-choice-img"
                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easy_alu_picket.webp"
                    width={48}
                    height={32}
                  />
                  <div className="bluecheck1">
                    <img
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/check_icon.svg"
                      width={16}
                    />
                  </div>
                </button>
              </div>

              <div
                className={CustSlug != 'aluleaf' ? 'step1-selection bigsize-button ConfiguratorMobileButton' : 'hidden'}
              >
                <button
                  id="ConfigStep1Baseclamps"
                  className={gelaender == 'baseclamps' && 'activeitem'}
                  onClick={() => {
                    setgelaender('baseclamps');
                    setcamy(2, 1);
                    setcolorr('brano');
                  }}
                >
                  <div className="step1-mobile-button-text-adjust">
                    <h4>
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[109] : 'Baseclamp system'}
                    </h4>
                    <span>
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[110] : 'MOD - 6000/6400'}
                    </span>
                  </div>
                  <img
                    className="railing-choice-img"
                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/mod6400step1.webp"
                    width={48}
                    height={32}
                  />
                  <div className="bluecheck1">
                    <img
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/check_icon.svg"
                      width={16}
                    />
                  </div>
                </button>
              </div>

              <div
                className={CustSlug != 'aluleaf' ? 'step1-selection bigsize-button ConfiguratorMobileButton' : 'hidden'}
              >
                <button
                  id="ConfigStep1FrenchBalcony"
                  className={gelaender == 'frenchbalcony' && 'activeitem'}
                  onClick={() => {
                    setgelaender('frenchbalcony');
                    setcamy(1, 1);
                  }}
                >
                  <div className="step1-mobile-button-text-adjust">
                    <h4>
                      {infotext.data.length > 0
                        ? infotext.data[0].attributes.FreeData1.data[139]
                        : 'French balcony system'}
                    </h4>
                    <span>
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[138] : 'French balcony'}
                    </span>
                  </div>
                  <img
                    className="railing-choice-img"
                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/frenchbalcony2.png"
                    width={48}
                    height={28}
                  />
                  <div className="bluecheck1">
                    <img
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/check_icon.svg"
                      width={16}
                    />
                  </div>
                </button>
              </div>

              <div
                className={CustSlug != 'aluleaf' ? 'step1-selection bigsize-button ConfiguratorMobileButton' : 'hidden'}
              >
                <button
                  id="ConfigStep1Qline"
                  className={gelaender == 'qline' && 'activeitem'}
                  onClick={() => {
                    setgelaender('qline');
                    setcamy(1, 1);
                    setcolorr('satin316');
                    sethandlaufmat('round');
                    setwall1(false);
                    setwall2(false);
                  }}
                >
                  <div className="step1-mobile-button-text-adjust">
                    <h4>
                      {infotext.data.length > 0
                        ? infotext.data[0].attributes.FreeData1.data[150]
                        : 'Post railing system'}
                    </h4>
                    <span>
                      {infotext.data.length > 0
                        ? infotext.data[0].attributes.FreeData1.data[151]
                        : 'Q-line/Square Line'}
                    </span>
                  </div>
                  <img
                    className="railing-choice-img"
                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/qline_step1.webp"
                    width={48}
                    height={28}
                  />
                  <div className="bluecheck1">
                    <img
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/check_icon.svg"
                      width={16}
                    />
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div className="forbackdiv firstforback">
            <button
              className="forbtn"
              id="firstforbtn-ConfiguratorStep1"
              onClick={() => {
                setselectstep(2);
                setstep1bool(true);
                window.scrollTo(0, 0);
              }}
            >
              {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[0] : 'Next Step'}{' '}
            </button>
          </div>
        </>
      );
    }

    if (selectstep == 2) {
      return (
        <>
          {gelaender != 'frenchbalcony' && (
            <div className="step1choice step1-configurator step2config">
              <h3 className="Headline-configurator">
                {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[41] : 'Select a shape'}{' '}
              </h3>

              <div className="step1-selection bigsize-button ConfiguratorDesktopButton">
                <button
                  className={form == 'i' ? 'activeitem' : ''}
                  id="ConfigStep2IShape"
                  ref={ishape2}
                  onClick={() => {
                    setform('i');
                    setcoords([
                      [0, 0, 1],
                      [0, 10, 1],
                    ]);
                    activeitem(ishape2, 'step2', 1);
                  }}
                >
                  {gelaender == 'picket' ? (
                    <img src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easyalupicket_ishape.png" />
                  ) : gelaender == 'glass' ? (
                    <img src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easyglasssmart_ishape.png" />
                  ) : gelaender == 'baseclamps' ? (
                    <img
                      width={248}
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/mod6400_i_shape.webp"
                    />
                  ) : gelaender == 'qline' ? (
                    <img
                      width={248}
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/qline_step2i.webp"
                    />
                  ) : (
                    <img src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easyaluglass_ishape.png" />
                  )}
                  <div className="bluecheck1">
                    <img
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/check_icon.svg"
                      width={16}
                    />
                  </div>
                </button>
                <h4>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[42] : 'Straight'}</h4>
              </div>

              <div className="step1-selection bigsize-button ConfiguratorDesktopButton">
                <button
                  className={form == 'l' ? 'activeitem' : ''}
                  id="ConfigStep2LShape"
                  ref={lshape2}
                  onClick={() => {
                    setform('l');
                    setcoords([
                      [0, 0, 1],
                      [0, 10, 1],
                      [0, 0, 2],
                      [10, 0, 2],
                    ]);
                    activeitem(lshape2, 'step2', 1);

                    if (qlineinfill == 'cables' && PostShape != 'round') {
                      setqlineinfill('glass');
                    }
                    if (qlineinfill == 'cables' && PostShape == 'round' && montageart != 'top') {
                      setqlineinfill('glass');
                    }
                  }}
                >
                  {gelaender == 'picket' ? (
                    <img src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easyalupicket_lshape.png" />
                  ) : gelaender == 'glass' ? (
                    <img src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easyglasssmart_lshape.png" />
                  ) : gelaender == 'baseclamps' ? (
                    <img
                      width={248}
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/mod6400_l_shape.webp"
                    />
                  ) : gelaender == 'qline' ? (
                    <img
                      width={248}
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/qline_step2l.webp"
                    />
                  ) : (
                    <img src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easyaluglass_lshape.png" />
                  )}
                  <div className="bluecheck1">
                    <img
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/check_icon.svg"
                      width={16}
                    />
                  </div>
                </button>
                <h4>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[43] : 'Corner'}</h4>
              </div>

              <div className="step1-selection bigsize-button ConfiguratorDesktopButton">
                <button
                  className={form == 'u' ? 'activeitem' : ''}
                  id="ConfigStep2UShape"
                  ref={ushape2}
                  onClick={() => {
                    setform('u');
                    setcoords([
                      [0, 0, 1],
                      [0, 10, 1],
                      [0, 0, 2],
                      [10, 0, 2],
                      [20, 0, 2],
                      [25, 0, 2],
                      [30, 10, 3],
                      [30, 10, 3],
                    ]);
                    activeitem(ushape2, 'step2', 1);
                    if (qlineinfill == 'cables' && PostShape != 'round') {
                      setqlineinfill('glass');
                    }
                    if (qlineinfill == 'cables' && PostShape == 'round' && montageart != 'top') {
                      setqlineinfill('glass');
                    }
                  }}
                >
                  {gelaender == 'picket' ? (
                    <img src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easyalupicket_ushape.png" />
                  ) : gelaender == 'glass' ? (
                    <img src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easyglasssmart_ushape.png" />
                  ) : gelaender == 'baseclamps' ? (
                    <img
                      width={248}
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/mod6400_u_shape.webp"
                    />
                  ) : gelaender == 'qline' ? (
                    <img
                      width={248}
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/qline_step2u.webp"
                    />
                  ) : (
                    <img src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easyaluglass_ushape.png" />
                  )}
                  <div className="bluecheck1">
                    <img
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/check_icon.svg"
                      width={16}
                    />
                  </div>
                </button>
                <h4>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[44] : 'U-shape'}</h4>
              </div>

              <div className="step1-selection bigsize-button ConfiguratorMobileButton">
                <button
                  className={form == 'i' ? 'activeitem' : ''}
                  ref={ishape2}
                  id="ConfigStep2IShape"
                  onClick={() => {
                    setform('i');
                    setcoords([
                      [0, 0, 1],
                      [0, 10, 1],
                    ]);
                    activeitem(ishape2, 'step2', 1);
                  }}
                >
                  <h4>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[42] : 'Straight'}</h4>
                  {gelaender == 'picket' ? (
                    <img src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easyalupicket_ishape.png" />
                  ) : gelaender == 'glass' ? (
                    <img src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easyglasssmart_ishape.png" />
                  ) : gelaender == 'baseclamps' ? (
                    <img
                      width={248}
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/mod6400_i_shape.webp"
                    />
                  ) : gelaender == 'qline' ? (
                    <img
                      width={248}
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/qline_step2i.webp"
                    />
                  ) : (
                    <img src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easyaluglass_ishape.png" />
                  )}
                  <div className="bluecheck1">
                    <img
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/check_icon.svg"
                      width={16}
                    />
                  </div>
                </button>
              </div>

              <div className="step1-selection bigsize-button ConfiguratorMobileButton">
                <button
                  className={form == 'l' ? 'activeitem' : ''}
                  id="ConfigStep2LShape"
                  ref={lshape2}
                  onClick={() => {
                    setform('l');
                    setcoords([
                      [0, 0, 1],
                      [0, 10, 1],
                      [0, 0, 2],
                      [10, 0, 2],
                    ]);
                    activeitem(lshape2, 'step2', 1);
                    if (qlineinfill == 'cables' && PostShape != 'round') {
                      setqlineinfill('glass');
                    }
                    if (qlineinfill == 'cables' && PostShape == 'round' && montageart != 'top') {
                      setqlineinfill('glass');
                    }
                  }}
                >
                  <h4>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[43] : 'Corner'}</h4>
                  {gelaender == 'picket' ? (
                    <img src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easyalupicket_lshape.png" />
                  ) : gelaender == 'glass' ? (
                    <img src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easyglasssmart_lshape.png" />
                  ) : gelaender == 'baseclamps' ? (
                    <img
                      width={248}
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/mod6400_l_shape.webp"
                    />
                  ) : gelaender == 'qline' ? (
                    <img
                      width={248}
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/qline_step2l.webp"
                    />
                  ) : (
                    <img src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easyaluglass_lshape.png" />
                  )}
                  <div className="bluecheck1">
                    <img
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/check_icon.svg"
                      width={16}
                    />
                  </div>
                </button>
              </div>

              <div className="step1-selection bigsize-button ConfiguratorMobileButton">
                <button
                  className={form == 'u' ? 'activeitem' : ''}
                  ref={ushape2}
                  id="ConfigStep2UShape"
                  onClick={() => {
                    setform('u');
                    setcoords([
                      [0, 0, 1],
                      [0, 10, 1],
                      [0, 0, 2],
                      [10, 0, 2],
                      [20, 0, 2],
                      [25, 0, 2],
                      [30, 10, 3],
                      [30, 10, 3],
                    ]);
                    activeitem(ushape2, 'step2', 1);
                    if (qlineinfill == 'cables' && PostShape != 'round') {
                      setqlineinfill('glass');
                    }
                    if (qlineinfill == 'cables' && PostShape == 'round' && montageart != 'top') {
                      setqlineinfill('glass');
                    }
                  }}
                >
                  <h4>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[44] : 'U-shape'}</h4>
                  {gelaender == 'picket' ? (
                    <img src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easyalupicket_ushape.png" />
                  ) : gelaender == 'glass' ? (
                    <img src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easyglasssmart_ushape.png" />
                  ) : gelaender == 'baseclamps' ? (
                    <img
                      width={248}
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/mod6400_u_shape.webp"
                    />
                  ) : gelaender == 'qline' ? (
                    <img
                      width={248}
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/qline_step2u.webp"
                    />
                  ) : (
                    <img src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easyaluglass_ushape.png" />
                  )}
                  <div className="bluecheck1">
                    <img
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/check_icon.svg"
                      width={16}
                    />
                  </div>
                </button>
              </div>
            </div>
          )}

          {gelaender == 'frenchbalcony' && (
            <div style={{ padding: '16px' }}>
              <h3 className="Headline-configurator">
                {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[134] : 'Window-configuration'}
              </h3>
              <br />
              <div className="measurementinputclass frenchbalconyinput">
                <h4>
                  {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[135] : 'Window width'}
                  <span className="FrenchBalconyInnerSpan">
                    {para.count == 'en-us' || para.count == 'es-us' ? '(max 82")' : '(max 2100mm)'}
                  </span>
                </h4>
                <label>
                  <span>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[136] : 'width'}</span>
                  <input
                    type="number"
                    placeholder={
                      params.count != ('en-us' || 'es-us')
                        ? windowwidth + ' mm'
                        : parseFloat(windowwidth).toFixed(2) + '"'
                    }
                    onChange={(e) => {
                      if (parseInt(e.target.value) >= 5) {
                        let adjustedValue = checkAndAdjustInput(e.target.value);

                        if (fenstermontage == 'Inset') {
                          setFbcustomglaswidth(parseInt(e.target.value) - 60);
                          if (para.count == 'en-us' || para.count == 'es-us') {
                            setFbcustomglaswidth(parseFloat(e.target.value).toFixed(2) - 2.36);
                          }
                        } else {
                          setFbcustomglaswidth(parseInt(e.target.value) + 100);
                          if (para.count == 'en-us' || para.count == 'es-us') {
                            setFbcustomglaswidth(parseFloat(parseFloat(e.target.value).toFixed(2)) + 3.94);
                          }
                        }
                        setwindowwidth(adjustedValue);
                      }
                    }}
                  />
                </label>
              </div>
              <br />
              <h4>
                {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[137] : 'Amount of windows'}
              </h4>
              <div className="windowamounts">
                <button className={windowamount == 1 && 'activeitem'} onClick={() => setwindowamount(1)}>
                  1
                </button>
                <button className={windowamount == 2 && 'activeitem'} onClick={() => setwindowamount(2)}>
                  2
                </button>
              </div>

              <br />
              <h4>
                {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[45] : 'Select a mounting type'}
              </h4>

              <div className="FrenchBalconySystemSelect">
                <div className="FrenchBalconySystemCard">
                  <button
                    className={fenstermontage == 'Front' && 'activeitem'}
                    onClick={() => {
                      setfenstermontage('Front');
                      setFbcustomglaswidth(parseInt(windowwidth) + 100);
                      if (para.count == 'en-us' || para.count == 'es-us') {
                        setFbcustomglaswidth((parseFloat(parseFloat(windowwidth).toFixed(2)) + 3.94).toFixed(2));
                      }
                    }}
                  >
                    <img
                      width="30"
                      src={
                        fbsystem == 'EasyGlassView'
                          ? 'https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easyglassview_wall.jpg'
                          : 'https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/mod6507_wall.jpg'
                      }
                    />
                  </button>

                  <h3>
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[141] : 'Mount on wall'}
                  </h3>
                </div>
                <div className="FrenchBalconySystemCard">
                  <button
                    className={fenstermontage == 'Inset' && 'activeitem'}
                    onClick={() => {
                      setfenstermontage('Inset');

                      setFbcustomglaswidth(parseInt(windowwidth) - 60);
                      if (para.count == 'en-us' || para.count == 'es-us') {
                        setFbcustomglaswidth(parseFloat(windowwidth).toFixed(2) - 2.36);
                      }
                    }}
                  >
                    <img
                      width="30"
                      src={
                        fbsystem == 'EasyGlassView'
                          ? 'https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easyglassview_frame.jpg'
                          : 'https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/mod6507_frame.jpg'
                      }
                    />
                  </button>

                  <h3>
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[140] : 'Mount on frame'}
                  </h3>
                </div>
              </div>
            </div>
          )}
          <div className="forbackdiv">
            <button
              className="backbtn"
              onClick={() => {
                setselectstep(1);
                window.scrollTo(0, 0);
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#030303" viewBox="0 0 256 256">
                <path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z"></path>
              </svg>
            </button>
            <button className="forbtn" id="ConfiguratorStep2" onClick={() => setselectstep(3)}>
              {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[0] : 'Next Step'}
            </button>
          </div>
        </>
      );
    }

    if (selectstep == 3) {
      return (
        <>
          {gelaender != 'frenchbalcony' && (
            <motion.div className="step1choice step1-configurator step3-configurator">
              <h3 className="Headline-configurator">
                {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[2] : 'Define measurements'}
              </h3>

              {gelaender != 'qline' && (
                <div className="Handrailselect-wrap">
                  <div className="step1-selection">
                    <h4>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[3] : 'Height'}</h4>

                    <div className="heightclass">
                      <button
                        ref={height1}
                        className={hohe == 900 && 'activeitem'}
                        onClick={() => {
                          sethohe(900);
                        }}
                      >
                        {params.count != ('en-us' || 'es-us') ? '900' + ' mm' : 36 + '"'}{' '}
                      </button>
                      <button
                        ref={height2}
                        className={hohe == 1000 && 'activeitem'}
                        onClick={() => {
                          sethohe(1000);
                        }}
                      >
                        {params.count != ('en-us' || 'es-us') ? '1000' + ' mm' : 42 + '"'}
                      </button>
                      <button
                        ref={height3}
                        className={hohe == 1100 && 'activeitem'}
                        onClick={() => {
                          sethohe(1100);
                        }}
                      >
                        {params.count != ('en-us' || 'es-us') ? '1100' + ' mm' : 48 + '"'}
                      </button>
                    </div>
                  </div>
                </div>
              )}

              <div className="Handrailselect-wrap">
                <div className="step1-selection step-3-measurements-section">
                  <div className="">
                    <h4>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[31] : 'Sections'}</h4>
                  </div>
                  <div className="measurementinputclass">
                    <label>
                      <span>
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[6] : 'Length'} A
                      </span>
                      <input
                        type="number"
                        id="Measurement1"
                        placeholder={
                          params.count != ('en-us' || 'es-us') ? len1 + ' mm' : parseFloat(len1 / 25.4).toFixed(2) + '"'
                        }
                        onChange={(e) => {
                          adjustmeasure(e.target.value, '1');
                          setglaspanelwithi(100.00001);
                        }}
                      />
                    </label>
                    {(form == 'u' || form == 'l') && (
                      <label>
                        <span>
                          {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[6] : 'Length'} B
                        </span>
                        <input
                          id="Measurement2"
                          placeholder={
                            params.count != ('en-us' || 'es-us')
                              ? len2 + ' mm'
                              : parseFloat(len2 / 25.4).toFixed(2) + '"'
                          }
                          onChange={(e) => {
                            adjustmeasure(e.target.value, '2');
                            setglaspanelwithl(100.00001);
                          }}
                          type="number"
                        />
                      </label>
                    )}
                    {form == 'u' && (
                      <label>
                        <span>
                          {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[6] : 'Length'} C
                        </span>
                        <input
                          id="Measurement3"
                          placeholder={
                            params.count != ('en-us' || 'es-us')
                              ? len3 + ' mm'
                              : parseFloat(len3 / 25.4).toFixed(2) + '"'
                          }
                          onChange={(e) => {
                            adjustmeasure(e.target.value, '3');
                            setglaspanelwithu(100.00001);
                          }}
                          type="number"
                        />
                      </label>
                    )}
                  </div>
                  <p id="Configurator-size-error-warning"></p>
                </div>
              </div>

              {gelaender == 'glass' && cuttosize && (
                <div className="Configurator-checkbox-step3-top">
                  <div className="Configurator-step3-checkbox-div">
                    <input
                      checked
                      id="configcuttosizeid"
                      onChange={() => {
                        if (document.getElementById('configcuttosizeid').checked) {
                          setcuttosize(true);
                        } else {
                          setcuttosize(false);
                        }
                      }}
                      type="checkbox"
                    />
                    <label>
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[91] : 'Cut to size?'}
                    </label>
                  </div>
                  <span id="step-3-hidden-i">
                    <div className="step-3-hidden-i ConfigHoveText">
                      <p>{infotext.data.length > 0 && infotext.data[0].attributes.FreeData3.data[1]}</p>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#676767" viewBox="0 0 256 256">
                      <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"></path>
                    </svg>
                  </span>
                </div>
              )}
              {gelaender == 'glass' && !cuttosize && (
                <div className="Configurator-checkbox-step3-top">
                  <div className="Configurator-step3-checkbox-div">
                    <input
                      id="configcuttosizeid"
                      onChange={() => {
                        if (document.getElementById('configcuttosizeid').checked) {
                          setcuttosize(true);
                        } else {
                          setcuttosize(false);
                        }
                      }}
                      type="checkbox"
                    />
                    <label>
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[91] : 'Cut to size?'}
                    </label>
                  </div>
                  <span id="step-3-hidden-i">
                    <div className="step-3-hidden-i ConfigHoveText">
                      <p>{infotext.data.length > 0 && infotext.data[0].attributes.FreeData3.data[1]}</p>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#676767" viewBox="0 0 256 256">
                      <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"></path>
                    </svg>
                  </span>
                </div>
              )}

              {gelaender == 'qline' && montageart == 'top' && (
                <div className="Configurator-checkbox-step3-top">
                  <div className="Configurator-step3-checkbox-div">
                    <label>
                      {infotext.data.length > 0
                        ? infotext.data[0].attributes.FreeData1.data[152]
                        : '100 mm offset topmount'}
                    </label>
                  </div>
                  <span id="step-3-hidden-i">
                    <div className="step-3-hidden-i ConfigHoveText">
                      <p>
                        {infotext.data.length > 0
                          ? infotext.data[0].attributes.FreeData1.data[153]
                          : 'We concider 100mm offset to the edge of the underground'}
                      </p>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#676767" viewBox="0 0 256 256">
                      <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"></path>
                    </svg>
                  </span>
                </div>
              )}

              {gelaender != 'glass' && gelaender != 'baseclamps' && gelaender != 'qline' && cuttosize && (
                <div className="Configurator-checkbox-step3-top">
                  <div className="Configurator-step3-checkbox-div">
                    <input
                      checked
                      id="configcuttosizeid"
                      onChange={() => {
                        if (document.getElementById('configcuttosizeid').checked) {
                          setcuttosize(true);
                        } else {
                          setcuttosize(false);
                        }
                      }}
                      type="checkbox"
                    />
                    <label>
                      {infotext.data.length > 0
                        ? infotext.data[0].attributes.FreeData1.data[92]
                        : 'Cut Handrail to size?'}
                    </label>
                  </div>
                  <span id="step-3-hidden-i">
                    <div className="step-3-hidden-i ConfigHoveText">
                      <p>{infotext.data.length > 0 && infotext.data[0].attributes.FreeData3.data[0]}</p>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#676767" viewBox="0 0 256 256">
                      <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"></path>
                    </svg>
                  </span>
                </div>
              )}
              {gelaender != 'glass' && gelaender != 'baseclamps' && gelaender != 'qline' && !cuttosize && (
                <div className="Configurator-checkbox-step3-top">
                  <div className="Configurator-step3-checkbox-div">
                    <input
                      id="configcuttosizeid"
                      onChange={() => {
                        if (document.getElementById('configcuttosizeid').checked) {
                          setcuttosize(true);
                        } else {
                          setcuttosize(false);
                        }
                      }}
                      type="checkbox"
                    />
                    <label>
                      {infotext.data.length > 0
                        ? infotext.data[0].attributes.FreeData1.data[92]
                        : 'Cut Handrail to size?'}
                    </label>
                  </div>
                  <span id="step-3-hidden-i">
                    <div className="step-3-hidden-i ConfigHoveText">
                      <p>{infotext.data.length > 0 && infotext.data[0].attributes.FreeData3.data[0]}</p>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#676767" viewBox="0 0 256 256">
                      <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"></path>
                    </svg>
                  </span>
                </div>
              )}

              {gelaender == 'baseclamps' && (
                <>
                  {' '}
                  <br /> <br />
                  <h4 className="BaseClampHeadline">
                    {infotext.data.length > 0 && infotext.data[0].attributes.FreeData1.data[111]}
                  </h4>
                  <div className="select-container" id="ConfigSelectGlassThiccness">
                    {para.count != 'en-us' && para.count != 'es-us' && (
                      <select
                        value={glassthicknessbaseclamps}
                        onChange={(e) => {
                          setglassthicknessbaseclamps(e.target.value);
                          if (
                            e.target.value != '17.52mm' &&
                            e.target.value != '16.76mm' &&
                            e.target.value != '5/8"' &&
                            e.target.value != '11/16"'
                          ) {
                            setbaseclampsubsystem('64');
                          }
                        }}
                      >
                        <option value={'16.76mm'}>16.76mm</option>
                        <option value={'17.52mm'}>17.52mm</option>
                        <option value={'20.76mm'}>20.76mm</option>
                        <option value={'21.52mm'}>21.52mm</option>
                      </select>
                    )}
                    {(para.count == 'en-us' || para.count == 'es-us') && (
                      <select
                        value={glassthicknessbaseclamps}
                        onChange={(e) => {
                          setglassthicknessbaseclamps(e.target.value);
                          if (
                            e.target.value != '17.52mm' &&
                            e.target.value != '16.76mm' &&
                            e.target.value != '5/8"' &&
                            e.target.value != '11/16"'
                          ) {
                            setbaseclampsubsystem('64');
                          }
                        }}
                      >
                        <option value={'5/8"'}>5/8"</option>
                        <option value={'11/16"'}>11/16"</option>
                        <option value={'13/16"'}>13/16"</option>
                        <option value={'27/32"'}>27/32"</option>
                      </select>
                    )}
                  </div>
                </>
              )}

              {gelaender == 'baseclamps' && (
                <>
                  {' '}
                  <br /> <br />
                  <div className="Baseclampsystem-hover">
                    <h4 className="BaseClampHeadline" id="HeadlineSystem">
                      {infotext.data.length > 0 && infotext.data[0].attributes.FreeData1.data[112]}
                    </h4>
                    <span>
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7 0.5C5.71442 0.5 4.45772 0.881218 3.3888 1.59545C2.31988 2.30968 1.48676 3.32484 0.994786 4.51256C0.502816 5.70028 0.374095 7.00721 0.624899 8.26809C0.875703 9.52896 1.49477 10.6872 2.40381 11.5962C3.31285 12.5052 4.47104 13.1243 5.73192 13.3751C6.99279 13.6259 8.29973 13.4972 9.48744 13.0052C10.6752 12.5132 11.6903 11.6801 12.4046 10.6112C13.1188 9.54229 13.5 8.28558 13.5 7C13.4982 5.27665 12.8128 3.62441 11.5942 2.40582C10.3756 1.18722 8.72335 0.50182 7 0.5ZM7 12.5C5.91221 12.5 4.84884 12.1774 3.94437 11.5731C3.0399 10.9687 2.33495 10.1098 1.91867 9.10476C1.50238 8.09977 1.39347 6.9939 1.60568 5.927C1.8179 4.86011 2.34173 3.8801 3.11092 3.11091C3.8801 2.34172 4.86011 1.8179 5.92701 1.60568C6.9939 1.39346 8.09977 1.50238 9.10476 1.91866C10.1098 2.33494 10.9687 3.03989 11.5731 3.94436C12.1774 4.84883 12.5 5.9122 12.5 7C12.4983 8.45818 11.9184 9.85617 10.8873 10.8873C9.85617 11.9184 8.45819 12.4983 7 12.5ZM8 10C8 10.1326 7.94732 10.2598 7.85356 10.3536C7.75979 10.4473 7.63261 10.5 7.5 10.5C7.23479 10.5 6.98043 10.3946 6.7929 10.2071C6.60536 10.0196 6.5 9.76522 6.5 9.5V7C6.36739 7 6.24022 6.94732 6.14645 6.85355C6.05268 6.75979 6 6.63261 6 6.5C6 6.36739 6.05268 6.24021 6.14645 6.14645C6.24022 6.05268 6.36739 6 6.5 6C6.76522 6 7.01957 6.10536 7.20711 6.29289C7.39465 6.48043 7.5 6.73478 7.5 7V9.5C7.63261 9.5 7.75979 9.55268 7.85356 9.64645C7.94732 9.74021 8 9.86739 8 10ZM6 4.25C6 4.10166 6.04399 3.95666 6.1264 3.83332C6.20881 3.70999 6.32595 3.61386 6.46299 3.55709C6.60003 3.50032 6.75083 3.48547 6.89632 3.51441C7.04181 3.54335 7.17544 3.61478 7.28033 3.71967C7.38522 3.82456 7.45665 3.9582 7.48559 4.10368C7.51453 4.24917 7.49968 4.39997 7.44291 4.53701C7.38615 4.67406 7.29002 4.79119 7.16668 4.8736C7.04334 4.95601 6.89834 5 6.75 5C6.55109 5 6.36032 4.92098 6.21967 4.78033C6.07902 4.63968 6 4.44891 6 4.25Z"
                          fill="#001020"
                        />
                      </svg>

                      <div id="Confighovertext-baseclamps">
                        <p>{infotext.data.length > 0 && infotext.data[0].attributes.FreeData1.data[113]}</p>
                      </div>
                    </span>
                  </div>
                  <div className="BaseClampSystem">
                    <button
                      onClick={() => {
                        setbaseclampsubsystem('60');
                      }}
                      id={
                        glassthicknessbaseclamps == '16.76mm' ||
                        glassthicknessbaseclamps == '17.52mm' ||
                        glassthicknessbaseclamps == '11/16"' ||
                        glassthicknessbaseclamps == '5/8"'
                          ? 'MOD6000'
                          : 'inactivesubsystem'
                      }
                      className={baseclampsubsystem == '60' && 'activeitem'}
                    >
                      MOD 6000
                    </button>
                    <button
                      id="MOD6400"
                      onClick={() => {
                        setbaseclampsubsystem('64');
                      }}
                      className={baseclampsubsystem == '64' && 'activeitem'}
                    >
                      MOD 6400
                    </button>
                  </div>
                </>
              )}

              <div className="Handrailselect-wrap">
                <div
                  className="Handrailselect step1-selection Configurator-MountBlock"
                  id={gelaender == 'baseclamps' && 'hiddenmount'}
                >
                  <h4>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[30] : 'Mount'}</h4>
                  <div className="inoutchoice" id="ConfigMountingOptions">
                    <button
                      id={gelaender != 'baseclamps' && 'topmont'}
                      className={montageart == 'top' && 'activeitem'}
                      ref={topmountref}
                      onClick={() => {
                        setmontageart('top');
                        activeitem(topmountref, 'step3', 2);
                      }}
                    >
                      <p>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[4] : 'Topmount'}</p>
                      <span>
                        <img
                          width="40"
                          src={
                            gelaender != 'glass' && gelaender != 'qline'
                              ? 'https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/top_mount.webp'
                              : gelaender == 'qline'
                                ? 'https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/qline_top.jpg'
                                : 'https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easy_glass_topmount.webp'
                          }
                        />
                      </span>
                    </button>
                    <button
                      id={gelaender != 'baseclamps' && 'sidemont'}
                      className={montageart == 'side' && 'activeitem'}
                      ref={faciamountref}
                      onClick={() => {
                        setmontageart('side');
                        activeitem(faciamountref, 'step3', 2);

                        if (colorr == 'brano' && gelaender === 'baluster') {
                          setcolorr('gray');
                        }

                        if (gelaender == 'qline' && qlineinfill == 'cables' && form != 'i') {
                          setqlineinfill('glass');
                        }
                      }}
                    >
                      <p>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[5] : 'Faciamount'}</p>
                      <span>
                        <img
                          width="40"
                          src={
                            gelaender != 'glass' && gelaender != 'qline'
                              ? 'https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/fascia_mount.webp'
                              : gelaender == 'qline'
                                ? 'https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/qline_fascia.jpg'
                                : 'https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easy_glass_fasciamount.webp'
                          }
                        />
                      </span>
                    </button>
                  </div>
                </div>
              </div>

              {(gelaender == 'glass' || gelaender == 'baseclamps') && includeglass && (
                <div className="Configurator-checkbox-step3">
                  <div className="Configurator-step3-checkbox-div">
                    <input
                      checked
                      id="configglassid"
                      onChange={() => {
                        if (document.getElementById('configglassid').checked) {
                          setincludeglass(true);
                        } else {
                          setincludeglass(false);
                        }
                      }}
                      type="checkbox"
                    />
                    <label>
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[93] : 'Include Glass?'}
                    </label>
                  </div>
                </div>
              )}
              {(gelaender == 'glass' || gelaender == 'baseclamps') && !includeglass && (
                <div className="Configurator-checkbox-step3">
                  <div className="Configurator-step3-checkbox-div">
                    <input
                      id="configglassid"
                      onChange={() => {
                        if (document.getElementById('configglassid').checked) {
                          setincludeglass(true);
                        } else {
                          setincludeglass(false);
                        }
                      }}
                      type="checkbox"
                    />
                    <label>
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[93] : 'Include Glass?'}
                    </label>
                  </div>
                </div>
              )}
            </motion.div>
          )}

          {gelaender == 'frenchbalcony' && (
            <div style={{ paddingLeft: '16px', paddingRight: '16px' }}>
              <h3 className="Headline-configurator">
                {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[143] : 'Select your system'}
              </h3>
              <div className="FrenchBalconySystemSelect">
                <div className="FrenchBalconySystemCard">
                  <button
                    className={fbsystem == 'EasyGlassView' && 'activeitem'}
                    onClick={() => {
                      setfbsystem('EasyGlassView');
                      sethandlaufmat('edgep');
                      setcolorr('brano');
                    }}
                  >
                    <img
                      width={200}
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/easyglassview-step3.png"
                    />
                  </button>
                  <h3>Easy Glass View</h3>
                </div>
                <div className="FrenchBalconySystemCard">
                  <button
                    className={fbsystem == 'Mod6507' && 'activeitem'}
                    onClick={() => {
                      setfbsystem('Mod6507');
                      setcolorr(translationEdelstahl[para.count]);
                    }}
                  >
                    <img
                      width={200}
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/mod6507-step3.png"
                    />
                  </button>
                  <h3>MOD 6507</h3>
                </div>
              </div>
              <>
                {/*<h4>Depth of Windows</h4>
                <br />
                <div className="FrontOrInset">
                  <button
                    className={windowinset > 60 && 'activeitem'}
                    onClick={() => {
                      setwindowinset(100);
                    }}
                  >
                    {'above 60mm'}
                  </button>
                  <button
                    className={windowinset < 60 && 'activeitem'}
                    onClick={() => {
                      setwindowinset(0);
                    }}
                  >
                    {'below 60mm'}
                  </button>
                </div>
                <label>
                  <input 
                    type="range" 
                    style={{width:"100%"}}
                    min="0" 
                    max="500" 
                    step="1" 
                    value={windowinset} 
                    onChange={(e) => setwindowinset(e.target.value)} 
                  />
                  
                  {windowinset} mm
                </label>
                <div className='PlusMinusButtonWrap'>
                <button className='PlusMinusButton' onClick={()=>{setwindowinset(windowinset = parseInt(windowinset)-1)}}>-</button>
                <button className='PlusMinusButton' onClick={()=>{setwindowinset(windowinset = parseInt(windowinset)+1)}}>+</button>
                </div>*/}{' '}
              </>
            </div>
          )}

          <div className="forbackdiv">
            <button
              className="backbtn"
              onClick={() => {
                setselectstep(2);
                setstep1bool(true);
                window.scrollTo(0, 0);
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#030303" viewBox="0 0 256 256">
                <path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z"></path>
              </svg>
            </button>
            <button
              className="forbtn"
              id="ConfiguratorStep3"
              onClick={() => {
                setselectstep(4);
                window.scrollTo(0, 0);
              }}
            >
              {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[0] : 'Next Step'}
            </button>
          </div>
        </>
      );
    }

    if (selectstep == 4) {
      return (
        <>
          {gelaender != 'frenchbalcony' && gelaender != 'qline' && (
            <motion.div className="step1-configurator step3-configurator">
              <h3 className="Headline-configurator">
                {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[45] : 'Select a mounting type'}
              </h3>
              <div className="Handrailselect-wrap">
                <div className="Handrailselect step1-selection">
                  <h4>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[27] : 'Underground'}</h4>
                  <div className="inoutchoice underground-choice-class">
                    <button
                      ref={unterg1}
                      className={untergrundd == 'beton' && 'activeitem'}
                      onClick={() => {
                        setuntergrundd('beton');
                        activeitem(unterg1, 'step4', 1);
                      }}
                    >
                      <p style={{ textAlign: 'left' }}>
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[7] : 'Concrete'}
                        {gelaender == 'glass' && montageart == 'top' && (
                          <span>
                            {infotext.data.length > 0
                              ? infotext.data[0].attributes.FreeData1.data[107]
                              : '(60 mm distance)'}
                          </span>
                        )}
                      </p>
                      <span>
                        <img
                          width="30"
                          src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/mounting_surface_concrete.webp"
                        />
                      </span>
                    </button>
                    <button
                      ref={unterg2}
                      className={untergrundd == 'holz' && 'activeitem'}
                      onClick={() => {
                        setuntergrundd('holz');
                        activeitem(unterg2, 'step4', 1);
                      }}
                    >
                      <p style={{ textAlign: 'left' }}>
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[8] : 'Wood'}
                        {gelaender == 'glass' && montageart == 'top' && (
                          <span>
                            {infotext.data.length > 0
                              ? infotext.data[0].attributes.FreeData1.data[107]
                              : '(60 mm distance)'}
                          </span>
                        )}
                      </p>
                      <span>
                        <img
                          width="30"
                          src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/mounting_surface_wood.webp"
                        />
                      </span>
                    </button>
                    <button
                      ref={unterg3}
                      className={untergrundd == 'metall' && 'activeitem'}
                      onClick={() => {
                        setuntergrundd('metall');
                        activeitem(unterg3, 'step4', 1);
                      }}
                    >
                      <p style={{ textAlign: 'left' }}>
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[9] : 'Metall'}
                        {gelaender == 'glass' && montageart == 'top' && (
                          <span>
                            {infotext.data.length > 0
                              ? infotext.data[0].attributes.FreeData1.data[108]
                              : '(0 mm distance)'}
                          </span>
                        )}
                      </p>
                      <span>
                        <img
                          width="30"
                          src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/mounting_surface_metal.webp"
                        />
                      </span>
                    </button>
                  </div>
                </div>
              </div>
              <br />

              {gelaender == 'baseclamps' && (
                <div className="baseclampsglassdistribution">
                  <h4 className="BaseClampHeadline">
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[114] : 'Glass A'}
                  </h4>
                  <div className="inoutchoice">
                    <button
                      className={glaspanelwidthi == 100.00001 ? 'activeitem' : ''}
                      onClick={() => {
                        setglaspanelwithi(100.00001);
                      }}
                    >
                      <span>
                        <img
                          width="120"
                          src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/Mod6400_2_klemmen.png"
                        />
                      </span>
                    </button>
                    <button
                      id={!allowed3clampsi ? 'greyoutglass' : ''}
                      className={glaspanelwidthi == 150.00001 ? 'activeitem' : ''}
                      onClick={() => {
                        setglaspanelwithi(150.00001);
                      }}
                    >
                      <span>
                        <img
                          width="120"
                          src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/Mod6400_3_klemmen.png"
                        />
                      </span>
                    </button>
                  </div>
                  <br />
                  {(form == 'l' || form == 'u') && (
                    <>
                      <h4 className="BaseClampHeadline">
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[115] : 'Glass B'}
                      </h4>
                      <div className="inoutchoice">
                        <button
                          className={glaspanelwidthl == 100.00001 ? 'activeitem' : ''}
                          onClick={() => {
                            setglaspanelwithl(100.00001);
                          }}
                        >
                          <span>
                            <img
                              width="120"
                              src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/Mod6400_2_klemmen.png"
                            />
                          </span>
                        </button>
                        <button
                          id={!allowed3clampsl ? 'greyoutglass' : ''}
                          className={glaspanelwidthl == 150.00001 ? 'activeitem' : ''}
                          onClick={() => {
                            setglaspanelwithl(150.00001);
                          }}
                        >
                          <span>
                            <img
                              width="120"
                              src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/Mod6400_3_klemmen.png"
                            />
                          </span>
                        </button>
                      </div>
                    </>
                  )}
                  <br />
                  {form == 'u' && (
                    <>
                      <h4 className="BaseClampHeadline">
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[116] : 'Glass C'}
                      </h4>
                      <div className="inoutchoice">
                        <button
                          className={glaspanelwidthu == 100.00001 ? 'activeitem' : ''}
                          onClick={() => {
                            setglaspanelwithu(100.00001);
                          }}
                        >
                          <span>
                            <img
                              width="120"
                              src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/Mod6400_2_klemmen.png"
                            />
                          </span>
                        </button>
                        <button
                          id={!allowed3clampsu ? 'greyoutglass' : ''}
                          className={glaspanelwidthu == 150.00001 ? 'activeitem' : ''}
                          onClick={() => {
                            setglaspanelwithu(150.00001);
                          }}
                        >
                          <span>
                            <img
                              width="120"
                              src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/Mod6400_3_klemmen.png"
                            />
                          </span>
                        </button>
                      </div>
                    </>
                  )}
                  <br />
                </div>
              )}

              <div className="Handrailselect-wrap">
                <div className="Handrailselect step1-selection" id={gelaender == 'baseclamps' && 'hiddenmount'}>
                  <h4>
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[46] : 'Wall mounting A'}
                  </h4>
                  <div className="inoutchoice">
                    <button
                      ref={wall1s}
                      className={wall1 && 'activeitem'}
                      onClick={() => {
                        setwall1(true);
                        activeitem(wall1s, 'step4', 2);
                      }}
                    >
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[48] : 'Wall connection'}
                      <span>
                        <img
                          width="30"
                          src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/wall_connection_yes.webp"
                        />
                      </span>
                    </button>
                    <button
                      ref={free1}
                      className={!wall1 && 'activeitem'}
                      onClick={() => {
                        setwall1(false);
                        activeitem(free1, 'step4', 2);
                      }}
                    >
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[49] : 'No connection'}
                      <span>
                        <img
                          width="30"
                          src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/wall_connection_no.webp"
                        />
                      </span>
                    </button>
                  </div>
                  <br /> <br />
                  <h4>
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[47] : 'Wall mounting B'}
                  </h4>
                  <div className="inoutchoice">
                    <button
                      ref={wall2s}
                      className={wall2 && 'activeitem'}
                      onClick={() => {
                        setwall2(true);
                        activeitem(wall2s, 'step4', 3);
                      }}
                    >
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[48] : 'Wall connection'}
                      <span>
                        <img
                          width="30"
                          src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/wall_connection_yes.webp"
                        />
                      </span>
                    </button>
                    <button
                      ref={free2}
                      className={!wall2 && 'activeitem'}
                      onClick={() => {
                        setwall2(false);
                        activeitem(free2, 'step4', 3);
                      }}
                    >
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[49] : 'No connection'}
                      <span>
                        <img
                          width="30"
                          src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/wall_connection_no.webp"
                        />
                      </span>
                    </button>
                  </div>
                </div>
              </div>
              <br />

              <div className="forbackdiv">
                <button
                  className="backbtn"
                  onClick={() => {
                    setselectstep(3);
                    window.scrollTo(0, 0);
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#030303" viewBox="0 0 256 256">
                    <path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z"></path>
                  </svg>
                </button>
                <button
                  className="forbtn"
                  id="ConfiguratorStep4"
                  onClick={() => {
                    setselectstep(5);
                    window.scrollTo(0, 0);
                  }}
                >
                  {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[0] : 'Next Step'}
                </button>
              </div>
            </motion.div>
          )}
          {gelaender == 'frenchbalcony' && (
            <motion.div className="step1-configurator step3-configurator FrenchBalconyWrapStep4">
              <h3 className="FineTuningStep5">
                {infotext.data.length > 0 && infotext.data[0].attributes.FreeData1.data[144]}
              </h3>

              {fbsystem == 'EasyGlassView' && (
                <h4 className={gelaender == 'glass' && 'hide'}>
                  {infotext.data.length > 0 && infotext.data[0].attributes.FreeData1.data[29]}
                </h4>
              )}
              {
                <>
                  {fbsystem == 'EasyGlassView' && (
                    <div className={'inoutchoice ColorSelectFb'}>
                      <button
                        id="gray5"
                        className={colorr == 'gray' && !ralcolorbool && 'activeitem'}
                        ref={colorr1}
                        onClick={() => {
                          setcolorr('gray');
                          setralcolorbool(false);
                        }}
                      >
                        <p id="colordescription1" className={colorr == 'gray' ? '' : ''}>
                          {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[13] : 'Grey'}
                        </p>{' '}
                        <div></div>
                      </button>

                      <button
                        id="brano5"
                        className={colorr == 'brano' && !ralcolorbool && 'activeitem'}
                        ref={colorr3}
                        onClick={() => {
                          setcolorr('brano');
                          setralcolorbool(false);
                        }}
                      >
                        <p id="colordescription3" className={colorr == 'brano' ? '' : ''}>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[60]
                            : 'brushed Anodized'}
                        </p>
                        <div></div>
                      </button>

                      <button
                        id="gray5"
                        className={ralcolorbool && 'activeitem'}
                        ref={colorr1}
                        onClick={() => {
                          setcolorr('gray');
                          setralcolorbool(true);
                        }}
                      >
                        <p id="colordescription1" className="CustomRalColor">
                          RAL:
                          <input
                            type="text"
                            className={ralcolorbool && ralcolor.length != 4 && ralcolor != 5 ? 'error-ral' : ''}
                            onChange={(e) => {
                              const value = e.target.value;
                              // Allow only digits and limit to 4 characters
                              if (/^\d{0,4}$/.test(value)) {
                                setralcolor(value.toString());
                              }
                            }}
                            value={ralcolor}
                            id="RalColorInput"
                            placeholder={'0000'}
                          />
                        </p>{' '}
                        <div>
                          <img
                            src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/multicoloricon.webp"
                            width="48"
                            height="48"
                          />
                        </div>
                      </button>
                    </div>
                  )}

                  {AnkerImAngebot !== undefined && (
                    <div className="Configurator-checkbox-step3-top" style={{ marginLeft: '-8px' }}>
                      <div className="Configurator-step3-checkbox-div">
                        <input
                          id="FbAnkerImAngebot"
                          onChange={() => setAnkerImAngebot(!AnkerImAngebot)}
                          type="checkbox"
                          checked={AnkerImAngebot}
                        />
                        <label style={{ marginLeft: '16px' }} htmlFor="FbAnkerImAngebot">
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[146]
                            : 'Anchor in offer?'}
                        </label>
                      </div>
                    </div>
                  )}

                  <div className="FbCustomGlassWrap">
                    <div className="Configurator-checkbox-step3-top">
                      <div className="Configurator-step3-checkbox-div">
                        <input
                          id="FbCustomGlass"
                          onChange={() => setFbcustomglas(!Fbcustomglas)}
                          type="checkbox"
                          checked={Fbcustomglas}
                        />
                        <label style={{ marginLeft: '16px' }} htmlFor="FbCustomGlass">
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[147]
                            : 'Include glass in offer?'}
                        </label>
                      </div>
                    </div>

                    {Fbcustomglas && (
                      <div className="FrenchBalconyCustomGlass">
                        <p>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[145]
                            : 'We will offer Glaspanels with -60mm and +100mm respectivly to your selected mounting situation. If you prefer a custom glass width please enter your customwidth below'}
                        </p>
                        <label>
                          <span>
                            {param.count != 'en-us' && param.count != 'es-us' && (
                              <>
                                {Fbcustomglaswidth != parseInt(windowwidth) + 100 &&
                                Fbcustomglaswidth != parseInt(windowwidth) - 60
                                  ? infotext.data[0].attributes.FreeData1.data[149] + '(mm):'
                                  : infotext.data[0].attributes.FreeData1.data[148] + '(mm):'}
                              </>
                            )}
                            {(param.count == 'en-us' || param.count == 'es-us') && (
                              <>
                                {Fbcustomglaswidth != parseFloat(windowwidth).toFixed(2) - 2.63 &&
                                Fbcustomglaswidth != parseFloat(windowwidth).toFixed(2) + 3.94
                                  ? infotext.data[0].attributes.FreeData1.data[149] + '(inch):'
                                  : infotext.data[0].attributes.FreeData1.data[148] + '(inch):'}
                              </>
                            )}
                          </span>
                          <input
                            value={Fbcustomglaswidth}
                            onChange={(e) => {
                              if (para.count == 'en-us' || para.count == 'es-us') {
                                setFbcustomglaswidth(parseFloat(e.target.value).toFixed(2));
                              } else {
                                setFbcustomglaswidth(e.target.value);
                              }
                            }}
                            type="text"
                            placeholder={Fbcustomglaswidth + 'mm'}
                          />
                        </label>
                      </div>
                    )}
                  </div>
                </>
              }

              <div className="forbackdiv">
                <button
                  className="backbtn"
                  onClick={() => {
                    setselectstep(3);
                    window.scrollTo(0, 0);
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#030303" viewBox="0 0 256 256">
                    <path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z"></path>
                  </svg>
                </button>
                <button
                  className="forbtn"
                  id="ConfiguratorStep4"
                  onClick={() => {
                    setselectstep(fbsystem == 'EasyGlassView' ? 5 : 6);
                    fbsystem == 'Mod6507' && saveConfig();
                    window.scrollTo(0, 0);
                  }}
                >
                  {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[0] : 'Next Step'}
                </button>
              </div>
            </motion.div>
          )}
          {gelaender == 'qline' && (
            <motion.div className="step1-configurator step3-configurator">
              <h3 className="Headline-configurator">
                {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[155] : 'Choose your Design'}
              </h3>

              {gelaender == 'qline' && (
                <>
                  <br />
                  <h4 className="QlineHeadline">
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[156] : 'Select system'}
                  </h4>
                  <div className="Handrailselect-wrap">
                    <div className="PostSelect">
                      <button
                        className={PostShape == 'round' && Pfostenrund == '42' && 'activeitem'}
                        onClick={() => {
                          setPostShape('round');
                          setPfostenrund('42');
                          sethandlaufmat('round');
                          setQlineHandlauf('42');
                          setClampShape('round');
                          if (
                            para.count == 'en-us' ||
                            para.count == 'es-us' ||
                            para.count == 'fr-ca' ||
                            para.count == 'en-ca'
                          ) {
                            setClampShape('square');
                          }
                        }}
                      >
                        <span>
                          {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[157] : 'Q-line 42'}
                        </span>
                        <img
                          width="30"
                          src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/Formen_Configurator_BlueK.webp"
                        />
                      </button>
                      <button
                        className={PostShape == 'round' && Pfostenrund == '48' && 'activeitem'}
                        onClick={() => {
                          setPostShape('round');
                          setPfostenrund('48');
                          sethandlaufmat('round');
                          setQlineHandlauf('48');
                          setClampShape('round');
                          if (
                            para.count == 'en-us' ||
                            para.count == 'es-us' ||
                            para.count == 'fr-ca' ||
                            para.count == 'en-ca'
                          ) {
                            setClampShape('square');
                          }
                        }}
                      >
                        <span>
                          {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[158] : 'Q-line 48'}
                        </span>
                        <img
                          width="30"
                          src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/Formen_Configurator_BlueK.webp"
                        />
                      </button>

                      <button
                        className={PostShape == '40x40' && 'activeitem'}
                        onClick={() => {
                          setPostShape('40x40');
                          sethandlaufmat('square');
                          setClampShape('square');
                          if (qlineinfill == 'cables' && form != 'i') {
                            setqlineinfill('glass');
                          }
                        }}
                      >
                        <span>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[159]
                            : 'Square Line 40x40'}
                        </span>
                        <img
                          width="30"
                          src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/Formen_Configurator_BlueQ.webp"
                        />
                      </button>
                      <button
                        className={PostShape == '60x30' && 'activeitem'}
                        onClick={() => {
                          setPostShape('60x30');
                          sethandlaufmat('60x30');

                          setcolorr('satin316');
                          setClampShape('square');
                          if (qlineinfill == 'cables' && form != 'i') {
                            setqlineinfill('glass');
                          }
                        }}
                      >
                        <span>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[160]
                            : 'Square Line 60x30'}
                        </span>
                        <img
                          width="30"
                          src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/Formen_Configurator_BlueR.webp"
                        />
                      </button>
                    </div>
                  </div>
                </>
              )}
              <br />

              <div className="qline-select-infill" id="ConfigSelectInfillQline">
                <h4 className="QlineHeadline">
                  {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[161] : 'Select Infill'}
                </h4>
                <div className="inoutchoice qline-select-infill">
                  <>
                    <button
                      className={qlineinfill == 'glass' && 'activeitem'}
                      onClick={() => {
                        setqlineinfill('glass');
                      }}
                    >
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[162] : 'Glass'}
                    </button>
                    {((PostShape == 'round' && montageart == 'top') || form == 'i') && (
                      <button
                        className={qlineinfill == 'cables' && 'activeitem'}
                        onClick={() => {
                          setqlineinfill('cables');
                        }}
                      >
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[163] : 'Fast-fix Cables'}
                      </button>
                    )}
                    <button
                      className={qlineinfill == 'verticalbars' && 'activeitem'}
                      onClick={() => {
                        setqlineinfill('verticalbars');
                      }}
                    >
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[164] : '12mm Crossbars'}
                    </button>

                    {para.count != 'es-us' && para.count != 'en-us' && (
                      <button
                        className={qlineinfill == 'plates' && 'activeitem'}
                        id="ConfiguratorStep4-Plates"
                        onClick={() => {
                          setqlineinfill('plates');
                        }}
                      >
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[165] : 'Plates'}
                        <span id="step-3-hidden-i-plates">
                          <div className="step-3-hidden-i ConfigHoveText">
                            <p>
                              {infotext.data.length > 0
                                ? infotext.data[0].attributes.FreeData1.data[166]
                                : 'All plate infill will be bespoke - please discuss exact pattern/requirements with sales team'}
                            </p>
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            fill="#676767"
                            viewBox="0 0 256 256"
                          >
                            <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"></path>
                          </svg>
                        </span>
                      </button>
                    )}
                    <button
                      className={qlineinfill == 'NoInfill' && 'activeitem'}
                      onClick={() => {
                        setqlineinfill('NoInfill');
                      }}
                    >
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[167] : 'No Infill'}
                    </button>
                  </>
                </div>
              </div>

              <div className="forbackdiv">
                <button
                  className="backbtn"
                  onClick={() => {
                    setselectstep(3);
                    window.scrollTo(0, 0);
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#030303" viewBox="0 0 256 256">
                    <path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z"></path>
                  </svg>
                </button>
                <button
                  className="forbtn"
                  id="ConfiguratorStep4"
                  onClick={() => {
                    setselectstep(5);
                    window.scrollTo(0, 0);
                  }}
                >
                  {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[0] : 'Next Step'}
                </button>
              </div>
            </motion.div>
          )}
        </>
      );
    }

    if (selectstep == 5) {
      return (
        <>
          {gelaender != 'frenchbalcony' && gelaender != 'qline' && (
            <div className="step1-configurator step3-configurator step5-configurator">
              <h3 className="Headline-configurator">
                {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[50] : 'Select a Handrail type'}
              </h3>
              <div className="Handrailselect-wrap">
                <div className="Handrailselect step1-selection">
                  <h4>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[28] : 'Handrail'}</h4>

                  <div className="inoutchoice">
                    {gelaender != 'glass' && gelaender != 'baseclamps' && (
                      <>
                        <button
                          ref={handlauf2}
                          className={handlaufmat == 'bevel' && 'activeitem'}
                          onClick={() => {
                            sethandlaufmat('bevel');
                            activeitem(handlauf1, 'step5', 1);
                          }}
                        >
                          {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[10] : 'Bevel'}
                          <span>
                            <img
                              width="30"
                              src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/bevel.png"
                            />
                          </span>
                        </button>
                        <button
                          ref={handlauf1}
                          className={handlaufmat == 'straight' && 'activeitem'}
                          onClick={() => {
                            sethandlaufmat('straight');
                            activeitem(handlauf2, 'step5', 1);
                          }}
                        >
                          {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[11] : 'Straight'}
                          <span>
                            <img
                              width="30"
                              src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/straight.png"
                            />
                          </span>
                        </button>
                      </>
                    )}

                    {gelaender == 'baseclamps' && (
                      <>
                        <button
                          ref={handlauf1}
                          className={handlaufmat == 'none' && 'activeitem'}
                          onClick={() => {
                            sethandlaufmat('none');
                          }}
                        >
                          {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[63] : 'none'}
                          <span>
                            <img
                              width="30"
                              src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/edge_protection_no.webp"
                            />
                          </span>
                        </button>
                        <button
                          ref={handlauf2}
                          className={handlaufmat == 'edgep' && 'activeitem'}
                          onClick={() => {
                            sethandlaufmat('edgep');
                          }}
                        >
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[62]
                            : 'Edge protection'}
                          <span>
                            <img
                              width="30"
                              src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/edge_protection_yes.webp"
                            />
                          </span>
                        </button>
                      </>
                    )}

                    {gelaender == 'baseclamps' && handlaufmat != 'none' && cuttosize && (
                      <div className="Configurator-checkbox-step3-top">
                        <div className="Configurator-step3-checkbox-div">
                          <input
                            checked
                            id="configcuttosizeid"
                            onChange={() => {
                              if (document.getElementById('configcuttosizeid').checked) {
                                setcuttosize(true);
                              } else {
                                setcuttosize(false);
                              }
                            }}
                            type="checkbox"
                          />
                          <label>
                            {infotext.data.length > 0
                              ? infotext.data[0].attributes.FreeData1.data[92]
                              : 'Cut Handrail to size?'}
                          </label>
                        </div>
                        <span id="step-3-hidden-i">
                          <div className="step-3-hidden-i ConfigHoveText">
                            <p>{infotext.data.length > 0 && infotext.data[0].attributes.FreeData3.data[0]}</p>
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            fill="#676767"
                            viewBox="0 0 256 256"
                          >
                            <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"></path>
                          </svg>
                        </span>
                      </div>
                    )}
                    {gelaender == 'baseclamps' && handlaufmat != 'none' && !cuttosize && (
                      <div className="Configurator-checkbox-step3-top">
                        <div className="Configurator-step3-checkbox-div">
                          <input
                            id="configcuttosizeid"
                            onChange={() => {
                              if (document.getElementById('configcuttosizeid').checked) {
                                setcuttosize(true);
                              } else {
                                setcuttosize(false);
                              }
                            }}
                            type="checkbox"
                          />
                          <label>
                            {infotext.data.length > 0
                              ? infotext.data[0].attributes.FreeData1.data[92]
                              : 'Cut Handrail to size?'}
                          </label>
                        </div>
                        <span id="step-3-hidden-i">
                          <div className="step-3-hidden-i ConfigHoveText">
                            <p>{infotext.data.length > 0 && infotext.data[0].attributes.FreeData3.data[0]}</p>
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            fill="#676767"
                            viewBox="0 0 256 256"
                          >
                            <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"></path>
                          </svg>
                        </span>
                      </div>
                    )}

                    {gelaender == 'glass' && (
                      <>
                        <button
                          className={handlaufmat == 'edgep' && 'activeitem'}
                          onClick={() => {
                            sethandlaufmat('edgep');
                          }}
                        >
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[62]
                            : 'Edge protection'}
                          <span>
                            <img
                              width="30"
                              src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/edge_protection_yes.webp"
                            />
                          </span>
                        </button>
                        <button
                          className={handlaufmat == 'round' && 'activeitem'}
                          onClick={() => {
                            sethandlaufmat('round');
                          }}
                        >
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[105]
                            : 'Edge protection'}
                          <span>
                            <img
                              width="30"
                              src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/round_caprail.webp"
                            />
                          </span>
                        </button>
                        <button
                          className={handlaufmat == 'normal' && 'activeitem'}
                          onClick={() => {
                            sethandlaufmat('normal');
                          }}
                        >
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[106]
                            : 'Edge protection'}
                          <span>
                            <img
                              width="30"
                              src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/u_profile.webp"
                            />
                          </span>
                        </button>
                        <button
                          className={handlaufmat == 'none' && 'activeitem'}
                          onClick={() => {
                            sethandlaufmat('none');
                          }}
                        >
                          {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[63] : 'none'}
                          <span>
                            <img
                              width="30"
                              src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/edge_protection_no.webp"
                            />
                          </span>
                        </button>
                      </>
                    )}
                  </div>

                  <div className="step1-selection step5-colorselect">
                    <h4 className={gelaender == 'glass' && 'hide'}>
                      {infotext.data.length > 0 &&
                        gelaender != 'baseclamps' &&
                        infotext.data[0].attributes.FreeData1.data[29]}
                      {infotext.data.length > 0 &&
                        gelaender == 'baseclamps' &&
                        infotext.data[0].attributes.FreeData1.data[119]}
                    </h4>

                    {gelaender != 'glass' && gelaender != 'baseclamps' && (
                      <div className={'inoutchoice'}>
                        <button
                          id="gray5"
                          className={colorr == 'gray' && 'activeitem'}
                          ref={colorr1}
                          onClick={() => {
                            setcolorr('gray');
                          }}
                        >
                          <p id="colordescription1" className={colorr == 'gray' ? '' : ''}>
                            {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[13] : 'Grey'}
                          </p>{' '}
                          <div></div>
                        </button>
                        {gelaender != 'picket' && para.count != 'en-us' && para.count != 'es-us' && (
                          <button
                            id="anrtz5"
                            className={colorr == 'anrtz' && 'activeitem'}
                            ref={colorr2}
                            onClick={() => {
                              setcolorr('anrtz');
                            }}
                          >
                            <p id="colordescription2" className={colorr == 'anrtz' ? '' : ''}>
                              {infotext.data.length > 0
                                ? infotext.data[0].attributes.FreeData1.data[14]
                                : 'Anthracite grey'}
                            </p>
                            <div></div>
                          </button>
                        )}
                        {gelaender != 'picket' && montageart == 'top' && (
                          <button
                            id="brano5"
                            className={colorr == 'brano' && 'activeitem'}
                            ref={colorr3}
                            onClick={() => {
                              setcolorr('brano');
                            }}
                          >
                            <p id="colordescription3" className={colorr == 'brano' ? '' : ''}>
                              {infotext.data.length > 0
                                ? infotext.data[0].attributes.FreeData1.data[60]
                                : 'brushed Anodized'}
                            </p>
                            <div></div>
                          </button>
                        )}
                        <button
                          id="black5"
                          className={colorr == 'black' && 'activeitem'}
                          ref={colorr3}
                          onClick={() => {
                            setcolorr('black');
                          }}
                        >
                          <p id="colordescription3" className={colorr == 'black' ? '' : ''}>
                            {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[12] : 'Black'}
                          </p>
                          <div></div>
                        </button>
                      </div>
                    )}

                    {gelaender == 'baseclamps' && (
                      <div className={'inoutchoice'}>
                        <button
                          id="polished5"
                          className={colorr == 'gray' && 'activeitem'}
                          ref={colorr1}
                          onClick={() => {
                            setcolorr('gray');
                          }}
                        >
                          <p id="colordescription1" className={colorr == 'gray' ? '' : ''}>
                            {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[117] : 'Grey'}
                          </p>{' '}
                          <div></div>
                        </button>

                        {gelaender != 'picket' && (
                          <button
                            id="brushed5"
                            className={colorr == 'brano' && 'activeitem'}
                            ref={colorr3}
                            onClick={() => {
                              setcolorr('brano');
                            }}
                          >
                            <p id="colordescription3" className={colorr == 'brano' ? '' : ''}>
                              {infotext.data.length > 0
                                ? infotext.data[0].attributes.FreeData1.data[118]
                                : 'brushed Anodized'}
                            </p>
                            <div></div>
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="forbackdiv">
                <button className="backbtn" onClick={() => setselectstep(4)}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#030303" viewBox="0 0 256 256">
                    <path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z"></path>
                  </svg>
                </button>
                <button
                  className="forbtn"
                  id="ConfiguratorStep5"
                  onClick={() => {
                    {
                      setselectstep(6);
                      saveConfig();
                      setshowmenu(false);
                      window.scrollTo(0, 0);
                    }
                  }}
                >
                  {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[16] : 'Finish'}
                </button>
              </div>
            </div>
          )}
          {gelaender == 'frenchbalcony' && (
            <div className="step1-configurator step3-configurator step5-configurator FrenchBalconyWrapStep4">
              <h3 className="Headline-configurator">
                {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[50] : 'Select a Handrail type'}
              </h3>
              <div className="FrenchBalconySystemSelect">
                <div className="FrenchBalconySystemCard">
                  <button
                    className={handlaufmat == 'none' && 'activeitem'}
                    onClick={() => {
                      sethandlaufmat('none');
                    }}
                  >
                    <img
                      width="30"
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/no_handrail_fb.jpg"
                    />
                  </button>
                  <h3>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[63] : 'none'}</h3>
                </div>
                <div className="FrenchBalconySystemCard">
                  <button
                    className={handlaufmat == 'edgep' && 'activeitem'}
                    onClick={() => {
                      sethandlaufmat('edgep');
                    }}
                  >
                    <img
                      width="30"
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/yes_handrail_fb.jpg"
                    />
                  </button>
                  <h3>
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[62] : 'Edge protection'}
                  </h3>
                </div>

                <div className="forbackdiv">
                  <button className="backbtn" onClick={() => setselectstep(4)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#030303" viewBox="0 0 256 256">
                      <path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z"></path>
                    </svg>
                  </button>
                  <button
                    className="forbtn"
                    id="ConfiguratorStep5"
                    onClick={() => {
                      {
                        setselectstep(6);
                        saveConfig();
                        setshowmenu(false);
                        window.scrollTo(0, 0);
                      }
                    }}
                  >
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[16] : 'Finish'}
                  </button>
                </div>
              </div>
            </div>
          )}
          {gelaender == 'qline' && (
            <div className="step1-configurator step3-configurator step5-configurator FrenchBalconyWrapStep4">
              <h3 className="Headline-configurator">
                {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[50] : 'Select a Handrail type'}
              </h3>

              <div className="Handrailselect-wrap">
                <div className="Handrailselect step1-selection">
                  <h4>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[28] : 'Handrail'}</h4>

                  <div className="inoutchoice">
                    {gelaender != 'glass' && gelaender != 'baseclamps' && (
                      <>
                        {((PostShape != '60x30' && Pfostenrund != '48' && PostShape == 'round') ||
                          PostShape == '40x40') && (
                          <button
                            ref={handlauf2}
                            className={handlaufmat == 'round' && QlineHandlauf == '42' && 'activeitem'}
                            onClick={() => {
                              sethandlaufmat('round');
                              setQlineHandlauf('42');
                            }}
                          >
                            {infotext.data.length > 0
                              ? infotext.data[0].attributes.FreeData1.data[168]
                              : '42.4 x 2.0 mm round'}
                            <span>
                              <img
                                width="30"
                                src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/Formen_Configurator_BlueK.webp"
                              />
                            </span>
                          </button>
                        )}
                        {((PostShape != '40x40' && PostShape == 'round' && Pfostenrund != '42') ||
                          PostShape == '60x30') && (
                          <button
                            ref={handlauf2}
                            className={handlaufmat == 'round' && QlineHandlauf == '48' && 'activeitem'}
                            onClick={() => {
                              sethandlaufmat('round');
                              setQlineHandlauf('48');
                            }}
                          >
                            {infotext.data.length > 0
                              ? infotext.data[0].attributes.FreeData1.data[169]
                              : '48.3 x 2.0 mm round'}
                            <span>
                              <img
                                width="30"
                                src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/Formen_Configurator_BlueK.webp"
                              />
                            </span>
                          </button>
                        )}
                        {((PostShape != '60x30' &&
                          Pfostenrund != '48' &&
                          Pfostenrund != '42' &&
                          PostShape != 'round') ||
                          PostShape == '40x40') && (
                          <button
                            ref={handlauf1}
                            className={handlaufmat == 'square' && 'activeitem'}
                            onClick={() => {
                              sethandlaufmat('square');
                            }}
                          >
                            {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[170] : '40x40 mm'}
                            <span>
                              <img
                                width="30"
                                src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/Formen_Configurator_BlueQ.webp"
                              />
                            </span>
                          </button>
                        )}
                        {PostShape == '60x30' && (
                          <button
                            ref={handlauf1}
                            className={handlaufmat == '60x30' && 'activeitem'}
                            onClick={() => {
                              sethandlaufmat('60x30');
                            }}
                          >
                            {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[171] : '60x20 mm'}
                            <span>
                              <img
                                width="30"
                                src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/Formen_Configurator_BlueR.webp"
                              />
                            </span>
                          </button>
                        )}
                      </>
                    )}
                  </div>

                  <div className="Handrailselect-wrap">
                    <div className="Handrailselect step1-selection" id={gelaender == 'baseclamps' && 'hiddenmount'}>
                      <h4>
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[46] : 'Wall mounting A'}
                      </h4>
                      <div className="inoutchoice">
                        <button
                          ref={wall1s}
                          className={wall1 && 'activeitem'}
                          onClick={() => {
                            setwall1(true);
                            activeitem(wall1s, 'step4', 2);
                          }}
                        >
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[48]
                            : 'Wall connection'}
                          <span>
                            <img
                              width="30"
                              src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/wall_connection_yes.webp"
                            />
                          </span>
                        </button>
                        <button
                          ref={free1}
                          className={!wall1 && 'activeitem'}
                          onClick={() => {
                            setwall1(false);
                            activeitem(free1, 'step4', 2);
                          }}
                        >
                          {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[49] : 'No connection'}
                          <span>
                            <img
                              width="30"
                              src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/wall_connection_no.webp"
                            />
                          </span>
                        </button>
                      </div>
                      <br /> <br />
                      <h4>
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[47] : 'Wall mounting B'}
                      </h4>
                      <div className="inoutchoice">
                        <button
                          ref={wall2s}
                          className={wall2 && 'activeitem'}
                          onClick={() => {
                            setwall2(true);
                            activeitem(wall2s, 'step4', 3);
                          }}
                        >
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[48]
                            : 'Wall connection'}
                          <span>
                            <img
                              width="30"
                              src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/wall_connection_yes.webp"
                            />
                          </span>
                        </button>
                        <button
                          ref={free2}
                          className={!wall2 && 'activeitem'}
                          onClick={() => {
                            setwall2(false);
                            activeitem(free2, 'step4', 3);
                          }}
                        >
                          {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[49] : 'No connection'}
                          <span>
                            <img
                              width="30"
                              src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/wall_connection_no.webp"
                            />
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="FrenchBalconySystemSelect">
                <div className="forbackdiv">
                  <button className="backbtn" onClick={() => setselectstep(4)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#030303" viewBox="0 0 256 256">
                      <path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z"></path>
                    </svg>
                  </button>
                  <button
                    className="forbtn"
                    id="ConfiguratorStep5"
                    onClick={() => {
                      {
                        setselectstep(5.5);
                        saveConfig();
                        setshowmenu(false);
                        window.scrollTo(0, 0);
                      }
                    }}
                  >
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[16] : 'Finish'}
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      );
    }

    if (selectstep == 5.5) {
      return (
        <>
          {gelaender == 'qline' && (
            <div className="step1-configurator step3-configurator step5-configurator ">
              <h3 className="Headline-configurator">
                {infotext.data.length > 0 && infotext.data[0].attributes.FreeData1.data[144]}
              </h3>
              <div className="Handrailselect-wrap">
                <div className="Handrailselect step1-selection">
                  <div className="step1-selection step5-colorselect QlineColorSelection">
                    <h4 className={gelaender == 'glass' && 'hide'}>
                      {infotext.data.length > 0 &&
                        gelaender != 'baseclamps' &&
                        infotext.data[0].attributes.FreeData1.data[29]}
                    </h4>

                    <div className={'inoutchoice QlineColorchoice'}>
                      <button
                        id="satin316"
                        className={colorr == 'satin316' && !ralcolorbool && 'activeitem'}
                        ref={colorr1}
                        onClick={() => {
                          setcolorr('satin316');

                          setralcolorbool(false);
                        }}
                      >
                        <p id="colordescription1" className={colorr == 'satin316' ? '' : ''}>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[172]
                            : '316 Satin polished'}
                        </p>{' '}
                        <div></div>
                      </button>
                      {PostShape != '60x30' && (
                        <button
                          id="satin304"
                          className={colorr == 'satin304' && !ralcolorbool && 'activeitem'}
                          ref={colorr1}
                          onClick={() => {
                            setcolorr('satin304');

                            setralcolorbool(false);
                          }}
                        >
                          <p id="colordescription1" className={colorr == 'satin304' ? '' : ''}>
                            {infotext.data.length > 0
                              ? infotext.data[0].attributes.FreeData1.data[173]
                              : '304 Satin polished'}
                          </p>{' '}
                          <div></div>
                        </button>
                      )}

                      {para.count != 'en-us' &&
                        para.count != 'es-us' &&
                        para.count != 'en-ca' &&
                        para.count != 'fr-ca' && (
                          <button
                            id="gray5"
                            className={ralcolorbool && 'activeitem'}
                            ref={colorr1}
                            onClick={() => {
                              setcolorr('satin316');
                              setralcolorbool(true);
                            }}
                          >
                            <p id="colordescription1" className="CustomRalColor">
                              RAL:
                              <input
                                type="text"
                                className={ralcolorbool && ralcolor.length != 4 && ralcolor != 5 ? 'error-ral' : ''}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  // Allow only digits and limit to 4 characters
                                  if (/^\d{0,4}$/.test(value)) {
                                    setralcolor(value.toString());
                                  }
                                }}
                                value={ralcolor}
                                id="RalColorInput"
                                placeholder={'0000'}
                              />
                            </p>{' '}
                            <div>
                              <img
                                src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/multicoloricon.webp"
                                width="48"
                                height="48"
                              />
                            </div>
                          </button>
                        )}
                    </div>
                  </div>
                </div>
              </div>
              {(qlineinfill == 'glass' || qlineinfill == 'plates') && (
                <>
                  <br />
                  {para.count != 'en-us' && para.count != 'es-us' && para.count != 'en-ca' && para.count != 'fr-ca' && (
                    <>
                      <h4 className="QlineHeadline">
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[174] : 'Clamp shape'}
                      </h4>
                      <div className="Handrailselect-wrap">
                        <div className="PostSelect">
                          <button
                            className={ClampShape == 'round' && 'activeitem'}
                            onClick={() => setClampShape('round')}
                          >
                            <span>
                              {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[175] : 'Round'}
                            </span>
                            <img
                              width="30"
                              src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/Formen_Configurator_BlueK.webp"
                            />
                          </button>
                          <button
                            className={ClampShape == 'square' && 'activeitem'}
                            onClick={() => setClampShape('square')}
                          >
                            <span>
                              {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[176] : 'Square'}
                            </span>
                            <img
                              width="30"
                              src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/Formen_Configurator_BlueQ.webp"
                            />
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}

              <br />
              {cuttosize && (
                <div className="Configurator-checkbox-step3-top" id="QlineCutToSize">
                  <div className="Configurator-step3-checkbox-div">
                    <input
                      checked
                      id="configcuttosizeid"
                      onChange={() => {
                        if (document.getElementById('configcuttosizeid').checked) {
                          setcuttosize(true);
                        } else {
                          setcuttosize(false);
                        }
                      }}
                      type="checkbox"
                    />
                    <label>
                      {infotext.data.length > 0
                        ? infotext.data[0].attributes.FreeData1.data[92]
                        : 'Cut Handrail to size?'}
                    </label>
                  </div>
                  <span id="step-3-hidden-i">
                    <div className="step-3-hidden-i ConfigHoveText">
                      <p>{infotext.data.length > 0 && infotext.data[0].attributes.FreeData3.data[0]}</p>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#676767" viewBox="0 0 256 256">
                      <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"></path>
                    </svg>
                  </span>
                </div>
              )}
              {!cuttosize && (
                <div className="Configurator-checkbox-step3-top" id="QlineCutToSize">
                  <div className="Configurator-step3-checkbox-div">
                    <input
                      id="configcuttosizeid"
                      onChange={() => {
                        if (document.getElementById('configcuttosizeid').checked) {
                          setcuttosize(true);
                        } else {
                          setcuttosize(false);
                        }
                      }}
                      type="checkbox"
                    />
                    <label>
                      {infotext.data.length > 0
                        ? infotext.data[0].attributes.FreeData1.data[92]
                        : 'Cut Handrail to size?'}
                    </label>
                  </div>
                  <span id="step-3-hidden-i">
                    <div className="step-3-hidden-i ConfigHoveText">
                      <p>{infotext.data.length > 0 && infotext.data[0].attributes.FreeData3.data[0]}</p>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#676767" viewBox="0 0 256 256">
                      <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"></path>
                    </svg>
                  </span>
                </div>
              )}
              {TapHandrail && (
                <div className="Configurator-checkbox-step3-top" id="TapAndDrillHandrail">
                  <div className="Configurator-step3-checkbox-div">
                    <input
                      checked
                      id="configtaphandrailid"
                      onChange={() => {
                        if (document.getElementById('configtaphandrailid').checked) {
                          setTapHandrail(true);
                        } else {
                          setTapHandrail(false);
                        }
                      }}
                      type="checkbox"
                    />
                    <label>
                      {infotext.data.length > 0
                        ? infotext.data[0].attributes.FreeData1.data[177]
                        : 'Tap and drill handrail'}
                    </label>
                  </div>
                  <span id="step-3-hidden-i">
                    <div className="step-3-hidden-i ConfigHoveText">
                      <p>
                        {infotext.data.length > 0
                          ? infotext.data[0].attributes.FreeData1.data[178]
                          : 'Text concerning us offering Tap and drill'}
                      </p>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#676767" viewBox="0 0 256 256">
                      <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"></path>
                    </svg>
                  </span>
                </div>
              )}
              {!TapHandrail && (
                <div className="Configurator-checkbox-step3-top" id="TapAndDrillHandrail">
                  <div className="Configurator-step3-checkbox-div">
                    <input
                      id="configtaphandrailid"
                      onChange={() => {
                        if (document.getElementById('configtaphandrailid').checked) {
                          setTapHandrail(true);
                        } else {
                          setTapHandrail(false);
                        }
                      }}
                      type="checkbox"
                    />
                    <label>
                      {infotext.data.length > 0
                        ? infotext.data[0].attributes.FreeData1.data[177]
                        : 'Tap and drill handrail'}
                    </label>
                  </div>
                  <span id="step-3-hidden-i">
                    <div className="step-3-hidden-i ConfigHoveText">
                      <p>
                        {infotext.data.length > 0
                          ? infotext.data[0].attributes.FreeData1.data[178]
                          : 'Text concerning us offering Tap and drill'}{' '}
                      </p>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#676767" viewBox="0 0 256 256">
                      <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"></path>
                    </svg>
                  </span>
                </div>
              )}
              {TapPosts && (
                <div className="Configurator-checkbox-step3-top" id="TapAndDrillPosts">
                  <div className="Configurator-step3-checkbox-div">
                    <input
                      checked
                      id="configTapPostsid"
                      onChange={() => {
                        if (document.getElementById('configTapPostsid').checked) {
                          setTapPosts(true);
                        } else {
                          setTapPosts(false);
                        }
                      }}
                      type="checkbox"
                    />
                    <label>
                      {infotext.data.length > 0
                        ? infotext.data[0].attributes.FreeData1.data[179]
                        : 'Tap and drill posts'}
                    </label>
                  </div>
                  <span id="step-3-hidden-i">
                    <div className="step-3-hidden-i ConfigHoveText">
                      <p>
                        {infotext.data.length > 0
                          ? infotext.data[0].attributes.FreeData1.data[180]
                          : 'Text concerning us offering Tap and drill posts'}
                      </p>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#676767" viewBox="0 0 256 256">
                      <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"></path>
                    </svg>
                  </span>
                </div>
              )}
              {!TapPosts && (
                <div className="Configurator-checkbox-step3-top" id="TapAndDrillPosts">
                  <div className="Configurator-step3-checkbox-div">
                    <input
                      id="configTapPostsid"
                      onChange={() => {
                        if (document.getElementById('configTapPostsid').checked) {
                          setTapPosts(true);
                        } else {
                          setTapPosts(false);
                        }
                      }}
                      type="checkbox"
                    />
                    <label>
                      {infotext.data.length > 0
                        ? infotext.data[0].attributes.FreeData1.data[179]
                        : 'Tap and drill posts'}
                    </label>
                  </div>
                  <span id="step-3-hidden-i">
                    <div className="step-3-hidden-i ConfigHoveText">
                      <p>
                        {infotext.data.length > 0
                          ? infotext.data[0].attributes.FreeData1.data[180]
                          : 'Text concerning us offering Tap and drill posts'}
                      </p>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#676767" viewBox="0 0 256 256">
                      <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"></path>
                    </svg>
                  </span>
                </div>
              )}

              {AnkerImAngebot !== undefined && (
                <div className="Configurator-checkbox-step3-top" style={{ marginLeft: '-8px' }}>
                  <div className="Configurator-step3-checkbox-div">
                    <input
                      id="FbAnkerImAngebot"
                      onChange={() => setAnkerImAngebot(!AnkerImAngebot)}
                      type="checkbox"
                      checked={AnkerImAngebot}
                    />
                    <label style={{ marginLeft: '16px' }} htmlFor="FbAnkerImAngebot">
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[146] : 'Anchor in offer?'}
                    </label>
                  </div>
                </div>
              )}

              <div className="FrenchBalconySystemSelect">
                <div className="forbackdiv">
                  <button className="backbtn" onClick={() => setselectstep(5)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#030303" viewBox="0 0 256 256">
                      <path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z"></path>
                    </svg>
                  </button>
                  <button
                    className="forbtn"
                    id="ConfiguratorStep5"
                    onClick={() => {
                      {
                        setselectstep(6);
                        saveConfig();
                        setshowmenu(false);
                        window.scrollTo(0, 0);
                      }
                    }}
                  >
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[16] : 'Finish'}
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      );
    }

    if (selectstep == 6) {
      if (camval < 1) {
        setcamval(1);
        setTimeout(() => {
          document.getElementById('businessid').click();
        }, 10);
      }

      return (
        <>
          <div className={showmenu ? 'responsiveShowMenuShananigans finalstepclass' : 'finalstepclass'}>
            <div>
              <h3 className="Headline-configurator">
                {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[55] : 'Overview'}
                <span
                  onMouseEnter={() => {
                    document.getElementById('hovertextRailingDisclaimer').innerText =
                      infotext.data[0].attributes.FreeData1.data[181];
                  }}
                  onMouseLeave={() => {
                    document.getElementById('hovertextRailingDisclaimer').innerText = '';
                  }}
                  id="HovertextRailingEnter"
                  className="HoverStep6Disclaimer"
                >
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7 0.5C5.71442 0.5 4.45772 0.881218 3.3888 1.59545C2.31988 2.30968 1.48676 3.32484 0.994786 4.51256C0.502816 5.70028 0.374095 7.00721 0.624899 8.26809C0.875703 9.52896 1.49477 10.6872 2.40381 11.5962C3.31285 12.5052 4.47104 13.1243 5.73192 13.3751C6.99279 13.6259 8.29973 13.4972 9.48744 13.0052C10.6752 12.5132 11.6903 11.6801 12.4046 10.6112C13.1188 9.54229 13.5 8.28558 13.5 7C13.4982 5.27665 12.8128 3.62441 11.5942 2.40582C10.3756 1.18722 8.72335 0.50182 7 0.5ZM7 12.5C5.91221 12.5 4.84884 12.1774 3.94437 11.5731C3.0399 10.9687 2.33495 10.1098 1.91867 9.10476C1.50238 8.09977 1.39347 6.9939 1.60568 5.927C1.8179 4.86011 2.34173 3.8801 3.11092 3.11091C3.8801 2.34172 4.86011 1.8179 5.92701 1.60568C6.9939 1.39346 8.09977 1.50238 9.10476 1.91866C10.1098 2.33494 10.9687 3.03989 11.5731 3.94436C12.1774 4.84883 12.5 5.9122 12.5 7C12.4983 8.45818 11.9184 9.85617 10.8873 10.8873C9.85617 11.9184 8.45819 12.4983 7 12.5ZM8 10C8 10.1326 7.94732 10.2598 7.85356 10.3536C7.75979 10.4473 7.63261 10.5 7.5 10.5C7.23479 10.5 6.98043 10.3946 6.7929 10.2071C6.60536 10.0196 6.5 9.76522 6.5 9.5V7C6.36739 7 6.24022 6.94732 6.14645 6.85355C6.05268 6.75979 6 6.63261 6 6.5C6 6.36739 6.05268 6.24021 6.14645 6.14645C6.24022 6.05268 6.36739 6 6.5 6C6.76522 6 7.01957 6.10536 7.20711 6.29289C7.39465 6.48043 7.5 6.73478 7.5 7V9.5C7.63261 9.5 7.75979 9.55268 7.85356 9.64645C7.94732 9.74021 8 9.86739 8 10ZM6 4.25C6 4.10166 6.04399 3.95666 6.1264 3.83332C6.20881 3.70999 6.32595 3.61386 6.46299 3.55709C6.60003 3.50032 6.75083 3.48547 6.89632 3.51441C7.04181 3.54335 7.17544 3.61478 7.28033 3.71967C7.38522 3.82456 7.45665 3.9582 7.48559 4.10368C7.51453 4.24917 7.49968 4.39997 7.44291 4.53701C7.38615 4.67406 7.29002 4.79119 7.16668 4.8736C7.04334 4.95601 6.89834 5 6.75 5C6.55109 5 6.36032 4.92098 6.21967 4.78033C6.07902 4.63968 6 4.44891 6 4.25Z"
                      fill="#001020"
                    />
                  </svg>
                  <div id="hovertextRailingDisclaimer"></div>
                </span>
              </h3>

              <div className="overview-table">
                <div>
                  <h4 className="railing-type-title">
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[51] : 'Railing type'}:
                  </h4>
                </div>
                <div>
                  <p className="railing-type">
                    {gelaender == 'glass' && 'Easy Glass Smart'}
                    {gelaender == 'picket' && 'Easy Alu Picket'}
                    {gelaender == 'baluster' && 'Easy Alu'}
                    {gelaender == 'baseclamps' && baseclampsubsystem == '60' && 'MOD 6000'}
                    {gelaender == 'baseclamps' && baseclampsubsystem == '64' && 'MOD 6400'}
                    {gelaender == 'frenchbalcony' && fbsystem == 'EasyGlassView' && 'Easy Glass View'}
                    {gelaender == 'frenchbalcony' && fbsystem == 'Mod6507' && 'Mod 6507'}
                    {gelaender == 'qline' && PostShape == 'round' && 'Q-line'}
                    {gelaender == 'qline' && PostShape != 'round' && 'Square Line'}
                  </p>
                </div>
                {gelaender != 'baseclamps' && (
                  <>
                    <div>
                      <h4 className="mount-type-title">
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[52] : 'Mounting type'}:
                      </h4>
                    </div>
                    <div>
                      {gelaender != 'frenchbalcony' && (
                        <p className="mount-type">
                          {montageart == 'top' && (
                            <>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[4] : 'Topmount'}</>
                          )}
                          {montageart != 'top' && (
                            <>
                              {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[5] : 'Faciamount'}
                            </>
                          )}
                        </p>
                      )}
                      {gelaender == 'frenchbalcony' && (
                        <p className="mount-type">
                          {fenstermontage == 'Inset' && (
                            <>
                              {infotext.data.length > 0
                                ? infotext.data[0].attributes.FreeData1.data[140]
                                : 'Mount on frame'}
                            </>
                          )}
                          {fenstermontage != 'Inset' && (
                            <>
                              {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[141] : 'Wallmount'}
                            </>
                          )}
                        </p>
                      )}
                    </div>
                  </>
                )}
                {gelaender != 'frenchbalcony' && gelaender != 'qline' && (
                  <>
                    <div>
                      <h4 className="mount-surface-title">
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[53] : 'Mounting surface'}
                        :
                      </h4>
                    </div>
                    <div>
                      <p className="mount-surface">
                        {untergrundd == 'holz' && (
                          <>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[8] : 'Wood'}</>
                        )}
                        {untergrundd == 'beton' && (
                          <>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[7] : 'Concrete'}</>
                        )}
                        {untergrundd == 'metall' && (
                          <>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[9] : 'Metall'}</>
                        )}
                      </p>
                    </div>
                    {gelaender == 'baseclamps' && (
                      <>
                        <div>
                          <h4 className="surface-color-title">
                            {infotext.data.length > 0
                              ? infotext.data[0].attributes.FreeData1.data[54]
                              : 'Surface color'}
                            :
                          </h4>
                        </div>
                        <div>
                          <p className="surface-color">
                            {colorr == 'gray'
                              ? infotext.data[0].attributes.FreeData1.data[117]
                              : infotext.data[0].attributes.FreeData1.data[118]}
                          </p>
                        </div>
                      </>
                    )}
                    {gelaender != 'baseclamps' && (
                      <>
                        <div>
                          <h4 className="surface-color-title">
                            {infotext.data.length > 0
                              ? infotext.data[0].attributes.FreeData1.data[54]
                              : 'Surface color'}
                            :
                          </h4>
                        </div>
                        <div>
                          <p className="surface-color">
                            {colorr == 'anrtz' && gelaender != 'glass' && (
                              <>
                                {infotext.data.length > 0
                                  ? infotext.data[0].attributes.FreeData1.data[14]
                                  : 'Antrazith'}
                              </>
                            )}
                            {colorr == 'gray' && gelaender != 'glass' && gelaender != 'baseclamps' && (
                              <>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[13] : 'Grey'}</>
                            )}
                            {colorr == 'black' && gelaender != 'glass' && (
                              <>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[12] : 'Black'}</>
                            )}
                            {(colorr == 'brano' || gelaender == 'glass') && gelaender != 'baseclamps' && (
                              <>
                                {infotext.data.length > 0
                                  ? infotext.data[0].attributes.FreeData1.data[60]
                                  : 'Brushed anodized'}
                              </>
                            )}
                            {colorr == 'satin304' && <>satin304</>}
                            {colorr == 'satin316' && <>satin316</>}
                            {gelaender == 'baseclamps' &&
                              colorr == 'brano' &&
                              infotext.data[0].attributes.FreeData1.data[117]}
                          </p>
                        </div>
                      </>
                    )}{' '}
                  </>
                )}
              </div>
            </div>

            <button
              id="showProductsConfigurator"
              onClick={() => {
                if (showmenu) {
                  setshowmenu(false);
                  document.getElementById('modelcanvas2').style = 'position:relative';
                } else {
                  setshowmenu(true);
                  document.getElementById('modelcanvas2').style = 'position:absolute';
                }
              }}
            >
              {showmenu
                ? infotext.data[0].attributes.FreeData1.data[101]
                : infotext.data[0].attributes.FreeData1.data[100]}

              <span>
                <svg
                  id={showmenu && 'SvgIndividualComponentsRotation'}
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.0306 8.53074L9.53063 13.0307C9.38973 13.1716 9.19863 13.2508 8.99938 13.2508C8.80012 13.2508 8.60902 13.1716 8.46813 13.0307C8.32723 12.8898 8.24807 12.6987 8.24807 12.4995C8.24807 12.3002 8.32723 12.1091 8.46813 11.9682L11.6875 8.75011H2.5C2.30109 8.75011 2.11032 8.67109 1.96967 8.53044C1.82902 8.38979 1.75 8.19902 1.75 8.00011C1.75 7.8012 1.82902 7.61043 1.96967 7.46978C2.11032 7.32913 2.30109 7.25011 2.5 7.25011H11.6875L8.46937 4.03011C8.32848 3.88921 8.24932 3.69812 8.24932 3.49886C8.24932 3.2996 8.32848 3.10851 8.46937 2.96761C8.61027 2.82671 8.80137 2.74756 9.00062 2.74756C9.19988 2.74756 9.39098 2.82671 9.53187 2.96761L14.0319 7.46761C14.1018 7.53738 14.1573 7.62028 14.1951 7.71155C14.2329 7.80281 14.2523 7.90065 14.2522 7.99943C14.252 8.09822 14.2324 8.19601 14.1944 8.28718C14.1564 8.37836 14.1007 8.46113 14.0306 8.53074Z"
                    fill="#04468c"
                  />
                </svg>
              </span>
            </button>

            {infotext.data[0].attributes.FreeData1.data[120] && infotext.data[0].attributes.FreeData1.data[121] && (
              <div className="configuration-downloads">
                <h5>{infotext.data[0].attributes.FreeData1.data[120]}</h5>
                <div className="configuration-downloads-inner">
                  {/* <div
                    id="configuration-downloads-default-overview"
                    className="configuration-downloads-item"
                    onClick={() => downloadCurrentSchematic(true)}
                  >
                    <span className="text">{infotext.data[0].attributes.FreeData1.data[121]}</span>

                    <span className="icon">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M13.25 8.5V12C13.25 12.3315 13.1183 12.6495 12.8839 12.8839C12.6495 13.1183 12.3315 13.25 12 13.25H2C1.66848 13.25 1.35054 13.1183 1.11612 12.8839C0.881696 12.6495 0.75 12.3315 0.75 12V8.5C0.75 8.30109 0.829018 8.11032 0.96967 7.96967C1.11032 7.82902 1.30109 7.75 1.5 7.75C1.69891 7.75 1.88968 7.82902 2.03033 7.96967C2.17098 8.11032 2.25 8.30109 2.25 8.5V11.75H11.75V8.5C11.75 8.30109 11.829 8.11032 11.9697 7.96967C12.1103 7.82902 12.3011 7.75 12.5 7.75C12.6989 7.75 12.8897 7.82902 13.0303 7.96967C13.171 8.11032 13.25 8.30109 13.25 8.5ZM6.46938 9.03063C6.53905 9.10054 6.62185 9.15602 6.71301 9.19388C6.80417 9.23173 6.90191 9.25122 7.00062 9.25122C7.09934 9.25122 7.19707 9.23173 7.28824 9.19388C7.3794 9.15602 7.4622 9.10054 7.53187 9.03063L10.0319 6.53062C10.1728 6.38973 10.2519 6.19863 10.2519 5.99937C10.2519 5.80012 10.1728 5.60902 10.0319 5.46812C9.89098 5.32723 9.69988 5.24807 9.50062 5.24807C9.30137 5.24807 9.11027 5.32723 8.96937 5.46812L7.75 6.6875V1.5C7.75 1.30109 7.67098 1.11032 7.53033 0.96967C7.38968 0.829018 7.19891 0.75 7 0.75C6.80109 0.75 6.61032 0.829018 6.46967 0.96967C6.32902 1.11032 6.25 1.30109 6.25 1.5V6.6875L5.03062 5.46938C4.88973 5.32848 4.69863 5.24932 4.49937 5.24932C4.30012 5.24932 4.10902 5.32848 3.96812 5.46938C3.82723 5.61027 3.74807 5.80137 3.74807 6.00063C3.74807 6.19988 3.82723 6.39098 3.96812 6.53188L6.46938 9.03063Z"
                          fill="#001020"
                        />
                      </svg>
                    </span>
                  </div> */}

                  {infotext.data[0].attributes.FreeData1.data[122] && (
                    <div
                      id="configuration-downloads-custom-overview"
                      className="configuration-downloads-item"
                      onClick={() => downloadCurrentSchematic(false)}
                    >
                      <span className="text">{infotext.data[0].attributes.FreeData1.data[122]}</span>

                      <span className="icon">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M13.25 8.5V12C13.25 12.3315 13.1183 12.6495 12.8839 12.8839C12.6495 13.1183 12.3315 13.25 12 13.25H2C1.66848 13.25 1.35054 13.1183 1.11612 12.8839C0.881696 12.6495 0.75 12.3315 0.75 12V8.5C0.75 8.30109 0.829018 8.11032 0.96967 7.96967C1.11032 7.82902 1.30109 7.75 1.5 7.75C1.69891 7.75 1.88968 7.82902 2.03033 7.96967C2.17098 8.11032 2.25 8.30109 2.25 8.5V11.75H11.75V8.5C11.75 8.30109 11.829 8.11032 11.9697 7.96967C12.1103 7.82902 12.3011 7.75 12.5 7.75C12.6989 7.75 12.8897 7.82902 13.0303 7.96967C13.171 8.11032 13.25 8.30109 13.25 8.5ZM6.46938 9.03063C6.53905 9.10054 6.62185 9.15602 6.71301 9.19388C6.80417 9.23173 6.90191 9.25122 7.00062 9.25122C7.09934 9.25122 7.19707 9.23173 7.28824 9.19388C7.3794 9.15602 7.4622 9.10054 7.53187 9.03063L10.0319 6.53062C10.1728 6.38973 10.2519 6.19863 10.2519 5.99937C10.2519 5.80012 10.1728 5.60902 10.0319 5.46812C9.89098 5.32723 9.69988 5.24807 9.50062 5.24807C9.30137 5.24807 9.11027 5.32723 8.96937 5.46812L7.75 6.6875V1.5C7.75 1.30109 7.67098 1.11032 7.53033 0.96967C7.38968 0.829018 7.19891 0.75 7 0.75C6.80109 0.75 6.61032 0.829018 6.46967 0.96967C6.32902 1.11032 6.25 1.30109 6.25 1.5V6.6875L5.03062 5.46938C4.88973 5.32848 4.69863 5.24932 4.49937 5.24932C4.30012 5.24932 4.10902 5.32848 3.96812 5.46938C3.82723 5.61027 3.74807 5.80137 3.74807 6.00063C3.74807 6.19988 3.82723 6.39098 3.96812 6.53188L6.46938 9.03063Z"
                            fill="#001020"
                          />
                        </svg>
                      </span>
                    </div>
                  )}
                </div>
                {CustSlug == 'Rvs' && (
                  <span
                    style={{
                      marginTop: '32px',
                      backgroundColor: 'transparent',
                      width: '198px',
                      height: '136px',
                      display: 'block',
                    }}
                  >
                    <img
                      width={182}
                      height={120}
                      src="https://strapiwmc4hstore.blob.core.windows.net/partner-configurator/rvslogo.png"
                    />
                  </span>
                )}
                {CustSlug == 'rvs-land' && (
                  <span
                    style={{
                      marginTop: '32px',
                      backgroundColor: 'transparent',
                      width: '198px',
                      height: '136px',
                      display: 'block',
                    }}
                  >
                    <img
                      width={182}
                      src="https://strapiwmc4hstore.blob.core.windows.net/partner-configurator/Logo-blauw-transparant-rvs-land.png"
                    />
                  </span>
                )}
                {CustSlug == 'storax' && (
                  <span
                    style={{
                      marginTop: '32px',
                      backgroundColor: 'transparent',
                      width: '198px',
                      height: '136px',
                      display: 'block',
                    }}
                  >
                    <img width={182} src="https://www.storax.nl/app/uploads/2019/03/storax.svg" />
                  </span>
                )}
                {/*CustSlug == 'wholesaleglass' && (
                  <span
                    style={{
                      marginTop: '32px',
                      backgroundColor: 'transparent',
                      width: '174px',
                      height: '154px',
                      display: 'block',
                    }}
                  >
                    <img width={182} src="https://www.s3i.co.uk/image/s3i/pscss/S3i_Logo.svg" />
                  </span>
                )*/}
                {CustSlug == 'hekwerkshop' && (
                  <span
                    style={{
                      marginTop: '32px',
                      backgroundColor: 'transparent',
                      width: '198px',
                      height: '136px',
                      display: 'block',
                    }}
                  >
                    <img width={182} src="https://www.hekwerkwebshop.nl/img/hekwerkwebshop-logo.png" />
                  </span>
                )}

                {CustSlug == 'aluleaf' && (
                  <span
                    style={{
                      marginTop: '32px',
                      backgroundColor: 'transparent',
                      width: '198px',
                      height: '136px',
                      display: 'block',
                    }}
                  >
                    <img width={182} src="https://aluleaf.de/wp-content/uploads/2024/11/logo-aluleaf.svg" />
                  </span>
                )}

                {CustSlug == 'glasmaatje' && (
                  <span
                    style={{
                      marginTop: '32px',
                      backgroundColor: 'transparent',
                      width: '265px',
                      height: '114px',
                      display: 'block',
                    }}
                  >
                    <img width={182} src="https://s3.glasmaatje.nl/2026/03/Glasmaatje-bv-Logo.webp" />
                  </span>
                )}

                {CustSlug == 'glassinside' && (
                  <span
                    style={{
                      marginTop: '32px',
                      backgroundColor: 'transparent',
                      width: '135px',
                      height: '42px',
                      display: 'block',
                    }}
                  >
                    <img width={135} src="https://www.glassinside.nl/wp-content/uploads/2023/03/Glassinside-logo.svg" />
                  </span>
                )}
                {CustSlug == 'glas123' && (
                  <span
                    style={{
                      marginTop: '32px',
                      backgroundColor: 'transparent',
                      width: '200px',
                      height: '30px',
                      display: 'block',
                    }}
                  >
                    <img width={200} src="https://www.glas123.nl/assets/img/logo/converted/glas123nl_800x136.webp" />
                  </span>
                )}
              </div>
            )}

            {business && alreadycust == 0 && (
              <div className="businesscustomer">
                <div className="privatepublicclass">
                  <div className="privatepublicclass-inner">
                    <h3 className="Configurator-CustType-headline">
                      {infotext.data.length > 0
                        ? infotext.data[0].attributes.FreeData1.data[103]
                        : 'What customertype are you?'}
                    </h3>
                    <label className="custom-radio">
                      <input
                        type="radio"
                        className="radioinput"
                        name="radio"
                        id="businessid-ConfigStep6Business"
                        checked
                        onChange={() => setbusiness(true)}
                      />
                      <span className="spacer">
                        {' '}
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[17] : 'Business'}
                      </span>
                    </label>
                    <label className="custom-radio">
                      <input
                        type="radio"
                        className="radioinput"
                        name="radio"
                        id="ConfigStep6Private"
                        onChange={() => setbusiness(false)}
                      />
                      <span className="spacer">
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[56] : 'Private'}
                      </span>
                    </label>
                  </div>
                </div>

                <div className="privatepublicclass alreadycustomercheck">
                  <h4>
                    {infotext.data.length > 0
                      ? infotext.data[0].attributes.FreeData1.data[68]
                      : 'Are you already Q-railing customer?'}
                  </h4>
                  <div className="privatepublicclass-inner">
                    <label className="custom-radio">
                      <input
                        type="radio"
                        className="radioinput2"
                        name="radio2"
                        id="businessid-ConfigStep6ExistingCustomer"
                        onChange={() => setalreadycust(1)}
                      />
                      <span className="spacer">
                        {' '}
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[69] : 'Yes'}
                      </span>
                    </label>
                    <label className="custom-radio">
                      <input
                        type="radio"
                        className="radioinput2"
                        name="radio2"
                        id="ConfigStep6NewCustomer"
                        onChange={() => setalreadycust(2)}
                      />
                      <span className="spacer">
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[90] : 'No'}
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            )}

            {business && alreadycust == 1 && (
              <div className="businesscustomer">
                <div className="privatepublicclass">
                  <div className="privatepublicclass-inner privatepublicalreadycust2">
                    <h3 className="Configurator-CustType-headline">
                      {infotext.data.length > 0
                        ? infotext.data[0].attributes.FreeData1.data[103]
                        : 'What customertype are you?'}
                    </h3>
                    <label className="custom-radio">
                      <input
                        type="radio"
                        className="radioinput"
                        name="radio"
                        id="businessid-ConfigStep6Business"
                        checked
                        onChange={() => setbusiness(true)}
                      />
                      <span className="spacer">
                        {' '}
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[17] : 'Business'}
                      </span>
                    </label>
                    <label className="custom-radio">
                      <input
                        type="radio"
                        className="radioinput"
                        name="radio"
                        id="ConfigStep6Private"
                        onChange={() => setbusiness(false)}
                      />
                      <span className="spacer">
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[56] : 'Private'}
                      </span>
                    </label>
                  </div>
                </div>

                <div className="privatepublicclass alreadycustomercheck">
                  <h4>
                    {infotext.data.length > 0
                      ? infotext.data[0].attributes.FreeData1.data[68]
                      : 'Are you already Q-railing customer?'}
                  </h4>
                  <div className="privatepublicclass-inner">
                    <label className="custom-radio">
                      <input
                        type="radio"
                        className="radioinput2"
                        name="radio2"
                        id="businessid-ConfigStep6ExistingCustomer"
                        checked
                        onChange={() => setalreadycust(1)}
                      />
                      <span className="spacer">
                        {' '}
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[69] : 'Yes'}
                      </span>
                    </label>
                    <label className="custom-radio">
                      <input
                        type="radio"
                        className="radioinput2"
                        name="radio2"
                        id="ConfigStep6NewCustomer"
                        onChange={() => setalreadycust(2)}
                      />
                      <span className="spacer">
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[90] : 'No'}
                      </span>
                    </label>
                  </div>
                </div>

                <div className="contactmenu">
                  <label>
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[20] : 'CustomerID'}:
                  </label>{' '}
                  <input
                    id="ConfigRequestIdB"
                    onChange={(e) => {
                      custid = e.target.value;
                    }}
                    placeholder={
                      infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[20] : 'Customer Id'
                    }
                  />
                  <label>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[57] : 'E-mail'}:</label>{' '}
                  <input
                    id="ConfigRequestEmailB"
                    onChange={(e) => {
                      email = e.target.value;
                    }}
                    placeholder={infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[57] : 'E-mail'}
                  />
                  <label>
                    {infotext.data.length > 0
                      ? infotext.data[0].attributes.FreeData1.data[22]
                      : 'Additional Information'}{' '}
                    <span>
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[102] : '(optional)'}
                    </span>
                    :
                  </label>{' '}
                  <textarea
                    id="ConfigRequestTextB"
                    onChange={(e) => {
                      textareatext = e.target.value;
                    }}
                    placeholder={
                      infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[25] : 'Bitte in Schwarz'
                    }
                  />
                </div>
              </div>
            )}

            {business && alreadycust == 2 && (
              <div className="businesscustomer">
                <div className="privatepublicclass">
                  <div className="privatepublicclass-inner privatepublicalreadycust2">
                    <h3 className="Configurator-CustType-headline">
                      {infotext.data.length > 0
                        ? infotext.data[0].attributes.FreeData1.data[103]
                        : 'What customertype are you?'}
                    </h3>
                    <label className="custom-radio">
                      <input
                        type="radio"
                        className="radioinput"
                        name="radio"
                        id="businessid-ConfigStep6Business"
                        checked
                        onChange={() => setbusiness(true)}
                      />
                      <span className="spacer">
                        {' '}
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[17] : 'Business'}
                      </span>
                    </label>
                    <label className="custom-radio">
                      <input
                        type="radio"
                        className="radioinput"
                        name="radio"
                        id="ConfigStep6Private"
                        onChange={() => setbusiness(false)}
                      />
                      <span className="spacer">
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[56] : 'Private'}
                      </span>
                    </label>
                  </div>
                </div>

                <div className="privatepublicclass alreadycustomercheck">
                  <h4>
                    {infotext.data.length > 0
                      ? infotext.data[0].attributes.FreeData1.data[68]
                      : 'Are you already Q-railing customer?'}
                  </h4>
                  <div className="privatepublicclass-inner">
                    <label className="custom-radio">
                      <input
                        type="radio"
                        className="radioinput2"
                        name="radio2"
                        id="businessid-ConfigStep6ExistingCustomer"
                        onChange={() => setalreadycust(1)}
                      />
                      <span className="spacer">
                        {' '}
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[69] : 'Yes'}
                      </span>
                    </label>
                    <label className="custom-radio">
                      <input
                        type="radio"
                        className="radioinput2"
                        name="radio2"
                        id="ConfigStep6NewCustomer"
                        checked
                        onChange={() => setalreadycust(2)}
                      />
                      <span className="spacer">
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[90] : 'No'}
                      </span>
                    </label>
                  </div>
                </div>

                <div className="contactmenu registercustmenu">
                  <label>
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[66] : 'Company:'}
                  </label>{' '}
                  <input
                    id="ConfigRequestCompanyB"
                    onChange={(e) => {
                      custid = e.target.value;
                    }}
                    placeholder={infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[66] : 'Company'}
                  />
                  <label>
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[57] : 'E-mail:'}:
                  </label>{' '}
                  <input
                    id="ConfigRequestEmailB"
                    onChange={(e) => {
                      email = e.target.value;
                    }}
                    placeholder={infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[57] : 'E-mail'}
                  />
                  <label>
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[82] : 'Phone no.:'}:
                  </label>{' '}
                  <input
                    id="ConfigRequestPhoneB"
                    onChange={(e) => {
                      email = e.target.value;
                    }}
                    placeholder={
                      infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[82] : 'Phone no.'
                    }
                  />
                  <label>
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[85] : 'Salutation:'}:
                  </label>
                  <select id="ConfigRequestSalutationB">
                    <option>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[87] : 'Mr'}</option>
                    <option>
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[88] : 'Mrs/Ms'}
                    </option>
                    <option>
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[89] : 'Non Binary'}
                    </option>
                  </select>
                  <label>
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[64] : 'First Name:'}:
                  </label>{' '}
                  <input
                    id="ConfigRequestFirstNameB"
                    onChange={(e) => {
                      custid = e.target.value;
                    }}
                    placeholder={
                      infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[64] : 'First Name:'
                    }
                  />
                  <label>
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[65] : 'Last Name:'}:
                  </label>{' '}
                  <input
                    id="ConfigRequestLastNameB"
                    onChange={(e) => {
                      custid = e.target.value;
                    }}
                    placeholder={
                      infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[65] : 'Last Name'
                    }
                  />
                  <label>
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[81] : 'Street:'}:
                  </label>{' '}
                  <input
                    id="ConfigRequestStreetB"
                    onChange={(e) => {
                      email = e.target.value;
                    }}
                    placeholder={infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[81] : 'Street:'}
                  />
                  <label>
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[26] : 'Postcode:'}:
                  </label>{' '}
                  <input
                    id="ConfigRequestPostCodeB"
                    onChange={(e) => {
                      email = e.target.value;
                    }}
                    placeholder={
                      infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[26] : 'Postcode:'
                    }
                  />
                  <label>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[83] : 'City:'}:</label>{' '}
                  <input
                    id="ConfigRequestCityB"
                    onChange={(e) => {
                      email = e.target.value;
                    }}
                    placeholder={infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[83] : 'City:'}
                  />
                  <label>
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[84] : 'Country:'}:
                  </label>
                  <select id="ConfigRequestCountryB">
                    {infotext.data.length > 0 &&
                      infotext.data[0].attributes.FreeData4.data.map((item) => {
                        return <option>{item}</option>;
                      })}
                  </select>
                  <label>
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[86] : 'Industry Group:'}:
                  </label>
                  <select id="ConfigRequestIndustryGroupB">
                    {infotext.data.length > 0 &&
                      infotext.data[0].attributes.FreeData5.data.map((item) => {
                        return <option>{item}</option>;
                      })}
                  </select>
                  <label>
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[67] : 'USTID:'}{' '}
                    {para.count != 'it-it' &&
                      para.count != 'fr-lu' &&
                      para.count != 'nl-nl' &&
                      para.count != 'fi-fi' &&
                      para.count != 'da-dk' &&
                      para.count != 'pl-pl' &&
                      para.count != 'en-gb' &&
                      para.count != 'en-ie' && (
                        <span>
                          {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[102] : '(optional)'}
                        </span>
                      )}
                    :
                  </label>{' '}
                  <input
                    id="ConfigRequestVatB"
                    onChange={(e) => {
                      custid = e.target.value;
                    }}
                    placeholder={infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[67] : 'USTID'}
                  />
                  <label>
                    {infotext.data.length > 0
                      ? infotext.data[0].attributes.FreeData1.data[22]
                      : 'Additional Information'}{' '}
                    <span>
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[102] : '(optional)'}
                    </span>
                    :
                  </label>{' '}
                  <input
                    type="text"
                    id="ConfigRequestTextB"
                    onChange={(e) => {
                      textareatext = e.target.value;
                    }}
                    placeholder={
                      infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[25] : 'please in black'
                    }
                  />
                </div>
              </div>
            )}

            {!business && (
              <div className="businesscustomer">
                <div className="privatepublicclass">
                  <div className="privatepublicclass-inner privatepublicalreadycust2">
                    <h3 className="Configurator-CustType-headline">
                      {infotext.data.length > 0
                        ? infotext.data[0].attributes.FreeData1.data[103]
                        : 'What customertype are you?'}
                    </h3>
                    {/*<label>
                      <input
                        className="radioinput"
                        type="radio"
                        name="radio"
                        id="businessid-ConfigStep6Business"
                        onChange={() => setbusiness(true)}
                      />
                      <span className="spacer">
                        {' '}
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[17] : 'Business'}
                      </span>
                    </label>*/}
                    <label>
                      <input
                        className="radioinput"
                        type="radio"
                        name="radio"
                        id="ConfigStep6Private"
                        checked
                        onChange={() => setbusiness(false)}
                      />
                      <span className="spacer">
                        {' '}
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[56] : 'Private'}
                      </span>
                    </label>
                  </div>
                </div>
                {!business && alreadycust == 1337 && (
                  <div className="contactmenu">
                    <label>
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[85] : 'Salutation:'}:
                    </label>
                    <select id="ConfigRequestSalutationP">
                      <option>
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[87] : 'Mr'}
                      </option>
                      <option>
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[88] : 'Mrs/Ms'}
                      </option>
                      <option>
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[89] : 'Non Binary'}
                      </option>
                    </select>
                    <label>
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[65] : 'Last Name:'}:
                    </label>{' '}
                    <input
                      id="ConfigRequestLastNameP"
                      onChange={(e) => {
                        custid = e.target.value;
                      }}
                      placeholder={
                        infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[65] : 'Last Name'
                      }
                    />
                    <label>
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[57] : 'E-mail'}:
                    </label>{' '}
                    <input
                      id="ConfigRequestEmail"
                      onChange={(e) => {
                        email = e.target.value;
                      }}
                      placeholder={infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[57] : 'E-mail'}
                    />
                    <label>
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[82] : 'Phone no.:'}:
                    </label>{' '}
                    <input
                      id="ConfigRequestPhoneP"
                      onChange={(e) => {
                        email = e.target.value;
                      }}
                      placeholder={
                        infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[82] : 'Phone no.'
                      }
                    />
                    <label>
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[81] : 'Street:'}:
                    </label>{' '}
                    <input
                      id="ConfigRequestStreetP"
                      onChange={(e) => {
                        email = e.target.value;
                      }}
                      placeholder={
                        infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[81] : 'Street:'
                      }
                    />
                    <label>
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[26] : 'Post code'}:
                    </label>{' '}
                    <input
                      id="ConfigRequestId"
                      className="ConfigRequestPostCodeP"
                      onChange={(e) => {
                        postcode = e.target.value;
                      }}
                      placeholder={
                        infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[26] : 'Post code'
                      }
                    />
                    <label>
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[83] : 'City:'}:
                    </label>{' '}
                    <input
                      id="ConfigRequestCityP"
                      onChange={(e) => {
                        email = e.target.value;
                      }}
                      placeholder={infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[83] : 'City:'}
                    />
                    <label>
                      {infotext.data.length > 0
                        ? infotext.data[0].attributes.FreeData1.data[22]
                        : 'Additional Information'}{' '}
                      <span>
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[102] : '(optional)'}
                      </span>
                      :
                    </label>{' '}
                    <textarea
                      id="ConfigRequestText"
                      onChange={(e) => {
                        textareatext = e.target.value;
                      }}
                      placeholder={
                        infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[25] : 'please in black'
                      }
                    />
                    {HasInstaller && (
                      <div className="Configurator-checkbox-step3-top">
                        <div className="Configurator-step3-checkbox-div" id="HasInstallerCheckboxDiv">
                          <input
                            checked
                            id="configHasInstaller"
                            onChange={() => {
                              if (document.getElementById('configHasInstaller').checked) {
                                setHasInstaller(true);
                              } else {
                                setHasInstaller(false);
                              }
                            }}
                            type="checkbox"
                          />
                          <label>
                            {infotext.data.length > 0
                              ? infotext.data[0].attributes.FreeData1.data[131]
                              : 'Cut to size?'}
                          </label>
                        </div>
                      </div>
                    )}
                    {!HasInstaller && (
                      <div className="Configurator-checkbox-step3-top">
                        <div className="Configurator-step3-checkbox-div" id="HasInstallerCheckboxDiv">
                          <input
                            id="configHasInstaller"
                            onChange={() => {
                              if (document.getElementById('configHasInstaller').checked) {
                                setHasInstaller(true);
                              } else {
                                setHasInstaller(false);
                              }
                            }}
                            type="checkbox"
                          />
                          <label>
                            {infotext.data.length > 0
                              ? infotext.data[0].attributes.FreeData1.data[131]
                              : 'Got an Installe?'}
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
          <div
            className={showmenu ? 'responsiveShowMenuShananigans forbackdiv' : 'forbackdiv'}
            id={business ? '' : 'AdjustForBackDiv'}
          >
            <button
              className="backbtn"
              onClick={() => {
                setselectstep(fbsystem == 'Mod6507' ? 4 : 5);

                if (gelaender == 'qline') {
                  setselectstep(5.5);
                }

                window.scrollTo(0, 0);
                setcamval(0);
                document.getElementById('modelcanvas2').style = 'position:relative';
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#030303" viewBox="0 0 256 256">
                <path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z"></path>
              </svg>
            </button>
            <button
              id="sendconfigrequest-ConfiguratorStep6"
              className={!business || alreadycust != 0 ? 'forbtn' : 'forbtn lockedsendbtn'}
              onClick={() => {
                if (business) {
                  RequestQuote();
                } else {
                  setselectstep(9);
                }
                if (document.getElementById('modelcanvas2')) {
                  document.getElementById('modelcanvas2').style = 'position:relative';
                }
              }}
            >
              {business && (
                <>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[23] : 'Request Quote'}</>
              )}
              {!business && <>{CustSlug != 'rubelo' ? 'Next' : 'Další krok'}</>}
            </button>
          </div>
        </>
      );
    }
    if (selectstep == 7) {
      return (
        <>
          <div className="Configurator-step7-checkmark-wrap">
            <span id="Configurator-final-checkmark">
              <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M19.2959 2.54597L7.2959 14.546C7.19138 14.6509 7.06719 14.7341 6.93044 14.7909C6.7937 14.8476 6.64709 14.8769 6.49902 14.8769C6.35096 14.8769 6.20435 14.8476 6.0676 14.7909C5.93085 14.7341 5.80666 14.6509 5.70215 14.546L0.452147 9.29598C0.3475 9.19133 0.264489 9.06709 0.207854 8.93037C0.15122 8.79364 0.12207 8.64709 0.12207 8.4991C0.12207 8.35111 0.15122 8.20456 0.207854 8.06783C0.264489 7.93111 0.3475 7.80687 0.452147 7.70223C0.556794 7.59758 0.681028 7.51457 0.817756 7.45793C0.954484 7.4013 1.10103 7.37215 1.24902 7.37215C1.39702 7.37215 1.54356 7.4013 1.68029 7.45793C1.81702 7.51457 1.94125 7.59758 2.0459 7.70223L6.49996 12.1563L17.704 0.9541C17.9154 0.742755 18.202 0.624023 18.5009 0.624023C18.7998 0.624023 19.0864 0.742755 19.2978 0.9541C19.5091 1.16544 19.6278 1.45209 19.6278 1.75098C19.6278 2.04986 19.5091 2.33651 19.2978 2.54785L19.2959 2.54597Z"
                  fill="white"
                />
              </svg>
            </span>
          </div>

          <h3 className="Configurator-final-text">
            {infotext.data.length > 0
              ? infotext.data[0].attributes.FreeData1.data[18]
              : 'Your request has been submitted successfully.'}
          </h3>

          <h4 className="Configurator-final-text-subhead">
            {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[96] : 'Next Step'}:
          </h4>
          {!business && form == 'boguscase' && (
            <p className="Configurator-final-text-text">
              {infotext.data.length > 0
                ? infotext.data[0].attributes.FreeData1.data[95]
                : 'Our team will review your request and connect you with one of our exclusive partners in your area'}
            </p>
          )}
          {!business && !HasInstaller && (
            <p className="Configurator-final-text-text">
              {infotext.data.length > 0
                ? infotext.data[0].attributes.FreeData1.data[95]
                : 'Our team will review your request and connect you with one of our exclusive partners in your area'}
            </p>
          )}
          {!business && HasInstaller && (
            <p className="Configurator-final-text-text">
              {infotext.data.length > 0
                ? infotext.data[0].attributes.FreeData1.data[95]
                : 'Our team will review your request and connect you with one of our exclusive partners in your area'}
            </p>
          )}

          {business && (
            <p className="Configurator-final-text-text">
              {infotext.data.length > 0
                ? infotext.data[0].attributes.FreeData1.data[19]
                : 'Our team will review your configuration and get back to you as soon as possible. Usually within the same business day.'}
            </p>
          )}
          {infotext.data[0].attributes.FreeData1.data[120] && infotext.data[0].attributes.FreeData1.data[121] && (
            <div className="configuration-downloads">
              <h5>{infotext.data[0].attributes.FreeData1.data[120]}</h5>
              <div className="configuration-downloads-inner">
                {/* <div
                  id="configuration-downloads-default-overview"
                  className="configuration-downloads-item"
                  onClick={() => downloadCurrentSchematic(true)}
                >
                  <span className="text">{infotext.data[0].attributes.FreeData1.data[121]}</span>

                  <span className="icon">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M13.25 8.5V12C13.25 12.3315 13.1183 12.6495 12.8839 12.8839C12.6495 13.1183 12.3315 13.25 12 13.25H2C1.66848 13.25 1.35054 13.1183 1.11612 12.8839C0.881696 12.6495 0.75 12.3315 0.75 12V8.5C0.75 8.30109 0.829018 8.11032 0.96967 7.96967C1.11032 7.82902 1.30109 7.75 1.5 7.75C1.69891 7.75 1.88968 7.82902 2.03033 7.96967C2.17098 8.11032 2.25 8.30109 2.25 8.5V11.75H11.75V8.5C11.75 8.30109 11.829 8.11032 11.9697 7.96967C12.1103 7.82902 12.3011 7.75 12.5 7.75C12.6989 7.75 12.8897 7.82902 13.0303 7.96967C13.171 8.11032 13.25 8.30109 13.25 8.5ZM6.46938 9.03063C6.53905 9.10054 6.62185 9.15602 6.71301 9.19388C6.80417 9.23173 6.90191 9.25122 7.00062 9.25122C7.09934 9.25122 7.19707 9.23173 7.28824 9.19388C7.3794 9.15602 7.4622 9.10054 7.53187 9.03063L10.0319 6.53062C10.1728 6.38973 10.2519 6.19863 10.2519 5.99937C10.2519 5.80012 10.1728 5.60902 10.0319 5.46812C9.89098 5.32723 9.69988 5.24807 9.50062 5.24807C9.30137 5.24807 9.11027 5.32723 8.96937 5.46812L7.75 6.6875V1.5C7.75 1.30109 7.67098 1.11032 7.53033 0.96967C7.38968 0.829018 7.19891 0.75 7 0.75C6.80109 0.75 6.61032 0.829018 6.46967 0.96967C6.32902 1.11032 6.25 1.30109 6.25 1.5V6.6875L5.03062 5.46938C4.88973 5.32848 4.69863 5.24932 4.49937 5.24932C4.30012 5.24932 4.10902 5.32848 3.96812 5.46938C3.82723 5.61027 3.74807 5.80137 3.74807 6.00063C3.74807 6.19988 3.82723 6.39098 3.96812 6.53188L6.46938 9.03063Z"
                        fill="#001020"
                      />
                    </svg>
                  </span>
                </div> */}

                {infotext.data[0].attributes.FreeData1.data[122] && (
                  <div
                    id="configuration-downloads-custom-overview"
                    className="configuration-downloads-item"
                    onClick={() => downloadCurrentSchematic(false)}
                  >
                    <span className="text">{infotext.data[0].attributes.FreeData1.data[122]}</span>

                    <span className="icon">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M13.25 8.5V12C13.25 12.3315 13.1183 12.6495 12.8839 12.8839C12.6495 13.1183 12.3315 13.25 12 13.25H2C1.66848 13.25 1.35054 13.1183 1.11612 12.8839C0.881696 12.6495 0.75 12.3315 0.75 12V8.5C0.75 8.30109 0.829018 8.11032 0.96967 7.96967C1.11032 7.82902 1.30109 7.75 1.5 7.75C1.69891 7.75 1.88968 7.82902 2.03033 7.96967C2.17098 8.11032 2.25 8.30109 2.25 8.5V11.75H11.75V8.5C11.75 8.30109 11.829 8.11032 11.9697 7.96967C12.1103 7.82902 12.3011 7.75 12.5 7.75C12.6989 7.75 12.8897 7.82902 13.0303 7.96967C13.171 8.11032 13.25 8.30109 13.25 8.5ZM6.46938 9.03063C6.53905 9.10054 6.62185 9.15602 6.71301 9.19388C6.80417 9.23173 6.90191 9.25122 7.00062 9.25122C7.09934 9.25122 7.19707 9.23173 7.28824 9.19388C7.3794 9.15602 7.4622 9.10054 7.53187 9.03063L10.0319 6.53062C10.1728 6.38973 10.2519 6.19863 10.2519 5.99937C10.2519 5.80012 10.1728 5.60902 10.0319 5.46812C9.89098 5.32723 9.69988 5.24807 9.50062 5.24807C9.30137 5.24807 9.11027 5.32723 8.96937 5.46812L7.75 6.6875V1.5C7.75 1.30109 7.67098 1.11032 7.53033 0.96967C7.38968 0.829018 7.19891 0.75 7 0.75C6.80109 0.75 6.61032 0.829018 6.46967 0.96967C6.32902 1.11032 6.25 1.30109 6.25 1.5V6.6875L5.03062 5.46938C4.88973 5.32848 4.69863 5.24932 4.49937 5.24932C4.30012 5.24932 4.10902 5.32848 3.96812 5.46938C3.82723 5.61027 3.74807 5.80137 3.74807 6.00063C3.74807 6.19988 3.82723 6.39098 3.96812 6.53188L6.46938 9.03063Z"
                          fill="#001020"
                        />
                      </svg>
                    </span>
                  </div>
                )}
                {infotext.data[0].attributes.FreeData1.data.length >= 130 && (
                  <div
                    id="configuration-downloads-pdf"
                    className="configuration-downloads-item"
                    onClick={() => downloadConfigurationPdf(true)}
                  >
                    <span className="text">{infotext.data[0].attributes.FreeData1.data[123]}</span>

                    <span className="icon">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M13.25 8.5V12C13.25 12.3315 13.1183 12.6495 12.8839 12.8839C12.6495 13.1183 12.3315 13.25 12 13.25H2C1.66848 13.25 1.35054 13.1183 1.11612 12.8839C0.881696 12.6495 0.75 12.3315 0.75 12V8.5C0.75 8.30109 0.829018 8.11032 0.96967 7.96967C1.11032 7.82902 1.30109 7.75 1.5 7.75C1.69891 7.75 1.88968 7.82902 2.03033 7.96967C2.17098 8.11032 2.25 8.30109 2.25 8.5V11.75H11.75V8.5C11.75 8.30109 11.829 8.11032 11.9697 7.96967C12.1103 7.82902 12.3011 7.75 12.5 7.75C12.6989 7.75 12.8897 7.82902 13.0303 7.96967C13.171 8.11032 13.25 8.30109 13.25 8.5ZM6.46938 9.03063C6.53905 9.10054 6.62185 9.15602 6.71301 9.19388C6.80417 9.23173 6.90191 9.25122 7.00062 9.25122C7.09934 9.25122 7.19707 9.23173 7.28824 9.19388C7.3794 9.15602 7.4622 9.10054 7.53187 9.03063L10.0319 6.53062C10.1728 6.38973 10.2519 6.19863 10.2519 5.99937C10.2519 5.80012 10.1728 5.60902 10.0319 5.46812C9.89098 5.32723 9.69988 5.24807 9.50062 5.24807C9.30137 5.24807 9.11027 5.32723 8.96937 5.46812L7.75 6.6875V1.5C7.75 1.30109 7.67098 1.11032 7.53033 0.96967C7.38968 0.829018 7.19891 0.75 7 0.75C6.80109 0.75 6.61032 0.829018 6.46967 0.96967C6.32902 1.11032 6.25 1.30109 6.25 1.5V6.6875L5.03062 5.46938C4.88973 5.32848 4.69863 5.24932 4.49937 5.24932C4.30012 5.24932 4.10902 5.32848 3.96812 5.46938C3.82723 5.61027 3.74807 5.80137 3.74807 6.00063C3.74807 6.19988 3.82723 6.39098 3.96812 6.53188L6.46938 9.03063Z"
                          fill="#001020"
                        />
                      </svg>
                    </span>
                  </div>
                )}
              </div>
            </div>
          )}
          <div className="forbackdiv finalbackfordiv">
            <a hrefLang={para.count} href={'/' + para.count + '/'}>
              {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[58] : 'Back to home'}
            </a>
            <button
              onClick={() => {
                const parts = window.location.href.split('?')[0].split('/');
                window.location.href = parts.splice(0, parts.length - 1).join('/');
              }}
            >
              {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[59] : 'Configure another railing'}
            </button>
          </div>

          {(para.count == 'de-de' || para.count == 'nl-nl' || para.count == 'fr-lu') &&
            business &&
            alreadycust == 2 && (
              <>
                <p className="Configurator-step7-fileupload-message">
                  {infotext.data.length > 0
                    ? infotext.data[0].attributes.FreeData1.data[104]
                    : 'Please upload your File'}
                </p>
                <div className="Configurator-step7-fileupload-div">
                  <label id="FormFileBlock-Document-label" for="FormFileBlock-Document">
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[97] : 'Choose File'}{' '}
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#ffffff" viewBox="0 0 256 256">
                      <path d="M240,136v64a16,16,0,0,1-16,16H32a16,16,0,0,1-16-16V136a16,16,0,0,1,16-16H80a8,8,0,0,1,0,16H32v64H224V136H176a8,8,0,0,1,0-16h48A16,16,0,0,1,240,136ZM85.66,77.66,120,43.31V128a8,8,0,0,0,16,0V43.31l34.34,34.35a8,8,0,0,0,11.32-11.32l-48-48a8,8,0,0,0-11.32,0l-48,48A8,8,0,0,0,85.66,77.66ZM200,168a12,12,0,1,0-12,12A12,12,0,0,0,200,168Z"></path>
                    </svg>
                    <input
                      onChange={() => {
                        document.getElementById('FormFileBlock-filenametext').innerText =
                          fileInputRef.current.files[0].name;
                      }}
                      id="FormFileBlock-Document"
                      accept=".pdf,image/png,image/jpeg"
                      type="file"
                      ref={fileInputRef}
                    />{' '}
                  </label>
                  <p id="FormFileBlock-filenametext"></p>
                  <button
                    id="Registerform-de-send-data"
                    onClick={() => {
                      sendDocs();
                    }}
                  >
                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[98] : 'Upload'}
                  </button>
                </div>
              </>
            )}
        </>
      );
    }
    if (selectstep == 8) {
      return (
        <>
          <div className="Configurator-step7-checkmark-wrap">
            <span id="Configurator-final-checkmark">
              <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M19.2959 2.54597L7.2959 14.546C7.19138 14.6509 7.06719 14.7341 6.93044 14.7909C6.7937 14.8476 6.64709 14.8769 6.49902 14.8769C6.35096 14.8769 6.20435 14.8476 6.0676 14.7909C5.93085 14.7341 5.80666 14.6509 5.70215 14.546L0.452147 9.29598C0.3475 9.19133 0.264489 9.06709 0.207854 8.93037C0.15122 8.79364 0.12207 8.64709 0.12207 8.4991C0.12207 8.35111 0.15122 8.20456 0.207854 8.06783C0.264489 7.93111 0.3475 7.80687 0.452147 7.70223C0.556794 7.59758 0.681028 7.51457 0.817756 7.45793C0.954484 7.4013 1.10103 7.37215 1.24902 7.37215C1.39702 7.37215 1.54356 7.4013 1.68029 7.45793C1.81702 7.51457 1.94125 7.59758 2.0459 7.70223L6.49996 12.1563L17.704 0.9541C17.9154 0.742755 18.202 0.624023 18.5009 0.624023C18.7998 0.624023 19.0864 0.742755 19.2978 0.9541C19.5091 1.16544 19.6278 1.45209 19.6278 1.75098C19.6278 2.04986 19.5091 2.33651 19.2978 2.54785L19.2959 2.54597Z"
                  fill="white"
                />
              </svg>
            </span>
          </div>

          <h3 className="Configurator-final-text">
            {infotext.data.length > 0
              ? infotext.data[0].attributes.FreeData1.data[18]
              : 'Your request has been submitted successfully.'}
          </h3>

          <h4 className="Configurator-final-text-subhead">
            {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[0] : 'Next Step'}:
          </h4>
          <p className="Configurator-final-text-text">
            {infotext.data.length > 0
              ? infotext.data[0].attributes.FreeData1.data[19]
              : 'Our team will review your configuration and get back to you as soon as possible. Usually within the same business day.'}
          </p>
          <div className="forbackdiv finalbackfordiv">
            <a hrefLang={para.count} href={'/' + para.count + '/'}>
              {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[58] : 'Back to home'}
            </a>
            <button
              onClick={() => {
                window.location.reload();
              }}
            >
              {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[59] : 'Configure another railing'}
            </button>
          </div>
        </>
      );
    }
  }
  function rotationobject(marker) {
    if (marker == 1) {
      orbitRef.current.autoRotate = true;
      orbitRef.current.reverseOrbit = false;
      orbitRef.current.autoRotateSpeed = 22;
    }

    if (marker == 2) {
      orbitRef.current.autoRotate = false;
      orbitRef.current.reverseOrbit = false;
      orbitRef.current.autoRotateSpeed = 22;
    }
    if (marker == 3) {
      orbitRef.current.autoRotate = true;
      orbitRef.current.reverseOrbit = true;
      orbitRef.current.autoRotateSpeed = 22;
    }
    if (marker == 4) {
      orbitRef.current.autoRotate = false;
      orbitRef.current.reverseOrbit = false;
      orbitRef.current.autoRotateSpeed = 22;
    }
  }
  function calculatesmart() {
    let length1 = len1 / 10;
    let length2 = len2 / 10;
    let length3 = len3 / 10;
    let amount25 = 0;
    let amount5 = 0;

    let amount5Alu = 0;
    if (form == 'i') {
      amount5Alu = parseInt(parseInt(len1) / 5000) + 1;
    }
    if (form == 'l') {
      amount5Alu = parseInt((parseInt(len1) + parseInt(len2)) / 5000) + 1;
    }
    if (form == 'u') {
      amount5Alu = parseInt((parseInt(len1) + parseInt(len2) + parseInt(len3)) / 5000) + 1;
    }
    //Hier Für Länder Anpassung
    let variablewidth = 120.0000001;

    let amount = parseInt(length1) / variablewidth;
    let amount2 = parseInt(length2) / variablewidth;
    let amount3 = parseInt(length3) / variablewidth;
    let ankertrigger = false;
    amount = parseInt(amount);
    amount2 = parseInt(amount2);
    amount3 = parseInt(amount3);
    amount = amount + 1;
    amount2 = amount2 + 1;
    amount3 = amount3 + 1;

    let finalarr = [
      [
        'Q-disc set',
        '208201-050-17',
        'https://shop.de.q-railing.com/product/image/medium/208201_%2300000001502d7503_1.jpg',
        '/208201?variants=050-17',
      ],
      [
        'Rubber cap rail',
        '205124-050-17',
        'https://shop.de.q-railing.com/product/image/small/205124_%2300000001502d73fc_1.jpg',
        '/205124?variants=050-17',
      ],
      [
        'Base channel 2.5m',
        '168210-025-00-18',
        'https://shop.us.q-railing.com/product/image/medium/168210_-11%3D0000000150000c7f_0.jpg',
        '/168210?variants=025-00-18',
      ],
      [
        'Base channel 5m',
        '168210-050-00-18',
        'https://shop.us.q-railing.com/product/image/medium/168210_-11%3D0000000150000c7f_0.jpg',
        '/168210?variants=050-00-18',
      ],
      [
        'Base channel corner',
        '168211-00-18',
        'https://shop.de.q-railing.com/product/image/medium/168211_%2300000001502d6d96_1.jpg',
        '/168211?variants=00-18',
      ],
      [
        'End cap',
        '168212-00-18',
        'https://shop.de.q-railing.com/product/image/medium/168212_%2300000001502d6cfb_1.jpg',
        '/168212?variants=00-18',
      ],
      [
        'Drainage profile',
        '168217-18',
        'https://shop.de.q-railing.com/product/image/medium/168217_%2300000001502d6c92_1.jpg',
        '/168217?variants=18',
      ],
      [
        'Base channel 2.5m',
        '168230-025-00-18',
        'https://shop.us.q-railing.com/product/image/medium/168230_-11%3D0000000150000c7f_0.jpg',
        '/168230?variants=025-00-18',
      ],
      [
        'Base channel 5m',
        '168230-050-00-18',
        'https://shop.us.q-railing.com/product/image/medium/168230_-11%3D0000000150000c7f_0.jpg',
        '/168230?variants=050-00-18',
      ],
      [
        'Base channel',
        '168231-02-18',
        'https://shop.us.q-railing.com/product/image/medium/168231_-11%3D0000000150000c6d_2.jpg',
        '/168231?variants=02-18',
      ],
      [
        'End cap',
        '168232-41-18',
        'https://shop.us.q-railing.com/product/image/medium/168232_-11%3D0000000150000c6d_2.jpg',
        '/168232?variants=41-18',
      ],
      [
        'End cap',
        '168232-42-18',
        'https://shop.us.q-railing.com/product/image/medium/168232_-11%3D0000000150000c6d_2.jpg',
        '/168232?variants=41-18',
      ],
      [
        'Clicked Cladding',
        '168234-050-18',
        'https://shop.us.q-railing.com/product/image/medium/168234_-11%3D0000000150000c89_1.jpg',
        '/168234?variants=050-18',
      ],
      [
        'Drainage profile',
        '168237-18',
        'https://shop.us.q-railing.com/product/image/medium/168237_-11%3D0000000150000c61_0.jpg',
        '/168237?variants=18',
      ],
      [
        'Cap rail',
        '146920-042-50-12',
        'https://shop.us.q-railing.com/product/image/medium/146920_-11%3D0000000150000c26_0.jpg',
        '/146920?variants=042-50-12',
      ],
      [
        'Flat end cap',
        '146732-042-12',
        'https://shop.us.q-railing.com/product/image/medium/146732_-11%3D0000000150000c1d_0.jpg',
        '/146732?variants=042-12',
      ],
      [
        'Wall flange',
        '146505-042-12',
        'https://shop.us.q-railing.com/product/image/medium/146505_-11%3D0000000150000c1d_0.jpg',
        '/146505?variants=042-12',
      ],
      [
        'Tube connector',
        '146792-042',
        'https://shop.us.q-railing.com/product/image/medium/146792_-11%3D0000000150000bfe_0.jpg',
        '/146792?variants=042',
      ],
      [
        'Fl. elbow, 90°',
        '146313-042-12',
        'https://shop.us.q-railing.com/product/image/medium/146313_-11%3D0000000150000c1d_0.jpg',
        '/146313?variants=042-12',
      ],
      [
        'Cleaning brush',
        ' 204093-012',
        'https://shop.us.q-railing.com/product/image/medium/204093_-11%3D0000000150000cc1_0.jpg',
        '/204093?variants=012',
      ],
      [
        'Mörtel',
        '204090-30',
        'https://shop.us.q-railing.com/product/image/medium/204090_-11%3D0000000150000cc0_0.jpg',
        '/204090?variants=30',
      ],
      ['Q-cleaner', '200601', 'https://shop.us.q-railing.com/product/image/medium/200601_0.jpg', '/200601'],
      ['Q-disc tool', '201000', 'https://shop.us.q-railing.com/product/image/medium/201000_0.jpg', '/201000'],
      [
        'Edge Protection 2.5m',
        '146940-025-18-12',
        'https://shop.de.q-railing.com/product/image/small/146940_%2300000001502d69eb_1.jpg',
        '/146940',
      ],
      [
        'Edge Protection 5m',
        '146940-050-18-12',
        'https://shop.de.q-railing.com/product/image/small/146940_%2300000001502d69eb_1.jpg',
        '/146940',
      ],
      [
        'Edge Protection Corner',
        '146340-500-18',
        'https://shop.de.q-railing.com/product/image/small/146340_%2300000001502e0cd3_1.jpg',
        '/146340',
      ],
      [
        'Anker-Metall',
        '240661-245',
        'https://shop.de.q-railing.com/product/image/small/240661_%2300000001502d76ea_1.jpg',
        '/240661',
      ],
      [
        'Unterlegscheibe',
        '240663-224',
        'https://shop.de.q-railing.com/product/image/small/240663_%2300000001502d76eb_1.jpg',
        '/240663',
      ],
      [
        'Mutter',
        '240651-208',
        'https://shop.de.q-railing.com/product/image/small/240651_%23000000015034e6da_1.jpg',
        '/240651',
      ],
      [
        'Anker-Beton',
        '244310-110',
        'https://shop.de.q-railing.com/product/image/small/244310_%2300000001502d7776_1.jpg',
        '/244310',
      ],
      ['Q-glue', '201331', 'https://shop.de.q-railing.com/product/image/small/201331_0.jpg', '/201331'],
      ['Q-Spray', '200620', 'https://shop.de.q-railing.com/product/image/small/200620_0.jpg', '/200620'],
      [
        'M10 Anker',
        '244410-113',
        'https://shop.de.q-railing.com/product/image/small/244410_%2300000001502d77a7_1.jpg',
        '/244410',
      ],
      [
        'M8 Anker',
        '244410-820',
        'https://shop.uk.q-railing.com/product/image/medium/244410_%2300000001502d77b0_1.jpg',
        '/244410',
      ],
      [
        'Mutter M10',
        '240650-108',
        'https://shop.de.q-railing.com/product/image/small/240650_%2300000001502d75a7_1.jpg',
        '/240650',
      ],
      [
        'Mutter M8',
        '240651',
        'https://shop.de.q-railing.com/product/image/small/240651_%23000000015034e6da_1.jpg',
        '/240651',
      ],
      ['Puster', '204092', 'https://shop.de.q-railing.com/product/image/small/204092_0.jpg', '/204092'],
      [
        'M8 Bürste',
        '204093-010',
        'https://shop.de.q-railing.com/product/image/small/204093_%2300000001502d5a05_1.jpg',
        '/204093',
      ],
      [
        'M10 Bürste',
        '204093-012',
        'https://shop.de.q-railing.com/product/image/small/204093_%2300000001502d5a05_1.jpg',
        '/204093',
      ],
      [
        'Mörtel',
        '204089-30',
        'https://shop.de.q-railing.com/product/image/small/204089_%2300000001504f08a4_1.jpg',
        '/204089',
      ],
      [
        'Bevel Handrail',
        '165953-050-33',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/165953-050-33_1.jpg',
        '/165953',
      ],
      [
        'Bevel Handrail',
        '165953-050-18',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/165953-050-18_1.jpg',
        '/165953',
      ],
      [
        'Bevel Handrail',
        '165953-050-82',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/165953-050-82_1.jpg',
        '/165953',
      ],
      [
        'Handrail',
        '165950-050-33',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/165950-050-33_1.jpg',
        '/165950',
      ],
      [
        'Handrail',
        '165950-050-18',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/165950-050-18_1.jpg',
        '/165950',
      ],
      [
        'Handrail',
        '165950-050-82',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/165950-050-82_1.jpg',
        '/165950',
      ],
      [
        'Endkappe sq Handrail',
        '165742-00',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/165742-00_1.jpg',
        '/165953',
      ],
      [
        'Endkappe sq Handrail',
        '165742-33',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/165742-33_1.jpg',
        '/165953',
      ],
      [
        'Endkappe sq Handrail',
        '165742-82',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/165742-82_1.jpg',
        '/165953',
      ],
      [
        'Endkappe Bv Handrail',
        '165744-00',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/165744-01-00_1.jpg',
        '/165953',
      ],
      [
        'Endkappe Bv Handrail',
        '165744-33',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/165744-01-33_1.jpg',
        '/165953',
      ],
      [
        'Endkappe Bv Handrail',
        '165744-82',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/165744-01-82_1.jpg',
        '/165953',
      ],
      [
        'Handrail connector',
        '165313',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/165313_1.jpg',
        '/165313',
      ],
      [
        'Handrail Cap',
        '155790-33',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/155790-33_1.jpg',
        '/155790-33',
      ],
      [
        'Handrail Cap',
        '155790-80',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/155790-80_1.jpg',
        '/155790-80',
      ],
      [
        'Handrail Cap',
        '145790-02',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/145790-02_1.jpg',
        '/145790-02',
      ],
      [
        'Handrail Cap Corner',
        '155314-33',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/155314-33_1.jpg',
        '/155314-33',
      ],
      [
        'Handrail Cap Corner',
        '155314-80',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/155314-80_1.jpg',
        '/155314-80',
      ],
      [
        'Handrail Cap Corner',
        '145314-02',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/145314-02_1.jpg',
        '/145314-02',
      ],
      [
        'Handrail Cap Bevel',
        '145791-02',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/145791-02_1.jpg',
        '/145791-02',
      ],
      [
        'Handrail Cap Corner',
        '145315-02',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/145315-02_1.jpg',
        '/145791-02',
      ],
      [
        'Wall flange',
        '165505',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/165505_1.jpg',
        '/165505',
      ],
      [
        'Anker Holz',
        '250251-010',
        'https://shop.de.q-railing.com/product/image/small/250251_%2300000001502d658e_1.jpg',
        '/250251-010',
      ],
      [
        'Anker Holz',
        '250250-808',
        'https://shop.de.q-railing.com/product/image/small/250250_%2300000001502d7801_1.jpg',
        '/250250-808',
      ],
      [
        'Handrail',
        '165950-050-00',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/165950-050-00_1.jpg',
        '/165950',
      ],
      [
        'Endkappe Bv Handrail',
        '165744-18',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/165744-01-18_1.jpg',
        '/165953',
      ],
      [
        'Bevel Handrail',
        '165953-050-00',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/165953-050-00_1.jpg',
        '/165953',
      ],
      [
        'Endkappe sq Handrail',
        '165742-18',
        'https://q-railing.s3.eu-central-1.amazonaws.com/ProductImages/165742-18_1.jpg',
        '/165953',
      ],
    ];
    if (infotext.data.length > 0) {
      finalarr = infotext.data[0].attributes.FreeData2.data;
    }
    //mindestens 200
    let amountklammernontop = 0;
    let CalcSeite1 = 0;
    let CalcSeite2 = 0;
    let CalcSeite3 = 0;

    if (form == 'i') {
      if (len1 > 5000 && len1 < 10000) {
        CalcSeite1 = 1;
      }
      if (len1 > 10000) {
        CalcSeite1 = 2;
      }
    }

    if (form == 'l') {
      if (len1 > 5000 && len1 < 10000) {
        CalcSeite1 = 1;
      }
      if (len1 > 10000) {
        CalcSeite1 = 2;
      }
      if (len2 > 5000 && len2 < 10000) {
        CalcSeite2 = 1;
      }
      if (len2 > 10000) {
        CalcSeite2 = 2;
      }
    }

    if (form == 'u') {
      if (len1 > 5000 && len1 < 10000) {
        CalcSeite1 = 1;
      }
      if (len1 > 10000) {
        CalcSeite1 = 2;
      }
      if (len2 > 5000 && len2 < 10000) {
        CalcSeite2 = 1;
      }
      if (len2 > 10000) {
        CalcSeite2 = 2;
      }
      if (len3 > 5000 && len3 < 10000) {
        CalcSeite3 = 1;
      }
      if (len3 > 10000) {
        CalcSeite3 = 2;
      }
    }
    amountklammernontop = CalcSeite1 + CalcSeite2 + CalcSeite3;

    // wenn Wand => keine endkappen
    //rubber-inlay =>caprail
    //Drainage nur in 4
    //Anker ->  5stk/m ;; Holz -> keinen Anker; Stahl = m12bolzen 240661-245(50 stk.vpe) +(Unterlegscheibe) 240663-224 + 240651-208(Mutter);Beton -> 244310-110(50stk);

    if (param.count == 'de-de' || param.count == 'de-at' || param.count == 'fr-lu' || param.count == 'nl-nl') {
      ankertrigger = true;
    }

    //Facia -> 168237-18 4/2500
    //209040 	204093-012 raus
    //"Puster" 204092 rein
    //208205-010 rubber

    //Ealu ->top CE & at -> m10 (244410-113 10vpe) + Mutter(240650-108 vpe50) ;;; Seitenmount -> anderer Flange; andere Pfosten;  m8(244410-820 10vpe) anker überall sonst + Mutter (240650-865);
    //Mörtel 204089-30 /30appl (m10)  && /40appl (m8)
    //"Puster" 204902
    // m8 Bürste - 204093-010
    // m10 Bürste - 204093-012

    /*Calc von PicketLength */
    let alulen1 = length1 * 10;
    let alulen2 = length2 * 10;
    let alulen3 = length3 * 10;

    if (montageart == 'top') {
      if (form == 'u') {
        if (wall1) {
          alulen1 = alulen1 - 98;
        } else {
          alulen1 = alulen1 - 88;
        }
        alulen2 = alulen2 - 176;
        if (wall2) {
          alulen3 = alulen3 - 98;
        } else {
          alulen3 = alulen3 - 88;
        }
      }
      if (form == 'l') {
        if (wall1) {
          alulen1 = alulen1 - 98;
        } else {
          alulen1 = alulen1 - 88;
        }
        if (wall2) {
          alulen2 = alulen2 - 98;
        } else {
          alulen2 = alulen2 - 88;
        }
      }
      if (form == 'i') {
        if (wall1) {
          alulen1 = alulen1 - 98;
        } else {
          alulen1 = alulen1 - 88;
        }
        if (wall2) {
          alulen1 = alulen1 - 10;
        } else {
          alulen1 = alulen1;
        }
      }
    } else {
      if (form == 'u') {
        if (wall1) {
          alulen1 = alulen1 - 10;
        }
        if (wall2) {
          alulen3 = alulen3 - 10;
        }
      }
      if (form == 'l') {
        if (wall1) {
          alulen1 = alulen1 - 10;
        }
        if (wall2) {
          alulen2 = alulen2 - 10;
        }
      }
      if (form == 'i') {
        if (wall1) {
          alulen1 = alulen1 - 10;
        }
        if (wall2) {
          alulen1 = alulen1 - 10;
        }
      }
    }

    let singlelength = alulen1 / amount / 10;
    let singlelength2 = alulen2 / amount2 / 10;
    let singlelength3 = alulen3 / amount3 / 10;
    let leftoverarr = [];
    let checkcheck;

    if (form == 'i' && montageart == 'top') {
      singlelength = (alulen1 + 88 - 20) / amount / 10;
      if (wall1) {
        singlelength = (alulen1 + 98 - 20) / amount / 10;
      }
      if (wall2) {
        singlelength = (alulen1 + 98 - 20) / amount / 10;
      }
      if (wall1 && wall2) {
        singlelength = (alulen1 + 88) / amount / 10;
      }
    }

    if (form == 'i' && montageart != 'top') {
      singlelength = (alulen1 - 20) / amount / 10;
      if (wall1) {
        singlelength = (alulen1 + 10 - 20) / amount / 10;
      }
      if (wall2) {
        singlelength = (alulen1 + 10 - 20) / amount / 10;
      }
      if (wall1 && wall2) {
        singlelength = alulen1 / amount / 10;
      }
    }

    //glassCalc

    let glasslength1 = length1 * 10;
    let glasslength2 = length2 * 10;
    let glasslength3 = length3 * 10;

    glasslength1 = glasslength1 - (amount - 1) * 10;
    glasslength2 = glasslength2 - (amount2 - 1) * 10;
    glasslength3 = glasslength3 - (amount3 - 1) * 10;

    let glassthickness = 17.52;
    let smarttop = 60 - glassthickness - 25.5;
    let smartfacsia = 66 - glassthickness - 28.5;

    if (montageart == 'top') {
      if (form == 'u') {
        glasslength1 = glasslength1 - smarttop - glassthickness - 10;
        glasslength2 = glasslength2 - 2 * smarttop;
        glasslength3 = glasslength3 - smarttop - glassthickness - 10;
      }
      if (form == 'l') {
        glasslength2 = glasslength2 - smarttop;
        glasslength1 = glasslength1 - smarttop - 10 - glassthickness;
      }
    }
    if (montageart != 'top') {
      if (form == 'u') {
        glasslength1 = glasslength1 - smartfacsia - glassthickness - 10;
        glasslength2 = glasslength2 - 2 * smartfacsia;
        glasslength3 = glasslength3 - smartfacsia - glassthickness - 10;
      }
      if (form == 'l') {
        glasslength2 = glasslength2 - smartfacsia;
        glasslength1 = glasslength1 - smartfacsia - 10 - glassthickness;
      }
    }

    if (wall1) {
      glasslength1 = glasslength1 - 10;
    }
    if (wall2 && form == 'i') {
      glasslength1 = glasslength1 - 10;
    }
    if (wall2 && form == 'l') {
      glasslength2 = glasslength2 - 10;
    }
    if (wall2 && form == 'u') {
      glasslength3 = glasslength3 - 10;
    }

    if ((untergrundd == 'beton' || untergrundd == 'holz') && montageart == 'top') {
      if (form == 'u') {
        glasslength1 = glasslength1 - 60;
        glasslength2 = glasslength2 - 120;
        glasslength3 = glasslength3 - 60;
      }
      if (form == 'l') {
        glasslength1 = glasslength1 - 60;
        glasslength2 = glasslength2 - 60;
      }
    }

    if (montageart != 'top') {
      if (form == 'u') {
        glasslength1 = glasslength1 + 66;
        glasslength2 = glasslength2 + 132;
        glasslength3 = glasslength3 + 66;
      }
      if (form == 'l') {
        glasslength1 = glasslength1 + 66;
        glasslength2 = glasslength2 + 66;
      }
    }

    let glassi = parseInt(glasslength1) / amount;
    let glassl = parseInt(glasslength2) / amount2;
    let glassu = parseInt(glasslength3) / amount3;

    let glassil = false;
    let glassiu = false;
    let glasslu = false;
    let glassilu = false;
    if (glassi == glassl) {
      glassil = true;
    }
    if (glassi == glassu) {
      glassiu = true;
    }
    if (glassl == glassu) {
      glasslu = true;
    }
    if (glassl == glassi && glassi == glassu) {
      glassilu = true;
    }

    let glasshohe = parseInt(hohe);
    if (para.count == 'en-us' || para.count == 'es-us') {
      if (parseInt(hohe) == 900) {
        glasshohe = glasshohe + 14.4;
      }
      if (parseInt(hohe) == 1000) {
        glasshohe = glasshohe + 66.8;
      }
      if (parseInt(hohe) == 1100) {
        glasshohe = glasshohe + 119.2;
      }
    }

    if (montageart == 'top') {
      glasshohe = glasshohe - 25;
      if (handlaufmat != 'none' && handlaufmat != 'round' && handlaufmat != 'normal') {
        glasshohe = glasshohe - 3;
      }
      if (handlaufmat == 'round') {
        glasshohe = glasshohe - 18;
      }
      if (handlaufmat == 'normal') {
        glasshohe = glasshohe - 7;
      }
    } else {
      glasshohe = glasshohe + 90;
      if (handlaufmat != 'none' && handlaufmat != 'round' && handlaufmat != 'normal') {
        glasshohe = glasshohe - 3;
      }
      if (handlaufmat == 'round') {
        glasshohe = glasshohe - 18;
      }
      if (handlaufmat == 'normal') {
        glasshohe = glasshohe - 7;
      }
    }

    if (para.count == 'en-us' || para.count == 'es-us') {
      glasshohe = glasshohe / 25.4;

      glassi = parseInt(glassi) / 25.4;
      glassl = parseInt(glassl) / 25.4;
      glassu = parseInt(glassu) / 25.4;
    }

    //connector calc
    let amountConnectors = 0;

    if (len1 > 5000 && len1 <= 10000) {
      amountConnectors = amountConnectors + 1;
    }
    if (len1 > 10000 && len1 <= 15000) {
      amountConnectors = amountConnectors + 2;
    }
    if (len2 > 5000 && len2 <= 10000 && (form == 'u' || form == 'l')) {
      amountConnectors = amountConnectors + 1;
    }
    if (len2 > 10000 && len2 <= 15000 && (form == 'u' || form == 'l')) {
      amountConnectors = amountConnectors + 2;
    }
    if (len3 > 5000 && len3 <= 10000 && form == 'u') {
      amountConnectors = amountConnectors + 1;
    }
    if (len3 > 10000 && len3 <= 15000 && form == 'u') {
      amountConnectors = amountConnectors + 2;
    }

    //BaseShoe calc
    let tolerance = 230 + 60;
    let utolerance = 460 + 120;
    if (montageart != 'top') {
      tolerance = 260;
      utolerance = 520;
    }
    if (form == 'i') {
      if (len1 - 10 < 2500) {
        amount25 = amount25 + 1;
        leftoverarr.push([2500 - parseInt(len1), 1]);
      }
      if (len1 - 10 > 2500 && len1 - 10 < 5000) {
        amount5 = amount5 + 1;
        leftoverarr.push([5000 - parseInt(len1), 1]);
      }
      if (len1 - 10 > 5000 && len1 - 10 < 7500) {
        amount5 = amount5 + 1;
        amount25 = amount25 + 1;
        leftoverarr.push([7500 - parseInt(len1), 1]);
      }
      if (len1 - 10 > 7500 && len1 - 10 < 10000) {
        amount5 = amount5 + 2;
        leftoverarr.push([10000 - parseInt(len1), 1]);
      }
      if (len1 - 10 > 10000 && len1 - 10 < 12500) {
        amount5 = amount5 + 2;
        amount25 = amount25 + 1;
        leftoverarr.push([12500 - parseInt(len1), 1]);
      }
      if (len1 - 1 > 12500 && len1 - 10 < 15000) {
        amount5 = amount5 + 3;
        leftoverarr.push([15000 - parseInt(len1), 1]);
      }
    }
    if (form == 'l' || form == 'u') {
      if (len1 - tolerance < 2500) {
        amount25 = amount25 + 1;
        leftoverarr.push([2500 - len1, 1]);
      }
      if (len1 - tolerance > 2500 && len1 - tolerance < 5000) {
        amount5 = amount5 + 1;
        leftoverarr.push([5000 - len1, 1]);
      }
      if (len1 - tolerance > 5000 && len1 - tolerance < 7500) {
        amount5 = amount5 + 1;
        amount25 = amount25 + 1;
        leftoverarr.push([7500 - len1, 1]);
      }
      if (len1 - tolerance > 7500 && len1 - tolerance < 10000) {
        amount5 = amount5 + 2;
        leftoverarr.push([10000 - len1, 1]);
      }
      if (len1 - tolerance > 10000 && len1 - tolerance < 12500) {
        amount5 = amount5 + 2;
        amount25 = amount25 + 1;
        leftoverarr.push([12500 - len1, 1]);
      }
      if (len1 - tolerance > 12500 && len1 - tolerance < 15000) {
        amount5 = amount5 + 3;
        leftoverarr.push([15000 - len1, 1]);
      }
    }

    if (form == 'l') {
      if (len2 - tolerance < 2500) {
        amount25 = amount25 + 1;
      }
      leftoverarr.push([2500 - len2, 2]);
      if (len2 - tolerance > 2500 && len2 - tolerance < 5000) {
        amount5 = amount5 + 1;
        leftoverarr.push([5000 - len2, 2]);
      }
      if (len2 - tolerance > 5000 && len2 - tolerance < 7500) {
        amount5 = amount5 + 1;
        amount25 = amount25 + 1;
        leftoverarr.push([7500 - len2, 2]);
      }
      if (len2 - tolerance > 7500 && len2 - tolerance < 10000) {
        amount5 = amount5 + 2;
        leftoverarr.push([10000 - len2, 2]);
      }
      if (len2 - tolerance > 10000 && len2 - tolerance < 12500) {
        amount5 = amount5 + 2;
        amount25 = amount25 + 1;
        leftoverarr.push([12500 - len2, 2]);
      }
      if (len2 - tolerance > 12500 && len2 - tolerance < 15000) {
        amount5 = amount5 + 3;
        leftoverarr.push([15000 - len2, 2]);
      }
    }
    if (form == 'u') {
      if (len2 - utolerance < 2500) {
        amount25 = amount25 + 1;
      }
      leftoverarr.push([2500 - len2, 2]);
      if (len2 - utolerance > 2500 && len2 - utolerance < 5000) {
        amount5 = amount5 + 1;
        leftoverarr.push([5000 - len2, 2]);
      }
      if (len2 - utolerance > 5000 && len2 - utolerance < 7500) {
        amount5 = amount5 + 1;
        amount25 = amount25 + 1;
        leftoverarr.push([7500 - len2, 2]);
      }
      if (len2 - utolerance > 7500 && len2 - utolerance < 10000) {
        amount5 = amount5 + 2;
        leftoverarr.push([10000 - len2, 2]);
      }
      if (len2 - utolerance > 10000 && len2 - utolerance < 12500) {
        amount5 = amount5 + 2;
        amount25 = amount25 + 1;
        leftoverarr.push([12500 - len2, 2]);
      }
      if (len2 - utolerance > 12500 && len2 - utolerance < 15000) {
        amount5 = amount5 + 3;
        leftoverarr.push([15000 - len2, 2]);
      }
    }
    if (form == 'u') {
      if (len3 - tolerance < 2500) {
        amount25 = amount25 + 1;
        leftoverarr.push([2500 - len3, 3]);
      }
      if (len3 - tolerance > 2500 && len3 - tolerance < 5000) {
        amount5 = amount5 + 1;
        leftoverarr.push([5000 - len3, 3]);
      }
      if (len3 - tolerance > 5000 && len3 - tolerance < 7500) {
        amount5 = amount5 + 1;
        amount25 = amount25 + 1;
        leftoverarr.push([7500 - len3, 3]);
      }
      if (len3 - tolerance > 7500 && len3 - tolerance < 10000) {
        amount5 = amount5 + 2;
        leftoverarr.push([10000 - len3, 3]);
      }
      if (len3 - tolerance > 10000 && len3 - tolerance < 12500) {
        amount5 = amount5 + 2;
        amount25 = amount25 + 1;
        leftoverarr.push([12500 - len3, 3]);
      }
      if (len3 - tolerance > 12500 && len3 - tolerance < 15000) {
        amount5 = amount5 + 3;
        leftoverarr.push([15000 - len3, 3]);
      }
    }
    leftoverarr = leftoverarr.sort(function (a, b) {
      return a - b;
    });
    for (let o = 0; o < leftoverarr.length; o++) {
      if (leftoverarr[o][0] - len1 > 0 && leftoverarr[o][1] != 1 && form != 'i') {
        amount25 = amount25 - 1;

        for (let l = 0; l < leftoverarr.length; l++) {
          if (leftoverarr[l][1] == 1) {
            leftoverarr[l] = 0;
          }
        }
        leftoverarr[o] = 0;
      }
      if (leftoverarr[o][0] - len2 > 0 && leftoverarr[o][1] != 2 && (form == 'l' || form == 'u')) {
        amount25 = amount25 - 1;
        for (let l = 0; l < leftoverarr.length; l++) {
          if (leftoverarr[l][1] == 2) {
            leftoverarr[l] = 0;
          }
        }
        leftoverarr[o] = 0;
      }
      if (leftoverarr[o][0] - len3 > 0 && leftoverarr[o][1] != 3 && form == 'u') {
        amount25 = amount25 - 1;
        for (let l = 0; l < leftoverarr.length; l++) {
          if (leftoverarr[l][1] == 3) {
            leftoverarr[l] = 0;
          }
        }
        leftoverarr[o] = 0;
      }
    }
    let shoplink = 'https://shop.de.q-railing.com';
    let anchors = 0;
    let wallsactive = 2;
    let drainageprofile = 0;

    let lengthy1 = len1 + 300;

    switch (para.count) {
      case 'de-de':
        shoplink = shoplink.replace('.de.', '.de.');
        break;
      case 'de-at':
        shoplink = shoplink.replace('.de.', '.at.');
        break;
      case 'en-us':
        shoplink = shoplink.replace('.de.', '.us.');
        break;
      case 'en-gb':
        shoplink = shoplink.replace('.de.', '.uk.');
        break;
      case 'en-ir':
        shoplink = shoplink.replace('.de.', '.uk.');
        break;
      case 'fr-lu':
        shoplink = shoplink.replace('.de.', '.de.');
        break;
      case 'es-es':
        shoplink = shoplink.replace('.de.', '.es.');
        break;
      case 'it-it':
        shoplink = shoplink.replace('.de.', '.it.');
        break;
      case 'pl-pl':
        shoplink = shoplink.replace('.de.', '.pl.');
        break;
      case 'pt-pt':
        shoplink = shoplink.replace('.de.', '.bu.');
        break;
      case 'nb-no':
        shoplink = shoplink.replace('.de.', '.no.');
        break;
      case 'sv-se':
        shoplink = shoplink.replace('.de.', '.se.');
        break;
      case 'ch-de':
        shoplink = shoplink.replace('.de.', '.de.');
        break;
      case 'ch-it':
        shoplink = shoplink.replace('.de.', '.de.');
        break;
      case 'ch-fr':
        shoplink = shoplink.replace('.de.', '.de.');
        break;
      case 'fr-fr':
        shoplink = shoplink.replace('.de.', '.de.');
        break;
      case 'da-dk':
        shoplink = shoplink.replace('.de.', '.dk.');
        break;
      case 'nl-be':
        shoplink = shoplink.replace('.de.', '.de.');
        break;
      case 'fr-be':
        shoplink = shoplink.replace('.de.', '.de.');
        break;
      case 'fi-fi':
        shoplink = shoplink.replace('.de.', '.dk.');
        break;
      case 'fr-ca':
        shoplink = shoplink.replace('.de.', '.us.');
        break;
      case 'en-ca':
        shoplink = shoplink.replace('.de.', '.us.');
        break;
      case 'pt-br':
        shoplink = shoplink.replace('.de.', '.bu.');
        break;
      case 'tr-tr':
        shoplink = shoplink.replace('.de.', '.bu.');
        break;
      default:
    }
    if (wall1) {
      wallsactive = wallsactive - 1;
    }
    if (wall2) {
      wallsactive = wallsactive - 1;
    }
    let gesamtleng = 0;
    if (form == 'i') {
      gesamtleng = parseInt(len1);
    }
    if (form == 'l') {
      gesamtleng = parseInt(len1) + parseInt(len2);
    }
    if (form == 'u') {
      gesamtleng = parseInt(len1) + parseInt(len2) + parseInt(len3);
    }

    let alarm = false;
    let resstring = '';
    let resamount;
    let casetrigger = 0;

    if (
      (singlelength == singlelength2 && (form == 'l' || form == 'u')) ||
      (singlelength2 == singlelength3 && form == 'u') ||
      (singlelength == singlelength3 && form == 'u') ||
      (singlelength == singlelength3 && singlelength == singlelength2 && form == 'u')
    ) {
      alarm = true;
      if (singlelength == singlelength2) {
        resamount = amount + amount2;
        casetrigger = 1;
      }
      if (singlelength2 == singlelength3) {
        resamount = amount2 + amount3;
        casetrigger = 2;
      }
      if (singlelength == singlelength3) {
        resamount = amount + amount3;
        casetrigger = 3;
      }
      if (singlelength == singlelength3 && singlelength == singlelength2) {
        resamount = amount + amount3 + amount2;
        casetrigger = 4;
      }
    }

    let ankercalc = 0;
    let ankercalc2 = 0;
    ankercalc = (parseInt(gesamtleng / 1000) + 1) * 5;
    ankercalc2 = (parseInt(gesamtleng / 1000) + 1) * 5;
    let anchorcalcalu = amount * 2;
    if (form == 'l') {
      anchorcalcalu = (amount + amount2) * 2;
    }
    if (form == 'u') {
      anchorcalcalu = (amount + amount2 + amount3) * 2;
    }
    let hovertabletext = ' Dies ist ein Beschreibener Text bezüglich Handlauf';
    if (infotext.data.length > 0) {
      hovertabletext = infotext.data[0].attributes.FreeData1.data[61];
    }

    //baseclampcalcs
    let baseclampamount = 0;
    let length2y = parseInt(len2 / 10);
    let length1y = parseInt(len1 / 10);
    let length3y = parseInt(len3 / 10);
    let amounty = parseInt(parseInt(length1) / glaspanelwidthi);
    let amount2y = parseInt(parseInt(length2) / glaspanelwidthl);
    let amount3y = parseInt(parseInt(length3) / glaspanelwidthu);
    let actglaslengi = len1 - amounty * 10;
    let actglaslengl = len2 - amount2y * 10;
    let actglaslengu = len3 - amount3y * 10;

    if (form == 'i') {
      actglaslengi = len1 - (amounty + 2) * 10;
    }

    if (form == 'l') {
      actglaslengi = len1 - 60 - (amounty + 1) * 10;
      actglaslengl = len2 - 60 - (amount2y + 1) * 10;
    }

    if (form == 'u') {
      actglaslengi = len1 - 60 - (amounty + 1) * 10;
      actglaslengl = len2 - 120 - amount2y * 10;
      actglaslengu = len3 - 60 - (amount3y + 1) * 10;
    }

    let glaspaneli = (actglaslengi / (parseInt(amounty) + 1)).toFixed(2);
    let glaspanell = (actglaslengl / (parseInt(amount2y) + 1)).toFixed(2);
    let glaspanelu = (actglaslengu / (parseInt(amount3y) + 1)).toFixed(2);
    let heighty = hohe;
    let actheight = heighty - 60;

    if (para.count == 'en-us' || para.count == 'es-us') {
      glaspaneli = (glaspaneli / 25.4).toFixed(2) + '"';
      glaspanell = (glaspanell / 25.4).toFixed(2) + '"';
      glaspanelu = (glaspanelu / 25.4).toFixed(2) + '"';

      actheight = actheight == 900 ? '36"' : actheight == 1000 ? '42"' : '48"';
    } else {
      actheight = actheight + 'mm';
      glaspaneli = parseInt(glaspaneli) + 'mm';
      glaspanell = parseInt(glaspanell) + 'mm';
      glaspanelu = parseInt(glaspanelu) + 'mm';
    }
    let measureglasi = '' + glaspaneli + ' x ' + actheight + ' x' + glassthicknessbaseclamps;
    let measureglasl = '' + glaspanell + ' x ' + actheight + ' x' + glassthicknessbaseclamps;
    let measureglasu = '' + glaspanelu + ' x ' + actheight + ' x' + glassthicknessbaseclamps;

    let baseclampcase = 0;

    if (glaspaneli == glaspanell && (form == 'l' || form == 'u')) {
      baseclampcase = 1;
    }
    if (glaspaneli == glaspanelu && form == 'u') {
      baseclampcase = 2;
    }
    if (glaspanell == glaspanelu && form == 'u') {
      baseclampcase = 3;
    }
    if (glaspaneli == glaspanell && glaspaneli == glaspanelu && form == 'u') {
      baseclampcase = 4;
    }

    if (form == 'i') {
      if (glaspanelwidthi < 101) {
        baseclampamount = (parseInt(amounty) + 1) * 2;
      } else {
        baseclampamount = (parseInt(amounty) + 1) * 3;
      }
    }

    let ConnectorForAlu = 0;

    if (form == 'l' || form == 'u') {
      ConnectorForAlu = ConnectorForAlu + 2;
    }
    if (form == 'u') {
      ConnectorForAlu = ConnectorForAlu + 2;
    }
    if (len1 > 5000) {
      ConnectorForAlu = ConnectorForAlu + 2;
    }
    if (len2 > 5000 && (form == 'l' || form == 'u')) {
      ConnectorForAlu = ConnectorForAlu + 2;
    }
    if (len3 > 5000 && form == 'u') {
      ConnectorForAlu = ConnectorForAlu + 2;
    }
    if (len1 >= 10000) {
      ConnectorForAlu = ConnectorForAlu + 2;
    }
    if (len2 >= 10000 && (form == 'l' || form == 'u')) {
      ConnectorForAlu = ConnectorForAlu + 2;
    }
    if (len3 >= 10000 && form == 'u') {
      ConnectorForAlu = ConnectorForAlu + 2;
    }

    if (form == 'l') {
      if (glaspanelwidthi < 101) {
        baseclampamount = (parseInt(amounty) + 1) * 2;
      } else if (glaspanelwidthi > 101) {
        baseclampamount = (parseInt(amounty) + 1) * 3;
      }

      if (glaspanelwidthl < 101) {
        baseclampamount = baseclampamount + (parseInt(amount2y) + 1) * 2;
      } else if (glaspanelwidthl > 101) {
        baseclampamount = baseclampamount + (parseInt(amount2y) + 1) * 3;
      }
    }

    if (form == 'u') {
      if (glaspanelwidthi < 101) {
        baseclampamount = (parseInt(amounty) + 1) * 2;
      } else if (glaspanelwidthi > 101) {
        baseclampamount = (parseInt(amounty) + 1) * 3;
      }

      if (glaspanelwidthl < 101) {
        baseclampamount = baseclampamount + (parseInt(amount2y) + 1) * 2;
      } else if (glaspanelwidthl > 101) {
        baseclampamount = baseclampamount + (parseInt(amount2y) + 1) * 3;
      }
      if (glaspanelwidthu < 101) {
        baseclampamount = baseclampamount + (parseInt(amount3y) + 1) * 2;
      } else if (glaspanelwidthu > 101) {
        baseclampamount = baseclampamount + (parseInt(amount3y) + 1) * 3;
      }
    }
    let postamount = 0;
    let baramount25 = amount25;
    let baramount5 = amount5;
    baramount25 = 0;
    let barlengnubmer = 5000;

    let barnumber = gesamtleng;
    if (montageart != 'top') {
      {
        form == 'l' && (barnumber = barnumber + 100);
      }
      {
        form == 'u' && (barnumber = barnumber + 200);
      }
    }
    baramount5 = parseInt(barnumber / barlengnubmer) + 1;

    let rubberamount = 0;
    let closestI = 0;
    let closestL = 0;
    let closestU = 0;
    //qlinejump
    if (gelaender == 'qline') {
      let postdistancevalue = 1000;

      if (montageart == 'top') {
        if (PostShape == '40x40') {
          postdistancevalue = 1000;
        }
        if (PostShape == 'round' && Pfostenrund != '48') {
          postdistancevalue = 1000;
        }
        if (PostShape == 'round' && Pfostenrund == '48') {
          postdistancevalue = 1200;
        }
        if (PostShape == '60x30') {
          postdistancevalue = 1200;
        }
      }
      if (montageart != 'top') {
        if (PostShape == '40x40') {
          postdistancevalue = 900;
        }
        if (PostShape == 'round' && Pfostenrund != '48') {
          postdistancevalue = 900;
        }
        if (PostShape == 'round' && Pfostenrund == '48') {
          postdistancevalue = 1100;
        }
        if (PostShape == '60x30') {
          postdistancevalue = 1100;
        }
      }
      let idmlen1 = len1;
      let idmlen2 = len2;
      let idmlen3 = len3;

      if (montageart != 'top' || PostShape == '60x30') {
        if (form == 'u') {
          idmlen1 = len1 - 250;
          idmlen2 = len2 - 500;
          idmlen3 = len3 - 250;
        }
        if (form == 'l') {
          idmlen1 = len1 - 250;
          idmlen2 = len2 - 250;
        }
      }

      let amountI = parseInt(idmlen1 / postdistancevalue);
      let amountL = parseInt(idmlen2 / postdistancevalue);
      let amountU = parseInt(idmlen3 / postdistancevalue);
      amountI = amountI + 1;
      amountL = amountL + 1;
      amountU = amountU + 1;
      //Handrail precise calculations

      {
        form == 'i'
          ? (amountI = amountI + 1)
          : form == 'l'
            ? (amountL = amountL + 1)
            : form == 'u'
              ? (amountU = amountU + 1)
              : 0;
      }
      if (montageart != 'top' || PostShape == '60x30' || (PostShape == 'round' && qlineinfill == 'cables')) {
        form == 'i'
          ? (amountI = amountI)
          : form == 'l'
            ? (amountL = amountL + 1)
            : form == 'u'
              ? (amountU = amountU + 2)
              : 0;
      }

      {
        form == 'i'
          ? (postamount = amountI)
          : form == 'l'
            ? (postamount = amountL + amountI)
            : form == 'u'
              ? (postamount = amountU + amountI + amountL)
              : (postamount = 0);
      }
      //edgecase postamount
      if (form == 'u' && montageart != 'top' && len2 < 1000) {
        postamount = postamount - 1;
      }
      //rubberamount
      rubberamount = postamount * 4 - 4;

      if ((form == 'u' || form == 'l') && montageart != 'top') {
        rubberamount = rubberamount + 8;
        if (form == 'l') {
          rubberamount = rubberamount - 4;
        }
      }
      rubberamount = rubberamount * 2;
      //cables
      let cablesets = [];
      const results = [1000, 2500, 5000, 7500, 10000, 12500, 20000];

      const findClosest = (num, arr) => {
        const filteredArr = arr.filter((value) => value >= num);
        return filteredArr.reduce((prev, curr) => {
          return Math.abs(curr - num) < Math.abs(prev - num) ? curr : prev;
        });
      };
      closestI = findClosest(len1, results);
      closestL = findClosest(len2, results);
      closestU = findClosest(len3, results);
      switch (closestI) {
        case 1000:
          closestI = 248;
          break;
        case 2500:
          closestI = 249;
          break;
        case 5000:
          closestI = 250;
          break;
        case 7500:
          closestI = 251;
          break;
        case 10000:
          closestI = 252;
          break;
        case 12500:
          closestI = 253;
          break;
        case 20000:
          closestI = 254;
          break;
      }
      switch (closestL) {
        case 1000:
          closestL = 248;
          break;
        case 2500:
          closestL = 249;
          break;
        case 5000:
          closestL = 250;
          break;
        case 7500:
          closestL = 251;
          break;
        case 10000:
          closestL = 252;
          break;
        case 12500:
          closestL = 253;
          break;
        case 20000:
          closestL = 254;
          break;
      }
      switch (closestU) {
        case 1000:
          closestU = 248;
          break;
        case 2500:
          closestU = 249;
          break;
        case 5000:
          closestU = 250;
          break;
        case 7500:
          closestU = 251;
          break;
        case 10000:
          closestU = 252;
          break;
        case 12500:
          closestU = 253;
          break;
        case 20000:
          closestU = 254;
          break;
      }
    }

    let handraillength = gesamtleng;

    if (montageart == 'top') {
      if (form == 'i') {
        handraillength = handraillength - 20;
      }
      if (form == 'l') {
        {
          handlaufmat == 'round' && (handraillength = handraillength - 150 - 260);
        }
        {
          handlaufmat == '40x40' && (handraillength = handraillength - 150 - 250);
        }
        {
          handlaufmat == '60x30' && (handraillength = handraillength - 150 - 270);
        }
        {
          handlaufmat == 'round' && (handraillength = handraillength - 150 - 270);
        }
      }
      if (form == 'l') {
        {
          handlaufmat == 'round' && (handraillength = handraillength - 150 - 260 - 150);
        }
        {
          handlaufmat == '40x40' && (handraillength = handraillength - 150 - 250 - 150);
        }
        {
          handlaufmat == '60x30' && (handraillength = handraillength - 150 - 270 - 150);
        }
        {
          handlaufmat == 'round' && (handraillength = handraillength - 150 - 270 - 150);
        }
      }
    } else {
      if (form == 'i') {
        handraillength = handraillength - 20;
      }
      if (form == 'l') {
        {
          handlaufmat == 'round' &&
            PostShape == 'round' &&
            QlineHandlauf == '48' &&
            (handraillength = handraillength + 15 + 58.3);
        }
        {
          handlaufmat == 'round' &&
            PostShape == 'round' &&
            QlineHandlauf == '42' &&
            (handraillength = handraillength + 15 + 62.4);
        }
        {
          handlaufmat == '40x40' && PostShape == '40x40' && (handraillength = handraillength + 15 + 70);
        }
        {
          handlaufmat == 'round' && PostShape == '40x40' && (handraillength = handraillength + 15 + 60);
        }
        {
          handlaufmat == '60x30' && (handraillength = handraillength + 15 + 70);
        }

        {
          handlaufmat == 'round' && PostShape == '60x30' && (handraillength = handraillength + 15 + 70);
        }
      }
      if (form == 'l') {
        {
          handlaufmat == 'round' &&
            PostShape == 'round' &&
            QlineHandlauf == '48' &&
            (handraillength = handraillength + 15 + 58.3 + 15);
        }
        {
          handlaufmat == 'round' &&
            PostShape == 'round' &&
            QlineHandlauf == '42' &&
            (handraillength = handraillength + 15 + 62.4 + 15);
        }
        {
          handlaufmat == '40x40' && PostShape == '40x40' && (handraillength = handraillength + 15 + 70 + 15);
        }
        {
          handlaufmat == 'round' && PostShape == '40x40' && (handraillength = handraillength + 15 + 60 + 15);
        }
        {
          handlaufmat == '60x30' && (handraillength = handraillength + 15 + 70 + 15);
        }

        {
          handlaufmat == 'round' && PostShape == '60x30' && (handraillength = handraillength + 15 + 70 + 15);
        }
      }
    }

    let handrailnumber = parseInt(handraillength / 5000) + 1;

    return (
      <>
        {gelaender == 'glass' && (
          <>
            <div className={'articlelist-wrap ' + (!showmenu ? 'hide-element' : '')}></div>
            <div className={'articlelist ' + (!showmenu ? 'hide-element' : '')}>
              <div className="articlelist-inner-header">
                <h3>
                  {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[70] : 'Individual Components'}
                </h3>
                <button
                  id="closeproductlist"
                  onClick={() => {
                    if (showmenu) {
                      setshowmenu(false);
                      document.getElementById('modelcanvas2').style = 'position:relative';
                    } else {
                      setshowmenu(true);
                      document.getElementById('modelcanvas2').style = 'position:absolute';
                    }
                  }}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M19.5459 17.954C19.7572 18.1653 19.876 18.452 19.876 18.7509C19.876 19.0497 19.7572 19.3364 19.5459 19.5477C19.3346 19.7591 19.0479 19.8778 18.749 19.8778C18.4501 19.8778 18.1635 19.7591 17.9521 19.5477L12 13.5937L6.0459 19.5459C5.83455 19.7572 5.54791 19.8759 5.24902 19.8759C4.95014 19.8759 4.66349 19.7572 4.45215 19.5459C4.2408 19.3345 4.12207 19.0479 4.12207 18.749C4.12207 18.4501 4.2408 18.1635 4.45215 17.9521L10.4062 11.9999L4.45402 6.04586C4.24268 5.83451 4.12395 5.54787 4.12395 5.24898C4.12395 4.9501 4.24268 4.66345 4.45402 4.45211C4.66537 4.24076 4.95201 4.12203 5.2509 4.12203C5.54978 4.12203 5.83643 4.24076 6.04777 4.45211L12 10.4062L17.954 4.45117C18.1654 4.23983 18.452 4.12109 18.7509 4.12109C19.0498 4.12109 19.3364 4.23983 19.5478 4.45117C19.7591 4.66251 19.8778 4.94916 19.8778 5.24804C19.8778 5.54693 19.7591 5.83358 19.5478 6.04492L13.5937 11.9999L19.5459 17.954Z"
                      fill="#001020"
                    />
                  </svg>
                </button>
              </div>
              {montageart == 'top' && (
                <table className="articletable">
                  <tr>
                    <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[71] : 'Type'}</td>
                    <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[72] : 'Art.Image'}</td>
                    <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[73] : 'Art. No.'}</td>
                    <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[74] : 'Amount'}</td>
                  </tr>
                  {amount5 > 0 && (
                    <tr>
                      <td>{finalarr[3][0]}</td>
                      <td>
                        <img src={finalarr[3][2]} width="48px" />
                      </td>
                      <td>{finalarr[3][1]}</td>
                      <td className="table_amount"> x {amount5}</td>
                    </tr>
                  )}
                  {amount25 > 0 && (
                    <tr>
                      <td>{finalarr[2][0]}</td>
                      <td>
                        <img src={finalarr[2][2]} width="48px" />
                      </td>
                      <td>{finalarr[2][1]}</td>
                      <td className="table_amount"> x {amount25}</td>
                    </tr>
                  )}

                  {((includeglass && !glassil && !glassilu && !glassiu && !glasslu) ||
                    form == 'i' ||
                    (form == 'l' && !glassil)) && (
                    <>
                      {
                        <tr>
                          <td>{finalarr[73][0]}</td>
                          <td>
                            <img src={finalarr[73][2]} width="48px" />
                          </td>
                          <td>
                            {para.count == 'en-us' || para.count == 'es-us'
                              ? glassi.toFixed(2) + '"'
                              : parseInt(glassi)}
                            x{para.count == 'en-us' || para.count == 'es-us' ? glasshohe.toFixed(2) + '"' : glasshohe}
                            {para.count == 'en-us' || (para.count == 'es-us' && '"')}
                            {para.count == 'en-us' || para.count == 'es-us' ? 'x11/16"' : 'x17.52 mm'}
                          </td>
                          <td className="table_amount"> x {amount}</td>
                        </tr>
                      }
                      {(form == 'l' || form == 'u') && (
                        <tr>
                          <td>{finalarr[73][0]}</td>
                          <td>
                            <img src={finalarr[73][2]} width="48px" />
                          </td>
                          <td>
                            {para.count == 'en-us' || para.count == 'es-us'
                              ? glassl.toFixed(2) + '"'
                              : parseInt(glassl)}
                            x{para.count == 'en-us' || para.count == 'es-us' ? glasshohe.toFixed(2) + '"' : glasshohe}
                            {para.count == 'en-us' || (para.count == 'es-us' && +'"')}
                            {para.count == 'en-us' || para.count == 'es-us' ? 'x11/16"' : 'x17.52 mm'}
                          </td>
                          <td className="table_amount"> x {amount2}</td>
                        </tr>
                      )}
                      {form == 'u' && (
                        <tr>
                          <td>{finalarr[73][0]}</td>
                          <td>
                            <img src={finalarr[73][2]} width="48px" />
                          </td>
                          <td>
                            {para.count == 'en-us' || para.count == 'es-us'
                              ? glassu.toFixed(2) + '"'
                              : parseInt(glassu)}
                            x{para.count == 'en-us' || para.count == 'es-us' ? glasshohe.toFixed(2) + '"' : glasshohe}
                            {para.count == 'en-us' || (para.count == 'es-us' && +'"')}
                            {para.count == 'en-us' || para.count == 'es-us' ? 'x11/16"' : 'x17.52 mm'}
                          </td>
                          <td className="table_amount"> x {amount3}</td>
                        </tr>
                      )}
                    </>
                  )}

                  {((includeglass && glassilu && form == 'u') || (form == 'l' && glassil)) && (
                    <>
                      {
                        <tr>
                          <td>{finalarr[73][0]}</td>
                          <td>
                            <img src={finalarr[73][2]} width="48px" />
                          </td>
                          <td>
                            {para.count == 'en-us' || para.count == 'es-us'
                              ? glassi.toFixed(2) + '"'
                              : parseInt(glassi)}
                            x{para.count == 'en-us' || para.count == 'es-us' ? glasshohe.toFixed(2) + '"' : glasshohe}
                            {para.count == 'en-us' || para.count == 'es-us' ? 'x11/16"' : 'x17.52 mm'}
                          </td>
                          <td className="table_amount">
                            {' '}
                            x {form == 'u' ? amount + amount2 + amount3 : amount + amount2}
                          </td>
                        </tr>
                      }
                    </>
                  )}

                  {includeglass && glassil && form == 'u' && !glassilu && (
                    <>
                      {
                        <tr>
                          <td>{finalarr[73][0]}</td>
                          <td>
                            <img src={finalarr[73][2]} width="48px" />
                          </td>
                          <td>
                            {para.count == 'en-us' || para.count == 'es-us'
                              ? glassi.toFixed(2) + '"'
                              : parseInt(glassi)}
                            x{para.count == 'en-us' || para.count == 'es-us' ? glasshohe.toFixed(2) + '"' : glasshohe}
                            {para.count == 'en-us' || para.count == 'es-us' ? 'x11/16"' : 'x17.52 mm'}
                          </td>
                          <td className="table_amount"> x {amount + amount2}</td>
                        </tr>
                      }
                      {form == 'u' && (
                        <tr>
                          <td>{finalarr[73][0]}</td>
                          <td>
                            <img src={finalarr[73][2]} width="48px" />
                          </td>
                          <td>
                            {para.count == 'en-us' || para.count == 'es-us'
                              ? glassu.toFixed(2) + '"'
                              : parseInt(glassu)}
                            x{para.count == 'en-us' || para.count == 'es-us' ? glasshohe.toFixed(2) + '"' : glasshohe}
                            {para.count == 'en-us' || para.count == 'es-us' ? 'x11/16"' : 'x17.52 mm'}
                          </td>
                          <td className="table_amount"> x {amount3}</td>
                        </tr>
                      )}
                    </>
                  )}

                  {includeglass && glasslu && form == 'u' && !glassilu && !glassiu && !glassil && (
                    <>
                      {
                        <tr>
                          <td>{finalarr[73][0]}</td>
                          <td>
                            <img src={finalarr[73][2]} width="48px" />
                          </td>
                          <td>
                            {para.count == 'en-us' || para.count == 'es-us'
                              ? glassi.toFixed(2) + '"'
                              : parseInt(glassi)}
                            x{para.count == 'en-us' || para.count == 'es-us' ? glasshohe.toFixed(2) + '"' : glasshohe}
                            {para.count == 'en-us' || para.count == 'es-us' ? 'x11/16"' : 'x17.52 mm'}
                          </td>
                          <td className="table_amount"> x {amount}</td>
                        </tr>
                      }
                      {form == 'u' && (
                        <tr>
                          <td>{finalarr[73][0]}</td>
                          <td>
                            <img src={finalarr[73][2]} width="48px" />
                          </td>
                          <td>
                            {para.count == 'en-us' || para.count == 'es-us'
                              ? glassu.toFixed(2) + '"'
                              : parseInt(glassu)}
                            x{para.count == 'en-us' || para.count == 'es-us' ? glasshohe.toFixed(2) + '"' : glasshohe}
                            {para.count == 'en-us' || para.count == 'es-us' ? 'x11/16"' : 'x17.52 mm'}
                          </td>
                          <td className="table_amount"> x {amount3 + amount2}</td>
                        </tr>
                      )}
                    </>
                  )}

                  {includeglass && glassiu && form == 'u' && !glassilu && (
                    <>
                      {
                        <tr>
                          <td>{finalarr[73][0]}</td>
                          <td>
                            <img src={finalarr[73][2]} width="48px" />
                          </td>
                          <td>
                            {para.count == 'en-us' || para.count == 'es-us'
                              ? glassi.toFixed(2) + '"'
                              : parseInt(glassi)}
                            x{para.count == 'en-us' || para.count == 'es-us' ? glasshohe.toFixed(2) + '"' : glasshohe}
                            {para.count == 'en-us' || para.count == 'es-us' ? 'x11/16"' : 'x17.52 mm'}
                          </td>
                          <td className="table_amount"> x {amount + amount3}</td>
                        </tr>
                      }
                      {
                        <tr>
                          <td>{finalarr[73][0]}</td>
                          <td>
                            <img src={finalarr[73][2]} width="48px" />
                          </td>
                          <td>
                            {para.count == 'en-us' || para.count == 'es-us'
                              ? glassl.toFixed(2) + '"'
                              : parseInt(glassl)}
                            x{para.count == 'en-us' || para.count == 'es-us' ? glasshohe.toFixed(2) + '"' : glasshohe}
                            {para.count == 'en-us' || para.count == 'es-us' ? 'x11/16"' : 'x17.52 mm'}
                          </td>
                          <td className="table_amount"> x {amount2}</td>
                        </tr>
                      }
                    </>
                  )}

                  {form != 'i' && (
                    <tr>
                      <td>{finalarr[4][0]}:</td>
                      {form == 'l' && (
                        <>
                          <td>
                            <img width="48px" src={finalarr[4][2]} />
                          </td>
                          <td>{finalarr[4][1]}</td>
                          <td className="table_amount">x 1</td>
                        </>
                      )}
                      {form == 'u' && (
                        <>
                          <td>
                            <img width="48px" src={finalarr[4][2]} />
                          </td>
                          <td>{finalarr[4][1]}</td>
                          <td className="table_amount">x 2</td>
                        </>
                      )}
                    </tr>
                  )}
                  {handlaufmat == 'edgep' && amount25 > 0 && (
                    <tr>
                      <td>{finalarr[23][0]} </td>
                      <td>
                        <img src={finalarr[23][2]} width="48px" />
                      </td>
                      <td>{finalarr[23][1]}</td>
                      <td className="table_amount"> x {amount25}</td>
                    </tr>
                  )}
                  {handlaufmat == 'edgep' && amount5 > 0 && (
                    <tr>
                      <td>{finalarr[24][0]} </td>
                      <td>
                        <img src={finalarr[24][2]} width="48px" />
                      </td>
                      <td>{finalarr[24][1]}</td>
                      <td className="table_amount"> x {amount5}</td>
                    </tr>
                  )}

                  {/*NEU - Handlauf */}

                  {handlaufmat == 'normal' && (
                    <tr>
                      <td>{finalarr[74][0]} </td>
                      <td>
                        <img src={finalarr[74][2]} width="48px" />
                      </td>
                      <td>{finalarr[74][1]}</td>
                      <td className="table_amount"> x {parseInt(gesamtleng / 5000) + 1}</td>
                    </tr>
                  )}
                  {handlaufmat == 'round' && (
                    <tr>
                      <td>{finalarr[14][0]} </td>
                      <td>
                        <img src={finalarr[14][2]} width="48px" />
                      </td>
                      <td>{finalarr[14][1]}</td>
                      <td className="table_amount"> x {parseInt(gesamtleng / 5000) + 1}</td>
                    </tr>
                  )}

                  {/*NEU - Handlauf-ecken */}

                  {handlaufmat == 'normal' && form != 'i' && (
                    <tr>
                      <td>{finalarr[75][0]} </td>
                      <td>
                        <img src={finalarr[75][2]} width="48px" />
                      </td>
                      <td>{finalarr[75][1]}</td>
                      <td className="table_amount"> x {form == 'u' ? 2 : 1}</td>
                    </tr>
                  )}
                  {handlaufmat == 'round' && form != 'i' && (
                    <tr>
                      <td>{finalarr[18][0]} </td>
                      <td>
                        <img src={finalarr[18][2]} width="48px" />
                      </td>
                      <td>{finalarr[18][1]}</td>
                      <td className="table_amount"> x {form == 'u' ? 2 : 1}</td>
                    </tr>
                  )}

                  {/*NEU - Handlauf-Gummi */}

                  {(handlaufmat == 'round' || handlaufmat == 'normal') && (
                    <tr>
                      <td>{finalarr[1][0]} </td>
                      <td>
                        <img src={finalarr[1][2]} width="48px" />
                      </td>
                      <td>{finalarr[1][1]}</td>
                      <td className="table_amount"> x {parseInt(gesamtleng / 5000) + 1}</td>
                    </tr>
                  )}

                  {/*Flanges//Endcaps NEU */}

                  {(wall1 || wall2) && handlaufmat == 'round' && (
                    <tr>
                      <td>{finalarr[16][0]} </td>
                      <td>
                        <img src={finalarr[16][2]} width="48px" />
                      </td>
                      <td>{finalarr[16][1]}</td>
                      <td className="table_amount"> x {wall1 && wall2 ? 2 : 1}</td>
                    </tr>
                  )}

                  {(!wall1 || !wall2) && handlaufmat == 'round' && (
                    <tr>
                      <td>{finalarr[15][0]} </td>
                      <td>
                        <img src={finalarr[15][2]} width="48px" />
                      </td>
                      <td>{finalarr[15][1]}</td>
                      <td className="table_amount"> x {!wall1 && !wall2 ? 2 : 1}</td>
                    </tr>
                  )}

                  {(!wall1 || !wall2) && handlaufmat == 'normal' && (
                    <tr>
                      <td>{finalarr[76][0]} </td>
                      <td>
                        <img src={finalarr[76][2]} width="48px" />
                      </td>
                      <td>{finalarr[76][1]}</td>
                      <td className="table_amount"> x {!wall1 && !wall2 ? 2 : 1}</td>
                    </tr>
                  )}

                  {/*Connector Round-handrail */}

                  {(parseInt(len1) > 5000 ||
                    (parseInt(len2) > 5000 && (form == 'l' || form == 'u')) ||
                    (parseInt(len3) > 5000 && form == 'u')) &&
                    handlaufmat == 'round' && (
                      <tr>
                        <td>{finalarr[77][0]} </td>
                        <td>
                          <img src={finalarr[77][2]} width="48px" />
                        </td>
                        <td>{finalarr[77][1]}</td>
                        <td className="table_amount"> x {amountConnectors}</td>
                      </tr>
                    )}
                  {/*Q-glue*/}
                  {handlaufmat == 'round' && form != 'i' && (
                    <>
                      {
                        <tr>
                          <td>{finalarr[30][0]} </td>
                          <td>
                            <img src={finalarr[30][2]} width="48px" />
                          </td>
                          <td>{finalarr[30][1]}</td>
                          <td className="table_amount"> x {!wall1 && !wall2 ? 2 : 1}</td>
                        </tr>
                      }
                    </>
                  )}

                  <tr>
                    <td>{finalarr[5][0]}</td>
                    <td>
                      <img src={finalarr[5][2]} width="48px" />
                    </td>
                    <td>{finalarr[5][1]}</td>
                    <td className="table_amount"> x 2</td>
                  </tr>

                  {inout == 'out' && (
                    <tr>
                      <td>{finalarr[6][0]}</td>
                      <td>
                        <img src={finalarr[6][2]} width="48px" />
                      </td>
                      <td>{finalarr[6][1]}</td>
                      <td className="table_amount"> x {parseInt(parseInt(gesamtleng / 625)) + 1}</td>
                    </tr>
                  )}
                  {(wall1 || wall2) && handlaufmat == 'bogut' && (
                    <tr>
                      <td>{finalarr[16][0]}</td>
                      <td>
                        <img src={finalarr[16][2]} width="48px" />
                      </td>
                      <td>{finalarr[16][1]}</td>
                      <td className="table_amount">{wall1 && wall2 ? 'x 2' : 'x 1'}</td>
                    </tr>
                  )}

                  {form != 'i' && handlaufmat == 'edgep' && (
                    <tr>
                      <td>{finalarr[25][0]}</td>
                      {form == 'l' && (
                        <>
                          <td>
                            <img width="48px" src={finalarr[25][2]} />
                          </td>
                          <td>{finalarr[25][1]}</td>
                          <td className="table_amount">x 1</td>
                        </>
                      )}
                      {form == 'u' && (
                        <>
                          <td>
                            <img width="48px" src={finalarr[25][2]} />
                          </td>
                          <td>{finalarr[25][1]}</td>
                          <td className="table_amount">x 2</td>
                        </>
                      )}
                    </tr>
                  )}
                  <tr>
                    <td>{finalarr[0][0]}</td>
                    <td>
                      <img src={finalarr[0][2]} width="48px" />
                    </td>
                    <td>{finalarr[0][1]}</td>
                    <td className="table_amount"> x {parseInt(gesamtleng / 5000) + 1}</td>
                  </tr>

                  {untergrundd == 'metall' && (
                    <>
                      <tr>
                        <td>{finalarr[26][0]}</td>
                        <td>
                          <img src={finalarr[26][2]} width="48px" />
                        </td>
                        <td>{finalarr[26][1]}</td>
                        <td className="table_amount"> x {ankercalc2}</td>
                      </tr>
                      <tr>
                        <td>{finalarr[27][0]}</td>
                        <td>
                          <img src={finalarr[27][2]} width="48px" />
                        </td>
                        <td>{finalarr[27][1]}</td>
                        <td className="table_amount"> x {ankercalc2}</td>
                      </tr>
                      <tr>
                        <td>{finalarr[28][0]}</td>
                        <td>
                          <img src={finalarr[28][2]} width="48px" />
                        </td>
                        <td>{finalarr[28][1]}</td>
                        <td className="table_amount"> x {ankercalc2}</td>
                      </tr>
                    </>
                  )}
                  {untergrundd == 'beton' && (
                    <>
                      <tr>
                        <td>{finalarr[29][0]}</td>
                        <td>
                          <img src={finalarr[29][2]} width="48px" />
                        </td>
                        <td>{finalarr[29][1]}</td>
                        <td className="table_amount"> x {ankercalc2}</td>
                      </tr>
                    </>
                  )}
                  {untergrundd == 'holz' && (
                    <>
                      <tr>
                        <td>{finalarr[62][0]}</td>
                        <td>
                          <img src={finalarr[62][2]} width="48px" />
                        </td>
                        <td>{finalarr[62][1]}</td>
                        <td className="table_amount"> x {ankercalc2}</td>
                      </tr>
                    </>
                  )}

                  <tr>
                    <td>{finalarr[21][0]}</td>
                    <td>
                      <img src={finalarr[21][2]} width="48px" />
                    </td>
                    <td>{finalarr[21][1]}</td>
                    <td className="table_amount"> x 1</td>
                  </tr>
                  <tr>
                    <td>{finalarr[22][0]}</td>
                    <td>
                      <img src={finalarr[22][2]} width="48px" />
                    </td>
                    <td>{finalarr[22][1]}</td>
                    <td className="table_amount"> x 1</td>
                  </tr>

                  <tr>
                    <td>{finalarr[31][0]}</td>
                    <td>
                      <img src={finalarr[31][2]} width="48px" />
                    </td>
                    <td>{finalarr[31][1]}</td>
                    <td className="table_amount"> x 1</td>
                  </tr>
                  {handlaufmat == 'edgep' && (
                    <tr>
                      <td>{finalarr[72][0]}</td>
                      <td>
                        <img src={finalarr[72][2]} width="48px" />
                      </td>
                      <td>{finalarr[72][1]}</td>
                      <td className="table_amount"> {parseInt(gesamtleng) > 33000 ? 'x 2' : 'x 1'}</td>
                    </tr>
                  )}

                  {untergrundd == 'concrete' && (
                    <tr>
                      <td>{finalarr[36][0]}</td>
                      <td>
                        <img src={finalarr[36][2]} width="48px" />
                      </td>
                      <td>{finalarr[36][1]}</td>
                      <td className="table_amount">x 1</td>
                    </tr>
                  )}
                </table>
              )}
              {montageart != 'top' && (
                <table className="articletable">
                  <tr>
                    <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[71] : 'Type'}</td>
                    <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[72] : 'Art.Image'}</td>
                    <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[73] : 'Art. No.'}</td>
                    <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[74] : 'Amount'}</td>
                  </tr>
                  {amount5 > 0 && (
                    <tr>
                      <td>{finalarr[8][0]} </td>
                      <td>
                        <img src={finalarr[8][2]} width="48px" />
                      </td>
                      <td>{finalarr[8][1]}</td>
                      <td className="table_amount"> x {amount5}</td>
                    </tr>
                  )}
                  {amount25 > 0 && (
                    <tr>
                      <td>{finalarr[7][0]} </td>
                      <td>
                        <img src={finalarr[7][2]} width="48px" />
                      </td>
                      <td>{finalarr[7][1]}</td>
                      <td className="table_amount"> x {amount25}</td>
                    </tr>
                  )}

                  {((includeglass && !glassil && !glassilu && !glassiu && !glasslu) ||
                    form == 'i' ||
                    (form == 'l' && !glassil)) && (
                    <>
                      {
                        <tr>
                          <td>{finalarr[73][0]}</td>
                          <td>
                            <img src={finalarr[73][2]} width="48px" />
                          </td>
                          <td>
                            {para.count == 'en-us' || para.count == 'es-us'
                              ? glassi.toFixed(2) + '"'
                              : parseInt(glassi)}
                            x{para.count == 'en-us' || para.count == 'es-us' ? glasshohe.toFixed(2) + '"' : glasshohe}
                            {para.count == 'en-us' || (para.count == 'es-us' && '"')}
                            {para.count == 'en-us' || para.count == 'es-us' ? 'x11/16"' : 'x17.52 mm'}
                          </td>
                          <td className="table_amount"> x {amount}</td>
                        </tr>
                      }
                      {(form == 'l' || form == 'u') && (
                        <tr>
                          <td>{finalarr[73][0]}</td>
                          <td>
                            <img src={finalarr[73][2]} width="48px" />
                          </td>
                          <td>
                            {para.count == 'en-us' || para.count == 'es-us'
                              ? glassl.toFixed(2) + '"'
                              : parseInt(glassl)}
                            x{para.count == 'en-us' || para.count == 'es-us' ? glasshohe.toFixed(2) + '"' : glasshohe}
                            {para.count == 'en-us' || (para.count == 'es-us' && +'"')}
                            {para.count == 'en-us' || para.count == 'es-us' ? 'x11/16"' : 'x17.52 mm'}
                          </td>
                          <td className="table_amount"> x {amount2}</td>
                        </tr>
                      )}
                      {form == 'u' && (
                        <tr>
                          <td>{finalarr[73][0]}</td>
                          <td>
                            <img src={finalarr[73][2]} width="48px" />
                          </td>
                          <td>
                            {para.count == 'en-us' || para.count == 'es-us'
                              ? glassu.toFixed(2) + '"'
                              : parseInt(glassu)}
                            x{para.count == 'en-us' || para.count == 'es-us' ? glasshohe.toFixed(2) + '"' : glasshohe}
                            {para.count == 'en-us' || (para.count == 'es-us' && +'"')}
                            {para.count == 'en-us' || para.count == 'es-us' ? 'x11/16"' : 'x17.52 mm'}
                          </td>
                          <td className="table_amount"> x {amount3}</td>
                        </tr>
                      )}
                    </>
                  )}

                  {((includeglass && glassilu && form == 'u') || (form == 'l' && glassil)) && (
                    <>
                      {
                        <tr>
                          <td>{finalarr[73][0]}</td>
                          <td>
                            <img src={finalarr[73][2]} width="48px" />
                          </td>
                          <td>
                            {para.count == 'en-us' || para.count == 'es-us'
                              ? glassi.toFixed(2) + '"'
                              : parseInt(glassi)}
                            x{para.count == 'en-us' || para.count == 'es-us' ? glasshohe.toFixed(2) + '"' : glasshohe}
                            {para.count == 'en-us' || para.count == 'es-us' ? 'x11/16"' : 'x17.52 mm'}
                          </td>
                          <td className="table_amount">
                            {' '}
                            x {form == 'u' ? amount + amount2 + amount3 : amount + amount2}
                          </td>
                        </tr>
                      }
                    </>
                  )}

                  {includeglass && glassil && form == 'u' && !glassilu && (
                    <>
                      {
                        <tr>
                          <td>{finalarr[73][0]}</td>
                          <td>
                            <img src={finalarr[73][2]} width="48px" />
                          </td>
                          <td>
                            {para.count == 'en-us' || para.count == 'es-us'
                              ? glassi.toFixed(2) + '"'
                              : parseInt(glassi)}
                            x{para.count == 'en-us' || para.count == 'es-us' ? glasshohe.toFixed(2) + '"' : glasshohe}
                            {para.count == 'en-us' || para.count == 'es-us' ? 'x11/16"' : 'x17.52 mm'}
                          </td>
                          <td className="table_amount"> x {amount + amount2}</td>
                        </tr>
                      }
                      {form == 'u' && (
                        <tr>
                          <td>{finalarr[73][0]}</td>
                          <td>
                            <img src={finalarr[73][2]} width="48px" />
                          </td>
                          <td>
                            {para.count == 'en-us' || para.count == 'es-us'
                              ? glassu.toFixed(2) + '"'
                              : parseInt(glassu)}
                            x{para.count == 'en-us' || para.count == 'es-us' ? glasshohe.toFixed(2) + '"' : glasshohe}
                            {para.count == 'en-us' || para.count == 'es-us' ? 'x11/16"' : 'x17.52 mm'}
                          </td>
                          <td className="table_amount"> x {amount3}</td>
                        </tr>
                      )}
                    </>
                  )}

                  {includeglass && glasslu && form == 'u' && !glassilu && !glassiu && !glassil && (
                    <>
                      {
                        <tr>
                          <td>{finalarr[73][0]}</td>
                          <td>
                            <img src={finalarr[73][2]} width="48px" />
                          </td>
                          <td>
                            {para.count == 'en-us' || para.count == 'es-us'
                              ? glassi.toFixed(2) + '"'
                              : parseInt(glassi)}
                            x{para.count == 'en-us' || para.count == 'es-us' ? glasshohe.toFixed(2) + '"' : glasshohe}
                            {para.count == 'en-us' || para.count == 'es-us' ? 'x11/16"' : 'x17.52 mm'}
                          </td>
                          <td className="table_amount"> x {amount}</td>
                        </tr>
                      }
                      {form == 'u' && (
                        <tr>
                          <td>{finalarr[73][0]}</td>
                          <td>
                            <img src={finalarr[73][2]} width="48px" />
                          </td>
                          <td>
                            {para.count == 'en-us' || para.count == 'es-us'
                              ? glassu.toFixed(2) + '"'
                              : parseInt(glassu)}
                            x{para.count == 'en-us' || para.count == 'es-us' ? glasshohe.toFixed(2) + '"' : glasshohe}
                            {para.count == 'en-us' || para.count == 'es-us' ? 'x11/16"' : 'x17.52 mm'}
                          </td>
                          <td className="table_amount"> x {amount3 + amount2}</td>
                        </tr>
                      )}
                    </>
                  )}

                  {includeglass && glassiu && form == 'u' && !glassilu && (
                    <>
                      {
                        <tr>
                          <td>{finalarr[73][0]}</td>
                          <td>
                            <img src={finalarr[73][2]} width="48px" />
                          </td>
                          <td>
                            {para.count == 'en-us' || para.count == 'es-us'
                              ? glassi.toFixed(2) + '"'
                              : parseInt(glassi)}
                            x{para.count == 'en-us' || para.count == 'es-us' ? glasshohe.toFixed(2) + '"' : glasshohe}
                            {para.count == 'en-us' || para.count == 'es-us' ? 'x11/16"' : 'x17.52 mm'}
                          </td>
                          <td className="table_amount"> x {amount + amount3}</td>
                        </tr>
                      }
                      {
                        <tr>
                          <td>{finalarr[73][0]}</td>
                          <td>
                            <img src={finalarr[73][2]} width="48px" />
                          </td>
                          <td>
                            {para.count == 'en-us' || para.count == 'es-us'
                              ? glassl.toFixed(2) + '"'
                              : parseInt(glassl)}
                            x{para.count == 'en-us' || para.count == 'es-us' ? glasshohe.toFixed(2) + '"' : glasshohe}
                            {para.count == 'en-us' || para.count == 'es-us' ? 'x11/16"' : 'x17.52 mm'}
                          </td>
                          <td className="table_amount"> x {amount2}</td>
                        </tr>
                      }
                    </>
                  )}

                  {form != 'i' && (
                    <tr>
                      <td>{finalarr[9][0]}</td>
                      {form == 'l' && (
                        <>
                          <td>
                            <img width="48px" src={finalarr[9][2]} />
                          </td>
                          <td>{finalarr[9][1]}</td>
                          <td className="table_amount">x 1</td>
                        </>
                      )}
                      {form == 'u' && (
                        <>
                          <td>
                            <img width="48px" src={finalarr[9][2]} />
                          </td>
                          <td>{finalarr[9][1]}</td>
                          <td className="table_amount">x 2</td>
                        </>
                      )}
                    </tr>
                  )}

                  {/*NEU - Handlauf */}

                  {handlaufmat == 'normal' && (
                    <tr>
                      <td>{finalarr[74][0]} </td>
                      <td>
                        <img src={finalarr[74][2]} width="48px" />
                      </td>
                      <td>{finalarr[74][1]}</td>
                      <td className="table_amount"> x {parseInt(gesamtleng / 5000) + 1}</td>
                    </tr>
                  )}
                  {handlaufmat == 'round' && (
                    <tr>
                      <td>{finalarr[14][0]} </td>
                      <td>
                        <img src={finalarr[14][2]} width="48px" />
                      </td>
                      <td>{finalarr[14][1]}</td>
                      <td className="table_amount"> x {parseInt(gesamtleng / 5000) + 1}</td>
                    </tr>
                  )}

                  {/*NEU - Handlauf-ecken */}

                  {handlaufmat == 'normal' && form != 'i' && (
                    <tr>
                      <td>{finalarr[75][0]} </td>
                      <td>
                        <img src={finalarr[75][2]} width="48px" />
                      </td>
                      <td>{finalarr[75][1]}</td>
                      <td className="table_amount"> x {form == 'u' ? 2 : 1}</td>
                    </tr>
                  )}
                  {handlaufmat == 'round' && form != 'i' && (
                    <tr>
                      <td>{finalarr[18][0]} </td>
                      <td>
                        <img src={finalarr[18][2]} width="48px" />
                      </td>
                      <td>{finalarr[18][1]}</td>
                      <td className="table_amount"> x {form == 'u' ? 2 : 1}</td>
                    </tr>
                  )}

                  {/*NEU - Handlauf-Gummi */}

                  {(handlaufmat == 'round' || handlaufmat == 'normal') && (
                    <tr>
                      <td>{finalarr[1][0]} </td>
                      <td>
                        <img src={finalarr[1][2]} width="48px" />
                      </td>
                      <td>{finalarr[1][1]}</td>
                      <td className="table_amount"> x {parseInt(gesamtleng / 5000) + 1}</td>
                    </tr>
                  )}

                  {/*Flanges//Endcaps NEU */}

                  {(wall1 || wall2) && handlaufmat == 'round' && (
                    <tr>
                      <td>{finalarr[16][0]} </td>
                      <td>
                        <img src={finalarr[16][2]} width="48px" />
                      </td>
                      <td>{finalarr[16][1]}</td>
                      <td className="table_amount"> x {wall1 && wall2 ? 2 : 1}</td>
                    </tr>
                  )}

                  {(!wall1 || !wall2) && handlaufmat == 'round' && (
                    <tr>
                      <td>{finalarr[15][0]} </td>
                      <td>
                        <img src={finalarr[15][2]} width="48px" />
                      </td>
                      <td>{finalarr[15][1]}</td>
                      <td className="table_amount"> x {!wall1 && !wall2 ? 2 : 1}</td>
                    </tr>
                  )}

                  {(!wall1 || !wall2) && handlaufmat == 'normal' && (
                    <tr>
                      <td>{finalarr[76][0]} </td>
                      <td>
                        <img src={finalarr[76][2]} width="48px" />
                      </td>
                      <td>{finalarr[76][1]}</td>
                      <td className="table_amount"> x {!wall1 && !wall2 ? 2 : 1}</td>
                    </tr>
                  )}

                  {/*Connector Round-handrail */}

                  {(parseInt(len1) > 5000 ||
                    (parseInt(len2) > 5000 && (form == 'l' || form == 'u')) ||
                    (parseInt(len3) > 5000 && form == 'u')) &&
                    handlaufmat == 'round' && (
                      <tr>
                        <td>{finalarr[77][0]} </td>
                        <td>
                          <img src={finalarr[77][2]} width="48px" />
                        </td>
                        <td>{finalarr[77][1]}</td>
                        <td className="table_amount"> x {amountConnectors}</td>
                      </tr>
                    )}

                  {/*Q-glue*/}
                  {handlaufmat == 'round' && form != 'i' && (
                    <>
                      {
                        <tr>
                          <td>{finalarr[30][0]} </td>
                          <td>
                            <img src={finalarr[30][2]} width="48px" />
                          </td>
                          <td>{finalarr[30][1]}</td>
                          <td className="table_amount"> x {!wall1 && !wall2 ? 2 : 1}</td>
                        </tr>
                      }
                    </>
                  )}

                  {handlaufmat == 'edgep' && amount25 > 0 && (
                    <tr>
                      <td>{finalarr[23][0]} </td>
                      <td>
                        <img src={finalarr[23][2]} width="48px" />
                      </td>
                      <td>{finalarr[23][1]}</td>
                      <td className="table_amount"> x {amount25}</td>
                    </tr>
                  )}
                  {handlaufmat == 'edgep' && amount5 > 0 && (
                    <tr>
                      <td>{finalarr[24][0]}</td>
                      <td>
                        <img src={finalarr[24][2]} width="48px" />
                      </td>
                      <td>{finalarr[24][1]}</td>
                      <td className="table_amount"> x {amount5}</td>
                    </tr>
                  )}

                  {!wall1 && (
                    <tr>
                      <td>{finalarr[10][0]}</td>
                      <td>
                        <img src={finalarr[10][2]} width="48px" />
                      </td>
                      <td>{finalarr[10][1]}</td>
                      <td className="table_amount"> x 1</td>
                    </tr>
                  )}
                  {!wall2 && (
                    <tr>
                      <td>{finalarr[11][0]}</td>
                      <td>
                        <img src={finalarr[11][2]} width="48px" />
                      </td>
                      <td>{finalarr[11][1]}</td>
                      <td className="table_amount"> x 1</td>
                    </tr>
                  )}

                  {inout == 'out' && (
                    <tr>
                      <td>{finalarr[13][0]}</td>
                      <td>
                        <img src={finalarr[13][2]} width="48px" />
                      </td>
                      <td>{finalarr[13][1]}</td>
                      <td className="table_amount"> x {parseInt(parseInt(gesamtleng / 625)) + 1}</td>
                    </tr>
                  )}
                  <tr>
                    <td>{finalarr[12][0]}</td>
                    <td>
                      <img src={finalarr[12][2]} width="48px" />
                    </td>
                    <td>{finalarr[12][1]}</td>
                    <td className="table_amount"> x {parseInt(gesamtleng / 5000) + 1}</td>
                  </tr>
                  {(wall1 || wall2) && handlaufmat == 'boguscase' && (
                    <tr>
                      <td>{finalarr[16][0]}</td>
                      <td>
                        <img src={finalarr[16][2]} width="48px" />
                      </td>
                      <td>{finalarr[16][1]}</td>
                      <td className="table_amount">{wall1 && wall2 ? 'x 2' : 'x 1'}</td>
                    </tr>
                  )}

                  {form != 'i' && handlaufmat == 'edgep' && (
                    <tr>
                      <td>{finalarr[25][0]}</td>
                      {form == 'l' && (
                        <>
                          <td>
                            <img width="48px" src={finalarr[25][2]} />
                          </td>
                          <td>{finalarr[25][1]}</td>
                          <td className="table_amount">x 1</td>
                        </>
                      )}
                      {form == 'u' && (
                        <>
                          <td>
                            <img width="48px" src={finalarr[25][2]} />
                          </td>
                          <td>{finalarr[25][1]}</td>
                          <td className="table_amount">x 2</td>
                        </>
                      )}
                    </tr>
                  )}
                  <tr>
                    <td>{finalarr[0][0]}</td>
                    <td>
                      <img src={finalarr[0][2]} width="48px" />
                    </td>
                    <td>{finalarr[0][1]}</td>
                    <td className="table_amount"> x {parseInt(gesamtleng / 5000) + 1}</td>
                  </tr>

                  {untergrundd == 'metall' && (
                    <>
                      <tr>
                        <td>{finalarr[26][0]}</td>
                        <td>
                          <img src={finalarr[26][2]} width="48px" />
                        </td>
                        <td>{finalarr[26][1]}</td>
                        <td className="table_amount"> x {ankercalc2}</td>
                      </tr>
                      <tr>
                        <td>{finalarr[27][0]}</td>
                        <td>
                          <img src={finalarr[27][2]} width="48px" />
                        </td>
                        <td>{finalarr[27][1]}</td>
                        <td className="table_amount"> x {ankercalc2}</td>
                      </tr>
                      <tr>
                        <td>{finalarr[28][0]}</td>
                        <td>
                          <img src={finalarr[28][2]} width="48px" />
                        </td>
                        <td>{finalarr[28][1]}</td>
                        <td className="table_amount"> x {ankercalc2}</td>
                      </tr>
                    </>
                  )}
                  {untergrundd == 'beton' && (
                    <>
                      <tr>
                        <td>{finalarr[29][0]}</td>
                        <td>
                          <img src={finalarr[29][2]} width="48px" />
                        </td>
                        <td>{finalarr[29][1]}</td>
                        <td className="table_amount"> x {ankercalc2}</td>
                      </tr>
                    </>
                  )}
                  {untergrundd == 'holz' && (
                    <>
                      <tr>
                        <td>{finalarr[62][0]}</td>
                        <td>
                          <img src={finalarr[62][2]} width="48px" />
                        </td>
                        <td>{finalarr[62][1]}</td>
                        <td className="table_amount"> x {ankercalc2}</td>
                      </tr>
                    </>
                  )}

                  <tr>
                    <td>{finalarr[21][0]}</td>
                    <td>
                      <img src={finalarr[21][2]} width="48px" />
                    </td>
                    <td>{finalarr[21][1]}</td>
                    <td className="table_amount"> x 1</td>
                  </tr>
                  <tr>
                    <td>{finalarr[22][0]}</td>
                    <td>
                      <img src={finalarr[22][2]} width="48px" />
                    </td>
                    <td>{finalarr[22][1]}</td>
                    <td className="table_amount"> x 1</td>
                  </tr>
                  <tr>
                    <td>{finalarr[31][0]}</td>
                    <td>
                      <img src={finalarr[31][2]} width="48px" />
                    </td>
                    <td>{finalarr[31][1]}</td>
                    <td className="table_amount"> x 1</td>
                  </tr>
                  {handlaufmat == 'edgep' && (
                    <tr>
                      <td>{finalarr[72][0]}</td>
                      <td>
                        <img src={finalarr[72][2]} width="48px" />
                      </td>
                      <td>{finalarr[72][1]}</td>
                      <td className="table_amount"> {parseInt(gesamtleng) > 33000 ? 'x 2' : 'x 1'}</td>
                    </tr>
                  )}
                  {untergrundd == 'concrete' && (
                    <tr>
                      <td>{finalarr[36][0]}</td>
                      <td>
                        <img src={finalarr[36][2]} width="48px" />
                      </td>
                      <td>{finalarr[36][1]}</td>
                      <td className="table_amount">x 1</td>
                    </tr>
                  )}
                </table>
              )}
            </div>
          </>
        )}
        {gelaender != 'glass' && gelaender != 'baseclamps' && gelaender != 'frenchbalcony' && gelaender != 'qline' && (
          <>
            <div className={'articlelist-wrap ' + (!showmenu ? 'hide-element' : '')}></div>

            <div className={'articlelist ' + (!showmenu ? 'hide-element' : '')}>
              <div className="articlelist-inner-header">
                <h3>
                  {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[70] : 'Individual Components'}
                </h3>
                <button
                  id="closeproductlist"
                  onClick={() => {
                    if (showmenu) {
                      setshowmenu(false);
                      document.getElementById('modelcanvas2').style = 'position:relative';
                    } else {
                      setshowmenu(true);
                      document.getElementById('modelcanvas2').style = 'position:absolute';
                    }
                  }}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M19.5459 17.954C19.7572 18.1653 19.876 18.452 19.876 18.7509C19.876 19.0497 19.7572 19.3364 19.5459 19.5477C19.3346 19.7591 19.0479 19.8778 18.749 19.8778C18.4501 19.8778 18.1635 19.7591 17.9521 19.5477L12 13.5937L6.0459 19.5459C5.83455 19.7572 5.54791 19.8759 5.24902 19.8759C4.95014 19.8759 4.66349 19.7572 4.45215 19.5459C4.2408 19.3345 4.12207 19.0479 4.12207 18.749C4.12207 18.4501 4.2408 18.1635 4.45215 17.9521L10.4062 11.9999L4.45402 6.04586C4.24268 5.83451 4.12395 5.54787 4.12395 5.24898C4.12395 4.9501 4.24268 4.66345 4.45402 4.45211C4.66537 4.24076 4.95201 4.12203 5.2509 4.12203C5.54978 4.12203 5.83643 4.24076 6.04777 4.45211L12 10.4062L17.954 4.45117C18.1654 4.23983 18.452 4.12109 18.7509 4.12109C19.0498 4.12109 19.3364 4.23983 19.5478 4.45117C19.7591 4.66251 19.8778 4.94916 19.8778 5.24804C19.8778 5.54693 19.7591 5.83358 19.5478 6.04492L13.5937 11.9999L19.5459 17.954Z"
                      fill="#001020"
                    />
                  </svg>
                </button>
              </div>

              <table className="articletable">
                <tr>
                  <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[71] : 'Type'}</td>
                  <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[72] : 'Art.Image'}</td>
                  <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[73] : 'Art. No.'}</td>
                  <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[74] : 'Amount'}</td>
                </tr>

                <tr>
                  <td className="ConfiguratorModulePopupHead">
                    Easy Alu Module{' '}
                    <button onClick={() => setOpenArtlist(!OpenArtlist)}>
                      Details
                      <svg
                        id={OpenArtlist ? 'CofiguratorSvgRotate' : ''}
                        width="7"
                        height="12"
                        viewBox="0 0 7 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.5306 6.5306L1.5306 11.5306C1.3897 11.6715 1.19861 11.7506 0.999348 11.7506C0.80009 11.7506 0.608994 11.6715 0.468098 11.5306C0.327201 11.3897 0.248047 11.1986 0.248047 10.9993C0.248047 10.8001 0.327201 10.609 0.468098 10.4681L4.93747 5.99997L0.469348 1.5306C0.399583 1.46083 0.344243 1.37801 0.306486 1.28686C0.26873 1.19571 0.249297 1.09801 0.249297 0.999348C0.249297 0.900686 0.26873 0.802989 0.306486 0.711837C0.344243 0.620685 0.399583 0.537863 0.469348 0.468098C0.539113 0.398333 0.621936 0.342993 0.713088 0.305236C0.80424 0.26748 0.901936 0.248047 1.0006 0.248047C1.09926 0.248047 1.19696 0.26748 1.28811 0.305236C1.37926 0.342993 1.46208 0.398333 1.53185 0.468098L6.53185 5.4681C6.60169 5.53786 6.65707 5.62072 6.69481 5.71193C6.73256 5.80313 6.75193 5.9009 6.75181 5.99961C6.7517 6.09832 6.7321 6.19603 6.69414 6.28715C6.65617 6.37827 6.6006 6.461 6.5306 6.5306Z"
                          fill="#667079"
                        ></path>
                      </svg>
                    </button>
                  </td>{' '}
                  <td>
                    {gelaender == 'picket' ? (
                      <img
                        width="48px"
                        src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/picket.jpg"
                      />
                    ) : (
                      <img
                        width="48px"
                        src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/ealu.jpg"
                      />
                    )}{' '}
                  </td>
                  <td>
                    {gelaender == 'picket' && montageart == 'top'
                      ? '665999'
                      : gelaender == 'picket' && montageart != 'top'
                        ? '665998'
                        : gelaender == 'baluster' && montageart == 'top'
                          ? '665997'
                          : '665996'}
                    -{hohe == 900 ? '090' : hohe == 1000 ? '100' : '110'}-00-{colorr == 'black' && '82'}
                    {colorr == 'gray' && '00'}
                    {colorr == 'anrtz' && '33'}
                    {colorr == 'brano' && '18'}
                  </td>
                  <td>x{form == 'i' ? amount : form == 'l' ? amount + amount2 : amount + amount2 + amount3}</td>
                </tr>

                {OpenArtlist && (
                  <>
                    {!alarm && (
                      <>
                        <tr className="ConfiguratorModulePopup">
                          <td>
                            Module:{parseInt(singlelength * 10)}x{hohe}{' '}
                          </td>
                          <td>
                            {gelaender == 'picket' ? (
                              <img
                                width="48px"
                                src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/picket.jpg"
                              />
                            ) : (
                              <img
                                width="48px"
                                src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/ealu.jpg"
                              />
                            )}
                          </td>
                          <td>
                            {gelaender == 'picket' && montageart == 'top'
                              ? '665999'
                              : gelaender == 'picket' && montageart != 'top'
                                ? '665998'
                                : gelaender == 'baluster' && montageart == 'top'
                                  ? '665997'
                                  : '665996'}
                            -{hohe == 900 ? '090' : hohe == 1000 ? '100' : '110'}-00-{colorr == 'black' && '82'}
                            {colorr == 'gray' && '00'}
                            {colorr == 'anrtz' && '33'}
                            {colorr == 'brano' && '18'}
                          </td>
                          <td>x {amount}</td>
                        </tr>
                        {(form == 'u' || form == 'l') && (
                          <tr className="ConfiguratorModulePopup">
                            <td>
                              Module:{parseInt(singlelength2 * 10)}x{hohe}
                            </td>
                            <td>
                              {gelaender == 'picket' ? (
                                <img
                                  width="48px"
                                  src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/picket.jpg"
                                />
                              ) : (
                                <img
                                  width="48px"
                                  src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/ealu.jpg"
                                />
                              )}
                            </td>
                            <td>
                              {gelaender == 'picket' && montageart == 'top'
                                ? '665999'
                                : gelaender == 'picket' && montageart != 'top'
                                  ? '665998'
                                  : gelaender == 'baluster' && montageart == 'top'
                                    ? '665997'
                                    : '665996'}
                              -{hohe == 900 ? '090' : hohe == 1000 ? '100' : '110'}-00-{colorr == 'black' && '82'}
                              {colorr == 'gray' && '00'}
                              {colorr == 'anrtz' && '33'}
                              {colorr == 'brano' && '18'}
                            </td>
                            <td>x {amount2}</td>
                          </tr>
                        )}
                        {form == 'u' && (
                          <tr className="ConfiguratorModulePopup">
                            <td>
                              Module:{parseInt(singlelength3 * 10)}x{hohe}
                            </td>
                            <td>
                              {gelaender == 'picket' ? (
                                <img
                                  width="48px"
                                  src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/picket.jpg"
                                />
                              ) : (
                                <img
                                  width="48px"
                                  src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/ealu.jpg"
                                />
                              )}
                            </td>
                            <td>
                              {gelaender == 'picket' && montageart == 'top'
                                ? '665999'
                                : gelaender == 'picket' && montageart != 'top'
                                  ? '665998'
                                  : gelaender == 'baluster' && montageart == 'top'
                                    ? '665997'
                                    : '665996'}
                              -{hohe == 900 ? '090' : hohe == 1000 ? '100' : '110'}-00-{colorr == 'black' && '82'}
                              {colorr == 'gray' && '00'}
                              {colorr == 'anrtz' && '33'}
                              {colorr == 'brano' && '18'}
                            </td>
                            <td>x {amount3}</td>
                          </tr>
                        )}
                      </>
                    )}

                    {casetrigger == 1 && (
                      <>
                        {form == 'l' && (
                          <tr className="ConfiguratorModulePopup">
                            <td>
                              Module:{parseInt(singlelength * 10)}x{hohe}
                            </td>
                            <td>
                              {gelaender == 'picket' ? (
                                <img
                                  width="48px"
                                  alt="EasyAluPicket"
                                  src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/picket.jpg"
                                />
                              ) : (
                                <img
                                  width="48px"
                                  alt="EasyAluImage"
                                  src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/ealu.jpg"
                                />
                              )}
                            </td>
                            <td>
                              {gelaender == 'picket' && montageart == 'top'
                                ? '665999'
                                : gelaender == 'picket' && montageart != 'top'
                                  ? '665998'
                                  : gelaender == 'baluster' && montageart == 'top'
                                    ? '665997'
                                    : '665996'}
                              -{hohe == 900 ? '090' : hohe == 1000 ? '100' : '110'}-00-{colorr == 'black' && '82'}
                              {colorr == 'gray' && '00'}
                              {colorr == 'anrtz' && '33'}
                              {colorr == 'brano' && '18'}
                            </td>
                            <td>x {amount + amount2}</td>
                          </tr>
                        )}
                        {form == 'u' && (
                          <>
                            {' '}
                            <tr className="ConfiguratorModulePopup">
                              <td>
                                Module:{parseInt(singlelength * 10)}x{hohe}
                              </td>
                              <td>
                                {gelaender == 'picket' ? (
                                  <img
                                    width="48px"
                                    alt="EasyAluPicket"
                                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/picket.jpg"
                                  />
                                ) : (
                                  <img
                                    width="48px"
                                    alt="EasyAluImage"
                                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/ealu.jpg"
                                  />
                                )}
                              </td>
                              <td>
                                {gelaender == 'picket' && montageart == 'top'
                                  ? '665999'
                                  : gelaender == 'picket' && montageart != 'top'
                                    ? '665998'
                                    : gelaender == 'baluster' && montageart == 'top'
                                      ? '665997'
                                      : '665996'}
                                -{hohe == 900 ? '090' : hohe == 1000 ? '100' : '110'}-00-{colorr == 'black' && '82'}
                                {colorr == 'gray' && '00'}
                                {colorr == 'anrtz' && '33'}
                                {colorr == 'brano' && '18'}
                              </td>
                              <td>x {amount + amount2}</td>
                            </tr>
                            <tr className="ConfiguratorModulePopup">
                              <td>
                                Module:{parseInt(singlelength * 10)}x{hohe}
                              </td>
                              <td>
                                {gelaender == 'picket' ? (
                                  <img
                                    width="48px"
                                    alt="EasyAluPicket"
                                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/picket.jpg"
                                  />
                                ) : (
                                  <img
                                    width="48px"
                                    alt="EasyAlu"
                                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/ealu.jpg"
                                  />
                                )}
                              </td>
                              <td>
                                {gelaender == 'picket' && montageart == 'top'
                                  ? '665999'
                                  : gelaender == 'picket' && montageart != 'top'
                                    ? '665998'
                                    : gelaender == 'baluster' && montageart == 'top'
                                      ? '665997'
                                      : '665996'}
                                -{hohe == 900 ? '090' : hohe == 1000 ? '100' : '110'}-00-{colorr == 'black' && '82'}
                                {colorr == 'gray' && '00'}
                                {colorr == 'anrtz' && '33'}
                                {colorr == 'brano' && '18'}
                              </td>
                              <td>x {amount3}</td>
                            </tr>
                          </>
                        )}
                      </>
                    )}
                    {casetrigger == 2 && (
                      <>
                        {form == 'u' && (
                          <>
                            {' '}
                            <tr className="ConfiguratorModulePopup">
                              <td>
                                Module:{parseInt(singlelength * 10)}x{hohe}
                              </td>
                              <td>
                                {gelaender == 'picket' ? (
                                  <img
                                    width="48px"
                                    alt="EasyAluPicket"
                                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/picket.jpg"
                                  />
                                ) : (
                                  <img
                                    width="48px"
                                    alt="EasyAlu"
                                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/ealu.jpg"
                                  />
                                )}
                              </td>
                              <td>
                                {gelaender == 'picket' && montageart == 'top'
                                  ? '665999'
                                  : gelaender == 'picket' && montageart != 'top'
                                    ? '665998'
                                    : gelaender == 'baluster' && montageart == 'top'
                                      ? '665997'
                                      : '665996'}
                                -{hohe == 900 ? '090' : hohe == 1000 ? '100' : '110'}-00-{colorr == 'black' && '82'}
                                {colorr == 'gray' && '00'}
                                {colorr == 'anrtz' && '33'}
                                {colorr == 'brano' && '18'}
                              </td>
                              <td>x {amount}</td>
                            </tr>
                            <tr className="ConfiguratorModulePopup">
                              <td>
                                Module:{parseInt(singlelength2 * 10)}x{hohe}
                              </td>
                              <td>
                                {gelaender == 'picket' ? (
                                  <img
                                    width="48px"
                                    alt="EasyAluPicket"
                                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/picket.jpg"
                                  />
                                ) : (
                                  <img
                                    width="48px"
                                    alt="EasyAlu"
                                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/ealu.jpg"
                                  />
                                )}
                              </td>
                              <td>
                                {gelaender == 'picket' && montageart == 'top'
                                  ? '665999'
                                  : gelaender == 'picket' && montageart != 'top'
                                    ? '665998'
                                    : gelaender == 'baluster' && montageart == 'top'
                                      ? '665997'
                                      : '665996'}
                                -{hohe == 900 ? '090' : hohe == 1000 ? '100' : '110'}-00-{colorr == 'black' && '82'}
                                {colorr == 'gray' && '00'}
                                {colorr == 'anrtz' && '33'}
                                {colorr == 'brano' && '18'}
                              </td>
                              <td>x {amount2 + amount3}</td>
                            </tr>
                          </>
                        )}
                      </>
                    )}
                    {casetrigger == 3 && (
                      <>
                        {form == 'u' && (
                          <>
                            <tr className="ConfiguratorModulePopup">
                              <td>
                                Module:{parseInt(singlelength2 * 10)}x{hohe}
                              </td>
                              <td>
                                {gelaender == 'picket' ? (
                                  <img
                                    width="48px"
                                    alt="EasyAluPicket"
                                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/picket.jpg"
                                  />
                                ) : (
                                  <img
                                    width="48px"
                                    alt="EasyAlu"
                                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/ealu.jpg"
                                  />
                                )}
                              </td>
                              <td>
                                {gelaender == 'picket' && montageart == 'top'
                                  ? '665999'
                                  : gelaender == 'picket' && montageart != 'top'
                                    ? '665998'
                                    : gelaender == 'baluster' && montageart == 'top'
                                      ? '665997'
                                      : '665996'}
                                -{hohe == 900 ? '090' : hohe == 1000 ? '100' : '110'}-00-{colorr == 'black' && '82'}
                                {colorr == 'gray' && '00'}
                                {colorr == 'anrtz' && '33'}
                                {colorr == 'brano' && '18'}
                              </td>
                              <td>x {amount2}</td>
                            </tr>
                            <tr className="ConfiguratorModulePopup">
                              <td>
                                Module:{parseInt(singlelength * 10)}x{hohe}
                              </td>
                              <td>
                                {gelaender == 'picket' ? (
                                  <img
                                    width="48px"
                                    alt="EasyAluPicket"
                                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/picket.jpg"
                                  />
                                ) : (
                                  <img
                                    width="48px"
                                    alt="EasyAlu"
                                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/ealu.jpg"
                                  />
                                )}
                              </td>
                              <td>
                                {gelaender == 'picket' && montageart == 'top'
                                  ? '665999'
                                  : gelaender == 'picket' && montageart != 'top'
                                    ? '665998'
                                    : gelaender == 'baluster' && montageart == 'top'
                                      ? '665997'
                                      : '665996'}
                                -{hohe == 900 ? '090' : hohe == 1000 ? '100' : '110'}-00-{colorr == 'black' && '82'}
                                {colorr == 'gray' && '00'}
                                {colorr == 'anrtz' && '33'}
                                {colorr == 'brano' && '18'}
                              </td>
                              <td>x {amount + amount3}</td>
                            </tr>
                          </>
                        )}
                      </>
                    )}
                    {casetrigger == 4 && (
                      <>
                        {form == 'u' && (
                          <>
                            <tr className="ConfiguratorModulePopup">
                              <td>
                                Module:{parseInt(singlelength * 10)}x{hohe}
                              </td>
                              <td>
                                {gelaender == 'picket' ? (
                                  <img
                                    width="48px"
                                    alt="EasyAluPicket"
                                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/picket.jpg"
                                  />
                                ) : (
                                  <img
                                    width="48px"
                                    alt="EasyAlu"
                                    src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/ealu.jpg"
                                  />
                                )}
                              </td>
                              <td>
                                {gelaender == 'picket' && montageart == 'top'
                                  ? '665999'
                                  : gelaender == 'picket' && montageart != 'top'
                                    ? '665998'
                                    : gelaender == 'baluster' && montageart == 'top'
                                      ? '665997'
                                      : '665996'}
                                -{hohe == 900 ? '090' : hohe == 1000 ? '100' : '110'}-00-{colorr == 'black' && '82'}
                                {colorr == 'gray' && '00'}
                                {colorr == 'anrtz' && '33'}
                                {colorr == 'brano' && '18'}
                              </td>
                              <td>x {amount + amount3 + amount2}</td>
                            </tr>
                          </>
                        )}
                      </>
                    )}
                  </>
                )}

                {handlaufmat == 'straight' && (len1 > 5000 || len2 > 5000 || len3 > 5000) && (
                  <>
                    {colorr == 'anrtz' ? (
                      <tr>
                        <td>{finalarr[53][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[53][2]} />
                        </td>
                        <td>{finalarr[53][1]}</td>
                        <td>x {amountklammernontop}</td>
                      </tr>
                    ) : colorr == 'gray' ? (
                      <tr>
                        <td>{finalarr[55][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[55][2]} />
                        </td>
                        <td>{finalarr[55][1]}</td>
                        <td>x {amountklammernontop}</td>
                      </tr>
                    ) : colorr == 'black' ? (
                      <tr>
                        <td>{finalarr[54][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[54][2]} />
                        </td>
                        <td>{finalarr[54][1]}</td>
                        <td>x {amountklammernontop}</td>
                      </tr>
                    ) : (
                      <tr>
                        <td>{finalarr[80][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[80][2]} />
                        </td>
                        <td>{finalarr[80][1]}</td>
                        <td>x {amountklammernontop}</td>
                      </tr>
                    )}
                  </>
                )}

                {handlaufmat == 'bevel' && (len1 > 5000 || len2 > 5000 || len3 > 5000) && (
                  <>
                    {colorr == 'anrtz' ? (
                      <tr>
                        <td>{finalarr[59][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[59][2]} />
                        </td>
                        <td>{finalarr[59][1]}</td>
                        <td>x {amountklammernontop}</td>
                      </tr>
                    ) : colorr == 'gray' ? (
                      <tr>
                        <td>{finalarr[59][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[59][2]} />
                        </td>
                        <td>{finalarr[59][1]}</td>
                        <td>x {amountklammernontop}</td>
                      </tr>
                    ) : colorr == 'black' ? (
                      <tr>
                        <td>{finalarr[105][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[105][2]} />
                        </td>
                        <td>{finalarr[105][1]}</td>
                        <td>x {amountklammernontop}</td>
                      </tr>
                    ) : (
                      <tr>
                        <td>{finalarr[59][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[59][2]} />
                        </td>
                        <td>{finalarr[59][1]}</td>
                        <td>x {amountklammernontop}</td>
                      </tr>
                    )}
                  </>
                )}

                {handlaufmat == 'bevel' && (
                  <>
                    {colorr == 'anrtz' ? (
                      <tr>
                        <td>
                          {finalarr[40][0]}
                          <span
                            onMouseEnter={() => {
                              document.getElementById('hovertextRailing').innerText = hovertabletext;
                            }}
                            onMouseLeave={() => {
                              document.getElementById('hovertextRailing').innerText = '';
                            }}
                            id="HovertextRailingEnter"
                          >
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7 0.5C5.71442 0.5 4.45772 0.881218 3.3888 1.59545C2.31988 2.30968 1.48676 3.32484 0.994786 4.51256C0.502816 5.70028 0.374095 7.00721 0.624899 8.26809C0.875703 9.52896 1.49477 10.6872 2.40381 11.5962C3.31285 12.5052 4.47104 13.1243 5.73192 13.3751C6.99279 13.6259 8.29973 13.4972 9.48744 13.0052C10.6752 12.5132 11.6903 11.6801 12.4046 10.6112C13.1188 9.54229 13.5 8.28558 13.5 7C13.4982 5.27665 12.8128 3.62441 11.5942 2.40582C10.3756 1.18722 8.72335 0.50182 7 0.5ZM7 12.5C5.91221 12.5 4.84884 12.1774 3.94437 11.5731C3.0399 10.9687 2.33495 10.1098 1.91867 9.10476C1.50238 8.09977 1.39347 6.9939 1.60568 5.927C1.8179 4.86011 2.34173 3.8801 3.11092 3.11091C3.8801 2.34172 4.86011 1.8179 5.92701 1.60568C6.9939 1.39346 8.09977 1.50238 9.10476 1.91866C10.1098 2.33494 10.9687 3.03989 11.5731 3.94436C12.1774 4.84883 12.5 5.9122 12.5 7C12.4983 8.45818 11.9184 9.85617 10.8873 10.8873C9.85617 11.9184 8.45819 12.4983 7 12.5ZM8 10C8 10.1326 7.94732 10.2598 7.85356 10.3536C7.75979 10.4473 7.63261 10.5 7.5 10.5C7.23479 10.5 6.98043 10.3946 6.7929 10.2071C6.60536 10.0196 6.5 9.76522 6.5 9.5V7C6.36739 7 6.24022 6.94732 6.14645 6.85355C6.05268 6.75979 6 6.63261 6 6.5C6 6.36739 6.05268 6.24021 6.14645 6.14645C6.24022 6.05268 6.36739 6 6.5 6C6.76522 6 7.01957 6.10536 7.20711 6.29289C7.39465 6.48043 7.5 6.73478 7.5 7V9.5C7.63261 9.5 7.75979 9.55268 7.85356 9.64645C7.94732 9.74021 8 9.86739 8 10ZM6 4.25C6 4.10166 6.04399 3.95666 6.1264 3.83332C6.20881 3.70999 6.32595 3.61386 6.46299 3.55709C6.60003 3.50032 6.75083 3.48547 6.89632 3.51441C7.04181 3.54335 7.17544 3.61478 7.28033 3.71967C7.38522 3.82456 7.45665 3.9582 7.48559 4.10368C7.51453 4.24917 7.49968 4.39997 7.44291 4.53701C7.38615 4.67406 7.29002 4.79119 7.16668 4.8736C7.04334 4.95601 6.89834 5 6.75 5C6.55109 5 6.36032 4.92098 6.21967 4.78033C6.07902 4.63968 6 4.44891 6 4.25Z"
                                fill="#001020"
                              />
                            </svg>
                            <div id="hovertextRailing"></div>
                          </span>
                        </td>
                        <td>
                          <img width="48px" src={finalarr[40][2]} />
                        </td>
                        <td>{finalarr[40][1]}</td>
                        <td>x {amount5Alu}</td>
                      </tr>
                    ) : colorr == 'gray' ? (
                      <tr>
                        <td>
                          {finalarr[66][0]}{' '}
                          <span
                            onMouseEnter={() => {
                              document.getElementById('hovertextRailing').innerText = hovertabletext;
                            }}
                            onMouseLeave={() => {
                              document.getElementById('hovertextRailing').innerText = '';
                            }}
                            id="HovertextRailingEnter"
                          >
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7 0.5C5.71442 0.5 4.45772 0.881218 3.3888 1.59545C2.31988 2.30968 1.48676 3.32484 0.994786 4.51256C0.502816 5.70028 0.374095 7.00721 0.624899 8.26809C0.875703 9.52896 1.49477 10.6872 2.40381 11.5962C3.31285 12.5052 4.47104 13.1243 5.73192 13.3751C6.99279 13.6259 8.29973 13.4972 9.48744 13.0052C10.6752 12.5132 11.6903 11.6801 12.4046 10.6112C13.1188 9.54229 13.5 8.28558 13.5 7C13.4982 5.27665 12.8128 3.62441 11.5942 2.40582C10.3756 1.18722 8.72335 0.50182 7 0.5ZM7 12.5C5.91221 12.5 4.84884 12.1774 3.94437 11.5731C3.0399 10.9687 2.33495 10.1098 1.91867 9.10476C1.50238 8.09977 1.39347 6.9939 1.60568 5.927C1.8179 4.86011 2.34173 3.8801 3.11092 3.11091C3.8801 2.34172 4.86011 1.8179 5.92701 1.60568C6.9939 1.39346 8.09977 1.50238 9.10476 1.91866C10.1098 2.33494 10.9687 3.03989 11.5731 3.94436C12.1774 4.84883 12.5 5.9122 12.5 7C12.4983 8.45818 11.9184 9.85617 10.8873 10.8873C9.85617 11.9184 8.45819 12.4983 7 12.5ZM8 10C8 10.1326 7.94732 10.2598 7.85356 10.3536C7.75979 10.4473 7.63261 10.5 7.5 10.5C7.23479 10.5 6.98043 10.3946 6.7929 10.2071C6.60536 10.0196 6.5 9.76522 6.5 9.5V7C6.36739 7 6.24022 6.94732 6.14645 6.85355C6.05268 6.75979 6 6.63261 6 6.5C6 6.36739 6.05268 6.24021 6.14645 6.14645C6.24022 6.05268 6.36739 6 6.5 6C6.76522 6 7.01957 6.10536 7.20711 6.29289C7.39465 6.48043 7.5 6.73478 7.5 7V9.5C7.63261 9.5 7.75979 9.55268 7.85356 9.64645C7.94732 9.74021 8 9.86739 8 10ZM6 4.25C6 4.10166 6.04399 3.95666 6.1264 3.83332C6.20881 3.70999 6.32595 3.61386 6.46299 3.55709C6.60003 3.50032 6.75083 3.48547 6.89632 3.51441C7.04181 3.54335 7.17544 3.61478 7.28033 3.71967C7.38522 3.82456 7.45665 3.9582 7.48559 4.10368C7.51453 4.24917 7.49968 4.39997 7.44291 4.53701C7.38615 4.67406 7.29002 4.79119 7.16668 4.8736C7.04334 4.95601 6.89834 5 6.75 5C6.55109 5 6.36032 4.92098 6.21967 4.78033C6.07902 4.63968 6 4.44891 6 4.25Z"
                                fill="#001020"
                              />
                            </svg>
                            <div id="hovertextRailing"></div>
                          </span>
                        </td>
                        <td>
                          <img width="48px" src={finalarr[66][2]} />
                        </td>
                        <td>{finalarr[66][1]}</td>
                        <td>x {amount5Alu}</td>
                      </tr>
                    ) : colorr == 'black' ? (
                      <tr>
                        <td>
                          {finalarr[42][0]}{' '}
                          <span
                            onMouseEnter={() => {
                              document.getElementById('hovertextRailing').innerText = hovertabletext;
                            }}
                            onMouseLeave={() => {
                              document.getElementById('hovertextRailing').innerText = '';
                            }}
                            id="HovertextRailingEnter"
                          >
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7 0.5C5.71442 0.5 4.45772 0.881218 3.3888 1.59545C2.31988 2.30968 1.48676 3.32484 0.994786 4.51256C0.502816 5.70028 0.374095 7.00721 0.624899 8.26809C0.875703 9.52896 1.49477 10.6872 2.40381 11.5962C3.31285 12.5052 4.47104 13.1243 5.73192 13.3751C6.99279 13.6259 8.29973 13.4972 9.48744 13.0052C10.6752 12.5132 11.6903 11.6801 12.4046 10.6112C13.1188 9.54229 13.5 8.28558 13.5 7C13.4982 5.27665 12.8128 3.62441 11.5942 2.40582C10.3756 1.18722 8.72335 0.50182 7 0.5ZM7 12.5C5.91221 12.5 4.84884 12.1774 3.94437 11.5731C3.0399 10.9687 2.33495 10.1098 1.91867 9.10476C1.50238 8.09977 1.39347 6.9939 1.60568 5.927C1.8179 4.86011 2.34173 3.8801 3.11092 3.11091C3.8801 2.34172 4.86011 1.8179 5.92701 1.60568C6.9939 1.39346 8.09977 1.50238 9.10476 1.91866C10.1098 2.33494 10.9687 3.03989 11.5731 3.94436C12.1774 4.84883 12.5 5.9122 12.5 7C12.4983 8.45818 11.9184 9.85617 10.8873 10.8873C9.85617 11.9184 8.45819 12.4983 7 12.5ZM8 10C8 10.1326 7.94732 10.2598 7.85356 10.3536C7.75979 10.4473 7.63261 10.5 7.5 10.5C7.23479 10.5 6.98043 10.3946 6.7929 10.2071C6.60536 10.0196 6.5 9.76522 6.5 9.5V7C6.36739 7 6.24022 6.94732 6.14645 6.85355C6.05268 6.75979 6 6.63261 6 6.5C6 6.36739 6.05268 6.24021 6.14645 6.14645C6.24022 6.05268 6.36739 6 6.5 6C6.76522 6 7.01957 6.10536 7.20711 6.29289C7.39465 6.48043 7.5 6.73478 7.5 7V9.5C7.63261 9.5 7.75979 9.55268 7.85356 9.64645C7.94732 9.74021 8 9.86739 8 10ZM6 4.25C6 4.10166 6.04399 3.95666 6.1264 3.83332C6.20881 3.70999 6.32595 3.61386 6.46299 3.55709C6.60003 3.50032 6.75083 3.48547 6.89632 3.51441C7.04181 3.54335 7.17544 3.61478 7.28033 3.71967C7.38522 3.82456 7.45665 3.9582 7.48559 4.10368C7.51453 4.24917 7.49968 4.39997 7.44291 4.53701C7.38615 4.67406 7.29002 4.79119 7.16668 4.8736C7.04334 4.95601 6.89834 5 6.75 5C6.55109 5 6.36032 4.92098 6.21967 4.78033C6.07902 4.63968 6 4.44891 6 4.25Z"
                                fill="#001020"
                              />
                            </svg>
                            <div id="hovertextRailing"></div>
                          </span>
                        </td>
                        <td>
                          <img width="48px" src={finalarr[42][2]} />
                        </td>
                        <td>{finalarr[42][1]}</td>
                        <td>x {amount5Alu}</td>
                      </tr>
                    ) : (
                      <tr>
                        <td>
                          {finalarr[41][0]}
                          <span
                            onMouseEnter={() => {
                              document.getElementById('hovertextRailing').innerText = hovertabletext;
                            }}
                            onMouseLeave={() => {
                              document.getElementById('hovertextRailing').innerText = '';
                            }}
                            id="HovertextRailingEnter"
                          >
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7 0.5C5.71442 0.5 4.45772 0.881218 3.3888 1.59545C2.31988 2.30968 1.48676 3.32484 0.994786 4.51256C0.502816 5.70028 0.374095 7.00721 0.624899 8.26809C0.875703 9.52896 1.49477 10.6872 2.40381 11.5962C3.31285 12.5052 4.47104 13.1243 5.73192 13.3751C6.99279 13.6259 8.29973 13.4972 9.48744 13.0052C10.6752 12.5132 11.6903 11.6801 12.4046 10.6112C13.1188 9.54229 13.5 8.28558 13.5 7C13.4982 5.27665 12.8128 3.62441 11.5942 2.40582C10.3756 1.18722 8.72335 0.50182 7 0.5ZM7 12.5C5.91221 12.5 4.84884 12.1774 3.94437 11.5731C3.0399 10.9687 2.33495 10.1098 1.91867 9.10476C1.50238 8.09977 1.39347 6.9939 1.60568 5.927C1.8179 4.86011 2.34173 3.8801 3.11092 3.11091C3.8801 2.34172 4.86011 1.8179 5.92701 1.60568C6.9939 1.39346 8.09977 1.50238 9.10476 1.91866C10.1098 2.33494 10.9687 3.03989 11.5731 3.94436C12.1774 4.84883 12.5 5.9122 12.5 7C12.4983 8.45818 11.9184 9.85617 10.8873 10.8873C9.85617 11.9184 8.45819 12.4983 7 12.5ZM8 10C8 10.1326 7.94732 10.2598 7.85356 10.3536C7.75979 10.4473 7.63261 10.5 7.5 10.5C7.23479 10.5 6.98043 10.3946 6.7929 10.2071C6.60536 10.0196 6.5 9.76522 6.5 9.5V7C6.36739 7 6.24022 6.94732 6.14645 6.85355C6.05268 6.75979 6 6.63261 6 6.5C6 6.36739 6.05268 6.24021 6.14645 6.14645C6.24022 6.05268 6.36739 6 6.5 6C6.76522 6 7.01957 6.10536 7.20711 6.29289C7.39465 6.48043 7.5 6.73478 7.5 7V9.5C7.63261 9.5 7.75979 9.55268 7.85356 9.64645C7.94732 9.74021 8 9.86739 8 10ZM6 4.25C6 4.10166 6.04399 3.95666 6.1264 3.83332C6.20881 3.70999 6.32595 3.61386 6.46299 3.55709C6.60003 3.50032 6.75083 3.48547 6.89632 3.51441C7.04181 3.54335 7.17544 3.61478 7.28033 3.71967C7.38522 3.82456 7.45665 3.9582 7.48559 4.10368C7.51453 4.24917 7.49968 4.39997 7.44291 4.53701C7.38615 4.67406 7.29002 4.79119 7.16668 4.8736C7.04334 4.95601 6.89834 5 6.75 5C6.55109 5 6.36032 4.92098 6.21967 4.78033C6.07902 4.63968 6 4.44891 6 4.25Z"
                                fill="#001020"
                              />
                            </svg>
                            <div id="hovertextRailing"></div>
                          </span>
                        </td>
                        <td>
                          <img width="48px" src={finalarr[41][2]} />
                        </td>
                        <td>{finalarr[41][1]}</td>
                        <td>x {amount5Alu}</td>
                      </tr>
                    )}
                  </>
                )}

                {handlaufmat == 'straight' && (
                  <>
                    {colorr == 'anrtz' ? (
                      <tr>
                        <td>
                          {finalarr[43][0]}
                          <span
                            onMouseEnter={() => {
                              document.getElementById('hovertextRailing').innerText = hovertabletext;
                            }}
                            onMouseLeave={() => {
                              document.getElementById('hovertextRailing').innerText = '';
                            }}
                            id="HovertextRailingEnter"
                          >
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7 0.5C5.71442 0.5 4.45772 0.881218 3.3888 1.59545C2.31988 2.30968 1.48676 3.32484 0.994786 4.51256C0.502816 5.70028 0.374095 7.00721 0.624899 8.26809C0.875703 9.52896 1.49477 10.6872 2.40381 11.5962C3.31285 12.5052 4.47104 13.1243 5.73192 13.3751C6.99279 13.6259 8.29973 13.4972 9.48744 13.0052C10.6752 12.5132 11.6903 11.6801 12.4046 10.6112C13.1188 9.54229 13.5 8.28558 13.5 7C13.4982 5.27665 12.8128 3.62441 11.5942 2.40582C10.3756 1.18722 8.72335 0.50182 7 0.5ZM7 12.5C5.91221 12.5 4.84884 12.1774 3.94437 11.5731C3.0399 10.9687 2.33495 10.1098 1.91867 9.10476C1.50238 8.09977 1.39347 6.9939 1.60568 5.927C1.8179 4.86011 2.34173 3.8801 3.11092 3.11091C3.8801 2.34172 4.86011 1.8179 5.92701 1.60568C6.9939 1.39346 8.09977 1.50238 9.10476 1.91866C10.1098 2.33494 10.9687 3.03989 11.5731 3.94436C12.1774 4.84883 12.5 5.9122 12.5 7C12.4983 8.45818 11.9184 9.85617 10.8873 10.8873C9.85617 11.9184 8.45819 12.4983 7 12.5ZM8 10C8 10.1326 7.94732 10.2598 7.85356 10.3536C7.75979 10.4473 7.63261 10.5 7.5 10.5C7.23479 10.5 6.98043 10.3946 6.7929 10.2071C6.60536 10.0196 6.5 9.76522 6.5 9.5V7C6.36739 7 6.24022 6.94732 6.14645 6.85355C6.05268 6.75979 6 6.63261 6 6.5C6 6.36739 6.05268 6.24021 6.14645 6.14645C6.24022 6.05268 6.36739 6 6.5 6C6.76522 6 7.01957 6.10536 7.20711 6.29289C7.39465 6.48043 7.5 6.73478 7.5 7V9.5C7.63261 9.5 7.75979 9.55268 7.85356 9.64645C7.94732 9.74021 8 9.86739 8 10ZM6 4.25C6 4.10166 6.04399 3.95666 6.1264 3.83332C6.20881 3.70999 6.32595 3.61386 6.46299 3.55709C6.60003 3.50032 6.75083 3.48547 6.89632 3.51441C7.04181 3.54335 7.17544 3.61478 7.28033 3.71967C7.38522 3.82456 7.45665 3.9582 7.48559 4.10368C7.51453 4.24917 7.49968 4.39997 7.44291 4.53701C7.38615 4.67406 7.29002 4.79119 7.16668 4.8736C7.04334 4.95601 6.89834 5 6.75 5C6.55109 5 6.36032 4.92098 6.21967 4.78033C6.07902 4.63968 6 4.44891 6 4.25Z"
                                fill="#001020"
                              />
                            </svg>
                            <div id="hovertextRailing"></div>
                          </span>
                        </td>
                        <td>
                          <img width="48px" src={finalarr[43][2]} />
                        </td>
                        <td>{finalarr[43][1]}</td>
                        <td>x {amount5Alu}</td>
                      </tr>
                    ) : colorr == 'gray' ? (
                      <tr>
                        <td>
                          {finalarr[64][0]}
                          <span
                            onMouseEnter={() => {
                              document.getElementById('hovertextRailing').innerText = hovertabletext;
                            }}
                            onMouseLeave={() => {
                              document.getElementById('hovertextRailing').innerText = '';
                            }}
                            id="HovertextRailingEnter"
                          >
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7 0.5C5.71442 0.5 4.45772 0.881218 3.3888 1.59545C2.31988 2.30968 1.48676 3.32484 0.994786 4.51256C0.502816 5.70028 0.374095 7.00721 0.624899 8.26809C0.875703 9.52896 1.49477 10.6872 2.40381 11.5962C3.31285 12.5052 4.47104 13.1243 5.73192 13.3751C6.99279 13.6259 8.29973 13.4972 9.48744 13.0052C10.6752 12.5132 11.6903 11.6801 12.4046 10.6112C13.1188 9.54229 13.5 8.28558 13.5 7C13.4982 5.27665 12.8128 3.62441 11.5942 2.40582C10.3756 1.18722 8.72335 0.50182 7 0.5ZM7 12.5C5.91221 12.5 4.84884 12.1774 3.94437 11.5731C3.0399 10.9687 2.33495 10.1098 1.91867 9.10476C1.50238 8.09977 1.39347 6.9939 1.60568 5.927C1.8179 4.86011 2.34173 3.8801 3.11092 3.11091C3.8801 2.34172 4.86011 1.8179 5.92701 1.60568C6.9939 1.39346 8.09977 1.50238 9.10476 1.91866C10.1098 2.33494 10.9687 3.03989 11.5731 3.94436C12.1774 4.84883 12.5 5.9122 12.5 7C12.4983 8.45818 11.9184 9.85617 10.8873 10.8873C9.85617 11.9184 8.45819 12.4983 7 12.5ZM8 10C8 10.1326 7.94732 10.2598 7.85356 10.3536C7.75979 10.4473 7.63261 10.5 7.5 10.5C7.23479 10.5 6.98043 10.3946 6.7929 10.2071C6.60536 10.0196 6.5 9.76522 6.5 9.5V7C6.36739 7 6.24022 6.94732 6.14645 6.85355C6.05268 6.75979 6 6.63261 6 6.5C6 6.36739 6.05268 6.24021 6.14645 6.14645C6.24022 6.05268 6.36739 6 6.5 6C6.76522 6 7.01957 6.10536 7.20711 6.29289C7.39465 6.48043 7.5 6.73478 7.5 7V9.5C7.63261 9.5 7.75979 9.55268 7.85356 9.64645C7.94732 9.74021 8 9.86739 8 10ZM6 4.25C6 4.10166 6.04399 3.95666 6.1264 3.83332C6.20881 3.70999 6.32595 3.61386 6.46299 3.55709C6.60003 3.50032 6.75083 3.48547 6.89632 3.51441C7.04181 3.54335 7.17544 3.61478 7.28033 3.71967C7.38522 3.82456 7.45665 3.9582 7.48559 4.10368C7.51453 4.24917 7.49968 4.39997 7.44291 4.53701C7.38615 4.67406 7.29002 4.79119 7.16668 4.8736C7.04334 4.95601 6.89834 5 6.75 5C6.55109 5 6.36032 4.92098 6.21967 4.78033C6.07902 4.63968 6 4.44891 6 4.25Z"
                                fill="#001020"
                              />
                            </svg>
                            <div id="hovertextRailing"></div>
                          </span>
                        </td>
                        <td>
                          <img width="48px" src={finalarr[64][2]} />
                        </td>
                        <td>{finalarr[64][1]}</td>
                        <td>x {amount5Alu}</td>
                      </tr>
                    ) : colorr == 'black' ? (
                      <tr>
                        <td>
                          {finalarr[45][0]}
                          <span
                            onMouseEnter={() => {
                              document.getElementById('hovertextRailing').innerText = hovertabletext;
                            }}
                            onMouseLeave={() => {
                              document.getElementById('hovertextRailing').innerText = '';
                            }}
                            id="HovertextRailingEnter"
                          >
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7 0.5C5.71442 0.5 4.45772 0.881218 3.3888 1.59545C2.31988 2.30968 1.48676 3.32484 0.994786 4.51256C0.502816 5.70028 0.374095 7.00721 0.624899 8.26809C0.875703 9.52896 1.49477 10.6872 2.40381 11.5962C3.31285 12.5052 4.47104 13.1243 5.73192 13.3751C6.99279 13.6259 8.29973 13.4972 9.48744 13.0052C10.6752 12.5132 11.6903 11.6801 12.4046 10.6112C13.1188 9.54229 13.5 8.28558 13.5 7C13.4982 5.27665 12.8128 3.62441 11.5942 2.40582C10.3756 1.18722 8.72335 0.50182 7 0.5ZM7 12.5C5.91221 12.5 4.84884 12.1774 3.94437 11.5731C3.0399 10.9687 2.33495 10.1098 1.91867 9.10476C1.50238 8.09977 1.39347 6.9939 1.60568 5.927C1.8179 4.86011 2.34173 3.8801 3.11092 3.11091C3.8801 2.34172 4.86011 1.8179 5.92701 1.60568C6.9939 1.39346 8.09977 1.50238 9.10476 1.91866C10.1098 2.33494 10.9687 3.03989 11.5731 3.94436C12.1774 4.84883 12.5 5.9122 12.5 7C12.4983 8.45818 11.9184 9.85617 10.8873 10.8873C9.85617 11.9184 8.45819 12.4983 7 12.5ZM8 10C8 10.1326 7.94732 10.2598 7.85356 10.3536C7.75979 10.4473 7.63261 10.5 7.5 10.5C7.23479 10.5 6.98043 10.3946 6.7929 10.2071C6.60536 10.0196 6.5 9.76522 6.5 9.5V7C6.36739 7 6.24022 6.94732 6.14645 6.85355C6.05268 6.75979 6 6.63261 6 6.5C6 6.36739 6.05268 6.24021 6.14645 6.14645C6.24022 6.05268 6.36739 6 6.5 6C6.76522 6 7.01957 6.10536 7.20711 6.29289C7.39465 6.48043 7.5 6.73478 7.5 7V9.5C7.63261 9.5 7.75979 9.55268 7.85356 9.64645C7.94732 9.74021 8 9.86739 8 10ZM6 4.25C6 4.10166 6.04399 3.95666 6.1264 3.83332C6.20881 3.70999 6.32595 3.61386 6.46299 3.55709C6.60003 3.50032 6.75083 3.48547 6.89632 3.51441C7.04181 3.54335 7.17544 3.61478 7.28033 3.71967C7.38522 3.82456 7.45665 3.9582 7.48559 4.10368C7.51453 4.24917 7.49968 4.39997 7.44291 4.53701C7.38615 4.67406 7.29002 4.79119 7.16668 4.8736C7.04334 4.95601 6.89834 5 6.75 5C6.55109 5 6.36032 4.92098 6.21967 4.78033C6.07902 4.63968 6 4.44891 6 4.25Z"
                                fill="#001020"
                              />
                            </svg>
                            <div id="hovertextRailing"></div>
                          </span>
                        </td>
                        <td>
                          <img width="48px" src={finalarr[45][2]} />
                        </td>
                        <td>{finalarr[45][1]}</td>
                        <td>x {amount5Alu}</td>
                      </tr>
                    ) : (
                      <tr>
                        <td>
                          {finalarr[44][0]}
                          <span
                            onMouseEnter={() => {
                              document.getElementById('hovertextRailing').innerText = hovertabletext;
                            }}
                            onMouseLeave={() => {
                              document.getElementById('hovertextRailing').innerText = '';
                            }}
                            id="HovertextRailingEnter"
                          >
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7 0.5C5.71442 0.5 4.45772 0.881218 3.3888 1.59545C2.31988 2.30968 1.48676 3.32484 0.994786 4.51256C0.502816 5.70028 0.374095 7.00721 0.624899 8.26809C0.875703 9.52896 1.49477 10.6872 2.40381 11.5962C3.31285 12.5052 4.47104 13.1243 5.73192 13.3751C6.99279 13.6259 8.29973 13.4972 9.48744 13.0052C10.6752 12.5132 11.6903 11.6801 12.4046 10.6112C13.1188 9.54229 13.5 8.28558 13.5 7C13.4982 5.27665 12.8128 3.62441 11.5942 2.40582C10.3756 1.18722 8.72335 0.50182 7 0.5ZM7 12.5C5.91221 12.5 4.84884 12.1774 3.94437 11.5731C3.0399 10.9687 2.33495 10.1098 1.91867 9.10476C1.50238 8.09977 1.39347 6.9939 1.60568 5.927C1.8179 4.86011 2.34173 3.8801 3.11092 3.11091C3.8801 2.34172 4.86011 1.8179 5.92701 1.60568C6.9939 1.39346 8.09977 1.50238 9.10476 1.91866C10.1098 2.33494 10.9687 3.03989 11.5731 3.94436C12.1774 4.84883 12.5 5.9122 12.5 7C12.4983 8.45818 11.9184 9.85617 10.8873 10.8873C9.85617 11.9184 8.45819 12.4983 7 12.5ZM8 10C8 10.1326 7.94732 10.2598 7.85356 10.3536C7.75979 10.4473 7.63261 10.5 7.5 10.5C7.23479 10.5 6.98043 10.3946 6.7929 10.2071C6.60536 10.0196 6.5 9.76522 6.5 9.5V7C6.36739 7 6.24022 6.94732 6.14645 6.85355C6.05268 6.75979 6 6.63261 6 6.5C6 6.36739 6.05268 6.24021 6.14645 6.14645C6.24022 6.05268 6.36739 6 6.5 6C6.76522 6 7.01957 6.10536 7.20711 6.29289C7.39465 6.48043 7.5 6.73478 7.5 7V9.5C7.63261 9.5 7.75979 9.55268 7.85356 9.64645C7.94732 9.74021 8 9.86739 8 10ZM6 4.25C6 4.10166 6.04399 3.95666 6.1264 3.83332C6.20881 3.70999 6.32595 3.61386 6.46299 3.55709C6.60003 3.50032 6.75083 3.48547 6.89632 3.51441C7.04181 3.54335 7.17544 3.61478 7.28033 3.71967C7.38522 3.82456 7.45665 3.9582 7.48559 4.10368C7.51453 4.24917 7.49968 4.39997 7.44291 4.53701C7.38615 4.67406 7.29002 4.79119 7.16668 4.8736C7.04334 4.95601 6.89834 5 6.75 5C6.55109 5 6.36032 4.92098 6.21967 4.78033C6.07902 4.63968 6 4.44891 6 4.25Z"
                                fill="#001020"
                              />
                            </svg>
                            <div id="hovertextRailing"></div>
                          </span>
                        </td>
                        <td>
                          <img width="48px" src={finalarr[44][2]} />
                        </td>
                        <td>{finalarr[44][1]}</td>
                        <td>x {amount5Alu}</td>
                      </tr>
                    )}
                  </>
                )}

                {(form == 'l' || form == 'u') && handlaufmat == 'straight' && (
                  <>
                    {colorr == 'anrtz' ? (
                      <tr>
                        <td>{finalarr[56][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[56][2]} />
                        </td>
                        <td>{finalarr[56][1]}</td>
                        <td>x {form == 'u' ? 2 : 1}</td>
                      </tr>
                    ) : colorr == 'gray' ? (
                      <tr>
                        <td>{finalarr[58][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[58][2]} />
                        </td>
                        <td>{finalarr[58][1]}</td>
                        <td>x {form == 'u' ? 2 : 1}</td>
                      </tr>
                    ) : colorr == 'black' ? (
                      <tr>
                        <td>{finalarr[57][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[57][2]} />
                        </td>
                        <td>{finalarr[57][1]}</td>
                        <td>x {form == 'u' ? 2 : 1}</td>
                      </tr>
                    ) : (
                      <tr>
                        <td>{finalarr[79][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[79][2]} />
                        </td>
                        <td>{finalarr[79][1]}</td>
                        <td>x {form == 'u' ? 2 : 1}</td>
                      </tr>
                    )}
                  </>
                )}

                {(form == 'l' || form == 'u') && handlaufmat == 'bevel' && (
                  <>
                    {colorr == 'anrtz' ? (
                      <tr>
                        <td>{finalarr[60][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[60][2]} />
                        </td>
                        <td>{finalarr[60][1]}</td>
                        <td>x {form == 'u' ? 2 : 1}</td>
                      </tr>
                    ) : colorr == 'gray' ? (
                      <tr>
                        <td>{finalarr[60][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[60][2]} />
                        </td>
                        <td>{finalarr[60][1]}</td>
                        <td>x {form == 'u' ? 2 : 1}</td>
                      </tr>
                    ) : colorr == 'black' ? (
                      <tr>
                        <td>{finalarr[106][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[106][2]} />
                        </td>
                        <td>{finalarr[106][1]}</td>
                        <td>x {form == 'u' ? 2 : 1}</td>
                      </tr>
                    ) : (
                      <tr>
                        <td>{finalarr[60][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[60][2]} />
                        </td>
                        <td>{finalarr[60][1]}</td>
                        <td>x {form == 'u' ? 2 : 1}</td>
                      </tr>
                    )}
                  </>
                )}

                {ankertrigger && untergrundd == 'beton' && (
                  <tr>
                    <td>{finalarr[32][0]}</td>
                    <td>
                      <img src={finalarr[32][2]} width="48px" />
                    </td>
                    <td>{finalarr[32][1]}</td>
                    <td className="table_amount">x {anchorcalcalu}</td>
                  </tr>
                )}
                {!ankertrigger && untergrundd == 'beton' && (
                  <tr>
                    <td>{finalarr[33][0]}</td>
                    <td>
                      <img src={finalarr[33][2]} width="48px" />
                    </td>
                    <td>{finalarr[33][1]}</td>
                    <td className="table_amount">x {anchorcalcalu}</td>
                  </tr>
                )}

                {ankertrigger && untergrundd == 'beton' && (
                  <tr>
                    <td>{finalarr[34][0]}</td>
                    <td>
                      <img src={finalarr[34][2]} width="48px" />
                    </td>
                    <td>{finalarr[34][1]}</td>
                    <td className="table_amount">x {anchorcalcalu}</td>
                  </tr>
                )}
                {!ankertrigger && untergrundd == 'beton' && (
                  <tr>
                    <td>{finalarr[35][0]}</td>
                    <td>
                      <img src={finalarr[35][2]} width="48px" />
                    </td>
                    <td>{finalarr[35][1]}</td>
                    <td className="table_amount">x {anchorcalcalu}</td>
                  </tr>
                )}

                {ankertrigger && untergrundd == 'holz' && (
                  <tr>
                    <td>{finalarr[62][0]}</td>
                    <td>
                      <img src={finalarr[62][2]} width="48px" />
                    </td>
                    <td>{finalarr[62][1]}</td>
                    <td className="table_amount">x {anchorcalcalu}</td>
                  </tr>
                )}
                {!ankertrigger && untergrundd == 'holz' && (
                  <tr>
                    <td>{finalarr[63][0]}</td>
                    <td>
                      <img src={finalarr[63][2]} width="48px" />
                    </td>
                    <td>{finalarr[63][1]}</td>
                    <td className="table_amount">x {anchorcalcalu}</td>
                  </tr>
                )}

                {(!wall1 || !wall2) && handlaufmat == 'straight' && (
                  <>
                    {colorr == 'anrtz' ? (
                      <tr>
                        <td>{finalarr[47][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[47][2]} />
                        </td>
                        <td>{finalarr[47][1]}</td>
                        <td>x {!wall1 && !wall2 ? 2 : 1}</td>
                      </tr>
                    ) : colorr == 'gray' ? (
                      <tr>
                        <td>{finalarr[46][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[46][2]} />
                        </td>
                        <td>{finalarr[46][1]}</td>
                        <td>x {!wall1 && !wall2 ? 2 : 1}</td>
                      </tr>
                    ) : colorr == 'black' ? (
                      <tr>
                        <td>{finalarr[48][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[48][2]} />
                        </td>
                        <td>{finalarr[48][1]}</td>
                        <td>x {!wall1 && !wall2 ? 2 : 1}</td>
                      </tr>
                    ) : (
                      <tr>
                        <td>{finalarr[67][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[67][2]} />
                        </td>
                        <td>{finalarr[67][1]}</td>
                        <td>x {!wall1 && !wall2 ? 2 : 1}</td>
                      </tr>
                    )}
                  </>
                )}

                {!wall1 && handlaufmat == 'bevel' && (
                  <>
                    {colorr == 'anrtz' ? (
                      <tr>
                        <td>{finalarr[50][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[50][2]} />
                        </td>
                        <td>{finalarr[50][1]}</td>
                        <td>x 1</td>
                      </tr>
                    ) : colorr == 'gray' ? (
                      <tr>
                        <td>{finalarr[49][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[49][2]} />
                        </td>
                        <td>{finalarr[49][1]}</td>
                        <td>x 1</td>
                      </tr>
                    ) : colorr == 'black' ? (
                      <tr>
                        <td>{finalarr[51][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[51][2]} />
                        </td>
                        <td>{finalarr[51][1]}</td>
                        <td>x 1</td>
                      </tr>
                    ) : (
                      <tr>
                        <td>{finalarr[65][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[65][2]} />
                        </td>
                        <td>{finalarr[65][1]}</td>
                        <td>x 1</td>
                      </tr>
                    )}
                  </>
                )}
                {!wall2 && handlaufmat == 'bevel' && (
                  <>
                    {colorr == 'anrtz' ? (
                      <tr>
                        <td>{finalarr[69][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[69][2]} />
                        </td>
                        <td>{finalarr[69][1]}</td>
                        <td>x 1</td>
                      </tr>
                    ) : colorr == 'gray' ? (
                      <tr>
                        <td>{finalarr[68][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[68][2]} />
                        </td>
                        <td>{finalarr[68][1]}</td>
                        <td>x 1</td>
                      </tr>
                    ) : colorr == 'black' ? (
                      <tr>
                        <td>{finalarr[70][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[70][2]} />
                        </td>
                        <td>{finalarr[70][1]}</td>
                        <td>x 1</td>
                      </tr>
                    ) : (
                      <tr>
                        <td>{finalarr[71][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[71][2]} />
                        </td>
                        <td>{finalarr[71][1]}</td>
                        <td>x 1</td>
                      </tr>
                    )}
                  </>
                )}

                {(wall1 || wall2) && (
                  <tr>
                    <td>{finalarr[61][0]}</td>
                    <td>
                      <img width="48px" src={finalarr[61][2]} />
                    </td>
                    <td>{finalarr[61][1]}</td>
                    <td>x {wall1 && wall2 ? 2 : 1}</td>
                  </tr>
                )}
                {(form == 'l' || form == 'u' || len1 > 5000) && (
                  <tr>
                    <td>{finalarr[52][0]}</td>
                    <td>
                      <img src={finalarr[52][2]} width="48px" />
                    </td>
                    <td>{finalarr[52][1]}</td>
                    <td className="table_amount">x {ConnectorForAlu}</td>
                  </tr>
                )}
                {/*(form == 'l' || form == 'u' || len1 >= 5000) && (
                  <>
                    {
                      <tr>
                        <td>{finalarr[52][0]}</td>
                        <td>
                          <img width="48px" src={finalarr[52][2]} />
                        </td>
                        <td>{finalarr[52][1]}</td>
                        <td>
                          x{form == 'i' && <>{len1 >= 10000 ? '4' : '2'}</>}
                          {form == 'l' && (
                            <>
                              {len1 < 5000 && len2 < 5000
                                ? '2'
                                : len1 >= 5000 && len1 < 10000 && len2 < 5000
                                  ? '4'
                                  : len1 < 5000 && len2 >= 5000 && len2 < 10000
                                    ? '4'
                                    : len1 >= 5000 && len1 < 10000 && len2 >= 5000 && len2 < 10000
                                      ? '6'
                                      : len1 >= 10000 && len2 < 5000
                                        ? '4'
                                        : len1 < 5000 && len2 >= 10000
                                          ? '4'
                                          : len1 >= 10000 && len2 >= 5000 && len2 < 10000
                                            ? '8'
                                            : len1 >= 5000 && len1 < 10000 && len2 >= 10000
                                              ? '10'
                                              : len1 >= 10000 && len2 >= 10000
                                                ? '10'
                                                : ''}
                            </>
                          )}
                          {form == 'u' && (
                            <>
                              {len1 < 5000 && len2 < 5000 && len3 < 5000
                                ? '6'
                                : len1 >= 5000 && len1 < 10000 && len2 < 5000 && len3 < 5000
                                  ? '8'
                                  : len1 < 5000 && len2 >= 5000 && len2 < 10000 && len3 < 5000
                                    ? '8'
                                    : len1 < 5000 && len2 < 5000 && len3 >= 5000 && len3 < 10000
                                      ? '8'
                                      : len1 >= 5000 && len1 < 10000 && len2 >= 5000 && len2 < 10000 && len3 < 5000
                                        ? '8'
                                        : len1 >= 5000 && len1 < 10000 && len2 < 5000 && len3 >= 5000 && len3 < 10000
                                          ? '8'
                                          : len1 < 5000 && len2 >= 5000 && len2 < 10000 && len3 >= 5000 && len3 < 10000
                                            ? '8'
                                            : len1 >= 5000 &&
                                                len1 < 10000 &&
                                                len2 >= 5000 &&
                                                len2 < 10000 &&
                                                len3 >= 5000 &&
                                                len3 < 10000
                                              ? '10'
                                              : len1 >= 10000 && len2 < 5000 && len3 < 5000
                                                ? '8'
                                                : len1 < 5000 && len2 >= 10000 && len3 < 5000
                                                  ? '8'
                                                  : len1 < 5000 && len2 < 5000 && len3 >= 10000
                                                    ? '8'
                                                    : len1 >= 10000 && len2 >= 5000 && len2 < 10000 && len3 < 5000
                                                      ? '10'
                                                      : len1 >= 10000 && len2 < 5000 && len3 >= 5000 && len3 < 10000
                                                        ? '10'
                                                        : len1 < 5000 && len2 >= 10000 && len3 >= 5000 && len3 < 10000
                                                          ? '10'
                                                          : len1 >= 10000 &&
                                                              len2 >= 5000 &&
                                                              len2 < 10000 &&
                                                              len3 >= 5000 &&
                                                              len3 < 10000
                                                            ? '12'
                                                            : len1 >= 5000 &&
                                                                len1 < 10000 &&
                                                                len2 >= 10000 &&
                                                                len3 < 5000
                                                              ? '10'
                                                              : len1 >= 5000 &&
                                                                  len1 < 10000 &&
                                                                  len2 < 5000 &&
                                                                  len3 >= 10000
                                                                ? '10'
                                                                : len1 < 5000 && len2 >= 10000 && len3 >= 10000
                                                                  ? '12'
                                                                  : len1 >= 5000 &&
                                                                      len1 < 10000 &&
                                                                      len2 >= 5000 &&
                                                                      len2 < 10000 &&
                                                                      len3 >= 10000
                                                                    ? '12'
                                                                    : len1 >= 10000 && len2 >= 10000 && len3 < 5000
                                                                      ? '12'
                                                                      : len1 >= 10000 && len2 < 5000 && len3 >= 10000
                                                                        ? '12'
                                                                        : len1 < 5000 && len2 >= 10000 && len3 >= 10000
                                                                          ? '12'
                                                                          : len1 >= 10000 &&
                                                                              len2 >= 10000 &&
                                                                              len3 >= 5000 &&
                                                                              len3 < 10000
                                                                            ? '14'
                                                                            : len1 >= 10000 &&
                                                                                len2 >= 5000 &&
                                                                                len2 < 10000 &&
                                                                                len3 >= 10000
                                                                              ? '14'
                                                                              : len1 >= 5000 &&
                                                                                  len1 < 10000 &&
                                                                                  len2 >= 10000 &&
                                                                                  len3 >= 10000
                                                                                ? '14'
                                                                                : len1 >= 10000 &&
                                                                                    len2 >= 10000 &&
                                                                                    len3 >= 10000
                                                                                  ? '16'
                                                                                  : ''}
                            </>
                          )}
                        </td>
                      </tr>
                    }
                  </>
                )*/}

                {untergrundd == 'beton' && (
                  <tr>
                    <td>{finalarr[36][0]}</td>
                    <td>
                      <img src={finalarr[36][2]} width="48px" />
                    </td>
                    <td>{finalarr[36][1]}</td>
                    <td className="table_amount">x 1</td>
                  </tr>
                )}
                {ankertrigger && untergrundd == 'beton' && (
                  <tr>
                    <td>{finalarr[38][0]}</td>
                    <td>
                      <img src={finalarr[37][2]} width="48px" />
                    </td>
                    <td>{finalarr[37][1]}</td>
                    <td className="table_amount">x 1</td>
                  </tr>
                )}
                {!ankertrigger && untergrundd == 'beton' && (
                  <tr>
                    <td>{finalarr[37][0]}</td>
                    <td>
                      <img src={finalarr[38][2]} width="48px" />
                    </td>
                    <td>{finalarr[38][1]}</td>
                    <td className="table_amount">x 1</td>
                  </tr>
                )}
                {ankertrigger && untergrundd == 'beton' && (
                  <tr>
                    <td>{finalarr[39][0]}</td>
                    <td>
                      <img src={finalarr[39][2]} width="48px" />
                    </td>
                    <td>{finalarr[39][1]}</td>
                    <td className="table_amount">
                      x {anchorcalcalu < 30 ? 1 : anchorcalcalu > 30 && anchorcalcalu < 60 ? 2 : 3}
                    </td>
                  </tr>
                )}
                {!ankertrigger && untergrundd == 'beton' && (
                  <tr>
                    <td>{finalarr[39][0]}</td>
                    <td>
                      <img src={finalarr[39][2]} width="48px" />
                    </td>
                    <td>{finalarr[39][1]}</td>
                    <td className="table_amount">
                      x {anchorcalcalu < 40 ? 1 : anchorcalcalu > 40 && anchorcalcalu < 80 ? 2 : 3}
                    </td>
                  </tr>
                )}
              </table>
            </div>
          </>
        )}

        {gelaender == 'baseclamps' && (
          <>
            <div className={'articlelist ' + (!showmenu ? 'hide-element' : '')}>
              <div className="articlelist-inner-header">
                <h3>
                  {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[70] : 'Individual Components'}
                </h3>
                <button
                  id="closeproductlist"
                  onClick={() => {
                    if (showmenu) {
                      setshowmenu(false);
                      document.getElementById('modelcanvas2').style = 'position:relative';
                    } else {
                      setshowmenu(true);
                      document.getElementById('modelcanvas2').style = 'position:absolute';
                    }
                  }}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M19.5459 17.954C19.7572 18.1653 19.876 18.452 19.876 18.7509C19.876 19.0497 19.7572 19.3364 19.5459 19.5477C19.3346 19.7591 19.0479 19.8778 18.749 19.8778C18.4501 19.8778 18.1635 19.7591 17.9521 19.5477L12 13.5937L6.0459 19.5459C5.83455 19.7572 5.54791 19.8759 5.24902 19.8759C4.95014 19.8759 4.66349 19.7572 4.45215 19.5459C4.2408 19.3345 4.12207 19.0479 4.12207 18.749C4.12207 18.4501 4.2408 18.1635 4.45215 17.9521L10.4062 11.9999L4.45402 6.04586C4.24268 5.83451 4.12395 5.54787 4.12395 5.24898C4.12395 4.9501 4.24268 4.66345 4.45402 4.45211C4.66537 4.24076 4.95201 4.12203 5.2509 4.12203C5.54978 4.12203 5.83643 4.24076 6.04777 4.45211L12 10.4062L17.954 4.45117C18.1654 4.23983 18.452 4.12109 18.7509 4.12109C19.0498 4.12109 19.3364 4.23983 19.5478 4.45117C19.7591 4.66251 19.8778 4.94916 19.8778 5.24804C19.8778 5.54693 19.7591 5.83358 19.5478 6.04492L13.5937 11.9999L19.5459 17.954Z"
                      fill="#001020"
                    />
                  </svg>
                </button>
              </div>

              <table className="articletable">
                <tr>
                  <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[71] : 'Type'}</td>
                  <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[72] : 'Art.Image'}</td>
                  <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[73] : 'Art. No.'}</td>
                  <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[74] : 'Amount'}</td>
                </tr>

                {baseclampcase == 4 && (
                  <tr>
                    <td>{finalarr[73][0]}</td>
                    <td>
                      <img src={finalarr[73][2]} width="48px" />
                    </td>
                    <td>{measureglasi}</td>
                    <td className="table_amount">
                      {' '}
                      x {parseInt(amounty) + 1 + (parseInt(amount3y) + 1) + (parseInt(amount2y) + 1)}
                    </td>
                  </tr>
                )}

                {baseclampcase == 0 && (
                  <>
                    <tr>
                      <td>{finalarr[73][0]}</td>
                      <td>
                        <img src={finalarr[73][2]} width="48px" />
                      </td>
                      <td>{measureglasi}</td>
                      <td className="table_amount"> x {parseInt(amounty) + 1}</td>
                    </tr>
                    {(form == 'u' || form == 'l') && (
                      <tr>
                        <td>{finalarr[73][0]}</td>
                        <td>
                          <img src={finalarr[73][2]} width="48px" />
                        </td>
                        <td>{measureglasl}</td>
                        <td className="table_amount"> x {parseInt(amount2y) + 1}</td>
                      </tr>
                    )}
                    {form == 'u' && (
                      <tr>
                        <td>{finalarr[73][0]}</td>
                        <td>
                          <img src={finalarr[73][2]} width="48px" />
                        </td>
                        <td>{measureglasu}</td>
                        <td className="table_amount"> x {parseInt(amount3y) + 1}</td>
                      </tr>
                    )}
                  </>
                )}

                {baseclampcase == 1 && (
                  <>
                    <tr>
                      <td>{finalarr[73][0]}</td>
                      <td>
                        <img src={finalarr[73][2]} width="48px" />
                      </td>
                      <td>{measureglasi}</td>
                      <td className="table_amount"> x {parseInt(amounty) + 1 + (parseInt(amount2y) + 1)}</td>
                    </tr>
                    {form == 'u' && (
                      <tr>
                        <td>{finalarr[73][0]}</td>
                        <td>
                          <img src={finalarr[73][2]} width="48px" />
                        </td>
                        <td>{measureglasu}</td>
                        <td className="table_amount"> x {parseInt(amount3y) + 1}</td>
                      </tr>
                    )}
                  </>
                )}

                {baseclampcase == 2 && (
                  <>
                    <tr>
                      <td>{finalarr[73][0]}</td>
                      <td>
                        <img src={finalarr[73][2]} width="48px" />
                      </td>
                      <td>{measureglasi}</td>
                      <td className="table_amount"> x {parseInt(amounty) + 1}</td>
                    </tr>
                    <tr>
                      <td>{finalarr[73][0]}</td>
                      <td>
                        <img src={finalarr[73][2]} width="48px" />
                      </td>
                      <td>{measureglasu}</td>
                      <td className="table_amount"> x {parseInt(amount3y) + 1 + (parseInt(amount2y) + 1)}</td>
                    </tr>
                  </>
                )}

                {baseclampcase == 3 && (
                  <>
                    <tr>
                      <td>{finalarr[73][0]}</td>
                      <td>
                        <img src={finalarr[73][2]} width="48px" />
                      </td>
                      <td>{measureglasi}</td>
                      <td className="table_amount"> x {parseInt(amounty) + 1 + (parseInt(amount3y) + 1)}</td>
                    </tr>
                    <tr>
                      <td>{finalarr[73][0]}</td>
                      <td>
                        <img src={finalarr[73][2]} width="48px" />
                      </td>
                      <td>{measureglasl}</td>
                      <td className="table_amount"> x {+(parseInt(amount2y) + 1)}</td>
                    </tr>
                  </>
                )}

                {colorr == 'brano' && baseclampsubsystem == '64' && (
                  <tr>
                    <td>{finalarr[87][0]}</td>
                    <td>
                      <img src={finalarr[87][2]} width="48px" />
                    </td>
                    <td>{finalarr[87][1]}</td>
                    <td className="table_amount"> x {baseclampamount}</td>
                  </tr>
                )}
                {colorr != 'brano' && baseclampsubsystem == '64' && (
                  <tr>
                    <td>{finalarr[88][0]}</td>
                    <td>
                      <img src={finalarr[88][2]} width="48px" />
                    </td>
                    <td>{finalarr[88][1]}</td>
                    <td className="table_amount"> x {baseclampamount}</td>
                  </tr>
                )}

                {colorr == 'brano' && baseclampsubsystem == '60' && (
                  <tr>
                    <td>{finalarr[81][0]}</td>
                    <td>
                      <img src={finalarr[81][2]} width="48px" />
                    </td>
                    <td>{finalarr[81][1]}</td>
                    <td className="table_amount"> x {baseclampamount}</td>
                  </tr>
                )}
                {colorr != 'brano' && baseclampsubsystem == '60' && (
                  <tr>
                    <td>{finalarr[82][0]}</td>
                    <td>
                      <img src={finalarr[82][2]} width="48px" />
                    </td>
                    <td>{finalarr[82][1]}</td>
                    <td className="table_amount"> x {baseclampamount}</td>
                  </tr>
                )}

                {baseclampsubsystem == '64' && (
                  <>
                    {(glassthicknessbaseclamps == '16.76mm' || glassthicknessbaseclamps == '5/8"') && (
                      <tr>
                        <td>{finalarr[89][0]}</td>
                        <td>
                          <img src={finalarr[89][2]} width="48px" />
                        </td>
                        <td>{finalarr[89][1]}</td>
                        <td className="table_amount"> x {baseclampamount}</td>
                      </tr>
                    )}
                    {(glassthicknessbaseclamps == '17.52mm' || glassthicknessbaseclamps == '11/16"') && (
                      <tr>
                        <td>{finalarr[90][0]}</td>
                        <td>
                          <img src={finalarr[90][2]} width="48px" />
                        </td>
                        <td>{finalarr[90][1]}</td>
                        <td className="table_amount"> x {baseclampamount}</td>
                      </tr>
                    )}
                    {(glassthicknessbaseclamps == '20.76mm' || glassthicknessbaseclamps == '13/16"') && (
                      <tr>
                        <td>{finalarr[91][0]}</td>
                        <td>
                          <img src={finalarr[91][2]} width="48px" />
                        </td>
                        <td>{finalarr[91][1]}</td>
                        <td className="table_amount"> x {baseclampamount}</td>
                      </tr>
                    )}
                    {(glassthicknessbaseclamps == '21.52mm' || glassthicknessbaseclamps == '27/32"') && (
                      <tr>
                        <td>{finalarr[92][0]}</td>
                        <td>
                          <img src={finalarr[92][2]} width="48px" />
                        </td>
                        <td>{finalarr[92][1]}</td>
                        <td className="table_amount"> x {baseclampamount}</td>
                      </tr>
                    )}
                  </>
                )}

                {baseclampsubsystem == '60' && (
                  <>
                    {(glassthicknessbaseclamps == '16.76mm' || glassthicknessbaseclamps == '5/8"') && (
                      <tr>
                        <td>{finalarr[85][0]}</td>
                        <td>
                          <img src={finalarr[85][2]} width="48px" />
                        </td>
                        <td>{finalarr[85][1]}</td>
                        <td className="table_amount"> x {baseclampamount}</td>
                      </tr>
                    )}
                    {(glassthicknessbaseclamps == '17.52mm' || glassthicknessbaseclamps == '11/16"') && (
                      <tr>
                        <td>{finalarr[86][0]}</td>
                        <td>
                          <img src={finalarr[86][2]} width="48px" />
                        </td>
                        <td>{finalarr[86][1]}</td>
                        <td className="table_amount"> x {baseclampamount}</td>
                      </tr>
                    )}
                  </>
                )}

                {untergrundd == 'beton' && (
                  <tr>
                    <td>{finalarr[93][0]}</td>
                    <td>
                      <img src={finalarr[93][2]} width="48px" />
                    </td>
                    <td>{finalarr[93][1]}</td>
                    <td className="table_amount">
                      {' '}
                      x {baseclampsubsystem == '60' ? baseclampamount : baseclampamount * 2}
                    </td>
                  </tr>
                )}
                {untergrundd == 'metall' && (
                  <tr>
                    <td>{finalarr[94][0]}</td>
                    <td>
                      <img src={finalarr[94][2]} width="48px" />
                    </td>
                    <td>{finalarr[94][1]}</td>
                    <td className="table_amount">
                      {' '}
                      x {baseclampsubsystem == '60' ? baseclampamount : baseclampamount * 2}
                    </td>
                  </tr>
                )}
                {untergrundd == 'metall' && (
                  <tr>
                    <td>{finalarr[95][0]}</td>
                    <td>
                      <img src={finalarr[95][2]} width="48px" />
                    </td>
                    <td>{finalarr[95][1]}</td>
                    <td className="table_amount">
                      {' '}
                      x {baseclampsubsystem == '60' ? baseclampamount : baseclampamount * 2}
                    </td>
                  </tr>
                )}
                {untergrundd == 'holz' && (
                  <tr>
                    <td>{finalarr[104][0]}</td>
                    <td>
                      <img src={finalarr[104][2]} width="48px" />
                    </td>
                    <td>{finalarr[104][1]}</td>
                    <td className="table_amount">
                      {' '}
                      x {baseclampsubsystem == '60' ? baseclampamount : baseclampamount * 2}
                    </td>
                  </tr>
                )}

                {handlaufmat != 'none' && (
                  <>
                    {amount25 > 0 &&
                      (glassthicknessbaseclamps == '16.76mm' ||
                        glassthicknessbaseclamps == '17.52mm' ||
                        glassthicknessbaseclamps == '5/8"' ||
                        glassthicknessbaseclamps == '11/16"') && (
                        <tr>
                          <td>{finalarr[96][0]}</td>
                          <td>
                            <img src={finalarr[96][2]} width="48px" />
                          </td>
                          <td>{finalarr[96][1]}</td>
                          <td className="table_amount"> x {amount25}</td>
                        </tr>
                      )}
                    {amount5 > 0 &&
                      (glassthicknessbaseclamps == '16.76mm' ||
                        glassthicknessbaseclamps == '17.52mm' ||
                        glassthicknessbaseclamps == '5/8"' ||
                        glassthicknessbaseclamps == '11/16"') && (
                        <tr>
                          <td>{finalarr[99][0]}</td>
                          <td>
                            <img src={finalarr[99][2]} width="48px" />
                          </td>
                          <td>{finalarr[99][1]}</td>
                          <td className="table_amount"> x {amount5}</td>
                        </tr>
                      )}

                    {amount25 > 0 &&
                      (glassthicknessbaseclamps == '20.76mm' ||
                        glassthicknessbaseclamps == '21.52mm' ||
                        glassthicknessbaseclamps == '13/16"' ||
                        glassthicknessbaseclamps == '27/32"') && (
                        <tr>
                          <td>{finalarr[97][0]}</td>
                          <td>
                            <img src={finalarr[97][2]} width="48px" />
                          </td>
                          <td>{finalarr[97][1]}</td>
                          <td className="table_amount"> x {amount25}</td>
                        </tr>
                      )}
                    {amount5 > 0 &&
                      (glassthicknessbaseclamps == '20.76mm' ||
                        glassthicknessbaseclamps == '21.52mm' ||
                        glassthicknessbaseclamps == '13/16"' ||
                        glassthicknessbaseclamps == '27/32"') && (
                        <tr>
                          <td>{finalarr[100][0]}</td>
                          <td>
                            <img src={finalarr[100][2]} width="48px" />
                          </td>
                          <td>{finalarr[100][1]}</td>
                          <td className="table_amount"> x {amount5}</td>
                        </tr>
                      )}

                    {(form == 'l' || form == 'u') &&
                      (glassthicknessbaseclamps == '16.76mm' ||
                        glassthicknessbaseclamps == '17.52mm' ||
                        glassthicknessbaseclamps == '5/8"' ||
                        glassthicknessbaseclamps == '11/16"') && (
                        <tr>
                          <td>{finalarr[102][0]}</td>
                          <td>
                            <img src={finalarr[102][2]} width="48px" />
                          </td>
                          <td>{finalarr[102][1]}</td>
                          <td className="table_amount"> x {form == 'l' ? 1 : 2}</td>
                        </tr>
                      )}
                    {(form == 'l' || form == 'u') &&
                      (glassthicknessbaseclamps == '20.76mm' ||
                        glassthicknessbaseclamps == '21.52mm' ||
                        glassthicknessbaseclamps == '13/16"' ||
                        glassthicknessbaseclamps == '27/32"') && (
                        <tr>
                          <td>{finalarr[103][0]}</td>
                          <td>
                            <img src={finalarr[103][2]} width="48px" />
                          </td>
                          <td>{finalarr[103][1]}</td>
                          <td className="table_amount"> x {form == 'l' ? 1 : 2}</td>
                        </tr>
                      )}
                  </>
                )}
              </table>
            </div>
          </>
        )}
        {gelaender == 'frenchbalcony' && (
          <>
            <div className={'articlelist ' + (!showmenu ? 'hide-element' : '')}>
              <div className="articlelist-inner-header">
                <h3>
                  {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[70] : 'Individual Components'}
                </h3>
                <button
                  id="closeproductlist"
                  onClick={() => {
                    if (showmenu) {
                      setshowmenu(false);
                      document.getElementById('modelcanvas2').style = 'position:relative';
                    } else {
                      setshowmenu(true);
                      document.getElementById('modelcanvas2').style = 'position:absolute';
                    }
                  }}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M19.5459 17.954C19.7572 18.1653 19.876 18.452 19.876 18.7509C19.876 19.0497 19.7572 19.3364 19.5459 19.5477C19.3346 19.7591 19.0479 19.8778 18.749 19.8778C18.4501 19.8778 18.1635 19.7591 17.9521 19.5477L12 13.5937L6.0459 19.5459C5.83455 19.7572 5.54791 19.8759 5.24902 19.8759C4.95014 19.8759 4.66349 19.7572 4.45215 19.5459C4.2408 19.3345 4.12207 19.0479 4.12207 18.749C4.12207 18.4501 4.2408 18.1635 4.45215 17.9521L10.4062 11.9999L4.45402 6.04586C4.24268 5.83451 4.12395 5.54787 4.12395 5.24898C4.12395 4.9501 4.24268 4.66345 4.45402 4.45211C4.66537 4.24076 4.95201 4.12203 5.2509 4.12203C5.54978 4.12203 5.83643 4.24076 6.04777 4.45211L12 10.4062L17.954 4.45117C18.1654 4.23983 18.452 4.12109 18.7509 4.12109C19.0498 4.12109 19.3364 4.23983 19.5478 4.45117C19.7591 4.66251 19.8778 4.94916 19.8778 5.24804C19.8778 5.54693 19.7591 5.83358 19.5478 6.04492L13.5937 11.9999L19.5459 17.954Z"
                      fill="#001020"
                    />
                  </svg>
                </button>
              </div>

              <table className="articletable">
                <tr>
                  <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[71] : 'Type'}</td>
                  <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[72] : 'Art.Image'}</td>
                  <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[73] : 'Art. No.'}</td>
                  <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[74] : 'Amount'}</td>
                </tr>
                {
                  <>
                    {fbsystem == 'EasyGlassView' && (
                      <>
                        <tr>
                          <td>{colorr != 'brano' ? finalarr[107][0] : finalarr[108][0]}</td>
                          <td>
                            <img src={colorr != 'brano' ? finalarr[107][2] : finalarr[108][2]} width="48px" />
                          </td>
                          <td>{colorr != 'brano' ? finalarr[107][1] : finalarr[108][1]}</td>
                          <td className="table_amount"> x 1</td>
                        </tr>
                        <tr>
                          <td>{finalarr[73][0]}</td>
                          <td>
                            <img src={finalarr[73][2]} width="48px" />
                          </td>
                          <td>
                            {para.count != 'en-us' && para.count != 'es-us' && (
                              <>
                                {fenstermontage == 'Inset' ? parseInt(Fbcustomglaswidth) : parseInt(Fbcustomglaswidth)}
                                x1100x17.52mm
                              </>
                            )}
                            {(para.count == 'en-us' || para.count == 'es-us') && (
                              <>{parseFloat(Fbcustomglaswidth).toFixed(2)}x43.3x11/16"</>
                            )}
                          </td>
                          <td className="table_amount"> x 1</td>
                        </tr>
                        {handlaufmat == 'edgep' && (
                          <tr>
                            <td>{colorr != 'brano' ? finalarr[109][0] : finalarr[110][0]}</td>
                            <td>
                              <img src={colorr != 'brano' ? finalarr[109][2] : finalarr[110][2]} width="48px" />
                            </td>
                            <td>{colorr != 'brano' ? finalarr[109][1] : finalarr[110][1]}</td>
                            <td className="table_amount"> x 1</td>
                          </tr>
                        )}
                        <tr>
                          <td>{colorr != 'bogus' ? finalarr[287][0] : finalarr[287][0]}</td>
                          <td>
                            <img src={colorr != 'bogus' ? finalarr[287][2] : finalarr[287][2]} width="48px" />
                          </td>
                          <td>{colorr != 'bogus' ? finalarr[287][1] : finalarr[287][1]}</td>
                          <td className="table_amount"> x 1</td>
                        </tr>

                        {AnkerImAngebot && (
                          <tr>
                            <td>{finalarr[115][0]}</td>
                            <td>
                              <img src={finalarr[115][2]} width="48px" />
                            </td>
                            <td>{finalarr[115][1]}</td>
                            <td className="table_amount"> x 4</td>
                          </tr>
                        )}
                      </>
                    )}
                    {fbsystem == 'Mod6507' && (
                      <>
                        <tr>
                          <td>{colorr != 'brano' ? finalarr[111][0] : finalarr[111][0]}</td>
                          <td>
                            <img src={colorr != 'brano' ? finalarr[111][2] : finalarr[111][2]} width="48px" />
                          </td>
                          <td>{colorr != 'brano' ? finalarr[111][1] : finalarr[111][1]}</td>
                          <td className="table_amount"> x 2</td>
                        </tr>
                        <tr>
                          <td>{colorr != 'brano' ? finalarr[112][0] : finalarr[112][0]}</td>
                          <td>
                            <img src={colorr != 'brano' ? finalarr[112][2] : finalarr[112][2]} width="48px" />
                          </td>
                          <td>{colorr != 'brano' ? finalarr[112][1] : finalarr[112][1]}</td>
                          <td className="table_amount"> x 2</td>
                        </tr>

                        <tr>
                          <td>{colorr != 'brano' ? finalarr[113][0] : finalarr[113][0]}</td>
                          <td>
                            <img src={colorr != 'brano' ? finalarr[113][2] : finalarr[113][2]} width="48px" />
                          </td>
                          <td>{colorr != 'brano' ? finalarr[113][1] : finalarr[113][1]}</td>
                          <td className="table_amount"> x 1</td>
                        </tr>
                        <tr>
                          <td>{colorr != 'brano' ? finalarr[114][0] : finalarr[114][0]}</td>
                          <td>
                            <img src={colorr != 'brano' ? finalarr[114][2] : finalarr[114][2]} width="48px" />
                          </td>
                          <td>{colorr != 'brano' ? finalarr[114][1] : finalarr[114][1]}</td>
                          <td className="table_amount"> x 1</td>
                        </tr>
                        <tr>
                          <td>{finalarr[73][0]}</td>
                          <td>
                            <img src={finalarr[73][2]} width="48px" />
                          </td>
                          <td>
                            {fenstermontage == 'Inset' ? parseInt(Fbcustomglaswidth) : parseInt(Fbcustomglaswidth)}
                            x1100x17.52mm
                          </td>
                          <td className="table_amount"> x 1</td>
                        </tr>
                        {AnkerImAngebot && (
                          <tr>
                            <td>{finalarr[115][0]}</td>
                            <td>
                              <img src={finalarr[115][2]} width="48px" />
                            </td>
                            <td>{finalarr[115][1]}</td>
                            <td className="table_amount"> x 4</td>
                          </tr>
                        )}
                      </>
                    )}
                  </>
                }
              </table>
            </div>
          </>
        )}
        {/*Start ArticleList QLine SquareLineJump qljump */}
        {gelaender == 'qline' && (
          <>
            <div className={'articlelist ' + (!showmenu ? 'hide-element' : '')}>
              <div className="articlelist-inner-header">
                <h3>
                  {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[70] : 'Individual Components'}
                </h3>
                <button
                  id="closeproductlist"
                  onClick={() => {
                    if (showmenu) {
                      setshowmenu(false);
                      document.getElementById('modelcanvas2').style = 'position:relative';
                    } else {
                      setshowmenu(true);
                      document.getElementById('modelcanvas2').style = 'position:absolute';
                    }
                  }}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M19.5459 17.954C19.7572 18.1653 19.876 18.452 19.876 18.7509C19.876 19.0497 19.7572 19.3364 19.5459 19.5477C19.3346 19.7591 19.0479 19.8778 18.749 19.8778C18.4501 19.8778 18.1635 19.7591 17.9521 19.5477L12 13.5937L6.0459 19.5459C5.83455 19.7572 5.54791 19.8759 5.24902 19.8759C4.95014 19.8759 4.66349 19.7572 4.45215 19.5459C4.2408 19.3345 4.12207 19.0479 4.12207 18.749C4.12207 18.4501 4.2408 18.1635 4.45215 17.9521L10.4062 11.9999L4.45402 6.04586C4.24268 5.83451 4.12395 5.54787 4.12395 5.24898C4.12395 4.9501 4.24268 4.66345 4.45402 4.45211C4.66537 4.24076 4.95201 4.12203 5.2509 4.12203C5.54978 4.12203 5.83643 4.24076 6.04777 4.45211L12 10.4062L17.954 4.45117C18.1654 4.23983 18.452 4.12109 18.7509 4.12109C19.0498 4.12109 19.3364 4.23983 19.5478 4.45117C19.7591 4.66251 19.8778 4.94916 19.8778 5.24804C19.8778 5.54693 19.7591 5.83358 19.5478 6.04492L13.5937 11.9999L19.5459 17.954Z"
                      fill="#001020"
                    />
                  </svg>
                </button>
              </div>

              <table className="articletable">
                <tr>
                  <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[71] : 'Type'}</td>
                  <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[72] : 'Art.Image'}</td>
                  <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[73] : 'Art. No.'}</td>
                  <td>{infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[74] : 'Amount'}</td>
                </tr>
                {
                  <>
                    {colorr != 'satin304' && (
                      <>
                        {/*Posts */}
                        {PostShape == 'round' && Pfostenrund == '42' && montageart == 'top' && (
                          <tr>
                            <td>{finalarr[207][0]}</td>
                            <td>
                              <img src={finalarr[207][2]} width="48px" />
                            </td>
                            <td>{finalarr[207][1]}</td>
                            <td className="table_amount"> x {postamount}</td>
                          </tr>
                        )}
                        {PostShape == 'round' && Pfostenrund == '48' && montageart == 'top' && (
                          <tr>
                            <td>{finalarr[206][0]}</td>
                            <td>
                              <img src={finalarr[206][2]} width="48px" />
                            </td>
                            <td>{finalarr[206][1]}</td>
                            <td className="table_amount"> x {postamount}</td>
                          </tr>
                        )}
                        {PostShape == 'round' && Pfostenrund == '42' && montageart != 'top' && (
                          <tr>
                            <td>{finalarr[209][0]}</td>
                            <td>
                              <img src={finalarr[209][2]} width="48px" />
                            </td>
                            <td>{finalarr[209][1]}</td>
                            <td className="table_amount"> x {postamount}</td>
                          </tr>
                        )}
                        {PostShape == 'round' && Pfostenrund == '48' && montageart != 'top' && (
                          <tr>
                            <td>{finalarr[208][0]}</td>
                            <td>
                              <img src={finalarr[208][2]} width="48px" />
                            </td>
                            <td>{finalarr[208][1]}</td>
                            <td className="table_amount"> x {postamount}</td>
                          </tr>
                        )}
                        {PostShape == '40x40' && montageart == 'top' && (
                          <tr>
                            <td>{finalarr[236][0]}</td>
                            <td>
                              <img src={finalarr[236][2]} width="48px" />
                            </td>
                            <td>{finalarr[236][1]}</td>
                            <td className="table_amount"> x {postamount}</td>
                          </tr>
                        )}
                        {PostShape == '60x30' && montageart == 'top' && (
                          <tr>
                            <td>{finalarr[235][0]}</td>
                            <td>
                              <img src={finalarr[235][2]} width="48px" />
                            </td>
                            <td>{finalarr[235][1]}</td>
                            <td className="table_amount"> x {postamount}</td>
                          </tr>
                        )}
                        {PostShape == '40x40' && montageart != 'top' && (
                          <tr>
                            <td>{finalarr[234][0]}</td>
                            <td>
                              <img src={finalarr[234][2]} width="48px" />
                            </td>
                            <td>{finalarr[234][1]}</td>
                            <td className="table_amount"> x {postamount}</td>
                          </tr>
                        )}
                        {PostShape == '60x30' && montageart != 'top' && (
                          <tr>
                            <td>{finalarr[237][0]}</td>
                            <td>
                              <img src={finalarr[237][2]} width="48px" />
                            </td>
                            <td>{finalarr[237][1]}</td>
                            <td className="table_amount"> x {postamount}</td>
                          </tr>
                        )}
                        {/*Handrail  */}
                        {handlaufmat == 'round' && (
                          <>
                            <tr>
                              <td>{Pfostenrund == '42' ? finalarr[203][0] : finalarr[205][0]} </td>
                              <td>
                                <img src={Pfostenrund == '42' ? finalarr[203][2] : finalarr[205][2]} width="48px" />
                              </td>
                              <td>{Pfostenrund == '42' ? finalarr[203][1] : finalarr[205][1]}</td>
                              <td className="table_amount"> x {handrailnumber}</td>
                            </tr>
                            {form != 'i' && (
                              <tr>
                                <td>{Pfostenrund == '42' ? finalarr[177][0] : finalarr[178][0]} </td>
                                <td>
                                  <img src={Pfostenrund == '42' ? finalarr[177][2] : finalarr[178][2]} width="48px" />
                                </td>
                                <td>{Pfostenrund == '42' ? finalarr[177][1] : finalarr[178][1]}</td>
                                <td className="table_amount"> x {form == 'u' ? 2 : 1}</td>
                              </tr>
                            )}
                          </>
                        )}

                        {handlaufmat == 'square' && (
                          <>
                            <tr>
                              <td>{finalarr[231][0]} </td>
                              <td>
                                <img src={finalarr[231][2]} width="48px" />
                              </td>
                              <td>{finalarr[231][1]}</td>
                              <td className="table_amount"> x {handrailnumber}</td>
                            </tr>
                            {form != 'i' && (
                              <tr>
                                <td>{finalarr[219][0]} </td>
                                <td>
                                  <img src={finalarr[219][2]} width="48px" />
                                </td>
                                <td>{finalarr[219][1]}</td>
                                <td className="table_amount"> x {form == 'u' ? 2 : 1}</td>
                              </tr>
                            )}
                          </>
                        )}
                        {handlaufmat == '60x30' && (
                          <>
                            <tr>
                              <td>{finalarr[233][0]} </td>
                              <td>
                                <img src={finalarr[233][2]} width="48px" />
                              </td>
                              <td>{finalarr[233][1]}</td>
                              <td className="table_amount"> x {handrailnumber}</td>
                            </tr>
                            {form != 'i' && (
                              <tr>
                                <td>{finalarr[220][0]} </td>
                                <td>
                                  <img src={finalarr[220][2]} width="48px" />
                                </td>
                                <td>{finalarr[220][1]}</td>
                                <td className="table_amount"> x {form == 'u' ? 2 : 1}</td>
                              </tr>
                            )}
                          </>
                        )}
                        {/* Glass oder horizontal bars */}
                        {(qlineinfill == 'glass' || qlineinfill == 'plates') && (
                          <>
                            {PostShape == 'round' && Pfostenrund == '42' && (
                              <>
                                {ClampShape == 'round' && (
                                  <tr>
                                    <td>{finalarr[213][0]}</td>
                                    <td>
                                      <img src={finalarr[213][2]} width="48px" />
                                    </td>
                                    <td>{finalarr[213][1]}</td>
                                    <td className="table_amount">
                                      {' '}
                                      x{' '}
                                      {
                                        <>
                                          {form == 'i'
                                            ? postamount * 4 - 4
                                            : form == 'l'
                                              ? postamount * 4 - 4
                                              : postamount * 4 - 4}
                                        </>
                                      }
                                    </td>
                                  </tr>
                                )}
                                {ClampShape != 'round' && (
                                  <tr>
                                    <td>{finalarr[216][0]}</td>
                                    <td>
                                      <img src={finalarr[216][2]} width="48px" />
                                    </td>
                                    <td>{finalarr[216][1]}</td>
                                    <td className="table_amount">
                                      {' '}
                                      x{' '}
                                      {
                                        <>
                                          {form == 'i'
                                            ? postamount * 4 - 4
                                            : form == 'l'
                                              ? postamount * 4 - 4
                                              : postamount * 4 - 4}
                                        </>
                                      }
                                    </td>
                                  </tr>
                                )}
                              </>
                            )}
                            {PostShape == 'round' && Pfostenrund == '48' && (
                              <>
                                {ClampShape == 'round' && (
                                  <tr>
                                    <td>{finalarr[214][0]}</td>
                                    <td>
                                      <img src={finalarr[214][2]} width="48px" />
                                    </td>
                                    <td>{finalarr[214][1]}</td>
                                    <td className="table_amount">
                                      {' '}
                                      x{' '}
                                      {
                                        <>
                                          {form == 'i'
                                            ? postamount * 4 - 4
                                            : form == 'l'
                                              ? postamount * 4 - 4
                                              : postamount * 4 - 4}
                                        </>
                                      }
                                    </td>
                                  </tr>
                                )}
                                {ClampShape != 'round' && (
                                  <tr>
                                    <td>{finalarr[217][0]}</td>
                                    <td>
                                      <img src={finalarr[217][2]} width="48px" />
                                    </td>
                                    <td>{finalarr[217][1]}</td>
                                    <td className="table_amount">
                                      {' '}
                                      x{' '}
                                      {
                                        <>
                                          {form == 'i'
                                            ? postamount * 4 - 4
                                            : form == 'l'
                                              ? postamount * 4 - 4
                                              : postamount * 4 - 4}
                                        </>
                                      }
                                    </td>
                                  </tr>
                                )}
                              </>
                            )}
                            {(PostShape == '40x40' || PostShape == '60x30') && (
                              <>
                                {ClampShape == 'round' && (
                                  <tr>
                                    <td>{finalarr[264][0]}</td>
                                    <td>
                                      <img src={finalarr[264][2]} width="48px" />
                                    </td>
                                    <td>{finalarr[264][1]}</td>
                                    <td className="table_amount">
                                      {' '}
                                      x{' '}
                                      {
                                        <>
                                          {form == 'i'
                                            ? postamount * 4 - 4
                                            : form == 'l'
                                              ? postamount * 4 - 4
                                              : postamount * 4 - 4}
                                        </>
                                      }
                                    </td>
                                  </tr>
                                )}
                                {ClampShape != 'round' && (
                                  <tr>
                                    <td>{finalarr[275][0]}</td>
                                    <td>
                                      <img src={finalarr[275][2]} width="48px" />
                                    </td>
                                    <td>{finalarr[275][1]}</td>
                                    <td className="table_amount">
                                      {' '}
                                      x{' '}
                                      {
                                        <>
                                          {form == 'i'
                                            ? postamount * 4 - 4
                                            : form == 'l'
                                              ? postamount * 4 - 4
                                              : postamount * 4 - 4}
                                        </>
                                      }
                                    </td>
                                  </tr>
                                )}
                              </>
                            )}
                            {((form != 'i' && montageart != 'top') ||
                              (form != 'i' && montageart == 'top' && PostShape == '60x30')) && (
                              <>
                                {ClampShape == 'round' && (
                                  <tr>
                                    <td>{finalarr[215][0]}</td>
                                    <td>
                                      <img src={finalarr[215][2]} width="48px" />
                                    </td>
                                    <td>{finalarr[215][1]}</td>
                                    <td className="table_amount"> x {<>{form == 'l' ? 2 : 4}</>}</td>
                                  </tr>
                                )}
                                {ClampShape != 'round' && (
                                  <tr>
                                    <td>{finalarr[218][0]}</td>
                                    <td>
                                      <img src={finalarr[218][2]} width="48px" />
                                    </td>
                                    <td>{finalarr[218][1]}</td>
                                    <td className="table_amount"> x {<>{form == 'l' ? 2 : 4}</>}</td>
                                  </tr>
                                )}
                              </>
                            )}
                            {/*SecurityPin */}
                            {montageart != 'top' && (
                              <tr>
                                <td>{finalarr[255][0]}</td>
                                <td>
                                  <img src={finalarr[255][2]} width="48px" />
                                </td>
                                <td>{finalarr[255][1]}</td>
                                <td className="table_amount">
                                  {' '}
                                  x{' '}
                                  {form == 'i'
                                    ? postamount * 4 - 4
                                    : form == 'l'
                                      ? postamount * 4 + 4
                                      : postamount * 4 + 4}
                                </td>
                              </tr>
                            )}
                            {/* RubberInlay*/}

                            {ClampShape != 'round' && (
                              <tr>
                                <td>{qlineinfill == 'plates' ? finalarr[259][0] : finalarr[260][0]}</td>
                                <td>
                                  <img
                                    src={qlineinfill == 'plates' ? finalarr[259][2] : finalarr[260][2]}
                                    width="48px"
                                  />
                                </td>
                                <td>{qlineinfill == 'plates' ? finalarr[259][1] : finalarr[260][1]}</td>
                                <td className="table_amount"> x {rubberamount}</td>
                              </tr>
                            )}
                            {ClampShape == 'round' && (
                              <tr>
                                <td>{qlineinfill == 'plates' ? finalarr[256][0] : finalarr[258][0]}</td>
                                <td>
                                  <img
                                    src={qlineinfill == 'plates' ? finalarr[256][2] : finalarr[258][2]}
                                    width="48px"
                                  />
                                </td>
                                <td>{qlineinfill == 'plates' ? finalarr[256][1] : finalarr[258][1]}</td>
                                <td className="table_amount"> x {rubberamount}</td>
                              </tr>
                            )}
                            {/*ClampScrews*/}
                            <tr>
                              <td>{qlineinfill == 'plates' ? finalarr[280][0] : finalarr[280][0]}</td>
                              <td>
                                <img src={qlineinfill == 'plates' ? finalarr[280][2] : finalarr[280][2]} width="48px" />
                              </td>
                              <td>{qlineinfill == 'plates' ? finalarr[280][1] : finalarr[280][1]}</td>
                              <td className="table_amount">
                                {' '}
                                x{' '}
                                {form == 'i'
                                  ? postamount * 4 - 4
                                  : form == 'l'
                                    ? postamount * 4 - 4
                                    : postamount * 4 - 4}
                              </td>
                            </tr>
                          </>
                        )}

                        {qlineinfill == 'verticalbars' && (
                          <>
                            {baramount5 >= 1 && (
                              <tr>
                                <td>{finalarr[212][0]} </td>
                                <td>
                                  <img src={finalarr[212][2]} width="48px" />
                                </td>
                                <td>{finalarr[212][1]}</td>
                                <td className="table_amount"> x {baramount5 * 10}</td>
                              </tr>
                            )}
                            {baramount25 >= 1 && (
                              <tr>
                                <td>{finalarr[211][0]} </td>
                                <td>
                                  <img src={finalarr[211][2]} width="48px" />
                                </td>
                                <td>{finalarr[211][1]}</td>
                                <td className="table_amount"> x {baramount25 * 10}</td>
                              </tr>
                            )}

                            {PostShape == 'round' && (
                              <>
                                {Pfostenrund == '48' && (
                                  <>
                                    <tr>
                                      <td>{finalarr[196][0]} </td>
                                      <td>
                                        <img src={finalarr[196][2]} width="48px" />
                                      </td>
                                      <td>{finalarr[196][1]}</td>
                                      <td className="table_amount">
                                        {' '}
                                        x{' '}
                                        {montageart == 'top' ? (
                                          <>{form == 'i' ? 10 : form == 'l' ? 20 : 30}</>
                                        ) : (
                                          <>{form == 'i' ? 10 : form == 'l' ? 10 : 10}</>
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>{finalarr[198][0]} </td>
                                      <td>
                                        <img src={finalarr[198][2]} width="48px" />
                                      </td>
                                      <td>{finalarr[198][1]}</td>
                                      <td className="table_amount">
                                        {' '}
                                        x{' '}
                                        {montageart == 'top' ? (
                                          <>{form == 'i' ? 10 : form == 'l' ? 20 : 30}</>
                                        ) : (
                                          <>{form == 'i' ? 10 : form == 'l' ? 10 : 10}</>
                                        )}
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>{finalarr[196][0]} </td>
                                      <td>
                                        <img src={finalarr[196][2]} width="48px" />
                                      </td>
                                      <td>{finalarr[196][1]}</td>
                                      <td className="table_amount">
                                        {' '}
                                        x{' '}
                                        {montageart == 'top' ? (
                                          <>
                                            {form == 'i'
                                              ? (postamount - 2) * 10
                                              : form == 'l'
                                                ? (postamount - 3) * 10
                                                : (postamount - 4) * 10}
                                          </>
                                        ) : (
                                          <>
                                            {form == 'i'
                                              ? postamount * 10 - 20
                                              : form == 'l'
                                                ? postamount * 10 - 20
                                                : postamount * 10 - 20}
                                          </>
                                        )}
                                      </td>
                                    </tr>
                                  </>
                                )}
                                {Pfostenrund == '42' && (
                                  <>
                                    <tr>
                                      <td>{finalarr[197][0]} </td>
                                      <td>
                                        <img src={finalarr[197][2]} width="48px" />
                                      </td>
                                      <td>{finalarr[197][1]}</td>
                                      <td className="table_amount">
                                        {' '}
                                        x{' '}
                                        {montageart == 'top' ? (
                                          <>{form == 'i' ? 10 : form == 'l' ? 20 : 30}</>
                                        ) : (
                                          <>{form == 'i' ? 10 : form == 'l' ? 10 : 10}</>
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>{finalarr[199][0]} </td>
                                      <td>
                                        <img src={finalarr[199][2]} width="48px" />
                                      </td>
                                      <td>{finalarr[199][1]}</td>
                                      <td className="table_amount">
                                        {' '}
                                        x{' '}
                                        {montageart == 'top' ? (
                                          <>{form == 'i' ? 10 : form == 'l' ? 20 : 30}</>
                                        ) : (
                                          <>{form == 'i' ? 10 : form == 'l' ? 10 : 10}</>
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>{finalarr[195][0]} </td>
                                      <td>
                                        <img src={finalarr[195][2]} width="48px" />
                                      </td>
                                      <td>{finalarr[195][1]}</td>
                                      <td className="table_amount">
                                        {' '}
                                        x{' '}
                                        {montageart == 'top' ? (
                                          <>
                                            {form == 'i'
                                              ? (postamount - 2) * 10
                                              : form == 'l'
                                                ? (postamount - 3) * 10
                                                : (postamount - 4) * 10}
                                          </>
                                        ) : (
                                          <>
                                            {form == 'i'
                                              ? postamount * 10 - 20
                                              : form == 'l'
                                                ? postamount * 10 - 20
                                                : postamount * 10 - 20}
                                          </>
                                        )}
                                      </td>
                                    </tr>
                                  </>
                                )}
                                {/*Screws Horz. Bars */}
                                <tr>
                                  <td>{finalarr[280][0]} </td>
                                  <td>
                                    <img src={finalarr[280][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[280][1]}</td>
                                  <td className="table_amount">
                                    {' '}
                                    x{' '}
                                    <>
                                      {(montageart != 'top' || PostShape == '60x30') && postamount * 10}
                                      {montageart == 'top' && PostShape != '60x30' && (
                                        <>
                                          {form == 'i'
                                            ? postamount * 10
                                            : form == 'l'
                                              ? postamount * 10 + 10
                                              : postamount * 10 + 20}
                                        </>
                                      )}
                                    </>
                                  </td>
                                </tr>
                              </>
                            )}
                            {PostShape != 'round' && (
                              <>
                                <tr>
                                  <td>{finalarr[271][0]} </td>
                                  <td>
                                    <img src={finalarr[271][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[271][1]}</td>
                                  <td className="table_amount">
                                    {' '}
                                    x{' '}
                                    {montageart == 'top' && PostShape != '60x30' ? (
                                      <>{form == 'i' ? 10 : form == 'l' ? 20 : 30}</>
                                    ) : (
                                      <>{form == 'i' ? 10 : form == 'l' ? 10 : 10}</>
                                    )}
                                  </td>
                                </tr>

                                <tr>
                                  <td>{finalarr[273][0]} </td>
                                  <td>
                                    <img src={finalarr[273][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[273][1]}</td>
                                  <td className="table_amount">
                                    {' '}
                                    x{' '}
                                    {montageart == 'top' && PostShape != '60x30' ? (
                                      <>{form == 'i' ? 10 : form == 'l' ? 20 : 30}</>
                                    ) : (
                                      <>{form == 'i' ? 10 : form == 'l' ? 10 : 10}</>
                                    )}
                                  </td>
                                </tr>

                                <tr>
                                  <td>{finalarr[269][0]} </td>
                                  <td>
                                    <img src={finalarr[269][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[269][1]}</td>
                                  <td className="table_amount">
                                    {' '}
                                    x{' '}
                                    {montageart == 'top' && PostShape != '60x30' ? (
                                      <>
                                        {form == 'i'
                                          ? (postamount - 2) * 10
                                          : form == 'l'
                                            ? (postamount - 3) * 10
                                            : (postamount - 4) * 10}
                                      </>
                                    ) : (
                                      <>
                                        {form == 'i'
                                          ? postamount * 10 - 20
                                          : form == 'l'
                                            ? postamount * 10 - 20
                                            : postamount * 10 - 20}
                                      </>
                                    )}
                                  </td>
                                </tr>
                              </>
                            )}
                            {((form != 'i' && montageart != 'top') || PostShape == '60x30') && (
                              <>
                                <tr>
                                  <td>{finalarr[210][0]} </td>
                                  <td>
                                    <img src={finalarr[210][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[210][1]}</td>
                                  <td className="table_amount"> x {form == 'l' ? 10 : 20}</td>
                                </tr>
                              </>
                            )}
                          </>
                        )}
                        {/*Flanges */}
                        {montageart != 'top' && (
                          <>
                            {PostShape == 'round' && Pfostenrund == '42' && (
                              <tr>
                                <td>{finalarr[185][0]} </td>
                                <td>
                                  <img src={finalarr[185][2]} width="48px" />
                                </td>
                                <td>{finalarr[185][1]}</td>
                                <td className="table_amount"> x {postamount}</td>
                              </tr>
                            )}
                            {PostShape == 'round' && Pfostenrund == '48' && (
                              <tr>
                                <td>{finalarr[186][0]} </td>
                                <td>
                                  <img src={finalarr[186][2]} width="48px" />
                                </td>
                                <td>{finalarr[186][1]}</td>
                                <td className="table_amount"> x {postamount}</td>
                              </tr>
                            )}
                            {PostShape == '40x40' && (
                              <tr>
                                <td>{finalarr[225][0]} </td>
                                <td>
                                  <img src={finalarr[225][2]} width="48px" />
                                </td>
                                <td>{finalarr[225][1]}</td>
                                <td className="table_amount"> x {postamount}</td>
                              </tr>
                            )}
                            {PostShape == '60x30' && (
                              <tr>
                                <td>{finalarr[226][0]} </td>
                                <td>
                                  <img src={finalarr[226][2]} width="48px" />
                                </td>
                                <td>{finalarr[226][1]}</td>
                                <td className="table_amount"> x {postamount}</td>
                              </tr>
                            )}
                          </>
                        )}
                        {/*Cables*/}
                        {qlineinfill == 'cables' && (
                          <>
                            <tr>
                              <td>{finalarr[closestI][0]} </td>
                              <td>
                                <img src={finalarr[closestI][2]} width="48px" />
                              </td>
                              <td>{finalarr[closestI][1]}</td>
                              <td className="table_amount"> x {12}</td>
                            </tr>
                            {(form == 'u' || form == 'l') && (
                              <tr>
                                <td>{finalarr[closestL][0]} </td>
                                <td>
                                  <img src={finalarr[closestL][2]} width="48px" />
                                </td>
                                <td>{finalarr[closestL][1]}</td>
                                <td className="table_amount"> x {12}</td>
                              </tr>
                            )}
                            {form == 'u' && (
                              <tr>
                                <td>{finalarr[closestU][0]} </td>
                                <td>
                                  <img src={finalarr[closestU][2]} width="48px" />
                                </td>
                                <td>{finalarr[closestU][1]}</td>
                                <td className="table_amount"> x {12}</td>
                              </tr>
                            )}
                            <tr>
                              <td>{finalarr[262][0]} </td>
                              <td>
                                <img src={finalarr[262][2]} width="48px" />
                              </td>
                              <td>{finalarr[262][1]}</td>
                              <td className="table_amount"> x {1}</td>
                            </tr>
                            <tr>
                              <td>{finalarr[247][0]} </td>
                              <td>
                                <img src={finalarr[247][2]} width="48px" />
                              </td>
                              <td>{finalarr[247][1]}</td>
                              <td className="table_amount">
                                {' '}
                                x{' '}
                                {form == 'i'
                                  ? (postamount - 2) * 24
                                  : form == 'l'
                                    ? (postamount - 4) * 24
                                    : (postamount - 6) * 24}
                              </td>
                            </tr>
                          </>
                        )}

                        {/*Endcaps */}
                        {(!wall1 || !wall2) && (
                          <>
                            {handlaufmat == 'round' && (
                              <tr>
                                <td>{Pfostenrund == '42' ? finalarr[242][0] : finalarr[243][0]} </td>
                                <td>
                                  <img src={Pfostenrund == '42' ? finalarr[242][2] : finalarr[243][2]} width="48px" />
                                </td>
                                <td>{Pfostenrund == '42' ? finalarr[242][1] : finalarr[243][1]}</td>
                                <td className="table_amount"> x {!wall1 && !wall2 ? 2 : 1}</td>
                              </tr>
                            )}
                            {handlaufmat == 'square' && (
                              <tr>
                                <td>{finalarr[238][0]} </td>
                                <td>
                                  <img src={finalarr[238][2]} width="48px" />
                                </td>
                                <td>{finalarr[238][1]}</td>
                                <td className="table_amount"> x {!wall1 && !wall2 ? 2 : 1}</td>
                              </tr>
                            )}
                            {handlaufmat == '60x30' && (
                              <tr>
                                <td>{finalarr[239][0]} </td>
                                <td>
                                  <img src={finalarr[239][2]} width="48px" />
                                </td>
                                <td>{finalarr[239][1]}</td>
                                <td className="table_amount"> x {!wall1 && !wall2 ? 2 : 1}</td>
                              </tr>
                            )}
                          </>
                        )}
                        {/*Wallmount */}
                        {(wall1 || wall2) && (
                          <>
                            {handlaufmat == 'round' && (
                              <>
                                <tr>
                                  <td>{Pfostenrund == '42' ? finalarr[179][0] : finalarr[180][0]} </td>
                                  <td>
                                    <img src={Pfostenrund == '42' ? finalarr[179][2] : finalarr[180][2]} width="48px" />
                                  </td>
                                  <td>{Pfostenrund == '42' ? finalarr[179][1] : finalarr[180][1]}</td>
                                  <td className="table_amount"> x {wall1 && wall2 ? 2 : 1}</td>
                                </tr>
                              </>
                            )}
                            {handlaufmat == 'square' && (
                              <tr>
                                <td>{finalarr[222][0]} </td>
                                <td>
                                  <img src={finalarr[222][2]} width="48px" />
                                </td>
                                <td>{finalarr[222][1]}</td>
                                <td className="table_amount"> x {wall1 && wall2 ? 2 : 1}</td>
                              </tr>
                            )}
                            {handlaufmat == '60x30' && (
                              <tr>
                                <td>{finalarr[221][0]} </td>
                                <td>
                                  <img src={finalarr[221][2]} width="48px" />
                                </td>
                                <td>{finalarr[221][1]}</td>
                                <td className="table_amount"> x {wall1 && wall2 ? 2 : 1}</td>
                              </tr>
                            )}
                          </>
                        )}
                        {/*Handrail Brackets */}
                        {PostShape == 'round' && (
                          <>
                            {handlaufmat == 'round' && (
                              <>
                                <tr>
                                  <td>{Pfostenrund == '42' ? finalarr[189][0] : finalarr[191][0]} </td>
                                  <td>
                                    <img src={Pfostenrund == '42' ? finalarr[189][2] : finalarr[191][2]} width="48px" />
                                  </td>
                                  <td>{Pfostenrund == '42' ? finalarr[189][1] : finalarr[191][1]}</td>
                                  <td className="table_amount">
                                    x{' '}
                                    {qlineinfill != 'cables' && montageart == 'top' && (
                                      <>{form == 'u' ? postamount - 2 : form == 'l' ? postamount - 1 : postamount}</>
                                    )}
                                    {(qlineinfill == 'cables' || montageart != 'top') && (
                                      <>{form == 'u' ? postamount : form == 'l' ? postamount : postamount}</>
                                    )}
                                  </td>
                                </tr>
                                {form != 'i' && qlineinfill != 'cables' && montageart == 'top' && (
                                  <tr>
                                    <td>{Pfostenrund == '42' ? finalarr[190][0] : finalarr[192][0]} </td>
                                    <td>
                                      <img
                                        src={Pfostenrund == '42' ? finalarr[190][2] : finalarr[192][2]}
                                        width="48px"
                                      />
                                    </td>
                                    <td>{Pfostenrund == '42' ? finalarr[190][1] : finalarr[192][1]}</td>
                                    <td className="table_amount"> x {form == 'u' ? 2 : 1}</td>
                                  </tr>
                                )}
                                <tr>
                                  <td>{finalarr[278][0]} </td>
                                  <td>
                                    <img src={finalarr[278][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[278][1]}</td>
                                  <td className="table_amount">
                                    {' '}
                                    x {montageart == 'top' && <>{postamount * 2}</>}
                                    {montageart != 'top' && <>{postamount * 2}</>}
                                  </td>
                                </tr>
                              </>
                            )}
                          </>
                        )}
                        {PostShape == '40x40' && (
                          <>
                            {(handlaufmat == 'square' || handlaufmat == '60x30') && (
                              <>
                                <tr>
                                  <td>{finalarr[227][0]} </td>
                                  <td>
                                    <img src={finalarr[227][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[227][1]}</td>
                                  <td className="table_amount">
                                    {' '}
                                    x{' '}
                                    {montageart == 'top' && (
                                      <>{form == 'u' ? postamount - 2 : form == 'l' ? postamount - 1 : postamount}</>
                                    )}
                                    {montageart != 'top' && (
                                      <>{form == 'u' ? postamount : form == 'l' ? postamount : postamount}</>
                                    )}
                                  </td>
                                </tr>
                                {form != 'i' && montageart == 'top' && (
                                  <tr>
                                    <td>{finalarr[228][0]} </td>
                                    <td>
                                      <img src={finalarr[228][2]} width="48px" />
                                    </td>
                                    <td>{finalarr[228][1]}</td>
                                    <td className="table_amount"> x {form == 'u' ? 2 : 1}</td>
                                  </tr>
                                )}
                                <tr>
                                  <td>{finalarr[279][0]} </td>
                                  <td>
                                    <img src={finalarr[279][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[279][1]}</td>
                                  <td className="table_amount">
                                    {' '}
                                    x {montageart == 'top' && <>{postamount * 2}</>}
                                    {montageart != 'top' && <>{postamount * 2}</>}
                                  </td>
                                </tr>
                              </>
                            )}
                            {handlaufmat == 'round' && (
                              <>
                                <tr>
                                  <td>{finalarr[283][0]} </td>
                                  <td>
                                    <img src={finalarr[283][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[283][1]}</td>
                                  <td className="table_amount">
                                    {' '}
                                    x{' '}
                                    {montageart == 'top' && (
                                      <>{form == 'u' ? postamount - 2 : form == 'l' ? postamount - 1 : postamount}</>
                                    )}
                                    {montageart != 'top' && (
                                      <>{form == 'u' ? postamount : form == 'l' ? postamount : postamount}</>
                                    )}
                                  </td>
                                </tr>
                                {form != 'i' && montageart == 'top' && (
                                  <tr>
                                    <td>{finalarr[285][0]} </td>
                                    <td>
                                      <img src={finalarr[285][2]} width="48px" />
                                    </td>
                                    <td>{finalarr[285][1]}</td>
                                    <td className="table_amount"> x {form == 'u' ? 2 : 1}</td>
                                  </tr>
                                )}
                                <tr>
                                  <td>{finalarr[278][0]} </td>
                                  <td>
                                    <img src={finalarr[278][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[278][1]}</td>
                                  <td className="table_amount">
                                    {' '}
                                    x {montageart == 'top' && <>{postamount * 2}</>}
                                    {montageart != 'top' && <>{postamount * 2}</>}
                                  </td>
                                </tr>
                              </>
                            )}
                          </>
                        )}
                        {PostShape == '60x30' && (
                          <>
                            {(handlaufmat == 'square' || handlaufmat == '60x30') && (
                              <>
                                <tr>
                                  <td>{finalarr[229][0]} </td>
                                  <td>
                                    <img src={finalarr[229][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[229][1]}</td>
                                  <td className="table_amount"> x {postamount}</td>
                                </tr>
                                <tr>
                                  <td>{finalarr[279][0]} </td>
                                  <td>
                                    <img src={finalarr[279][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[279][1]}</td>
                                  <td className="table_amount">
                                    {' '}
                                    x {montageart == 'top' && <>{postamount * 2}</>}
                                    {montageart != 'top' && <>{postamount * 2}</>}
                                  </td>
                                </tr>
                              </>
                            )}
                            {handlaufmat == 'round' && (
                              <>
                                <tr>
                                  <td>{finalarr[282][0]} </td>
                                  <td>
                                    <img src={finalarr[282][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[282][1]}</td>
                                  <td className="table_amount"> x {postamount}</td>
                                </tr>
                              </>
                            )}
                            <tr>
                              <td>{finalarr[279][0]} </td>
                              <td>
                                <img src={finalarr[279][2]} width="48px" />
                              </td>
                              <td>{finalarr[279][1]}</td>
                              <td className="table_amount">
                                {' '}
                                x {montageart == 'top' && <>{postamount * 2}</>}
                                {montageart != 'top' && <>{postamount * 2}</>}
                              </td>
                            </tr>
                          </>
                        )}

                        {/*CoverCaps */}
                        {PostShape == 'round' && (
                          <>
                            {montageart == 'top' && (
                              <>
                                <tr>
                                  <td>{Pfostenrund == '42' ? finalarr[183][0] : finalarr[184][0]} </td>
                                  <td>
                                    <img src={Pfostenrund == '42' ? finalarr[183][2] : finalarr[184][2]} width="48px" />
                                  </td>
                                  <td>{Pfostenrund == '42' ? finalarr[183][1] : finalarr[184][1]}</td>
                                  <td className="table_amount"> x {postamount}</td>
                                </tr>
                              </>
                            )}
                          </>
                        )}
                        {PostShape == '40x40' && (
                          <>
                            {montageart == 'top' && (
                              <>
                                <tr>
                                  <td>{finalarr[223][0]} </td>
                                  <td>
                                    <img src={finalarr[223][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[223][1]}</td>
                                  <td className="table_amount"> x {postamount}</td>
                                </tr>
                              </>
                            )}
                          </>
                        )}
                        {PostShape == '60x30' && (
                          <>
                            {montageart == 'top' && (
                              <>
                                <tr>
                                  <td>{finalarr[224][0]} </td>
                                  <td>
                                    <img src={finalarr[224][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[224][1]}</td>
                                  <td className="table_amount"> x {postamount}</td>
                                </tr>
                              </>
                            )}
                          </>
                        )}

                        {/*FasciaPostEndcaps */}

                        {PostShape == 'round' && (
                          <>
                            {montageart != 'top' && (
                              <>
                                <tr>
                                  <td>{Pfostenrund == '42' ? finalarr[242][0] : finalarr[243][0]} </td>
                                  <td>
                                    <img src={Pfostenrund == '42' ? finalarr[242][2] : finalarr[243][2]} width="48px" />
                                  </td>
                                  <td>{Pfostenrund == '42' ? finalarr[242][1] : finalarr[243][1]}</td>
                                  <td className="table_amount"> x {postamount}</td>
                                </tr>
                              </>
                            )}
                          </>
                        )}
                        {PostShape == '40x40' && (
                          <>
                            {montageart != 'top' && (
                              <>
                                <tr>
                                  <td>{finalarr[238][0]} </td>
                                  <td>
                                    <img src={finalarr[238][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[238][1]}</td>
                                  <td className="table_amount"> x {postamount}</td>
                                </tr>
                              </>
                            )}
                          </>
                        )}
                        {PostShape == '60x30' && (
                          <>
                            {montageart != 'top' && (
                              <>
                                <tr>
                                  <td>{finalarr[154][0]} </td>
                                  <td>
                                    <img src={finalarr[154][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[154][1]}</td>
                                  <td className="table_amount"> x {postamount}</td>
                                </tr>
                              </>
                            )}
                          </>
                        )}

                        {/*TubeConnector */}
                        {(form == 'i' && len1 > 5000) ||
                          (form == 'l' && (len1 > 5000 || len2 > 5000)) ||
                          (form == 'u' && (len1 > 5000 || len2 > 5000 || len3 > 5000) && (
                            <>
                              {handlaufmat == 'square' && (
                                <tr>
                                  <td>{finalarr[245][0]} </td>
                                  <td>
                                    <img src={finalarr[245][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[245][1]}</td>
                                  <td className="table_amount"> x {amountConnectors}</td>
                                </tr>
                              )}
                              {handlaufmat == '60x30' && (
                                <tr>
                                  <td>{finalarr[246][0]} </td>
                                  <td>
                                    <img src={finalarr[246][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[246][1]}</td>
                                  <td className="table_amount"> x {amountConnectors}</td>
                                </tr>
                              )}
                              {handlaufmat == 'round' && (
                                <tr>
                                  <td>{Pfostenrund == '42' ? finalarr[176][0] : finalarr[277][0]} </td>
                                  <td>
                                    <img src={Pfostenrund == '42' ? finalarr[176][2] : finalarr[277][2]} width="48px" />
                                  </td>
                                  <td>{Pfostenrund == '42' ? finalarr[176][1] : finalarr[277][1]}</td>
                                  <td className="table_amount"> x {amountConnectors}</td>
                                </tr>
                              )}
                            </>
                          ))}

                        <tr>
                          <td>{finalarr[21][0]}</td>
                          <td>
                            <img src={finalarr[21][2]} width="48px" />
                          </td>
                          <td>{finalarr[21][1]}</td>
                          <td className="table_amount"> x 1</td>
                        </tr>
                        <tr>
                          <td>{finalarr[30][0]} </td>
                          <td>
                            <img src={finalarr[30][2]} width="48px" />
                          </td>
                          <td>{finalarr[30][1]}</td>
                          <td className="table_amount"> x {gesamtleng > 15000 ? 3 : gesamtleng > 15000 ? 2 : 1}</td>
                        </tr>
                      </>
                    )}

                    {colorr == 'satin304' && (
                      <>
                        {/*Posts */}
                        {PostShape == 'round' && Pfostenrund == '42' && montageart == 'top' && (
                          <tr>
                            <td>{finalarr[146][0]}</td>
                            <td>
                              <img src={finalarr[146][2]} width="48px" />
                            </td>
                            <td>{finalarr[146][1]}</td>
                            <td className="table_amount"> x {postamount}</td>
                          </tr>
                        )}
                        {PostShape == 'round' && Pfostenrund == '48' && montageart == 'top' && (
                          <tr>
                            <td>{finalarr[147][0]}</td>
                            <td>
                              <img src={finalarr[147][2]} width="48px" />
                            </td>
                            <td>{finalarr[147][1]}</td>
                            <td className="table_amount"> x {postamount}</td>
                          </tr>
                        )}
                        {PostShape == 'round' && Pfostenrund == '42' && montageart != 'top' && (
                          <tr>
                            <td>{finalarr[148][0]}</td>
                            <td>
                              <img src={finalarr[148][2]} width="48px" />
                            </td>
                            <td>{finalarr[148][1]}</td>
                            <td className="table_amount"> x {postamount}</td>
                          </tr>
                        )}
                        {PostShape == 'round' && Pfostenrund == '48' && montageart != 'top' && (
                          <tr>
                            <td>{finalarr[149][0]}</td>
                            <td>
                              <img src={finalarr[149][2]} width="48px" />
                            </td>
                            <td>{finalarr[149][1]}</td>
                            <td className="table_amount"> x {postamount}</td>
                          </tr>
                        )}
                        {PostShape == '40x40' && montageart == 'top' && (
                          <tr>
                            <td>{finalarr[170][0]}</td>
                            <td>
                              <img src={finalarr[170][2]} width="48px" />
                            </td>
                            <td>{finalarr[170][1]}</td>
                            <td className="table_amount"> x {postamount}</td>
                          </tr>
                        )}
                        {PostShape == '60x30' && montageart == 'top' && (
                          <tr>
                            <td>{finalarr[235][0]}</td>
                            <td>
                              <img src={finalarr[235][2]} width="48px" />
                            </td>
                            <td>{finalarr[235][1]}</td>
                            <td className="table_amount"> x {postamount}</td>
                          </tr>
                        )}
                        {PostShape == '40x40' && montageart != 'top' && (
                          <tr>
                            <td>{finalarr[169][0]}</td>
                            <td>
                              <img src={finalarr[169][2]} width="48px" />
                            </td>
                            <td>{finalarr[169][1]}</td>
                            <td className="table_amount"> x {postamount}</td>
                          </tr>
                        )}
                        {PostShape == '60x30' && montageart != 'top' && (
                          <tr>
                            <td>{finalarr[235][0]}</td>
                            <td>
                              <img src={finalarr[235][2]} width="48px" />
                            </td>
                            <td>{finalarr[235][1]}</td>
                            <td className="table_amount"> x {postamount}</td>
                          </tr>
                        )}
                        {/*Handrail  */}
                        {handlaufmat == 'round' && (
                          <>
                            <tr>
                              <td>{Pfostenrund == '42' ? finalarr[143][0] : finalarr[145][0]} </td>
                              <td>
                                <img src={Pfostenrund == '42' ? finalarr[143][2] : finalarr[145][2]} width="48px" />
                              </td>
                              <td>{Pfostenrund == '42' ? finalarr[143][1] : finalarr[145][1]}</td>
                              <td className="table_amount"> x {handrailnumber}</td>
                            </tr>
                            {form != 'i' && (
                              <tr>
                                <td>{Pfostenrund == '42' ? finalarr[116][0] : finalarr[117][0]} </td>
                                <td>
                                  <img src={Pfostenrund == '42' ? finalarr[116][2] : finalarr[117][2]} width="48px" />
                                </td>
                                <td>{Pfostenrund == '42' ? finalarr[116][1] : finalarr[117][1]}</td>
                                <td className="table_amount"> x {form == 'u' ? 2 : 1}</td>
                              </tr>
                            )}
                          </>
                        )}

                        {handlaufmat == 'square' && (
                          <>
                            <tr>
                              <td>{finalarr[168][0]} </td>
                              <td>
                                <img src={finalarr[168][2]} width="48px" />
                              </td>
                              <td>{finalarr[168][1]}</td>
                              <td className="table_amount"> x {handrailnumber}</td>
                            </tr>{' '}
                            {form != 'i' && (
                              <tr>
                                <td>{finalarr[161][0]} </td>
                                <td>
                                  <img src={finalarr[161][2]} width="48px" />
                                </td>
                                <td>{finalarr[161][1]}</td>
                                <td className="table_amount"> x {form == 'u' ? 2 : 1}</td>
                              </tr>
                            )}
                          </>
                        )}
                        {handlaufmat == '60x30' && (
                          <>
                            <tr>
                              <td>{finalarr[233][0]} </td>
                              <td>
                                <img src={finalarr[233][2]} width="48px" />
                              </td>
                              <td>{finalarr[233][1]}</td>
                              <td className="table_amount"> x {handrailnumber}</td>
                            </tr>{' '}
                            {form != 'i' && (
                              <tr>
                                <td>{finalarr[220][0]} </td>
                                <td>
                                  <img src={finalarr[220][2]} width="48px" />
                                </td>
                                <td>{finalarr[220][1]}</td>
                                <td className="table_amount"> x {form == 'u' ? 2 : 1}</td>
                              </tr>
                            )}
                          </>
                        )}
                        {/* Glass oder horizontal bars */}
                        {(qlineinfill == 'glass' || qlineinfill == 'plates') && (
                          <>
                            {PostShape == 'round' && Pfostenrund == '42' && (
                              <>
                                {ClampShape == 'round' && (
                                  <tr>
                                    <td>{finalarr[155][0]}</td>
                                    <td>
                                      <img src={finalarr[155][2]} width="48px" />
                                    </td>
                                    <td>{finalarr[155][1]}</td>
                                    <td className="table_amount">
                                      {' '}
                                      x{' '}
                                      {
                                        <>
                                          {form == 'i'
                                            ? postamount * 4 - 4
                                            : form == 'l'
                                              ? postamount * 4 - 4
                                              : postamount * 4 - 4}
                                        </>
                                      }
                                    </td>
                                  </tr>
                                )}
                                {ClampShape != 'round' && (
                                  <tr>
                                    <td>{finalarr[158][0]}</td>
                                    <td>
                                      <img src={finalarr[158][2]} width="48px" />
                                    </td>
                                    <td>{finalarr[158][1]}</td>
                                    <td className="table_amount">
                                      {' '}
                                      x{' '}
                                      {
                                        <>
                                          {form == 'i'
                                            ? postamount * 4 - 4
                                            : form == 'l'
                                              ? postamount * 4 - 4
                                              : postamount * 4 - 4}
                                        </>
                                      }
                                    </td>
                                  </tr>
                                )}
                              </>
                            )}
                            {PostShape == 'round' && Pfostenrund == '48' && (
                              <>
                                {ClampShape == 'round' && (
                                  <tr>
                                    <td>{finalarr[156][0]}</td>
                                    <td>
                                      <img src={finalarr[156][2]} width="48px" />
                                    </td>
                                    <td>{finalarr[156][1]}</td>
                                    <td className="table_amount">
                                      {' '}
                                      x{' '}
                                      {
                                        <>
                                          {form == 'i'
                                            ? postamount * 4 - 4
                                            : form == 'l'
                                              ? postamount * 4 - 4
                                              : postamount * 4 - 4}
                                        </>
                                      }
                                    </td>
                                  </tr>
                                )}
                                {ClampShape != 'round' && (
                                  <tr>
                                    <td>{finalarr[159][0]}</td>
                                    <td>
                                      <img src={finalarr[159][2]} width="48px" />
                                    </td>
                                    <td>{finalarr[159][1]}</td>
                                    <td className="table_amount">
                                      {' '}
                                      x{' '}
                                      {
                                        <>
                                          {form == 'i'
                                            ? postamount * 4 - 4
                                            : form == 'l'
                                              ? postamount * 4 - 4
                                              : postamount * 4 - 4}
                                        </>
                                      }
                                    </td>
                                  </tr>
                                )}
                              </>
                            )}
                            {(PostShape == '40x40' || PostShape == '60x30') && (
                              <>
                                {ClampShape == 'round' && (
                                  <tr>
                                    <td>{finalarr[263][0]}</td>
                                    <td>
                                      <img src={finalarr[263][2]} width="48px" />
                                    </td>
                                    <td>{finalarr[263][1]}</td>
                                    <td className="table_amount">
                                      {' '}
                                      x{' '}
                                      {
                                        <>
                                          {form == 'i'
                                            ? postamount * 4 - 4
                                            : form == 'l'
                                              ? postamount * 4 - 4
                                              : postamount * 4 - 4}
                                        </>
                                      }
                                    </td>
                                  </tr>
                                )}
                                {ClampShape != 'round' && (
                                  <tr>
                                    <td>{finalarr[274][0]}</td>
                                    <td>
                                      <img src={finalarr[274][2]} width="48px" />
                                    </td>
                                    <td>{finalarr[274][1]}</td>
                                    <td className="table_amount">
                                      {' '}
                                      x{' '}
                                      {
                                        <>
                                          {form == 'i'
                                            ? postamount * 4 - 4
                                            : form == 'l'
                                              ? postamount * 4 - 4
                                              : postamount * 4 - 4}
                                        </>
                                      }
                                    </td>
                                  </tr>
                                )}
                              </>
                            )}

                            {form != 'i' && montageart != 'top' && (
                              <>
                                {ClampShape == 'round' && (
                                  <tr>
                                    <td>{finalarr[157][0]}</td>
                                    <td>
                                      <img src={finalarr[157][2]} width="48px" />
                                    </td>
                                    <td>{finalarr[157][1]}</td>
                                    <td className="table_amount"> x {<>{form == 'l' ? 2 : 4}</>}</td>
                                  </tr>
                                )}
                                {ClampShape != 'round' && (
                                  <tr>
                                    <td>{finalarr[160][0]}</td>
                                    <td>
                                      <img src={finalarr[160][2]} width="48px" />
                                    </td>
                                    <td>{finalarr[160][1]}</td>
                                    <td className="table_amount"> x {<>{form == 'l' ? 2 : 4}</>}</td>
                                  </tr>
                                )}
                              </>
                            )}
                            {/*SecurityPin */}
                            {montageart != 'top' && (
                              <tr>
                                <td>{finalarr[255][0]}</td>
                                <td>
                                  <img src={finalarr[255][2]} width="48px" />
                                </td>
                                <td>{finalarr[255][1]}</td>
                                <td className="table_amount">
                                  {' '}
                                  x{' '}
                                  {form == 'i'
                                    ? postamount * 4 - 4
                                    : form == 'l'
                                      ? postamount * 4 + 4
                                      : postamount * 4 + 4}
                                </td>
                              </tr>
                            )}
                            {/* RubberInlay*/}

                            {ClampShape != 'round' && (
                              <tr>
                                <td>{qlineinfill == 'plates' ? finalarr[259][0] : finalarr[260][0]}</td>
                                <td>
                                  <img
                                    src={qlineinfill == 'plates' ? finalarr[259][2] : finalarr[260][2]}
                                    width="48px"
                                  />
                                </td>
                                <td>{qlineinfill == 'plates' ? finalarr[259][1] : finalarr[260][1]}</td>
                                <td className="table_amount"> x {rubberamount}</td>
                              </tr>
                            )}
                            {ClampShape == 'round' && (
                              <tr>
                                <td>{qlineinfill == 'plates' ? finalarr[256][0] : finalarr[258][0]}</td>
                                <td>
                                  <img
                                    src={qlineinfill == 'plates' ? finalarr[256][2] : finalarr[258][2]}
                                    width="48px"
                                  />
                                </td>
                                <td>{qlineinfill == 'plates' ? finalarr[256][1] : finalarr[258][1]}</td>
                                <td className="table_amount"> x {rubberamount}</td>
                              </tr>
                            )}
                            {/*ClampScrews*/}
                            <tr>
                              <td>{qlineinfill == 'plates' ? finalarr[280][0] : finalarr[280][0]}</td>
                              <td>
                                <img src={qlineinfill == 'plates' ? finalarr[280][2] : finalarr[280][2]} width="48px" />
                              </td>
                              <td>{qlineinfill == 'plates' ? finalarr[280][1] : finalarr[280][1]}</td>
                              <td className="table_amount">
                                {' '}
                                x{' '}
                                {form == 'i'
                                  ? postamount * 4 - 4
                                  : form == 'l'
                                    ? postamount * 4 - 4
                                    : postamount * 4 - 4}
                              </td>
                            </tr>
                          </>
                        )}

                        {qlineinfill == 'verticalbars' && (
                          <>
                            {baramount5 >= 1 && (
                              <tr>
                                <td>{finalarr[153][0]} </td>
                                <td>
                                  <img src={finalarr[153][2]} width="48px" />
                                </td>
                                <td>{finalarr[153][1]}</td>
                                <td className="table_amount"> x {baramount5 * 10}</td>
                              </tr>
                            )}
                            {baramount25 >= 1 && (
                              <tr>
                                <td>{finalarr[152][0]} </td>
                                <td>
                                  <img src={finalarr[152][2]} width="48px" />
                                </td>
                                <td>{finalarr[152][1]}</td>
                                <td className="table_amount"> x {baramount25 * 10}</td>
                              </tr>
                            )}
                            {PostShape == 'round' && (
                              <>
                                {Pfostenrund == '48' && (
                                  <>
                                    <tr>
                                      <td>{finalarr[139][0]} </td>
                                      <td>
                                        <img src={finalarr[139][2]} width="48px" />
                                      </td>
                                      <td>{finalarr[139][1]}</td>
                                      <td className="table_amount">
                                        {' '}
                                        x{' '}
                                        {montageart == 'top' ? (
                                          <>{form == 'i' ? 10 : form == 'l' ? 20 : 30}</>
                                        ) : (
                                          <>{form == 'i' ? 10 : form == 'l' ? 10 : 10}</>
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>{finalarr[137][0]} </td>
                                      <td>
                                        <img src={finalarr[137][2]} width="48px" />
                                      </td>
                                      <td>{finalarr[137][1]}</td>
                                      <td className="table_amount">
                                        {' '}
                                        x{' '}
                                        {montageart == 'top' ? (
                                          <>{form == 'i' ? 10 : form == 'l' ? 20 : 30}</>
                                        ) : (
                                          <>{form == 'i' ? 10 : form == 'l' ? 10 : 10}</>
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>{finalarr[135][0]} </td>
                                      <td>
                                        <img src={finalarr[135][2]} width="48px" />
                                      </td>
                                      <td>{finalarr[135][1]}</td>
                                      <td className="table_amount">
                                        {' '}
                                        x{' '}
                                        {montageart == 'top' ? (
                                          <>
                                            {form == 'i'
                                              ? (postamount - 2) * 10
                                              : form == 'l'
                                                ? (postamount - 3) * 10
                                                : (postamount - 4) * 10}
                                          </>
                                        ) : (
                                          <>
                                            {form == 'i'
                                              ? postamount * 10 - 20
                                              : form == 'l'
                                                ? postamount * 10 - 20
                                                : postamount * 10 - 20}
                                          </>
                                        )}
                                      </td>
                                    </tr>
                                  </>
                                )}
                                {Pfostenrund == '42' && (
                                  <>
                                    <tr>
                                      <td>{finalarr[138][0]} </td>
                                      <td>
                                        <img src={finalarr[138][2]} width="48px" />
                                      </td>
                                      <td>{finalarr[138][1]}</td>
                                      <td className="table_amount">
                                        {' '}
                                        x{' '}
                                        {montageart == 'top' ? (
                                          <>{form == 'i' ? 10 : form == 'l' ? 20 : 30}</>
                                        ) : (
                                          <>{form == 'i' ? 10 : form == 'l' ? 10 : 10}</>
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>{finalarr[136][0]} </td>
                                      <td>
                                        <img src={finalarr[136][2]} width="48px" />
                                      </td>
                                      <td>{finalarr[136][1]}</td>
                                      <td className="table_amount">
                                        {' '}
                                        x{' '}
                                        {montageart == 'top' ? (
                                          <>{form == 'i' ? 10 : form == 'l' ? 20 : 30}</>
                                        ) : (
                                          <>{form == 'i' ? 10 : form == 'l' ? 10 : 10}</>
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>{finalarr[134][0]} </td>
                                      <td>
                                        <img src={finalarr[134][2]} width="48px" />
                                      </td>
                                      <td>{finalarr[134][1]}</td>
                                      <td className="table_amount">
                                        {' '}
                                        x{' '}
                                        {montageart == 'top' ? (
                                          <>
                                            {form == 'i'
                                              ? (postamount - 2) * 10
                                              : form == 'l'
                                                ? (postamount - 3) * 10
                                                : (postamount - 4) * 10}
                                          </>
                                        ) : (
                                          <>
                                            {form == 'i'
                                              ? postamount * 10 - 20
                                              : form == 'l'
                                                ? postamount * 10 - 20
                                                : postamount * 10 - 20}
                                          </>
                                        )}
                                      </td>
                                    </tr>
                                  </>
                                )}
                              </>
                            )}
                            {PostShape != 'round' && (
                              <>
                                <tr>
                                  <td>{finalarr[270][0]} </td>
                                  <td>
                                    <img src={finalarr[270][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[270][1]}</td>
                                  <td className="table_amount">
                                    {' '}
                                    x{' '}
                                    {montageart == 'top' ? (
                                      <>{form == 'i' ? 10 : form == 'l' ? 20 : 30}</>
                                    ) : (
                                      <>{form == 'i' ? 10 : form == 'l' ? 10 : 10}</>
                                    )}
                                  </td>
                                </tr>

                                <tr>
                                  <td>{finalarr[272][0]} </td>
                                  <td>
                                    <img src={finalarr[272][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[272][1]}</td>
                                  <td className="table_amount">
                                    {' '}
                                    x{' '}
                                    {montageart == 'top' ? (
                                      <>{form == 'i' ? 10 : form == 'l' ? 20 : 30}</>
                                    ) : (
                                      <>{form == 'i' ? 10 : form == 'l' ? 10 : 10}</>
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>{finalarr[268][0]} </td>
                                  <td>
                                    <img src={finalarr[268][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[268][1]}</td>
                                  <td className="table_amount">
                                    {' '}
                                    x{' '}
                                    {montageart == 'top' && PostShape != '60x30' ? (
                                      <>
                                        {form == 'i'
                                          ? (postamount - 2) * 10
                                          : form == 'l'
                                            ? (postamount - 3) * 10
                                            : (postamount - 4) * 10}
                                      </>
                                    ) : (
                                      <>
                                        {form == 'i'
                                          ? postamount * 10 - 20
                                          : form == 'l'
                                            ? postamount * 10 - 20
                                            : postamount * 10 - 20}
                                      </>
                                    )}
                                  </td>
                                </tr>
                              </>
                            )}
                            {((form != 'i' && montageart != 'top') || (PostShape == '60x30' && form != 'i')) && (
                              <>
                                <tr>
                                  <td>{finalarr[150][0]} </td>
                                  <td>
                                    <img src={finalarr[150][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[150][1]}</td>
                                  <td className="table_amount"> x {form == 'l' ? 10 : 20}</td>
                                </tr>
                              </>
                            )}

                            {/*Screws Horz. Bars */}
                            <tr>
                              <td>{finalarr[280][0]} </td>
                              <td>
                                <img src={finalarr[280][2]} width="48px" />
                              </td>
                              <td>{finalarr[280][1]}</td>
                              <td className="table_amount">
                                {' '}
                                x{' '}
                                <>
                                  {(montageart != 'top' || PostShape == '60x30') && postamount * 10}
                                  {montageart == 'top' && PostShape != '60x30' && (
                                    <>
                                      {form == 'i'
                                        ? postamount * 10
                                        : form == 'l'
                                          ? postamount * 10 + 10
                                          : postamount * 10 + 20}
                                    </>
                                  )}
                                </>
                              </td>
                            </tr>
                          </>
                        )}
                        {/*Flanges */}
                        {montageart != 'top' && (
                          <>
                            {PostShape == 'round' && Pfostenrund == '42' && (
                              <tr>
                                <td>{finalarr[124][0]} </td>
                                <td>
                                  <img src={finalarr[124][2]} width="48px" />
                                </td>
                                <td>{finalarr[124][1]}</td>
                                <td className="table_amount"> x {postamount}</td>
                              </tr>
                            )}
                            {PostShape == 'round' && Pfostenrund == '48' && (
                              <tr>
                                <td>{finalarr[125][0]} </td>
                                <td>
                                  <img src={finalarr[125][2]} width="48px" />
                                </td>
                                <td>{finalarr[125][1]}</td>
                                <td className="table_amount"> x {postamount}</td>
                              </tr>
                            )}
                            {PostShape == '40x40' && (
                              <tr>
                                <td>{finalarr[164][0]} </td>
                                <td>
                                  <img src={finalarr[164][2]} width="48px" />
                                </td>
                                <td>{finalarr[164][1]}</td>
                                <td className="table_amount"> x {postamount}</td>
                              </tr>
                            )}
                            {PostShape == '60x30' && (
                              <tr>
                                <td>{finalarr[226][0]} </td>
                                <td>
                                  <img src={finalarr[226][2]} width="48px" />
                                </td>
                                <td>{finalarr[226][1]}</td>
                                <td className="table_amount"> x {postamount}</td>
                              </tr>
                            )}
                          </>
                        )}
                        {/*Cables */}
                        {qlineinfill == 'cables' && (
                          <>
                            <tr>
                              <td>{finalarr[closestI][0]} </td>
                              <td>
                                <img src={finalarr[closestI][2]} width="48px" />
                              </td>
                              <td>{finalarr[closestI][1]}</td>
                              <td className="table_amount"> x 12</td>
                            </tr>

                            {(form == 'u' || form == 'l') && (
                              <tr>
                                <td>{finalarr[closestL][0]} </td>
                                <td>
                                  <img src={finalarr[closestL][2]} width="48px" />
                                </td>
                                <td>{finalarr[closestL][1]}</td>
                                <td className="table_amount"> x {'12'}</td>
                              </tr>
                            )}
                            {form == 'u' && (
                              <tr>
                                <td>{finalarr[closestU][0]} </td>
                                <td>
                                  <img src={finalarr[closestU][2]} width="48px" />
                                </td>
                                <td>{finalarr[closestU][1]}</td>
                                <td className="table_amount"> x {'12'}</td>
                              </tr>
                            )}
                            <tr>
                              <td>{finalarr[262][0]} </td>
                              <td>
                                <img src={finalarr[262][2]} width="48px" />
                              </td>
                              <td>{finalarr[262][1]}</td>
                              <td className="table_amount"> x {'1'}</td>
                            </tr>

                            <tr>
                              <td>{finalarr[247][0]} </td>
                              <td>
                                <img src={finalarr[247][2]} width="48px" />
                              </td>
                              <td>{finalarr[247][1]}</td>
                              <td className="table_amount">
                                {' '}
                                x{' '}
                                {form == 'i'
                                  ? (postamount - 2) * 24
                                  : form == 'l'
                                    ? (postamount - 4) * 24
                                    : (postamount - 6) * 24}
                              </td>
                            </tr>
                          </>
                        )}
                        {/*Endcaps */}
                        {(!wall1 || !wall2) && (
                          <>
                            {handlaufmat == 'round' && (
                              <tr>
                                <td>{Pfostenrund == '42' ? finalarr[174][0] : finalarr[175][0]} </td>
                                <td>
                                  <img src={Pfostenrund == '42' ? finalarr[174][2] : finalarr[175][2]} width="48px" />
                                </td>
                                <td>{Pfostenrund == '42' ? finalarr[174][1] : finalarr[175][1]}</td>
                                <td className="table_amount"> x {!wall1 && !wall2 ? 2 : 1}</td>
                              </tr>
                            )}
                            {handlaufmat == 'square' && (
                              <tr>
                                <td>{finalarr[171][0]} </td>
                                <td>
                                  <img src={finalarr[171][2]} width="48px" />
                                </td>
                                <td>{finalarr[171][1]}</td>
                                <td className="table_amount"> x {!wall1 && !wall2 ? 2 : 1}</td>
                              </tr>
                            )}
                            {handlaufmat == '60x30' && (
                              <tr>
                                <td>{finalarr[239][0]} </td>
                                <td>
                                  <img src={finalarr[239][2]} width="48px" />
                                </td>
                                <td>{finalarr[239][1]}</td>
                                <td className="table_amount"> x {!wall1 && !wall2 ? 2 : 1}</td>
                              </tr>
                            )}
                          </>
                        )}
                        {/*Wallmount */}
                        {(wall1 || wall2) && (
                          <>
                            {handlaufmat == 'round' && (
                              <>
                                <tr>
                                  <td>{Pfostenrund == '42' ? finalarr[118][0] : finalarr[119][0]} </td>
                                  <td>
                                    <img src={Pfostenrund == '42' ? finalarr[118][2] : finalarr[119][2]} width="48px" />
                                  </td>
                                  <td>{Pfostenrund == '42' ? finalarr[118][1] : finalarr[119][1]}</td>
                                  <td className="table_amount"> x {wall1 && wall2 ? 2 : 1}</td>
                                </tr>
                              </>
                            )}
                            {handlaufmat == 'square' && (
                              <tr>
                                <td>{finalarr[162][0]} </td>
                                <td>
                                  <img src={finalarr[162][2]} width="48px" />
                                </td>
                                <td>{finalarr[162][1]}</td>
                                <td className="table_amount"> x {wall1 && wall2 ? 2 : 1}</td>
                              </tr>
                            )}
                            {handlaufmat == '60x30' && (
                              <tr>
                                <td>{finalarr[221][0]} </td>
                                <td>
                                  <img src={finalarr[221][2]} width="48px" />
                                </td>
                                <td>{finalarr[221][1]}</td>
                                <td className="table_amount"> x {wall1 && wall2 ? 2 : 1}</td>
                              </tr>
                            )}
                          </>
                        )}

                        {/*Handrail Brackets */}
                        {PostShape == 'round' && (
                          <>
                            {handlaufmat == 'round' && (
                              <>
                                <tr>
                                  <td>{Pfostenrund == '42' ? finalarr[128][0] : finalarr[130][0]} </td>
                                  <td>
                                    <img src={Pfostenrund == '42' ? finalarr[128][2] : finalarr[130][2]} width="48px" />
                                  </td>
                                  <td>{Pfostenrund == '42' ? finalarr[128][1] : finalarr[130][1]}</td>
                                  <td className="table_amount">
                                    {' '}
                                    x{' '}
                                    {qlineinfill != 'cables' && (
                                      <>{form == 'u' ? postamount - 2 : form == 'l' ? postamount - 1 : postamount}</>
                                    )}
                                    {qlineinfill == 'cables' && (
                                      <>{form == 'u' ? postamount : form == 'l' ? postamount : postamount}</>
                                    )}
                                  </td>
                                </tr>
                                {form != 'i' && qlineinfill != 'cables' && montageart == 'top' && (
                                  <tr>
                                    <td>{Pfostenrund == '42' ? finalarr[129][0] : finalarr[131][0]} </td>
                                    <td>
                                      <img
                                        src={Pfostenrund == '42' ? finalarr[129][2] : finalarr[131][2]}
                                        width="48px"
                                      />
                                    </td>
                                    <td>{Pfostenrund == '42' ? finalarr[129][1] : finalarr[131][1]}</td>
                                    <td className="table_amount"> x {form == 'u' ? 2 : 1}</td>
                                  </tr>
                                )}
                                <tr>
                                  <td>{finalarr[278][0]} </td>
                                  <td>
                                    <img src={finalarr[278][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[278][1]}</td>
                                  <td className="table_amount">
                                    {' '}
                                    x {montageart == 'top' && <>{postamount * 2}</>}
                                    {montageart != 'top' && <>{postamount * 2}</>}
                                  </td>
                                </tr>
                              </>
                            )}
                          </>
                        )}
                        {PostShape == '40x40' && (
                          <>
                            {handlaufmat == 'square' && (
                              <>
                                <tr>
                                  <td>{finalarr[165][0]} </td>
                                  <td>
                                    <img src={finalarr[165][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[165][1]}</td>
                                  <td className="table_amount">
                                    {' '}
                                    x {form == 'u' ? postamount - 2 : form == 'l' ? postamount - 1 : postamount}
                                  </td>
                                </tr>
                                {form != 'i' && montageart == 'top' && (
                                  <tr>
                                    <td>{finalarr[166][0]} </td>
                                    <td>
                                      <img src={finalarr[166][2]} width="48px" />
                                    </td>
                                    <td>{finalarr[166][1]}</td>
                                    <td className="table_amount">
                                      {' '}
                                      x{form == 'l' && 1}
                                      {form == 'u' && 2}
                                    </td>
                                  </tr>
                                )}
                                <tr>
                                  <td>{finalarr[279][0]} </td>
                                  <td>
                                    <img src={finalarr[279][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[279][1]}</td>
                                  <td className="table_amount">
                                    {' '}
                                    x {montageart == 'top' && <>{postamount * 2}</>}
                                    {montageart != 'top' && <>{postamount * 2}</>}
                                  </td>
                                </tr>
                              </>
                            )}
                            {handlaufmat == 'round' && (
                              <>
                                <tr>
                                  <td>{finalarr[284][0]} </td>
                                  <td>
                                    <img src={finalarr[284][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[284][1]}</td>
                                  <td className="table_amount">
                                    {' '}
                                    x {form == 'u' ? postamount - 2 : form == 'l' ? postamount - 1 : postamount}
                                  </td>
                                </tr>
                                {form != 'i' && montageart == 'top' && (
                                  <tr>
                                    <td>{finalarr[286][0]} </td>
                                    <td>
                                      <img src={finalarr[286][2]} width="48px" />
                                    </td>
                                    <td>{finalarr[286][1]}</td>
                                    <td className="table_amount">
                                      {' '}
                                      x{form == 'l' && 1}
                                      {form == 'u' && 2}
                                    </td>
                                  </tr>
                                )}
                                <tr>
                                  <td>{finalarr[278][0]} </td>
                                  <td>
                                    <img src={finalarr[278][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[278][1]}</td>
                                  <td className="table_amount">
                                    {' '}
                                    x {montageart == 'top' && <>{postamount * 2}</>}
                                    {montageart != 'top' && <>{postamount * 2}</>}
                                  </td>
                                </tr>
                              </>
                            )}
                          </>
                        )}
                        {PostShape == '60x30' && (
                          <>
                            {(handlaufmat == 'square' || handlaufmat == '60x30') && (
                              <>
                                <tr>
                                  <td>{finalarr[229][0]} </td>
                                  <td>
                                    <img src={finalarr[229][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[229][1]}</td>
                                  <td className="table_amount"> x {postamount}</td>
                                </tr>
                                <tr>
                                  <td>{finalarr[279][0]} </td>
                                  <td>
                                    <img src={finalarr[279][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[279][1]}</td>
                                  <td className="table_amount">
                                    {' '}
                                    x {montageart == 'top' && <>{postamount * 2}</>}
                                    {montageart != 'top' && <>{postamount * 2}</>}
                                  </td>
                                </tr>
                              </>
                            )}
                            {handlaufmat == 'round' && (
                              <>
                                <tr>
                                  <td>{finalarr[282][0]} </td>
                                  <td>
                                    <img src={finalarr[282][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[282][1]}</td>
                                  <td className="table_amount"> x {postamount}</td>
                                </tr>
                                <tr>
                                  <td>{finalarr[279][0]} </td>
                                  <td>
                                    <img src={finalarr[279][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[279][1]}</td>
                                  <td className="table_amount">
                                    {' '}
                                    x {montageart == 'top' && <>{postamount * 2}</>}
                                    {montageart != 'top' && <>{postamount * 2}</>}
                                  </td>
                                </tr>
                              </>
                            )}
                          </>
                        )}

                        {/*CoverCaps */}
                        {PostShape == 'round' && (
                          <>
                            {montageart == 'top' && (
                              <>
                                <tr>
                                  <td>{Pfostenrund == '42' ? finalarr[122][0] : finalarr[123][0]} </td>
                                  <td>
                                    <img src={Pfostenrund == '42' ? finalarr[122][2] : finalarr[123][2]} width="48px" />
                                  </td>
                                  <td>{Pfostenrund == '42' ? finalarr[122][1] : finalarr[123][1]}</td>
                                  <td className="table_amount">
                                    {' '}
                                    x {form == 'u' ? postamount - 2 : form == 'l' ? postamount - 1 : postamount}
                                  </td>
                                </tr>
                              </>
                            )}
                          </>
                        )}
                        {PostShape == '40x40' && (
                          <>
                            {montageart == 'top' && (
                              <>
                                <tr>
                                  <td>{finalarr[163][0]} </td>
                                  <td>
                                    <img src={finalarr[163][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[163][1]}</td>
                                  <td className="table_amount"> x {postamount}</td>
                                </tr>
                              </>
                            )}
                          </>
                        )}

                        {PostShape == '60x30' && (
                          <>
                            {montageart == 'top' && (
                              <>
                                <tr>
                                  <td>{finalarr[224][0]} </td>
                                  <td>
                                    <img src={finalarr[224][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[224][1]}</td>
                                  <td className="table_amount"> x {postamount}</td>
                                </tr>
                              </>
                            )}
                          </>
                        )}

                        {/*FasciaPostEndcaps */}

                        {PostShape == 'round' && (
                          <>
                            {montageart != 'top' && (
                              <>
                                <tr>
                                  <td>{Pfostenrund == '42' ? finalarr[174][0] : finalarr[175][0]} </td>
                                  <td>
                                    <img src={Pfostenrund == '42' ? finalarr[174][2] : finalarr[175][2]} width="48px" />
                                  </td>
                                  <td>{Pfostenrund == '42' ? finalarr[174][1] : finalarr[175][1]}</td>
                                  <td className="table_amount"> x {postamount}</td>
                                </tr>
                              </>
                            )}
                          </>
                        )}
                        {PostShape == '40x40' && (
                          <>
                            {montageart != 'top' && (
                              <>
                                <tr>
                                  <td>{finalarr[171][0]} </td>
                                  <td>
                                    <img src={finalarr[171][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[171][1]}</td>
                                  <td className="table_amount"> x {postamount}</td>
                                </tr>
                              </>
                            )}
                          </>
                        )}
                        {PostShape == '60x30' && (
                          <>
                            {montageart != 'top' && (
                              <>
                                <tr>
                                  <td>{finalarr[154][0]} </td>
                                  <td>
                                    <img src={finalarr[154][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[154][1]}</td>
                                  <td className="table_amount"> x {postamount}</td>
                                </tr>
                              </>
                            )}
                          </>
                        )}

                        {/*TubeConnector */}
                        {(form == 'i' && len1 > 5000) ||
                          (form == 'l' && (len1 > 5000 || len2 > 5000)) ||
                          (form == 'u' && (len1 > 5000 || len2 > 5000 || len3 > 5000) && (
                            <>
                              {handlaufmat == 'square' && (
                                <tr>
                                  <td>{finalarr[245][0]} </td>
                                  <td>
                                    <img src={finalarr[245][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[245][1]}</td>
                                  <td className="table_amount"> x {amountConnectors}</td>
                                </tr>
                              )}
                              {handlaufmat == '60x30' && (
                                <tr>
                                  <td>{finalarr[246][0]} </td>
                                  <td>
                                    <img src={finalarr[246][2]} width="48px" />
                                  </td>
                                  <td>{finalarr[246][1]}</td>
                                  <td className="table_amount"> x {amountConnectors}</td>
                                </tr>
                              )}
                              {handlaufmat == 'round' && (
                                <tr>
                                  <td>{Pfostenrund == '42' ? finalarr[176][0] : finalarr[276][0]} </td>
                                  <td>
                                    <img src={Pfostenrund == '42' ? finalarr[176][2] : finalarr[276][2]} width="48px" />
                                  </td>
                                  <td>{Pfostenrund == '42' ? finalarr[176][1] : finalarr[276][1]}</td>
                                  <td className="table_amount"> x {amountConnectors}</td>
                                </tr>
                              )}
                            </>
                          ))}

                        <tr>
                          <td>{finalarr[21][0]}</td>
                          <td>
                            <img src={finalarr[21][2]} width="48px" />
                          </td>
                          <td>{finalarr[21][1]}</td>
                          <td className="table_amount"> x 1</td>
                        </tr>
                        <tr>
                          <td>{finalarr[30][0]} </td>
                          <td>
                            <img src={finalarr[30][2]} width="48px" />
                          </td>
                          <td>{finalarr[30][1]}</td>
                          <td className="table_amount"> x {gesamtleng > 15000 ? 3 : gesamtleng > 15000 ? 2 : 1}</td>
                        </tr>
                      </>
                    )}
                  </>
                }
              </table>
            </div>
          </>
        )}
      </>
    );
  }

  function RespMoveBar() {
    let thewidth = document.body.clientWidth;
    let calcy = 650 - thewidth - 16;

    if (thewidth < 650 && selectstep < 7) {
      document.getElementById('ConfigBtnRowId').style = 'left:-' + calcy + 'px !important;transition:0.3s;';
      document.getElementById('ConfigBtnRowId').classList.add('movedBar');
    }

    if (selectstep < 4 && document.getElementById('ConfigBtnRowId').classList.contains('movedBar')) {
      document.getElementById('ConfigBtnRowId').style = 'left:16px !important;transition:0.3s;';
    }
  }

  const [mailtoLink, setmailtoLink] = useState('');

  return (
    <>
      <Helmet>
        <title>{infotext.data.length > 0 ? infotext.data[0].attributes.MetaTitle : 'Q-railing Configurator.'}</title>
        <meta
          name="description"
          content={
            infotext.data.length > 0
              ? infotext.data[0].attributes.MetaText
              : 'Q-railing Configurator - configure your railing today'
          }
        ></meta>
      </Helmet>
      <PdfTemplateAnchor />
      <div className="Step5try">
        <div className="configurator-wrap">
          <Canvas
            id="modelcanvas2"
            ref={CameraRef}
            onMouseDown={() => {
              document.getElementById('modelcanvas2').style = 'cursor:grabbing !important';
            }}
            onMouseUp={() => {
              document.getElementById('modelcanvas2').style = 'cursor:grab !important';
            }}
            camera={{ position: [-95, 65, 112], fov: fovnbr }}
          >
            <ThreeUtilityGetter setRenderer={setRenderer} setScene={setScene} setCamera={setCamera} />
            <Suspense fallback={null}>
              <OrbitControls
                onChange={() => {
                  adjcount = adjcount + 1;
                  if (adjcount > 5) {
                    adjcount = 0;
                    setpolarcoord(orbitRef.current.getAzimuthalAngle());
                  }
                }}
                ref={orbitRef}
                enableRotate={true}
                Rotation={[Math.PI / 45, 0, 0]}
                enableZoom={true}
                keys={true}
                target={[10, 5, 0]}
                initialPosition={[2, 0, 20]}
                initialRotation={[Math.PI / 2, Math.PI / 2, 0]}
                minDistance={75}
                maxDistance={355}
              ></OrbitControls>

              <PerspectiveCamera ref={cammy}></PerspectiveCamera>
              <ambientLight></ambientLight>
              {gelaender == 'baluster' && (
                <Detailmodel
                  type="EASYGLASS"
                  pfosten={pfosten2}
                  klammer={klammer}
                  hohe={hohe}
                  gelaender={gelaender}
                  form={form}
                  handlaufmat={handlaufmat}
                  handlaufweg={handlaufweg}
                  doppel={doppel}
                  klammermaterial={klammermaterial}
                  pfostenmaterial={pfostenmaterial}
                  glasart={glasart}
                  montageart={montageart}
                  untergrund={untergrundd}
                  coords={coords}
                  selectstep={selectstep}
                  colorr={colorr}
                  len1={len1}
                  len2={len2}
                  len3={len3}
                  wall1={wall1}
                  wall2={wall2}
                  polarcoord={polarcoord}
                ></Detailmodel>
              )}
              {gelaender == 'picket' && (
                <EasyAlu
                  type="EASYGLASS"
                  pfosten={pfosten2}
                  klammer={klammer}
                  hohe={hohe}
                  gelaender={gelaender}
                  form={form}
                  handlaufmat={handlaufmat}
                  handlaufweg={handlaufweg}
                  doppel={doppel}
                  klammermaterial={klammermaterial}
                  pfostenmaterial={pfostenmaterial}
                  glasart={glasart}
                  montageart={montageart}
                  untergrund={untergrundd}
                  selectstep={selectstep}
                  colorr={colorr}
                  len1={len1}
                  len2={len2}
                  len3={len3}
                  wall1={wall1}
                  wall2={wall2}
                  polarcoord={polarcoord}
                ></EasyAlu>
              )}
              {gelaender == 'glass' && (
                <Glassmodel
                  type="EASYGLASS"
                  pfosten={pfosten2}
                  klammer={klammer}
                  hohe={hohe}
                  gelaender={gelaender}
                  form={form}
                  handlaufmat={handlaufmat}
                  handlaufweg={handlaufweg}
                  doppel={doppel}
                  klammermaterial={klammermaterial}
                  pfostenmaterial={pfostenmaterial}
                  glasart={glasart}
                  montageart={montageart}
                  untergrund={untergrundd}
                  selectstep={selectstep}
                  colorr={colorr}
                  len1={len1}
                  len2={len2}
                  len3={len3}
                  wall1={wall1}
                  wall2={wall2}
                  polarcoord={polarcoord}
                ></Glassmodel>
              )}

              {gelaender == 'baseclamps' && (
                <BaseClampModel
                  pfosten={pfosten2}
                  klammer={klammer}
                  hohe={hohe}
                  gelaender={gelaender}
                  form={form}
                  panelwidthi={glaspanelwidthi}
                  panelwidthl={glaspanelwidthl}
                  panelwidthu={glaspanelwidthu}
                  handlaufmat={handlaufmat}
                  handlaufweg={handlaufweg}
                  doppel={doppel}
                  klammermaterial={klammermaterial}
                  pfostenmaterial={pfostenmaterial}
                  glasart={glasart}
                  montageart={montageart}
                  untergrund={untergrundd}
                  selectstep={selectstep}
                  colorr={colorr}
                  len1={len1}
                  len2={len2}
                  len3={len3}
                  wall1={wall1}
                  wall2={wall2}
                  polarcoord={polarcoord}
                ></BaseClampModel>
              )}

              {gelaender == 'frenchbalcony' && (
                <FrenchBalcony
                  pfosten={pfosten2}
                  klammer={klammer}
                  hohe={hohe}
                  gelaender={gelaender}
                  form={form}
                  handlaufmat={handlaufmat}
                  handlaufweg={handlaufweg}
                  doppel={doppel}
                  klammermaterial={klammermaterial}
                  pfostenmaterial={pfostenmaterial}
                  glasart={glasart}
                  montageart={montageart}
                  untergrund={untergrundd}
                  selectstep={selectstep}
                  colorr={colorr}
                  len1={len1}
                  len2={len2}
                  len3={len3}
                  wall1={wall1}
                  wall2={wall2}
                  polarcoord={polarcoord}
                  windowamount={windowamount}
                  windowwidth={windowwidth}
                  windowdistance={windowdistance}
                  windowheight={windowheight}
                  windowinset={windowinset}
                  fenstermontage={fenstermontage}
                  fbsystem={fbsystem}
                  bodentief={bodentief}
                ></FrenchBalcony>
              )}

              {gelaender == 'qline' && (
                <Qline
                  pfosten={pfosten2}
                  klammer={klammer}
                  hohe={hohe}
                  gelaender={gelaender}
                  form={form}
                  handlaufmat={handlaufmat}
                  handlaufweg={handlaufweg}
                  doppel={doppel}
                  klammermaterial={klammermaterial}
                  pfostenmaterial={pfostenmaterial}
                  glasart={glasart}
                  montageart={montageart}
                  untergrund={untergrundd}
                  selectstep={selectstep}
                  colorr={colorr}
                  len1={len1}
                  len2={len2}
                  len3={len3}
                  wall1={wall1}
                  wall2={wall2}
                  polarcoord={polarcoord}
                  postshape={PostShape}
                  clampshape={ClampShape}
                  qlineinfill={qlineinfill}
                  pfostenrund={Pfostenrund}
                  qlinehandlauf={QlineHandlauf}
                ></Qline>
              )}

              <Environment files="/marry_hall_1k_low.hdr" />
            </Suspense>
          </Canvas>
          <div className="configuratorsteps">
            {selectstep < 7 && (
              <div className="configuratorsteps-btnrow" id="ConfigBtnRowId">
                <button className={selectstep == 1 ? 'activeitem2' : 'usedbutton'} onClick={() => setselectstep(1)}>
                  {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[75] : 'Type'}
                  <span>|</span>
                </button>
                <button
                  id={selectstep == 1 && 'Step2Navbar'}
                  className={selectstep < 2 ? 'inactivebtn' : selectstep == 2 ? 'activeitem2' : 'usedbutton'}
                  onClick={() => {
                    setselectstep(2);
                    setstep1bool(true);
                  }}
                >
                  {infotext.data.length > 0 && (
                    <>
                      {gelaender != 'frenchbalcony'
                        ? infotext.data[0].attributes.FreeData1.data[76]
                        : infotext.data[0].attributes.FreeData1.data[133]}
                    </>
                  )}
                  <span>|</span>
                </button>
                <button
                  className={selectstep < 3 ? 'inactivebtn' : selectstep == 3 ? 'activeitem2' : 'usedbutton'}
                  onClick={() => setselectstep(3)}
                  id={selectstep == 2 && 'Step3Navbar'}
                >
                  {infotext.data.length > 0 && (
                    <>
                      {gelaender != 'frenchbalcony'
                        ? infotext.data[0].attributes.FreeData1.data[77]
                        : infotext.data[0].attributes.FreeData1.data[142]}
                    </>
                  )}
                  <span>|</span>
                </button>
                <button
                  className={selectstep < 4 ? 'inactivebtn' : selectstep == 4 ? 'activeitem2' : 'usedbutton'}
                  id={selectstep == 3 && 'Step4Navbar'}
                  onClick={() => {
                    setselectstep(4);
                  }}
                >
                  {infotext.data.length > 0 && (
                    <>
                      {gelaender == 'frenchbalcony'
                        ? infotext.data[0].attributes.FreeData1.data[144]
                        : gelaender == 'qline'
                          ? infotext.data[0].attributes.FreeData1.data[154]
                          : infotext.data[0].attributes.FreeData1.data[78]}
                    </>
                  )}
                  <span>|</span>
                </button>
                {fbsystem != 'Mod6507' && (
                  <button
                    className={selectstep < 5 ? 'inactivebtn' : selectstep == 5 ? 'activeitem2' : 'usedbutton'}
                    id={selectstep == 4 && 'Step5Navbar'}
                    onClick={() => {
                      setselectstep(5);
                    }}
                  >
                    {infotext.data.length > 0 && (
                      <>
                        {gelaender != 'frenchbalcony'
                          ? infotext.data[0].attributes.FreeData1.data[79]
                          : infotext.data[0].attributes.FreeData1.data[79]}
                      </>
                    )}
                    <span>|</span>
                  </button>
                )}
                {gelaender == 'qline' && (
                  <button
                    className={selectstep < 5.5 ? 'inactivebtn' : selectstep == 5.5 ? 'activeitem2' : 'usedbutton'}
                    id={selectstep == 5 && 'Step5Navbar'}
                    onClick={() => {
                      setselectstep(5.5);
                    }}
                  >
                    {infotext.data.length > 0 && (
                      <>{infotext.data.length > 0 && infotext.data[0].attributes.FreeData1.data[144]}</>
                    )}
                    <span>|</span>
                  </button>
                )}
                <button
                  className={selectstep < 6 ? 'inactivebtn' : selectstep == 6 ? 'activeitem2' : 'usedbutton'}
                  onClick={() => setselectstep(6)}
                  id={selectstep == 5 || (fbsystem == 'Mod6507' && selectstep == 4 && 'Step6Navbar')}
                >
                  {infotext.data.length > 0 && (
                    <>
                      {gelaender != 'frenchbalcony'
                        ? infotext.data[0].attributes.FreeData1.data[80]
                        : infotext.data[0].attributes.FreeData1.data[80]}
                    </>
                  )}
                </button>
              </div>
            )}

            <div className="rotationbox">
              {selectstep >= 7 && !props.title && (
                <div id="yourconfiguredrailing">
                  <h3>
                    {infotext.data.length > 0
                      ? infotext.data[0].attributes.FreeData1.data[24]
                      : 'Your Configured Railing'}{' '}
                  </h3>
                  <p id="configlink">{baseurl + '/' + para.count + finallink + savecode}</p>
                </div>
              )}
              {selectstep < 7 && (
                <>
                  <button
                    onMouseDown={() => {
                      setTimeout(() => {
                        orbitRef.current.object.fov = orbitRef.current.object.fov - 2;
                        cammy.current.fov = cammy.current.fov - 2;
                        setcampos1(22);
                        rotatecount = rotatecount + 1;
                        if (rotatecount % 1 == 0) {
                          orbitRef.current.autoRotate = true;
                          setTimeout(() => {
                            orbitRef.current.autoRotate = false;
                          }, 10);
                        }
                      }, 10);
                    }}
                  >
                    <img
                      width={20}
                      height={20}
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/plus.png"
                    />
                  </button>

                  <button
                    onMouseDown={() => {
                      setTimeout(() => {
                        orbitRef.current.object.fov = orbitRef.current.object.fov + 2;
                        cammy.current.fov = cammy.current.fov + 2;
                        setcampos1(23);
                        rotatecount = rotatecount + 1;
                        if (rotatecount % 1 == 0) {
                          orbitRef.current.autoRotate = true;
                          setTimeout(() => {
                            orbitRef.current.autoRotate = false;
                          }, 10);
                        }
                      }, 10);
                    }}
                  >
                    <img
                      width={20}
                      height={20}
                      src="https://strapiwmc4hstore.blob.core.windows.net/configurator-assets/minus.png"
                    />
                  </button>
                </>
              )}
            </div>
          </div>
        </div>

        <motion.div
          initial={{ y: -2200, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className={
            selectstep > 5
              ? 'Selects-configu step6select'
              : selectstep == 1 && step1bool
                ? 'Selects-configu step1-select-width step-1-changed'
                : selectstep == 1
                  ? 'Selects-configu step1-select-width'
                  : 'Selects-configu'
          }
          id={selectstep == 1 && 'QrailingConfiguratorSideMenu'}
        >
          {returnsteps()}
        </motion.div>
        {selectstep == 6 && calculatesmart()}
      </div>

      {params.title &&
        loadingdone == 0 &&
        (params.title != 'eg' || params.title != 'es') &&
        setTimeout(() => {
          setloadingdone(1);
          enteroldcode(params.title);
        }, 1500)}

      {selectstep >= 9 && (
        <>
          <div className="ConfiguratorPrivateForm-wrap">
            {selectstep >= 9 && selectstep < 11 && (
              <div className="ConfiguratorPrivatForm-inner">
                <div className="ConfiguratorPrivateForm-left">
                  <div className="ConfiguratorPrivateForm-left-inner">
                    <img id="schematicImage" alt="Generated Schematic" />

                    <div>
                      <div className="overview-table">
                        <div>
                          <h4 className="railing-type-title">
                            {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[51] : 'Railing type'}
                            :
                          </h4>
                        </div>
                        <div>
                          <p className="railing-type">
                            {gelaender == 'glass' && 'Easy Glass Smart'}
                            {gelaender == 'picket' && 'Easy Alu Picket'}
                            {gelaender == 'baluster' && 'Easy Alu'}
                            {gelaender == 'baseclamps' && baseclampsubsystem == '60' && 'MOD 6000'}
                            {gelaender == 'baseclamps' && baseclampsubsystem == '64' && 'MOD 6400'}
                            {gelaender == 'frenchbalcony' && fbsystem == 'EasyGlassView' && 'Easy Glass View'}
                            {gelaender == 'frenchbalcony' && fbsystem == 'Mod6507' && 'Mod 6507'}
                            {gelaender == 'qline' && PostShape == 'round' && 'Q-line'}
                            {gelaender == 'qline' && PostShape != 'round' && 'Square Line'}
                          </p>
                        </div>
                        {gelaender != 'baseclamps' && (
                          <>
                            <div>
                              <h4 className="mount-type-title">
                                {infotext.data.length > 0
                                  ? infotext.data[0].attributes.FreeData1.data[52]
                                  : 'Mounting type'}
                                :
                              </h4>
                            </div>
                            <div>
                              {gelaender != 'frenchbalcony' && (
                                <p className="mount-type">
                                  {montageart == 'top' && (
                                    <>
                                      {infotext.data.length > 0
                                        ? infotext.data[0].attributes.FreeData1.data[4]
                                        : 'Topmount'}
                                    </>
                                  )}
                                  {montageart != 'top' && (
                                    <>
                                      {infotext.data.length > 0
                                        ? infotext.data[0].attributes.FreeData1.data[5]
                                        : 'Faciamount'}
                                    </>
                                  )}
                                </p>
                              )}
                              {gelaender == 'frenchbalcony' && (
                                <p className="mount-type">
                                  {fenstermontage == 'Inset' && (
                                    <>
                                      {infotext.data.length > 0
                                        ? infotext.data[0].attributes.FreeData1.data[140]
                                        : 'Mount on frame'}
                                    </>
                                  )}
                                  {fenstermontage != 'Inset' && (
                                    <>
                                      {infotext.data.length > 0
                                        ? infotext.data[0].attributes.FreeData1.data[141]
                                        : 'Wallmount'}
                                    </>
                                  )}
                                </p>
                              )}
                            </div>
                          </>
                        )}
                        {gelaender != 'frenchbalcony' && gelaender != 'qline' && (
                          <>
                            <div>
                              <h4 className="mount-surface-title">
                                {infotext.data.length > 0
                                  ? infotext.data[0].attributes.FreeData1.data[53]
                                  : 'Mounting surface'}
                                :
                              </h4>
                            </div>
                            <div>
                              <p className="mount-surface">
                                {untergrundd == 'holz' && (
                                  <>
                                    {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[8] : 'Wood'}
                                  </>
                                )}
                                {untergrundd == 'beton' && (
                                  <>
                                    {infotext.data.length > 0
                                      ? infotext.data[0].attributes.FreeData1.data[7]
                                      : 'Concrete'}
                                  </>
                                )}
                                {untergrundd == 'metall' && (
                                  <>
                                    {infotext.data.length > 0
                                      ? infotext.data[0].attributes.FreeData1.data[9]
                                      : 'Metall'}
                                  </>
                                )}
                              </p>
                            </div>
                            {gelaender == 'baseclamps' && (
                              <>
                                <div>
                                  <h4 className="surface-color-title">
                                    {infotext.data.length > 0
                                      ? infotext.data[0].attributes.FreeData1.data[54]
                                      : 'Surface color'}
                                    :
                                  </h4>
                                </div>
                                <div>
                                  <p className="surface-color">
                                    {colorr == 'gray'
                                      ? infotext.data[0].attributes.FreeData1.data[117]
                                      : infotext.data[0].attributes.FreeData1.data[118]}
                                  </p>
                                </div>
                              </>
                            )}
                            {gelaender != 'baseclamps' && (
                              <>
                                <div>
                                  <h4 className="surface-color-title">
                                    {infotext.data.length > 0
                                      ? infotext.data[0].attributes.FreeData1.data[54]
                                      : 'Surface color'}
                                    :
                                  </h4>
                                </div>
                                <div>
                                  <p className="surface-color">
                                    {colorr == 'anrtz' && gelaender != 'glass' && (
                                      <>
                                        {infotext.data.length > 0
                                          ? infotext.data[0].attributes.FreeData1.data[14]
                                          : 'Antrazith'}
                                      </>
                                    )}
                                    {colorr == 'gray' && gelaender != 'glass' && gelaender != 'baseclamps' && (
                                      <>
                                        {infotext.data.length > 0
                                          ? infotext.data[0].attributes.FreeData1.data[13]
                                          : 'Grey'}
                                      </>
                                    )}
                                    {colorr == 'black' && gelaender != 'glass' && (
                                      <>
                                        {infotext.data.length > 0
                                          ? infotext.data[0].attributes.FreeData1.data[12]
                                          : 'Black'}
                                      </>
                                    )}
                                    {(colorr == 'brano' || gelaender == 'glass') && gelaender != 'baseclamps' && (
                                      <>
                                        {infotext.data.length > 0
                                          ? infotext.data[0].attributes.FreeData1.data[60]
                                          : 'Brushed anodized'}
                                      </>
                                    )}
                                    {colorr == 'satin304' && <>satin304</>}
                                    {colorr == 'satin316' && <>satin316</>}
                                    {gelaender == 'baseclamps' &&
                                      colorr == 'brano' &&
                                      infotext.data[0].attributes.FreeData1.data[117]}
                                  </p>
                                </div>
                              </>
                            )}{' '}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ConfiguratorPrivateForm-right">
                  {selectstep == 9 && (
                    <div className="ConfiguratorPrivateForm-right-inner">
                      <div className="contactmenu">
                        <div className="ConfigPrivateForm-Headline">
                          <h2>
                            {infotext.data.length > 0
                              ? infotext.data[0].attributes.FreeData1.data[182]
                              : 'Contact data'}
                          </h2>
                        </div>
                        <div className="ConfigPrivateForm-FirstRow ConfigPrivateForm-SpecialRow">
                          <div>
                            <label>
                              {infotext.data.length > 0
                                ? infotext.data[0].attributes.FreeData1.data[85]
                                : 'Salutation:'}
                              :
                            </label>
                            <select id="ConfigRequestSalutationP">
                              <option>
                                {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[87] : 'Mr'}
                              </option>
                              <option>
                                {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[88] : 'Mrs/Ms'}
                              </option>
                              <option>
                                {infotext.data.length > 0
                                  ? infotext.data[0].attributes.FreeData1.data[89]
                                  : 'Non Binary'}
                              </option>
                            </select>
                          </div>
                          {CustSlug != 'rubelo' && (
                            <div>
                              <label>{'Customer type'}:</label>
                              <select id="ConfigRequestCustomerTypeAddP">
                                <option>Business</option>
                                <option>Private</option>
                              </select>
                            </div>
                          )}
                          {CustSlug == 'rubelo' && (
                            <div>
                              <label>{'Typ zákazníka'}:</label>
                              <select id="ConfigRequestCustomerTypeAddP">
                                <option>Firma</option>
                                <option>Soukromá osoba</option>
                              </select>
                            </div>
                          )}
                        </div>
                        <div className="ConfigPrivateForm-NameRow">
                          <div className="ConfigPrivateForm-Rowentity">
                            <label>
                              {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[65] : 'Last Name:'}
                              :
                            </label>{' '}
                            <input
                              id="ConfigRequestLastNameP"
                              onChange={(e) => {
                                custid = e.target.value;
                                checkprivateactive();
                              }}
                              placeholder={
                                infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[65] : 'Last Name'
                              }
                            />
                          </div>
                          <div className="ConfigPrivateForm-Rowentity">
                            <label>
                              {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[64] : 'First Name'}
                              :
                            </label>{' '}
                            <input
                              id="ConfigRequestFirstNameP"
                              placeholder={
                                infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[64] : 'First Name'
                              }
                            />
                          </div>
                        </div>
                        <div className="ConfigPrivateForm-NameRow ConfigPrivateForm-Streetrow">
                          <div className="ConfigPrivateForm-Rowentity">
                            <label>
                              {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[81] : 'Street:'}:
                            </label>{' '}
                            <input
                              id="ConfigRequestStreetP"
                              onChange={(e) => {
                                email = e.target.value;
                                checkprivateactive();
                              }}
                              placeholder={
                                infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[81] : 'Street:'
                              }
                            />
                          </div>
                          <div className="ConfigPrivateForm-Rowentity">
                            <label>
                              {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[183] : 'Number'}
                            </label>{' '}
                            <input
                              id="ConfigRequestStreetNbrP"
                              placeholder={
                                infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[183] : 'Number'
                              }
                            />
                          </div>
                        </div>
                        <div className="ConfigPrivateForm-NameRow ConfigPrivateForm-Cityrow">
                          <div className="ConfigPrivateForm-Rowentity">
                            <label>
                              {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[26] : 'Post code'}:
                            </label>{' '}
                            <input
                              id="ConfigRequestId"
                              className="ConfigRequestPostCodeP"
                              onChange={(e) => {
                                postcode = e.target.value;
                                checkprivateactive();
                              }}
                              placeholder={
                                infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[26] : 'Post code'
                              }
                            />
                          </div>
                          <div className="ConfigPrivateForm-Rowentity">
                            <label>
                              {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[83] : 'City:'}:
                            </label>{' '}
                            <input
                              id="ConfigRequestCityP"
                              onChange={(e) => {
                                email = e.target.value;
                                checkprivateactive();
                              }}
                              placeholder={
                                infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[83] : 'City:'
                              }
                            />
                          </div>
                        </div>
                        <div className="ConfigPrivateForm-NameRow">
                          <div className="ConfigPrivateForm-Rowentity">
                            <label>
                              {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[82] : 'Phone no.:'}
                              :
                            </label>{' '}
                            <input
                              id="ConfigRequestPhoneP"
                              onChange={(e) => {
                                email = e.target.value;
                                checkprivateactive();
                              }}
                              placeholder={
                                infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[82] : 'Phone no.'
                              }
                            />
                          </div>
                          <div className="ConfigPrivateForm-Rowentity">
                            <label>
                              {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[57] : 'E-mail'}:
                            </label>{' '}
                            <input
                              id="ConfigRequestEmail"
                              onChange={(e) => {
                                email = e.target.value;
                                checkprivateactive();
                              }}
                              placeholder={
                                infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[57] : 'E-mail'
                              }
                            />
                          </div>
                        </div>
                        <label>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[22]
                            : 'Additional Information'}{' '}
                          <span>
                            {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[102] : '(optional)'}
                          </span>
                          :
                        </label>{' '}
                        <textarea
                          id="ConfigRequestText"
                          onChange={(e) => {
                            textareatext = e.target.value;
                            checkprivateactive();
                          }}
                          placeholder={
                            infotext.data.length > 0
                              ? infotext.data[0].attributes.FreeData1.data[25]
                              : 'please in black'
                          }
                        />
                        {/*<div className="Configurator-step9-hasinstallerchoice">
                          <p>
                            {infotext.data.length > 0
                              ? infotext.data[0].attributes.FreeData1.data[231]
                              : 'Ich habe bereits einen Handwerker, der sich um die Umsetzung dieses Projekts für mich kümmern kann.'}
                          </p>
                          <div className="Configurator-step9-hasinstallerchoice-btns">
                            <label>
                              {' '}
                              <input onClick={() => setHasInstaller(true)} checked={HasInstaller} type="radio" />
                              <span>
                                {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[69] : 'Yes'}
                              </span>
                            </label>
                            <label>
                              {' '}
                              <input onClick={() => setHasInstaller(false)} checked={!HasInstaller} type="radio" />
                              <span>
                                {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[90] : 'NO'}
                              </span>
                            </label>
                          </div>
                        </div>*/}
                      </div>
                    </div>
                  )}

                  {selectstep == 10 && (
                    <div className="ConfiguratorPrivateForm-right-inner">
                      <div className="Configurator-step10-Text-top">
                        <h2>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[184]
                            : 'Fast geschafft'}
                        </h2>
                        <p>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[185]
                            : 'We cannot sell to private customers but we can connect you with installers in your area'}
                          .
                        </p>
                      </div>
                      {!nothingbelow && (
                        <div className="Configurator-step10-Text">
                          <h2>
                            {infotext.data.length > 0
                              ? infotext.data[0].attributes.FreeData1.data[200]
                              : 'receive regional offers'}
                          </h2>
                          <p>
                            {infotext.data.length > 0
                              ? infotext.data[0].attributes.FreeData1.data[201]
                              : 'Bitte wählen Sie die Unternehmen aus, von denen Sie ein Angebot erhalten möchten.'}
                          </p>
                        </div>
                      )}

                      {nothingbelow && (
                        <>
                          <div className="Configurator-step10-Text">
                            <h4>Purtroppo non ci sono partner selezionabili nella tua zona.</h4>

                            <br />
                            <p>
                              Scrivici a <a href="mailto:sales.it@q-railing.com">sales.it@q-railing.com</a> o chiamaci
                              allo 045 8220042 per conoscere il partner più vicino a te.
                            </p>
                          </div>
                        </>
                      )}

                      <div>
                        <ConfiguratorPrivateConnectParent
                          locale={para.count}
                          setSelectStep={setselectstep}
                          Translations={infotext.data.length > 0 ? infotext : []}
                          PrivateData={PrivateData}
                          setnothingbelow={setnothingbelow}
                          setInstallerId={setInstallerId}
                          ConfigLink={baseurl + '/' + para.count + finallink + savecode}
                          AnnoyCustomer={setAnnoyCustomer}
                        ></ConfiguratorPrivateConnectParent>
                      </div>
                    </div>
                  )}
                  {selectstep == 9 && (
                    <div className="ConfigPrivateForm-Step9BtnsLine">
                      <button
                        onClick={() => {
                          setselectstep(6);
                        }}
                      >
                        <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M13.2501 6.00019C13.2501 6.1991 13.1711 6.38987 13.0304 6.53052C12.8898 6.67117 12.699 6.75019 12.5001 6.75019H3.3126L6.5326 9.96956C6.6735 10.1105 6.75265 10.3016 6.75265 10.5008C6.75265 10.7001 6.6735 10.8912 6.5326 11.0321C6.39171 11.173 6.20061 11.2521 6.00135 11.2521C5.8021 11.2521 5.611 11.173 5.4701 11.0321L0.970103 6.53206C0.900183 6.46238 0.844705 6.37959 0.806851 6.28843C0.768997 6.19726 0.749512 6.09952 0.749512 6.00081C0.749512 5.9021 0.768997 5.80436 0.806851 5.7132C0.844705 5.62204 0.900183 5.53924 0.970103 5.46956L5.4701 0.969563C5.53987 0.899798 5.62269 0.844457 5.71384 0.806701C5.80499 0.768945 5.90269 0.749512 6.00135 0.749512C6.10002 0.749512 6.19771 0.768945 6.28886 0.806701C6.38002 0.844457 6.46284 0.899798 6.5326 0.969563C6.60237 1.03933 6.65771 1.12215 6.69546 1.2133C6.73322 1.30445 6.75265 1.40215 6.75265 1.50081C6.75265 1.59947 6.73322 1.69717 6.69546 1.78832C6.65771 1.87948 6.60237 1.9623 6.5326 2.03206L3.3126 5.25019H12.5001C12.699 5.25019 12.8898 5.32921 13.0304 5.46986C13.1711 5.61051 13.2501 5.80128 13.2501 6.00019Z"
                            fill="#001020"
                          />
                        </svg>
                      </button>

                      <button
                        id={PrivateDataAvailable ? 'Config-Step10' : 'Config-Step10-disabled'}
                        onClick={() => {
                          if (PrivateDataAvailable) {
                            RequestQuote();

                            /*if (CustSlug === 'rubelo') {
                              sendToIframeParent();
                            }*/

                            if (HasInstaller) {
                              setselectstep(11);
                            } else {
                              setselectstep(10);
                            }
                          }
                        }}
                      >
                        {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[0] : 'Forward'}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}

            {selectstep >= 11 && (
              <div className="ConfiguratorPrivatForm-LastStep">
                {((InstallerId != 'None' && InstallerId != undefined) || HasInstaller) && (
                  <>
                    <div className="Configurator-step7-checkmark-wrap Configurator-step11-checkmark">
                      <span id="Configurator-final-checkmark">
                        <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M19.2959 2.54597L7.2959 14.546C7.19138 14.6509 7.06719 14.7341 6.93044 14.7909C6.7937 14.8476 6.64709 14.8769 6.49902 14.8769C6.35096 14.8769 6.20435 14.8476 6.0676 14.7909C5.93085 14.7341 5.80666 14.6509 5.70215 14.546L0.452147 9.29598C0.3475 9.19133 0.264489 9.06709 0.207854 8.93037C0.15122 8.79364 0.12207 8.64709 0.12207 8.4991C0.12207 8.35111 0.15122 8.20456 0.207854 8.06783C0.264489 7.93111 0.3475 7.80687 0.452147 7.70223C0.556794 7.59758 0.681028 7.51457 0.817756 7.45793C0.954484 7.4013 1.10103 7.37215 1.24902 7.37215C1.39702 7.37215 1.54356 7.4013 1.68029 7.45793C1.81702 7.51457 1.94125 7.59758 2.0459 7.70223L6.49996 12.1563L17.704 0.9541C17.9154 0.742755 18.202 0.624023 18.5009 0.624023C18.7998 0.624023 19.0864 0.742755 19.2978 0.9541C19.5091 1.16544 19.6278 1.45209 19.6278 1.75098C19.6278 2.04986 19.5091 2.33651 19.2978 2.54785L19.2959 2.54597Z"
                            fill="white"
                          />
                        </svg>
                      </span>
                    </div>

                    <h3 className="Configurator-final-text Configurator-step11-final-text">
                      {!HasInstaller && (
                        <>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[252]
                            : 'Your request has been submitted successfully.'}
                        </>
                      )}
                      {HasInstaller && (
                        <>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[251]
                            : 'Your request has been submitted successfully.'}
                        </>
                      )}
                    </h3>
                  </>
                )}
                {(InstallerId == 'None' || !InstallerId) && !HasInstaller && (
                  <>
                    <div className="Configurator-step7-checkmark-wrap Configurator-step11-checkmark">
                      <span id="Configurator-final-checkmark">
                        <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M19.2959 2.54597L7.2959 14.546C7.19138 14.6509 7.06719 14.7341 6.93044 14.7909C6.7937 14.8476 6.64709 14.8769 6.49902 14.8769C6.35096 14.8769 6.20435 14.8476 6.0676 14.7909C5.93085 14.7341 5.80666 14.6509 5.70215 14.546L0.452147 9.29598C0.3475 9.19133 0.264489 9.06709 0.207854 8.93037C0.15122 8.79364 0.12207 8.64709 0.12207 8.4991C0.12207 8.35111 0.15122 8.20456 0.207854 8.06783C0.264489 7.93111 0.3475 7.80687 0.452147 7.70223C0.556794 7.59758 0.681028 7.51457 0.817756 7.45793C0.954484 7.4013 1.10103 7.37215 1.24902 7.37215C1.39702 7.37215 1.54356 7.4013 1.68029 7.45793C1.81702 7.51457 1.94125 7.59758 2.0459 7.70223L6.49996 12.1563L17.704 0.9541C17.9154 0.742755 18.202 0.624023 18.5009 0.624023C18.7998 0.624023 19.0864 0.742755 19.2978 0.9541C19.5091 1.16544 19.6278 1.45209 19.6278 1.75098C19.6278 2.04986 19.5091 2.33651 19.2978 2.54785L19.2959 2.54597Z"
                            fill="white"
                          />
                        </svg>
                      </span>
                    </div>

                    <h3 className="Configurator-final-text Configurator-step11-final-text Configurator-step11-final-text-error">
                      {infotext.data.length > 0
                        ? infotext.data[0].attributes.FreeData1.data[202]
                        : 'Anfrage gespeichert'}
                    </h3>
                    <div className="Configurator-step11-warning">
                      <h5>
                        {infotext.data.length > 0
                          ? infotext.data[0].attributes.FreeData1.data[126]
                          : 'Vielen Dank für Ihre Anfrage!'}
                      </h5>
                      {CustSlug == 'Rvs' && (
                        <p>
                          Wij zullen uw aanvraag controleren en binnen drie werkdagen contact met u opnemen met een
                          vervolg of een aanbod.
                        </p>
                      )}
                      {CustSlug == 'rvs-land' && (
                        <p>
                          Wij zullen uw aanvraag controleren en binnen drie werkdagen contact met u opnemen met een
                          vervolg of een aanbod.
                        </p>
                      )}
                      {CustSlug == 'wholesaleglass' && (
                        <p>
                          We will review your request and contact you within three business days with a follow-up or an
                          offer.
                        </p>
                      )}
                      {CustSlug == 'aluleaf' && (
                        <p>
                          Wir werden Ihre Anfrage prüfen und uns innerhalb von drei Werktagen mit einer Rückmeldung oder
                          einem Angebot bei Ihnen melden.
                        </p>
                      )}
                      {CustSlug == 'storax' && (
                        <p>
                          Wij zullen uw aanvraag controleren en binnen drie werkdagen contact met u opnemen met een
                          vervolg of een aanbod.
                        </p>
                      )}
                      {CustSlug == 'hekwerkshop' && (
                        <p>
                          Wij zullen uw aanvraag controleren en binnen drie werkdagen contact met u opnemen met een
                          vervolg of een aanbod.
                        </p>
                      )}
                      {CustSlug == 'glasmaatje' && (
                        <p>
                          Wij zullen uw aanvraag controleren en binnen drie werkdagen contact met u opnemen met een
                          vervolg of een aanbod.
                        </p>
                      )}
                      {CustSlug == 'glas123' && (
                        <p>
                          Wij zullen uw aanvraag controleren en binnen drie werkdagen contact met u opnemen met een
                          vervolg of een aanbod.
                        </p>
                      )}
                      {CustSlug == 'rubelo' && (
                        <p>
                          Vaši žádost posoudíme a do tří pracovních dnů vás budeme kontaktovat s dalšími informacemi
                          nebo nabídkou.
                        </p>
                      )}
                    </div>
                  </>
                )}

                {HasInstaller && (
                  <div className="Configurator-step11-FinalHasInstallertext">
                    <p>
                      {infotext.data.length > 0
                        ? infotext.data[0].attributes.FreeData1.data[186]
                        : 'We cant sell to you if you are private customer - text'}
                    </p>
                    <button onClick={() => (window.location.href = mailtoLink)}>
                      {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[187] : 'Open Email Client'}
                    </button>
                  </div>
                )}
                <div className="Configurator-step11-confilink">
                  {CustSlug == 'Rvs' && <h3>Sla deze code op en open uw configuratie wanneer het u uitkomt:</h3>}
                  {CustSlug == 'rvs-land' && <h3>Sla deze code op en open uw configuratie wanneer het u uitkomt:</h3>}
                  {CustSlug == 'wholesaleglass' && (
                    <h3>Save this code and open your configuration when it suits you:</h3>
                  )}
                  {CustSlug == 'aluleaf' && (
                    <h3>Speichern Sie diesen Code und öffnen Sie Ihre Konfiguration, wann es Ihnen passt:</h3>
                  )}
                  {CustSlug == 'hekwerkshop' && (
                    <h3>Sla deze code op en open uw configuratie wanneer het u uitkomt:</h3>
                  )}
                  {CustSlug == 'storax' && <h3>Sla deze code op en open uw configuratie wanneer het u uitkomt:</h3>}
                  {CustSlug == 'rubelo' && (
                    <h3>Uložte tento kód a otevřete svou konfiguraci, kdykoli se vám to hodí:</h3>
                  )}
                  {CustSlug == 'glasmaatje' && <h3>Sla deze code op en open uw configuratie wanneer het u uitkomt:</h3>}
                  {CustSlug == 'glas123' && <h3>Sla deze code op en open uw configuratie wanneer het u uitkomt:</h3>}
                  {CustSlug == 'glassinside' && (
                    <h3>Sla deze code op en open uw configuratie wanneer het u uitkomt:</h3>
                  )}
                  <p id="configlink" className="Step-11-config-savecode">
                    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M19.625 5.58243C19.5905 6.77924 19.0984 7.91726 18.25 8.76211L15.2637 11.7502C14.8287 12.1875 14.3114 12.5342 13.7415 12.7702C13.1717 13.0062 12.5607 13.1269 11.9439 13.1252H11.9396C11.3123 13.1247 10.6914 12.9986 10.1137 12.7541C9.53596 12.5097 9.01307 12.152 8.5759 11.7021C8.13874 11.2522 7.79618 10.7192 7.56844 10.1347C7.34071 9.55021 7.23243 8.92598 7.25 8.29891C7.25513 8.11657 7.33248 7.94374 7.46504 7.81844C7.5976 7.69313 7.7745 7.62562 7.95684 7.63075C8.13917 7.63587 8.31201 7.71323 8.43731 7.84578C8.56262 7.97834 8.63013 8.15525 8.625 8.33758C8.61248 8.78096 8.68896 9.22234 8.84993 9.63566C9.01089 10.049 9.25306 10.4258 9.56214 10.744C9.87122 11.0621 10.2409 11.315 10.6494 11.4879C11.0579 11.6607 11.4969 11.7499 11.9405 11.7502C12.3765 11.7513 12.8084 11.666 13.2112 11.4991C13.6141 11.3323 13.9799 11.0873 14.2874 10.7782L17.2738 7.79188C17.8899 7.16798 18.2342 6.32565 18.2314 5.4488C18.2287 4.57195 17.8791 3.73179 17.2591 3.11176C16.6391 2.49173 15.7989 2.14218 14.9221 2.13944C14.0452 2.13669 13.2029 2.48097 12.579 3.09711L11.6337 4.04243C11.5037 4.16591 11.3306 4.23374 11.1513 4.23145C10.9721 4.22915 10.8008 4.15692 10.674 4.03014C10.5472 3.90336 10.475 3.73208 10.4727 3.5528C10.4704 3.37353 10.5382 3.20045 10.6617 3.07047L11.607 2.12516C12.0432 1.68888 12.561 1.3428 13.1309 1.10668C13.7008 0.870555 14.3116 0.749023 14.9285 0.749023C15.5454 0.749023 16.1562 0.870555 16.7262 1.10668C17.2961 1.3428 17.8139 1.68888 18.25 2.12516C18.7017 2.57801 19.0566 3.11806 19.293 3.71241C19.5294 4.30677 19.6423 4.94302 19.625 5.58243ZM8.36719 13.9553L7.42188 14.9006C7.11355 15.211 6.74661 15.457 6.34237 15.6243C5.93814 15.7916 5.50467 15.8769 5.06719 15.8752C4.41089 15.8746 3.76947 15.6796 3.22397 15.3147C2.67848 14.9497 2.25339 14.4313 2.00241 13.8249C1.75144 13.2185 1.68584 12.5513 1.81391 11.9076C1.94198 11.2639 2.25797 10.6726 2.72196 10.2084L5.70313 7.22211C6.17268 6.75008 6.77331 6.43015 7.42703 6.30386C8.08074 6.17757 8.75732 6.25076 9.3689 6.51393C9.98049 6.77709 10.4988 7.21807 10.8566 7.7796C11.2143 8.34112 11.3949 8.99724 11.375 9.66274C11.3699 9.84508 11.4374 10.022 11.5627 10.1545C11.688 10.2871 11.8608 10.3644 12.0432 10.3696C12.2255 10.3747 12.4024 10.3072 12.535 10.1819C12.6675 10.0566 12.7449 9.88375 12.75 9.70141C12.7665 9.06301 12.6531 8.4279 12.4168 7.83464C12.1804 7.24137 11.826 6.70231 11.375 6.25016C10.4943 5.36984 9.30004 4.87531 8.05481 4.87531C6.80957 4.87531 5.61531 5.36984 4.73461 6.25016L1.75 9.23649C1.09364 9.89259 0.646492 10.7285 0.465074 11.6387C0.283655 12.5488 0.376105 13.4923 0.730741 14.3499C1.08538 15.2076 1.68628 15.9408 2.45752 16.457C3.22875 16.9732 4.1357 17.2492 5.06375 17.2502C5.68067 17.2519 6.29182 17.1313 6.86181 16.8953C7.4318 16.6593 7.94931 16.3125 8.38438 15.8752L9.32969 14.9298C9.44095 14.7988 9.49907 14.6308 9.4926 14.459C9.48613 14.2872 9.41554 14.1241 9.29474 14.0018C9.17393 13.8795 9.01169 13.8069 8.84 13.7983C8.6683 13.7897 8.49961 13.8457 8.36719 13.9553Z"
                        fill="black"
                      />
                    </svg>

                    <a href={baseurl + '/' + para.count + '/' + savecode}>{savecode}</a>
                  </p>
                </div>
                {infotext.data[0].attributes.FreeData1.data[120] && infotext.data[0].attributes.FreeData1.data[121] && (
                  <div className="configuration-downloads  Step-11-config-savecode">
                    <div className="configuration-downloads-inner">
                      {/*infotext.data[0].attributes.FreeData1.data.length >= 130 && (
                        <div
                          id="configuration-downloads-pdf"
                          className="configuration-downloads-item"
                          onClick={() => downloadConfigurationPdf(true)}
                        >
                          <span className="Configurator-step11-icon">
                            <svg
                              width="18"
                              height="22"
                              viewBox="0 0 18 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17.7607 6.17058L12.0334 0.2475C11.9574 0.168948 11.8671 0.106659 11.7678 0.0641925C11.6685 0.0217257 11.562 -8.71419e-05 11.4545 2.61629e-07H1.63636C1.20237 2.61629e-07 0.786157 0.178296 0.47928 0.495666C0.172402 0.813035 0 1.24348 0 1.69231V20.3077C0 20.7565 0.172402 21.187 0.47928 21.5043C0.786157 21.8217 1.20237 22 1.63636 22H16.3636C16.7976 22 17.2138 21.8217 17.5207 21.5043C17.8276 21.187 18 20.7565 18 20.3077V6.76923C18.0001 6.65808 17.979 6.548 17.9379 6.44528C17.8969 6.34256 17.8366 6.24922 17.7607 6.17058ZM12.2727 2.88856L15.2069 5.92308H12.2727V2.88856ZM16.3636 20.3077H1.63636V1.69231H10.6364V6.76923C10.6364 6.99364 10.7226 7.20887 10.876 7.36755C11.0294 7.52624 11.2375 7.61538 11.4545 7.61538H16.3636V20.3077Z"
                                fill="black"
                              />
                            </svg>
                          </span>
                          <span className="text">{infotext.data[0].attributes.FreeData1.data[123]}</span>
                        </div>
                      )*/}
                      {infotext.data[0].attributes.FreeData1.data[122] && (
                        <div
                          id="configuration-downloads-custom-overview"
                          className="configuration-downloads-item"
                          onClick={() => downloadCurrentSchematic(false)}
                        >
                          <span className="Configurator-step11-icon">
                            <svg
                              width="22"
                              height="18"
                              viewBox="0 0 22 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.3077 0H1.69231C1.24348 0 0.813035 0.172402 0.495665 0.47928C0.178296 0.786157 0 1.20237 0 1.63636V16.3636C0 16.7976 0.178296 17.2138 0.495665 17.5207C0.813035 17.8276 1.24348 18 1.69231 18H20.3077C20.7565 18 21.187 17.8276 21.5043 17.5207C21.8217 17.2138 22 16.7976 22 16.3636V1.63636C22 1.20237 21.8217 0.786157 21.5043 0.47928C21.187 0.172402 20.7565 0 20.3077 0ZM20.3077 1.63636V12.1449L17.5503 9.47966C17.3931 9.32767 17.2066 9.2071 17.0012 9.12484C16.7959 9.04258 16.5758 9.00025 16.3535 9.00025C16.1312 9.00025 15.9111 9.04258 15.7058 9.12484C15.5005 9.2071 15.3139 9.32767 15.1567 9.47966L13.0413 11.5251L8.3875 7.02511C8.07016 6.71847 7.63989 6.54621 7.19125 6.54621C6.74261 6.54621 6.31234 6.71847 5.995 7.02511L1.69231 11.1856V1.63636H20.3077ZM1.69231 13.5L7.19231 8.18182L15.6538 16.3636H1.69231V13.5ZM20.3077 16.3636H18.0474L14.2397 12.6818L16.3551 10.6364L20.3077 14.4593V16.3636ZM12.6923 6.13636C12.6923 5.89363 12.7667 5.65635 12.9062 5.45453C13.0457 5.2527 13.2439 5.0954 13.4758 5.00251C13.7077 4.90962 13.9629 4.88532 14.2092 4.93267C14.4554 4.98003 14.6815 5.09691 14.859 5.26855C15.0365 5.44019 15.1574 5.65887 15.2064 5.89693C15.2554 6.135 15.2302 6.38177 15.1342 6.60602C15.0381 6.83028 14.8754 7.02195 14.6667 7.1568C14.458 7.29166 14.2126 7.36364 13.9615 7.36364C13.6249 7.36364 13.3021 7.23433 13.0641 7.00418C12.826 6.77402 12.6923 6.46186 12.6923 6.13636Z"
                                fill="black"
                              />
                            </svg>
                          </span>
                          <span className="text">{infotext.data[0].attributes.FreeData1.data[122]}</span>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}

            {selectstep >= 11 && (
              <div
                className="howwework2-wrap configurator-step11-cards"
                id={!HasInstaller && (InstallerId == 'None' || !InstallerId) ? 'ConfigHideCards' : ''}
              >
                <div className="howwework2-inner">
                  <div className="howwework2-header">
                    <h2>
                      {!HasInstaller && !InstallerId && (
                        <>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[210]
                            : 'So geht es weiter'}
                        </>
                      )}
                      {HasInstaller && (
                        <>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[235]
                            : 'So geht es weiter'}
                        </>
                      )}
                      {!HasInstaller && InstallerId != 'None' && InstallerId != undefined && (
                        <>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[243]
                            : 'So geht es weiter'}
                        </>
                      )}
                    </h2>
                    <div>
                      {/*!HasInstaller && !InstallerId && (
                        <p>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[211]
                            : 'Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Libero posuere consectetur est at lobortis.'}
                        </p>
                      )*/}
                      {/*HasInstaller && (
                        <p>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[236]
                            : 'Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Libero posuere consectetur est at lobortis.'}
                        </p>
                      )*/}
                      {/*!HasInstaller && InstallerId != 'None' && InstallerId != undefined && (
                        <p>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[244]
                            : 'Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Libero posuere consectetur est at lobortis.'}
                        </p>
                      )*/}
                    </div>
                  </div>

                  <div className="howwework2-cards">
                    <div className="howwework2-card" id="howwework2-card1">
                      <span id="howwework2-span01">01</span>
                      {!HasInstaller && !InstallerId && (
                        <h3>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[212]
                            : 'Daten an Partner übermittelt'}
                        </h3>
                      )}
                      {HasInstaller && (
                        <h3>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[237]
                            : 'Daten an Partner übermittelt'}
                        </h3>
                      )}
                      {!HasInstaller && InstallerId != 'None' && InstallerId != undefined && (
                        <h3>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[245]
                            : 'Daten an Partner übermittelt'}
                        </h3>
                      )}
                      {!HasInstaller && !InstallerId && (
                        <p>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[213]
                            : 'Alle Daten aus Ihrer Konfiguration sowie Ihre Kontaktdaten werden an die von Ihnen ausgewählten Partner-Unternehmen weitergegeben.'}
                        </p>
                      )}
                      {HasInstaller && (
                        <p>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[238]
                            : 'Alle Daten aus Ihrer Konfiguration sowie Ihre Kontaktdaten werden an die von Ihnen ausgewählten Partner-Unternehmen weitergegeben.'}
                        </p>
                      )}
                      {!HasInstaller && InstallerId != 'None' && InstallerId != undefined && (
                        <p>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[246]
                            : 'Alle Daten aus Ihrer Konfiguration sowie Ihre Kontaktdaten werden an die von Ihnen ausgewählten Partner-Unternehmen weitergegeben.'}
                        </p>
                      )}
                      <br />
                    </div>
                    <div className="howwework2-card" id="howwework2-card2">
                      <span id="howwework2-span02">02</span>
                      {!HasInstaller && !InstallerId && (
                        <h3>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[214]
                            : 'Title comes here'}
                        </h3>
                      )}
                      {HasInstaller && (
                        <h3>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[239]
                            : 'Title comes here'}
                        </h3>
                      )}
                      {!HasInstaller && InstallerId != 'None' && InstallerId != undefined && (
                        <h3>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[247]
                            : 'Title comes here'}
                        </h3>
                      )}
                      {HasInstaller && (
                        <p>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[240]
                            : 'Konfiguration sowie Ihre Kontaktdaten werden an die von Ihnen ausgewählten Partner-Unternehmen'}
                        </p>
                      )}
                      {!HasInstaller && InstallerId != 'None' && InstallerId != undefined && (
                        <p>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[248]
                            : 'Konfiguration sowie Ihre Kontaktdaten werden an die von Ihnen ausgewählten Partner-Unternehmen'}
                        </p>
                      )}
                      {!HasInstaller && !InstallerId && (
                        <p>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[215]
                            : 'Konfiguration sowie Ihre Kontaktdaten werden an die von Ihnen ausgewählten Partner-Unternehmen'}
                        </p>
                      )}
                      <br />
                    </div>
                    <div className="howwework2-card" id="howwework2-card3">
                      <span id="howwework2-span03">03</span>
                      {!HasInstaller && !InstallerId && (
                        <h3>
                          {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[216] : 'Dritter Punkt'}
                        </h3>
                      )}
                      {HasInstaller && (
                        <h3>
                          {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[241] : 'Dritter Punkt'}
                        </h3>
                      )}
                      {!HasInstaller && InstallerId != 'None' && InstallerId != undefined && (
                        <h3>
                          {infotext.data.length > 0 ? infotext.data[0].attributes.FreeData1.data[249] : 'Dritter Punkt'}
                        </h3>
                      )}
                      {!HasInstaller && !InstallerId && (
                        <p>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[217]
                            : 'Kontaktdaten werden an die von Ihnen ausgewählten Partner-Unternehmen weitergegeben'}
                        </p>
                      )}
                      {HasInstaller && (
                        <p>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[242]
                            : 'Kontaktdaten werden an die von Ihnen ausgewählten Partner-Unternehmen weitergegeben'}
                        </p>
                      )}
                      {!HasInstaller && InstallerId != 'None' && InstallerId != undefined && (
                        <p>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[250]
                            : 'Kontaktdaten werden an die von Ihnen ausgewählten Partner-Unternehmen weitergegeben'}
                        </p>
                      )}

                      <br />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {AnnoyCustomer && Popupcount === 0 && selectstep == 10 && (
              /*selectstep == 10 && InstallerId == 'None' && */ <>
                <div className="Configurator-Modal-step10-wrap">
                  <div className="Configurator-Modal-step10-outer">
                    <div className="Configurator-Modal-step10-inner">
                      <div className="Configurator-Modal-step10-closebtn">
                        <button
                          onClick={() => {
                            setPopupcount(1);
                          }}
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19.707 18.292C19.7999 18.3849 19.8736 18.4952 19.9238 18.6166C19.9741 18.738 20 18.8681 20 18.9995C20 19.1309 19.9741 19.261 19.9238 19.3824C19.8736 19.5038 19.7999 19.6141 19.707 19.707C19.6141 19.7999 19.5038 19.8736 19.3824 19.9238C19.261 19.9741 19.1309 20 18.9995 20C18.8681 20 18.738 19.9741 18.6166 19.9238C18.4952 19.8736 18.3849 19.7999 18.292 19.707L10 11.4137L1.70796 19.707C1.52033 19.8946 1.26585 20 1.0005 20C0.735151 20 0.48067 19.8946 0.29304 19.707C0.105409 19.5193 5.23067e-09 19.2648 0 18.9995C-5.23067e-09 18.7341 0.105409 18.4797 0.29304 18.292L8.58633 10L0.29304 1.70796C0.105409 1.52033 0 1.26585 0 1.0005C0 0.735151 0.105409 0.48067 0.29304 0.29304C0.48067 0.105409 0.735151 0 1.0005 0C1.26585 0 1.52033 0.105409 1.70796 0.29304L10 8.58633L18.292 0.29304C18.4797 0.105409 18.7341 -5.23067e-09 18.9995 0C19.2648 5.23067e-09 19.5193 0.105409 19.707 0.29304C19.8946 0.48067 20 0.735151 20 1.0005C20 1.26585 19.8946 1.52033 19.707 1.70796L11.4137 10L19.707 18.292Z"
                              fill="black"
                            />
                          </svg>
                        </button>
                      </div>
                      <div className="Configurator-Modal-step10-text">
                        <svg width="47" height="40" viewBox="0 0 47 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M45.9611 38.3537C45.7808 38.6528 45.5218 38.8999 45.2108 39.0697C44.8998 39.2394 44.548 39.3257 44.1914 39.3197H2.81095C2.45434 39.3257 2.10251 39.2394 1.79153 39.0697C1.48054 38.8999 1.22159 38.6528 1.04121 38.3537C0.877833 38.0848 0.791649 37.7783 0.791649 37.466C0.791649 37.1536 0.877833 36.8471 1.04121 36.5782L21.7315 1.64841C21.9155 1.35072 22.1756 1.1044 22.4865 0.933394C22.7975 0.762385 23.1487 0.672511 23.5059 0.672511C23.8632 0.672511 24.2143 0.762385 24.5253 0.933394C24.8362 1.1044 25.0964 1.35072 25.2804 1.64841L45.9706 36.5782C46.1326 36.8479 46.2171 37.1549 46.2154 37.4672C46.2138 37.7795 46.126 38.0857 45.9611 38.3537ZM21.6084 15.4V24.5999C21.6084 25.0879 21.8078 25.5559 22.1628 25.9009C22.5178 26.246 22.9992 26.4399 23.5012 26.4399C24.0032 26.4399 24.4846 26.246 24.8396 25.9009C25.1945 25.5559 25.3939 25.0879 25.3939 24.5999V15.4C25.3939 14.912 25.1945 14.444 24.8396 14.0989C24.4846 13.7538 24.0032 13.56 23.5012 13.56C22.9992 13.56 22.5178 13.7538 22.1628 14.0989C21.8078 14.444 21.6084 14.912 21.6084 15.4ZM25.8618 34.4132C26.1738 33.9593 26.3403 33.4257 26.3403 32.8798C26.3403 32.1478 26.0412 31.4458 25.5088 30.9282C24.9763 30.4106 24.2542 30.1198 23.5012 30.1198C22.9397 30.1198 22.3907 30.2817 21.9238 30.585C21.4569 30.8882 21.093 31.3193 20.8782 31.8236C20.6633 32.3279 20.607 32.8829 20.7166 33.4182C20.8261 33.9536 21.0965 34.4454 21.4936 34.8314C21.8907 35.2174 22.3966 35.4802 22.9473 35.5867C23.498 35.6932 24.0689 35.6386 24.5877 35.4297C25.1065 35.2208 25.5499 34.867 25.8618 34.4132Z"
                            fill="#E0BB16"
                          />
                        </svg>
                        <h3>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[218]
                            : 'Ohne Handwerksbetrieb geht es nicht weiter'}
                        </h3>
                        <p>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[219]
                            : 'Da wir ausschließlich mit Handwerksbetrieben zusammenarbeiten, können wir Ihre Anfrage aktuell nicht weiterbearbeiten, wenn Sie kein Unternehmen auswählen.'}
                        </p>
                        <h4>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[220]
                            : 'Was Sie tun können:'}
                        </h4>
                        <ul>
                          <li>
                            <span>
                              {infotext.data.length > 0
                                ? infotext.data[0].attributes.FreeData1.data[221]
                                : 'Wählen Sie eines der vorgeschlagenen Unternehmen aus, um den Prozess abzuschließen.'}
                            </span>
                          </li>
                          <li>
                            <span>
                              {infotext.data.length > 0
                                ? infotext.data[0].attributes.FreeData1.data[222]
                                : 'Alternativ können Sie später auf Ihre gespeicherte Konfiguration zurückgreifen, wenn Sie einen passenden Handwerker gefunden haben.'}
                            </span>
                          </li>
                        </ul>
                        <p>
                          {infotext.data.length > 0
                            ? infotext.data[0].attributes.FreeData1.data[223]
                            : 'Möchten Sie Ihre Auswahl ändern?'}
                        </p>

                        <div className="Config-step10-modal-ButtonLine">
                          <button
                            onClick={() => {
                              setselectstep(11);
                            }}
                          >
                            {infotext.data.length > 0
                              ? infotext.data[0].attributes.FreeData1.data[224]
                              : 'Trotzdem fortfahre'}
                          </button>
                          <button
                            onClick={() => {
                              setPopupcount(1);
                            }}
                          >
                            {infotext.data.length > 0
                              ? infotext.data[0].attributes.FreeData1.data[225]
                              : 'Auswahl ändern'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      )}
      {selectstep == 1 && (
        <div id="ConfiguratorIframeSpecialTab">
          <h3 style={{ fontWeight: '500', color: '#667079', fontSize: '12px' }}>
            Powered by{' '}
            <a
              style={{ color: '#667079', textDecoration: 'underline', fontWeight: '600' }}
              href="https://q-railing.com"
            >
              Q-railing
            </a>
          </h3>{' '}
          <label>
            {!para.title && (
              <>
                <input type="text" id="ConfiguratorCodeId" />
                <button
                  style={
                    CustSlug === 'rvs-land'
                      ? { backgroundColor: 'rgb(0, 159, 231)' }
                      : CustSlug === 'wholesaleglass'
                        ? { backgroundColor: '#191852' }
                        : undefined
                  }
                  onClick={() => {
                    const input = document.getElementById('ConfiguratorCodeId').value;
                    const queryParams = window.location.search;

                    if (input.length === 8) {
                      window.location.href = `/${param.count}/${input}${queryParams}`; // Replace `/redirect-path/` with your desired path
                    } else {
                      document.getElementById('ConfiguratorCodeId').style = 'border: 1px solid red';
                    }
                  }}
                >
                  {CustSlug != 'rubelo' &&
                    CustSlug != 'wholesaleglass' &&
                    CustSlug != 'aluleaf' &&
                    `Laad ${CustSlug == 'Rvs' ? 'RVS' : CustSlug == 'rvs-land' ? 'RVS' : CustSlug == 'hekwerkshop' ? 'hekwerk webshop' : CustSlug == 'storax' ? 'Storax' : CustSlug == 'glassinside' ? 'Glass inside' : CustSlug == 'glasmaatje' ? 'Glasmaatje' : CustSlug == 'aluleaf' ? 'Aluleaf' : CustSlug == 'glas123' ? 'Glas123' : CustSlug} configuratie`}
                  {CustSlug == 'rubelo' && `Načíst konfiguraci Q-railing`}
                  {CustSlug == 'wholesaleglass' && `Load Wholesale Glass configuration`}
                  {CustSlug == 'aluleaf' && `Laden Sie Ihre Aluleaf-Konfiguration`}
                </button>
              </>
            )}
            {para.title && (
              <>
                <button
                  onClick={() => {
                    const queryParams = window.location.search;
                    window.location.href = `/${para.count}/${queryParams}`;
                  }}
                  id="Configurator-UseConfigBtn"
                >
                  {para.count == 'nl-nl' ? 'Gebruik de configurator' : 'Use the configurator'}
                </button>
              </>
            )}
          </label>
        </div>
      )}
    </>
  );
}

export default KonfiguratorDetail;
